export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Base64 scalar type */
  Base64: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

/** Surface detection modes for AR objects */
export enum ArDetection {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
  VerticalAndHorizontal = 'VERTICAL_AND_HORIZONTAL'
}

/** Represents an Augmented Reality object in the system */
export type ArObject = {
  __typename?: 'ARObject';
  /**
   * Whether the object can be panned in AR view
   * @deprecated Not required for AR objects
   * @deprecated Not required
   */
  allows_pan?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the object can be rotated in AR view
   * @deprecated Not required for AR objects
   * @deprecated Not required
   */
  allows_rotation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Surface detection mode for the AR object
   * @deprecated Not required for AR objects
   * @deprecated Not required
   */
  detection?: Maybe<ArDetection>;
  /** Unique identifier of the AR object */
  id: Scalars['UUID']['output'];
  /** Target platform for the AR content */
  platform: ArPlatform;
  /**
   * Get thumbnail image URL for the AR object
   * @deprecated Not required for AR objects
   * @deprecated Not required
   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**
   * Type of the AR object
   * @deprecated Not required for AR objects
   * @deprecated Not required
   */
  type?: Maybe<ArObjectType>;
  /** URL to access the AR model file */
  url: Scalars['String']['output'];
};


/** Represents an Augmented Reality object in the system */
export type ArObjectThumbnailArgs = {
  size?: InputMaybe<Size>;
};

/** Types of AR objects in the system */
export enum ArObjectType {
  Default = 'DEFAULT'
}

/** Supported platforms for AR content */
export enum ArPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** Base interface for attributes representing creators (artists, brands, designers) */
export type AbstractActor = {
  /** Country where the actor originates from */
  country_of_origin?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['UUID']['output'];
};

/** Base interface for all attributes */
export type AbstractAttribute = {
  /** Detailed description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** Associated media files */
  media: Array<Media>;
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** Display name */
  title: Scalars['String']['output'];
};


/** Base interface for all attributes */
export type AbstractAttributeMediaArgs = {
  type?: InputMaybe<MediaType>;
};

/**
 * Base interface for all content blocks.
 * Defines the common properties that all block types must implement.
 */
export type AbstractBlock = {
  /** Unique identifier for the block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the block's content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** Input for creating a new abuse report */
export type AbuseReportInput = {
  /** Optional detailed description of the issue */
  description?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the content being reported (product or user) */
  id: Scalars['UUID']['input'];
  /** Reason for reporting the content */
  reason: AbuseReportReason;
  /** Type of content being reported */
  type: AbuseReportType;
};

/** Reasons that can be specified when reporting abusive content or behavior */
export enum AbuseReportReason {
  /** Product photos don't meet quality standards */
  PoorPhotoQuality = 'POOR_PHOTO_QUALITY',
  /** Content is considered spam or promotional material */
  Spam = 'SPAM',
  /** Content violates platform terms of service or community guidelines */
  ViolatingContent = 'VIOLATING_CONTENT',
  /** Product is listed in incorrect category */
  WrongCategory = 'WRONG_CATEGORY'
}

/** Types of content that can be reported for abuse */
export enum AbuseReportType {
  /** Report applies to a product listing */
  Product = 'PRODUCT',
  /** Report applies to a user's behavior or profile */
  User = 'USER'
}

/** One thing the merchant should do, as shown on the account dashboard. */
export type AccountAction = {
  __typename?: 'AccountAction';
  /**
   * Amount in EUR: the bid amount for RESPOND_TO_BID, the order payout for
   * DOWNLOAD_LABEL / LABEL_FAILED, the order total for CONFIRM_RECEIPT.
   */
  amount?: Maybe<Scalars['Float']['output']>;
  bidId?: Maybe<Scalars['UUID']['output']>;
  /** Grouped rows only (LISTINGS_EXPIRING) */
  count?: Maybe<Scalars['Int']['output']>;
  /** Bid expiry, postal send-by date, listing expiry when known */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Stable id: `<TYPE>:<entity id>`, e.g. `RESPOND_TO_BID:<bidId>`, `LISTINGS_EXPIRING:all` */
  id: Scalars['ID']['output'];
  labelFailure?: Maybe<PostalLabelFailure>;
  /** DOWNLOAD_LABEL rows: the hosted shipping label, so the action can download it in place */
  labelUrl?: Maybe<Scalars['String']['output']>;
  /** Sort key inside a priority class (newest first) */
  occurredAt: Scalars['DateTime']['output'];
  /** Order group of the order, for buyer-side deep links */
  orderGroupId?: Maybe<Scalars['UUID']['output']>;
  orderId?: Maybe<Scalars['UUID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  priority: AccountActionPriority;
  productId?: Maybe<Scalars['UUID']['output']>;
  threadId?: Maybe<Scalars['UUID']['output']>;
  /** Product title of the item concerned */
  title?: Maybe<Scalars['String']['output']>;
  type: AccountActionType;
};

/**
 * Priority class of an open action. The server sorts BLOCKER, then TIME_BOUND,
 * then REGULAR; inside a class rows whose `deadline` has passed come first, then
 * by `occurredAt` descending (newest first), so this week's purchase sits above a
 * bid from last month. Deadline and type ordering were dropped on 2026-09-12
 * because they buried recent rows.
 */
export enum AccountActionPriority {
  Blocker = 'BLOCKER',
  Regular = 'REGULAR',
  TimeBound = 'TIME_BOUND'
}

/** Kind of open action shown on the account dashboard (WHO-5531). */
export enum AccountActionType {
  /** The buyer should confirm receipt of a delivered item */
  ConfirmReceipt = 'CONFIRM_RECEIPT',
  /** Curation asked for changes on a listing */
  CurationChangesRequested = 'CURATION_CHANGES_REQUESTED',
  /** Postal label is ready; the seller still has to ship */
  DownloadLabel = 'DOWNLOAD_LABEL',
  /** Postal label creation failed at the carrier; the seller must fix or retry */
  LabelFailed = 'LABEL_FAILED',
  /** Grouped: listings expiring within 14 days */
  ListingsExpiring = 'LISTINGS_EXPIRING',
  /** An Open Home offer was accepted: the owner adds dimensions, weight and delivery so the buyer can check out */
  OpenHomeAddDetails = 'OPEN_HOME_ADD_DETAILS',
  /** The latest open bid in a thread awaits this merchant's answer: a buyer's bid for the seller, a seller's counter-offer for the buyer */
  RespondToBid = 'RESPOND_TO_BID',
  /** Stripe Connect account exists but payouts are not enabled yet */
  StripeVerification = 'STRIPE_VERIFICATION',
  /** A thread with unread messages from the last 30 days */
  UnansweredMessage = 'UNANSWERED_MESSAGE',
  /** A completed purchase without a review yet */
  WriteReview = 'WRITE_REVIEW'
}

/**
 * A recent fact about the merchant's account. A fact that is still an open
 * action (a NEW bid, an unshipped order) is never also an activity.
 */
export type AccountActivity = {
  __typename?: 'AccountActivity';
  amount?: Maybe<Scalars['Float']['output']>;
  /** LISTING_FAVORITED: how many members saved the listing in the window */
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  /** An Open Home piece: its room, for the link to the piece (Open Home pieces have no product page) */
  openHomeRoomId?: Maybe<Scalars['UUID']['output']>;
  /** Order group of the order, for buyer-side deep links */
  orderGroupId?: Maybe<Scalars['UUID']['output']>;
  orderId?: Maybe<Scalars['UUID']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** FAVORITE_PRICE_LOWERED: the price before the drop */
  previousAmount?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['UUID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: AccountActivityType;
};

export enum AccountActivityType {
  BidAccepted = 'BID_ACCEPTED',
  BidRejected = 'BID_REJECTED',
  /** A listing the merchant saved got at least 5% cheaper (buyer side; amount is the new price, previousAmount the old) */
  FavoritePriceLowered = 'FAVORITE_PRICE_LOWERED',
  /** A listing the merchant saved was sold to someone else (buyer side) */
  FavoriteSold = 'FAVORITE_SOLD',
  ListingExpired = 'LISTING_EXPIRED',
  /** Members saved one of the merchant's listings (seller side; count is how many in the window) */
  ListingFavorited = 'LISTING_FAVORITED',
  ListingPublished = 'LISTING_PUBLISHED',
  ListingSold = 'LISTING_SOLD',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderDelivered = 'ORDER_DELIVERED',
  /** A sale of the merchant's listing (seller side; amount is the payout) */
  OrderPlaced = 'ORDER_PLACED',
  OrderShipped = 'ORDER_SHIPPED',
  PayoutSent = 'PAYOUT_SENT',
  /** A purchase by the merchant (buyer side; amount is the price paid). WHO-5531 round 4, F12. */
  PurchasePlaced = 'PURCHASE_PLACED'
}

/**
 * Aggregate behind the account dashboard (WHO-5531). One query, server-sorted.
 * Each block resolves on its own (WHO-5981): a block whose sources fail is null,
 * with an error whose path names that block, and the other blocks still return.
 */
export type AccountDashboard = {
  __typename?: 'AccountDashboard';
  /** The merchant has ever had a non-draft product */
  hasListings: Scalars['Boolean']['output'];
  /** The merchant has ever bought (an order as buyer not in NEW or EXPIRED) */
  hasPurchases: Scalars['Boolean']['output'];
  /** Null when the block failed to load */
  kpis?: Maybe<AccountKpis>;
  /** Sorted BLOCKER, TIME_BOUND, REGULAR; inside a class overdue first, then deadline, type, occurredAt. Null when the block failed to load */
  openActions?: Maybe<Array<AccountAction>>;
  /** Newest first, at most 10, nothing older than 30 days */
  recentActivity?: Maybe<Array<AccountActivity>>;
};

/** Headline numbers for the account dashboard. */
export type AccountKpis = {
  __typename?: 'AccountKpis';
  /** Products with the canonical ACTIVE status */
  activeAdsCount: Scalars['Int']['output'];
  /**
   * Sum of order payouts still to be received (EUR): sales in ACCEPTED, SHIPPED or
   * DELIVERED, created in the last 90 days, whose payout has not been sent yet.
   * DISPUTED is excluded on purpose — a disputed payout is uncertain, not expected.
   */
  expectedPayout: Scalars['Float']['output'];
  /** Latest NEW buyer bids per thread on the merchant's live listings, awaiting the merchant's answer */
  openBidsCount: Scalars['Int']['output'];
  /** Sales created in the current calendar year, excluding NEW, EXPIRED and CANCELED */
  soldThisYearCount: Scalars['Int']['output'];
};

/** Why a sale needs action, in precedence order. */
export enum ActionNeededCause {
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  /** A completed sale whose transfer waits on the seller's blocked Stripe account. */
  Held = 'HELD'
}

/** Input for adding a boost package to the package cart. */
export type AddBoostToPackageCartInput = {
  /** Number of days to boost the product. Defaults to 7 days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to apply the discounted package price. Defaults to false. */
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Explicit opt-in to a cart whose UI groups every listing. Defaults to legacy one-listing behavior. */
  preserveOtherListings?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the product to boost. */
  productId: Scalars['UUID']['input'];
};

/** Input for adding a listing-fee (PPL) package to the package cart. */
export type AddListingFeeToPackageCartInput = {
  /** ID of the chosen listing-fee (PPL) package. */
  listingFeePackageId: Scalars['UUID']['input'];
  /** Explicit opt-in to a cart whose UI groups every listing. */
  preserveOtherListings?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the product the listing fee applies to. */
  productId: Scalars['UUID']['input'];
};

/** Input for adding a single product to cart */
export type AddProductToCart = {
  /** ID of product to add */
  product_id: Scalars['UUID']['input'];
};

/** Input for adding multiple products to cart */
export type AddProductsToCart = {
  /** IDs of products to add */
  productIds: Array<Scalars['UUID']['input']>;
};

/** Add an already-created server quote without accepting payment terms implicitly. */
export type AddPromotionToPackageCartInput = {
  /** The caller renders all listings grouped before checkout. */
  preserveOtherListings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Owned, unexpired web quote containing the label and price context. */
  quoteId: Scalars['ID']['input'];
};

/** Input for adding a referral code to a merchant */
export type AddReferralCodeInput = {
  referral_code: Scalars['String']['input'];
};

/** Result of adding a referral code */
export type AddReferralCodeResult = {
  __typename?: 'AddReferralCodeResult';
  success: Scalars['Boolean']['output'];
};

/** Input for adding a product to the boost cart */
export type AddToBoostCartInput = {
  /**
   * Whether to clear existing items in the cart before adding
   * NOTE - We will always clear the cart before adding a new item.
   * @deprecated We will always clear the cart before adding a new item.
   */
  clearBeforeAdding?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Number of days to boost the product
   * Defaults to 7 days
   */
  days?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Discount to apply to the boost package
   * Defaults to False
   */
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the product to boost */
  productId: Scalars['UUID']['input'];
};

export type AdditionalInfo = AbstractAttribute & {
  __typename?: 'AdditionalInfo';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type AdditionalInfoMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type AdditionalInfoSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type AdditionalInfoTitleArgs = {
  lang?: InputMaybe<Language>;
};

/** Type representing a physical address in the system */
export type Address = {
  __typename?: 'Address';
  /** Indicates if this address can be safely deleted */
  can_be_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** City name */
  city: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  /** Country code (ISO format) */
  country: Scalars['String']['output'];
  /** Unique identifier for the address */
  id: Scalars['UUID']['output'];
  /**
   * Primary address line (street and house number)
   * Protected by @sensitive directive
   */
  line1: Scalars['String']['output'];
  /**
   * Secondary address line (apartment, suite, etc.)
   * Protected by @sensitive directive
   */
  line2?: Maybe<Scalars['String']['output']>;
  /**
   * Geographic coordinates of the address
   * Protected by @sensitive directive
   */
  location?: Maybe<Location>;
  /**
   * Postal/ZIP code
   * Protected by @sensitive directive
   */
  postal_code: Scalars['String']['output'];
  /**
   * State or province name
   * Protected by @sensitive directive
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   * Label for the address (e.g., 'Home', 'Office')
   * Protected by @sensitive directive
   */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating or updating an address */
export type AddressInput = {
  /** City name */
  city: Scalars['String']['input'];
  /** Optional company name for the invoice address, max 120 characters. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country code (ISO format) */
  country: Scalars['String']['input'];
  /** Primary address line (street and house number) */
  line1: Scalars['String']['input'];
  /** Secondary address line (apartment, suite, etc.) */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Geographic coordinates of the address */
  location?: InputMaybe<LocationInput>;
  /** ID of the merchant this address belongs to */
  merchant_id: Scalars['UUID']['input'];
  /**
   * Postal/ZIP code. It must have the format of the address's country (the same per-country
   * formats as whoppah-web), else `ADDRESS_POSTAL_CODE_INVALID`; on `updateAddress` only when the
   * postcode or the country changes. For a US address: five digits or ZIP+4 (`12345-6789`,
   * `12345 6789` or `123456789`, stored as `12345-6789`), else `US_ADDRESS_ZIP_INVALID`.
   */
  postal_code: Scalars['String']['input'];
  /**
   * State or province name (optional). Required for a US address, as the two-letter USPS
   * code (50 states and DC, any case, stored upper-case), else `US_ADDRESS_STATE_INVALID`.
   */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Optional label for the address (e.g., 'Home', 'Office') */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AgentAuthorizationDecision = {
  __typename?: 'AgentAuthorizationDecision';
  /** Where to send the member's browser next (the assistant's redirect URI). */
  redirectUrl: Scalars['String']['output'];
};

/**
 * The OAuth authorization request an AI assistant sent, as passed through to the
 * consent page on whoppah.com (WHO-6316). Every field is required by the server,
 * which validates the request again on approve or deny.
 */
export type AgentAuthorizationInput = {
  client_id: Scalars['String']['input'];
  code_challenge: Scalars['String']['input'];
  code_challenge_method: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  response_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

/** What the consent page shows the member before they decide. */
export type AgentAuthorizationRequest = {
  __typename?: 'AgentAuthorizationRequest';
  /** False while the pilot runs and this member is not on its allowlist. */
  canApprove: Scalars['Boolean']['output'];
  /** The assistant's client id (an https URL). */
  clientId: Scalars['String']['output'];
  /** The assistant's name, from its client metadata document. */
  clientName: Scalars['String']['output'];
  logoUri?: Maybe<Scalars['String']['output']>;
  /** Host the member returns to after deciding, so they can recognise the assistant. */
  redirectHost: Scalars['String']['output'];
  /** The scopes requested, for example offers:write. */
  scopes: Array<Scalars['String']['output']>;
};

/** An AI assistant the member has connected. */
export type AgentGrant = {
  __typename?: 'AgentGrant';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  scopes: Array<Scalars['String']['output']>;
};

/** The input for the AnalyzeProductImage mutation. */
export type AnalyzeProductImageInput = {
  /** The base64 encoded images to analyze. */
  image: Scalars['Base64']['input'];
};

/** The result of the AnalyzeProductImage mutation. */
export type AnalyzeProductImageResult = {
  __typename?: 'AnalyzeProductImageResult';
  /** The id of the image */
  imageId: Scalars['String']['output'];
};

/** The input for the AnalyzeProductImages mutation. */
export type AnalyzeProductImagesInput = {
  /** The images to analyze. */
  images: Array<ProductImageInput>;
  /** The language of the output. */
  lang: Language;
};

/** The result of the AnalyzeProductImages mutation. */
export type AnalyzeProductImagesResult = {
  __typename?: 'AnalyzeProductImagesResult';
  /** The feedback of the product */
  results: Array<ImageFeedback>;
};

/** The input for the AnalyzeProductTitleAndImages mutation. */
export type AnalyzeProductTitleAndImagesInput = {
  /** The description of the product. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The base64 encoded images to analyze. */
  images: Array<Scalars['Base64']['input']>;
  /** The language of the output. */
  lang?: InputMaybe<Language>;
  /** The title of the product. */
  title: Scalars['String']['input'];
  /** The tone of voice to use for the response. */
  toneOfVoice?: InputMaybe<ToneOfVoice>;
};

/** The result of the AnalyzeProductTitleAndImages mutation. */
export type AnalyzeProductTitleAndImagesResult = {
  __typename?: 'AnalyzeProductTitleAndImagesResult';
  /** The brand of the product */
  brand?: Maybe<Brand>;
  /** The brand suggestion of the product */
  brandSuggestion?: Maybe<Scalars['String']['output']>;
  /** The category of the product */
  category?: Maybe<Category>;
  /** The colors of the product */
  colors: Array<Color>;
  /** The description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** The dimensions of the product */
  dimensions?: Maybe<Dimensions>;
  /**
   * The feedback of the product images
   * @deprecated Use the `analyzeProductImages` mutation for getting image feedback instead.
   */
  feedback?: Maybe<Scalars['String']['output']>;
  /** The hardware color of the product (handbag-only) */
  hardwareColor?: Maybe<HardwareColor>;
  /** The materials of the product */
  materials: Array<Material>;
  /** The model of the product (handbag-only, free-form string) */
  model?: Maybe<Scalars['String']['output']>;
  /** The quality of the product */
  quality?: Maybe<ProductQuality>;
  /** The styles of the product */
  styles: Array<Style>;
  /** The usage signs of the product */
  usageSigns: Array<UsageSign>;
  /** The description of the usage signs */
  usageSignsDescription?: Maybe<Scalars['String']['output']>;
};

export type AppScreen = {
  __typename?: 'AppScreen';
  name: ScreenName;
  params?: Maybe<AppScreenParams>;
};

export type AppScreenParams = ChatScreenParams | ProductScreenParams | SearchScreenParams | UserAdsScreenParams;

/** Orientation options for artwork */
export enum ArtOrientation {
  /** Wider than tall */
  Landscape = 'LANDSCAPE',
  /** Taller than wide */
  Portrait = 'PORTRAIT',
  /** Equal width and height */
  Square = 'SQUARE'
}

/** Size categories for artwork */
export enum ArtSize {
  /** Large artwork */
  Large = 'LARGE',
  /** Medium-sized artwork */
  Medium = 'MEDIUM',
  /** Very small artwork */
  Mini = 'MINI',
  /** Small artwork */
  Small = 'SMALL',
  /** Extra large artwork */
  XLarge = 'X_LARGE'
}

export type Artist = AbstractActor & AbstractAttribute & {
  __typename?: 'Artist';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ArtistMediaArgs = {
  type?: InputMaybe<MediaType>;
};

/** Union type representing any kind of product attribute */
export type Attribute = AdditionalInfo | Artist | Brand | Color | Designer | HardwareColor | Label | Material | Style | Subject | UsageSign;

/**
 * Block for displaying and filtering products by their attributes.
 * Used for creating attribute-based navigation and filtering interfaces.
 */
export type AttributeBlock = AbstractBlock & {
  __typename?: 'AttributeBlock';
  /** List of attributes associated with this block for filtering products */
  attributes: Array<Attribute>;
  /** Unique identifier for the attribute block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the block's content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** Filter input for attribute queries */
export type AttributeFilter = {
  /** Filter key to apply */
  key?: InputMaybe<AttributeFilterKey>;
  /** Value to filter by */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Available filter keys for attribute queries */
export enum AttributeFilterKey {
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG',
  /** Filter by attribute type */
  Type = 'TYPE'
}

/** Paginated result of attribute queries */
export type AttributeResult = {
  __typename?: 'AttributeResult';
  /** List of attributes in the current page */
  items: Array<Attribute>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** Sort options for attribute queries */
export enum AttributeSort {
  /** Sort by title */
  Title = 'TITLE'
}

/** Enumeration of all available attribute types */
export enum AttributeType {
  /** Additional product information */
  AdditionalInfo = 'ADDITIONAL_INFO',
  /** Artist who created the product */
  Artist = 'ARTIST',
  /** Brand or manufacturer of the product */
  Brand = 'BRAND',
  /** Color of the product */
  Color = 'COLOR',
  /** Designer of the product */
  Designer = 'DESIGNER',
  /** Hardware (metal) finish color, used for bags */
  HardwareColor = 'HARDWARE_COLOR',
  /** Label associated with the product */
  Label = 'LABEL',
  /** Material the product is made of */
  Material = 'MATERIAL',
  /** Style or design category of the product */
  Style = 'STYLE',
  /** Subject or theme of the product */
  Subject = 'SUBJECT',
  /** Signs of usage or wear on the product */
  UsageSign = 'USAGE_SIGN'
}

/** Filter input for the attributesByCategory query */
export type AttributesFilter = {
  /**
   * Top-level category ID (a category with no parent). Matches attributes
   * linked to this category or any of its descendants. Passing a non-top-level
   * or unknown category ID raises an error.
   */
  category?: InputMaybe<Scalars['UUID']['input']>;
  /** Restrict results to one or more attribute types */
  types?: InputMaybe<Array<AttributeType>>;
};

/** Type representing an auction in the system */
export type Auction = {
  __typename?: 'Auction';
  /** Whether bidding is allowed on this auction */
  allow_bid: Scalars['Boolean']['output'];
  /** Whether immediate purchase is allowed */
  allow_buy_now: Scalars['Boolean']['output'];
  /** Number of bids placed on this auction */
  bid_count: Scalars['Int']['output'];
  /** All bids placed on this auction */
  bids: Array<Bid>;
  /** Immediate purchase price (Buy Now) */
  buy_now_price?: Maybe<Price>;
  /** For future auctions, when they will become available */
  coming_soon_time?: Maybe<Scalars['DateTime']['output']>;
  /** When the auction was created */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** When the auction ended (if completed) */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the auction is close to expiring */
  expiring?: Maybe<Scalars['Boolean']['output']>;
  /** When the auction will expire if not completed */
  expiry_date?: Maybe<Scalars['DateTime']['output']>;
  /** Current highest bid */
  highest_bid?: Maybe<Bid>;
  /** Unique identifier for the auction */
  id: Scalars['UUID']['output'];
  /** Human-readable auction identifier */
  identifier: Scalars['String']['output'];
  /**
   * Minimum accepted bid amount
   * Formatted by the Auction.minimum_bid resolver. Converted to its `currency` argument
   * (display-only, like sold_at); actual bid amounts stay in the listing currency.
   * With `precision: WHOLE` it rounds up, not half up (€ 314,30 → € 315), so a card never
   * shows a bid below the minimum the bid service enforces
   */
  minimum_bid?: Maybe<Price>;
  /** Product being auctioned */
  product: Product;
  /** Final sale price when auction completed */
  sold_at?: Maybe<Price>;
  /** When the auction starts accepting bids */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** Current state of the auction */
  state: AuctionState;
  /** When the auction was last updated */
  updated?: Maybe<Scalars['DateTime']['output']>;
};


/** Type representing an auction in the system */
export type AuctionBuy_Now_PriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


/** Type representing an auction in the system */
export type AuctionMinimum_BidArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


/** Type representing an auction in the system */
export type AuctionSold_AtArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** Input for creating a new auction */
export type AuctionInput = {
  /** Whether to allow bidding */
  allow_bid: Scalars['Boolean']['input'];
  /** Whether to allow immediate purchase */
  allow_buy_now: Scalars['Boolean']['input'];
  /** Optional immediate purchase price */
  buy_now_price?: InputMaybe<PriceInput>;
  /** Currency for the auction prices */
  currency: Currency;
  /** Optional minimum bid amount */
  minimum_bid?: InputMaybe<PriceInput>;
  /** ID of the product to auction */
  product_id: Scalars['UUID']['input'];
};

/** Possible states of an auction */
export enum AuctionState {
  /** Auction was banned by administrators */
  Banned = 'BANNED',
  /** Auction only accepts bids (no buy now option) */
  BidOnly = 'BID_ONLY',
  /** Auction was manually canceled */
  Canceled = 'CANCELED',
  /** Auction is scheduled to start in the future */
  ComingSoon = 'COMING_SOON',
  /** Auction has been successfully completed with a sale */
  Completed = 'COMPLETED',
  /** Auction is being prepared but not yet published */
  Draft = 'DRAFT',
  /** Auction reached its expiry date without being completed */
  Expired = 'EXPIRED',
  /** Auction is live and accepting bids */
  Published = 'PUBLISHED',
  /** Item is reserved for a buyer */
  Reserved = 'RESERVED'
}

/** Represents an audio asset in the system */
export type Audio = {
  __typename?: 'Audio';
  /** Unique identifier of the audio */
  id: Scalars['UUID']['output'];
  /** Get thumbnail image URL for the audio */
  thumbnail: Scalars['String']['output'];
  /** Type of the audio content */
  type: AudioType;
  /** URL to access the audio file */
  url: Scalars['String']['output'];
};


/** Represents an audio asset in the system */
export type AudioThumbnailArgs = {
  size?: InputMaybe<Size>;
};

/**
 * Block for displaying audio content.
 * Used for embedding audio players and playlists.
 */
export type AudioBlock = AbstractBlock & {
  __typename?: 'AudioBlock';
  /** List of audio files to be played */
  audios: Array<Audio>;
  /** Unique identifier for the audio block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the audio content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** Types of audio assets in the system */
export enum AudioType {
  Description = 'DESCRIPTION'
}

/** Bank account information for merchant payouts */
export type BankAccount = {
  __typename?: 'BankAccount';
  account_holder_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  routing_number?: Maybe<Scalars['String']['output']>;
};

/** Input for creating/updating bank account details */
export type BankAccountInput = {
  account_holder_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  routing_number?: InputMaybe<Scalars['String']['input']>;
};

/** Review binding for a single shared payment; amounts always come from the server. */
export type BeginPackageCheckoutInput = {
  /** Stable retry key for this payment attempt. */
  idempotencyKey: Scalars['String']['input'];
  /** One affirmative agreement for every promotion quote in the cart. */
  promotionConsents: Array<PackagePromotionConsentInput>;
  /** Fingerprint returned for the exact cart the seller reviewed. */
  reviewedCartFingerprint: Scalars['String']['input'];
};

/**
 * Represents a bid placed on an auction.
 * Contains all information about an offer including buyer, seller, amount, and current state.
 */
export type Bid = {
  __typename?: 'Bid';
  /** Bid amount and currency */
  amount: Price;
  /** The auction this bid was placed on */
  auction: Auction;
  /** The merchant who placed the bid */
  buyer: Merchant;
  /** ID of the buyer merchant */
  buyerId: Scalars['UUID']['output'];
  /** State from which the bid was canceled (if applicable) */
  canceledFromState?: Maybe<BidCanceledFromState>;
  /** When the bid was created */
  created: Scalars['DateTime']['output'];
  /**
   * Display only: `amount` in its `currency` argument, for the buyer. The
   * listing's owner (the seller) gets `amount` unchanged, and so does a read
   * without `currency`. A buyer who typed a whole amount reads their own bid
   * (not a counter offer) back as that amount, as long as the rate has not moved
   * since, or as the buy-now when the bid bought at it and was stored at the
   * buy-now (which can be a penny off what they typed); a bid typed with cents can
   * read back a cent off. Never send it back as
   * a bid amount: `amount` is the negotiated, charged amount.
   */
  displayAmount: Price;
  /** When the bid ended (accepted/rejected/canceled) */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** When the bid will expire */
  expiry_date: Scalars['DateTime']['output'];
  /** Unique identifier for the bid */
  id: Scalars['UUID']['output'];
  /** Whether this is a counter-offer */
  is_counter: Scalars['Boolean']['output'];
  /** The merchant who received the bid */
  merchant: Merchant;
  /** ID of the seller merchant */
  merchantId: Scalars['UUID']['output'];
  /** Initial message sent with the bid */
  message?: Maybe<Message>;
  /** Associated order if bid was accepted */
  order?: Maybe<Order>;
  /** Current state of the bid */
  state: BidState;
  /** Associated message thread between buyer and seller */
  thread?: Maybe<Thread>;
};


/**
 * Represents a bid placed on an auction.
 * Contains all information about an offer including buyer, seller, amount, and current state.
 */
export type BidDisplayAmountArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** States from which a bid can be canceled */
export enum BidCanceledFromState {
  /** Cancel an accepted bid before completion */
  Accepted = 'ACCEPTED',
  /** Cancel a new, unprocessed bid */
  New = 'NEW'
}

/** Reasons why a bid might be canceled */
export enum BidCancellationReason {
  /** Testing the bidding system */
  BidsTested = 'BIDS_TESTED',
  /** Delivery timeline is too long */
  DeliveryTakesTooLong = 'DELIVERY_TAKES_TOO_LONG',
  /** Buyer found an alternative item */
  FoundAnotherItem = 'FOUND_ANOTHER_ITEM',
  /** Buyer lacks necessary funds */
  NoFundingAvailable = 'NO_FUNDING_AVAILABLE',
  /** Item is no longer needed */
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  /** Other unspecified reason */
  Other = 'OTHER',
  /** Shipping costs are not clear */
  TransportCostsUnclear = 'TRANSPORT_COSTS_UNCLEAR'
}

/** Filter input for bid-related queries */
export type BidFilter = {
  /** Filter key to apply */
  key: BidFilterKey;
  /** Value to filter by */
  value: Scalars['String']['input'];
};

/** Available filter keys for querying bids */
export enum BidFilterKey {
  /** Filter by specific auction */
  Auction = 'AUCTION',
  /** Filter by merchant who placed or received the bid */
  Merchant = 'MERCHANT',
  /** Filter by product being bid on */
  Product = 'PRODUCT'
}

/** Input for creating a new bid on an auction */
export type BidInput = {
  /** Bid amount and currency. A non-listing-currency amount (a display-currency bid) is converted to the auction's currency at the live rate at placement; the bid is stored and evaluated in the auction's currency */
  amount: PriceInput;
  /** ID of the auction to bid on */
  auction_id: Scalars['UUID']['input'];
  /** Whether to create a message thread with the seller */
  create_thread?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Paginated result type for bid queries.
 * Contains both the matched bids and pagination metadata.
 */
export type BidResult = {
  __typename?: 'BidResult';
  /** List of bids matching the query criteria */
  items: Array<Bid>;
  /** Pagination information including total count and page data */
  pagination: PaginationResult;
};

/** Available sorting options for bid queries */
export enum BidSort {
  /** Sort by creation timestamp */
  Created = 'CREATED',
  /** Default sorting behavior */
  Default = 'DEFAULT',
  /** Sort by associated product name */
  Name = 'NAME',
  /** Sort by last update timestamp */
  Updated = 'UPDATED'
}

/** Possible states of a bid throughout its lifecycle */
export enum BidState {
  /** Bid has been accepted by the seller */
  Accepted = 'ACCEPTED',
  /** Bid has been canceled by either party */
  Canceled = 'CANCELED',
  /** Transaction has been completed */
  Completed = 'COMPLETED',
  /** Bid has expired without response */
  Expired = 'EXPIRED',
  /** Newly placed bid awaiting response */
  New = 'NEW',
  /** Payment is being processed */
  Processing = 'PROCESSING',
  /** Bid has been rejected by the seller */
  Rejected = 'REJECTED'
}

/** Union type representing all possible block types */
export type Block = AttributeBlock | AudioBlock | CallToActionBlock | CategoriesBlock | CategoryBlock | CollectionBlock | EmbeddedMessageBlock | ImageBlock | MemberBlock | MerchantBlock | ProductBlock | QueryBlock | SearchProductsBlock | TextBlock | VideoBlock;

/**
 * Input type for filtering block queries.
 * Allows for flexible filtering of blocks based on key-value pairs.
 */
export type BlockFilter = {
  /** The attribute key to filter by */
  key?: InputMaybe<AttributeFilterKey>;
  /** The value to match against the chosen key */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Available filter keys for querying blocks.
 * Used to filter blocks by specific attributes.
 */
export enum BlockFilterKey {
  /** Filter by block placement location */
  Location = 'LOCATION',
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG'
}

/**
 * Possible locations where a content block can be placed within a page layout.
 * Each location represents a specific section of the page template.
 */
export enum BlockLocation {
  /** Left sidebar area */
  AsideLeft = 'ASIDE_LEFT',
  /** Right sidebar area */
  AsideRight = 'ASIDE_RIGHT',
  /** Main content area of the page */
  Body = 'BODY',
  /** Footer section of the page */
  Footer = 'FOOTER',
  /** Main header section of the page */
  Header = 'HEADER'
}

/**
 * Paginated result type for block queries.
 * Provides both pagination information and the matched blocks.
 */
export type BlockResult = {
  __typename?: 'BlockResult';
  /** List of blocks matching the query criteria */
  items: Array<Block>;
  /** Pagination metadata including total count and page information */
  pagination: PaginationResult;
};

/**
 * Available sorting options for block listings.
 * Determines the order in which blocks are returned.
 */
export enum BlockSort {
  /** Sort blocks by their placement location */
  Location = 'LOCATION',
  /** Sort blocks alphabetically by title */
  Title = 'TITLE'
}

/** Type representing the boost cart and its contents */
export type BoostCart = {
  __typename?: 'BoostCart';
  /** List of items in the boost cart to be boosted */
  items: Array<BoostCartItem>;
  /**
   * List of products in the cart to be boosted
   * @deprecated Use boostCart.items instead
   */
  products: Array<Product>;
  /** Total cost for boosting all products in the cart */
  total: Price;
};

/** Type representing an item in the boost cart */
export type BoostCartItem = {
  __typename?: 'BoostCartItem';
  /** The boost package being used */
  boostPackage: BoostPackage;
  /** The product being boosted */
  product: Product;
};

export type BoostPackage = {
  __typename?: 'BoostPackage';
  /** Number of days the product is boosted */
  days: Scalars['Int']['output'];
  /** Discounted price of the boost package */
  discountedPrice: Price;
  /** ID of the boost package */
  id: Scalars['UUID']['output'];
  /** Whether the boost package is the most popular */
  isMostPopular: Scalars['Boolean']['output'];
  /** Original price of the boost package */
  originalPrice: Price;
};

/**
 * Type representing a boost payment intent
 * Used for client-side payment processing
 */
export type BoostPayment = {
  __typename?: 'BoostPayment';
  /**
   * Client secret for processing the payment
   * Used with payment provider's SDK
   */
  paymentClientSecret: Scalars['String']['output'];
  /** ID of the payment intent (e.g., Stripe payment intent ID) */
  paymentIntentId: Scalars['String']['output'];
};

/** Boost status for a product */
export enum BoostStatus {
  /** Boost is currently active */
  Active = 'ACTIVE',
  /** No active boost on this product */
  Inactive = 'INACTIVE',
  /** Boost is purchased and will start when eligible */
  Pending = 'PENDING'
}

/** Type representing a product brand */
export type Brand = AbstractActor & AbstractAttribute & {
  __typename?: 'Brand';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** Associated listing page for the brand */
  listingPage?: Maybe<ListingPage>;
  media: Array<Media>;
  /** Whether this is a popular brand */
  popular: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  /** Whether this is a super popular brand */
  superPopular: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


/** Type representing a product brand */
export type BrandDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing a product brand */
export type BrandMediaArgs = {
  type?: InputMaybe<MediaType>;
};

/** Filter input for brand queries */
export type BrandsFilter = {
  /** Filter for designer brands */
  isDesignerBrand?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for popular brands */
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for super popular brands */
  superPopular?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a scheduled delivery appointment with Brenger */
export type BrengerAppointment = {
  __typename?: 'BrengerAppointment';
  /** API version used (1 or 2) */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Details of merchant who needs to respond */
  awaitingResponseFrom?: Maybe<Merchant>;
  /** ID of merchant who needs to respond */
  awaitingResponseFromId?: Maybe<Scalars['UUID']['output']>;
  /** Associated shipment details */
  brengerShipment?: Maybe<BrengerShipment>;
  /** Buying merchant details */
  buyer: Merchant;
  /** ID of the buying merchant */
  buyerId: Scalars['UUID']['output'];
  /** Date when appointment was finalized */
  finalisedDate?: Maybe<Scalars['Date']['output']>;
  /** Whether there are proposed dates pending */
  hasProposedDates: Scalars['Boolean']['output'];
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** Selling merchant details */
  merchant: Merchant;
  /** ID of the selling merchant */
  merchantId: Scalars['UUID']['output'];
  /** Associated order details */
  order: Order;
  /** Associated order ID */
  orderId: Scalars['UUID']['output'];
  /** Type of appointment (delivery/return) */
  type: BrengerAppointmentType;
};

/** Available scheduling options for a Brenger appointment */
export type BrengerAppointmentOptions = {
  __typename?: 'BrengerAppointmentOptions';
  /** Details of merchant who needs to respond */
  awaitingResponseFrom?: Maybe<Merchant>;
  /** ID of merchant who needs to respond */
  awaitingResponseFromId?: Maybe<Scalars['UUID']['output']>;
  /** Start of available date range */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** End of available date range */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Whether appointment is finalized */
  finalised: Scalars['Boolean']['output'];
  /** Dates that cannot be selected */
  unavailableDates?: Maybe<Array<UnavailableDate>>;
};

/** Type of Brenger appointment */
export enum BrengerAppointmentType {
  /** Initial delivery appointment */
  Delivery = 'DELIVERY',
  /** Return shipment appointment */
  Return = 'RETURN'
}

/** Input for proposing delivery dates */
export type BrengerDatesProposalInput = {
  /** Proposed delivery dates */
  dates: Array<Scalars['Date']['input']>;
  /** Order to propose dates for */
  orderId: Scalars['UUID']['input'];
};

/** A proposed date for Brenger delivery */
export type BrengerProposedDate = {
  __typename?: 'BrengerProposedDate';
  /** Associated appointment ID */
  brengerAppointmentId: Scalars['UUID']['output'];
  /** Proposed delivery date */
  date: Scalars['Date']['output'];
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** Details of merchant who proposed the date */
  merchant: Merchant;
  /** ID of merchant who proposed the date */
  merchantId: Scalars['UUID']['output'];
  /** Current state of the proposal */
  state: BrengerProposedDateState;
};

/** State of a proposed delivery date */
export enum BrengerProposedDateState {
  /** Date was accepted */
  Accepted = 'ACCEPTED',
  /** Newly proposed date */
  New = 'NEW',
  /** Date was rejected */
  Rejected = 'REJECTED'
}

/** Collection of proposed delivery dates */
export type BrengerProposedDates = {
  __typename?: 'BrengerProposedDates';
  /** List of proposed dates */
  proposedDates: Array<BrengerProposedDate>;
};

/** Represents a shipment handled by Brenger delivery service */
export type BrengerShipment = {
  __typename?: 'BrengerShipment';
  /** API version used (1 or 2) */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Currency code (e.g. EUR) */
  currency?: Maybe<Scalars['String']['output']>;
  /** Buyer enrichment/tracking URL (v2) */
  deliveryUrl?: Maybe<Scalars['String']['output']>;
  /** Status change events (v2) */
  events?: Maybe<Array<BrengerShipmentEvent>>;
  /** External reference sent to Brenger */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Internal shipment identifier */
  id: Scalars['UUID']['output'];
  /** Seller enrichment/tracking URL (v2) */
  pickupUrl?: Maybe<Scalars['String']['output']>;
  /** Price excluding VAT */
  priceExclVat?: Maybe<Scalars['Float']['output']>;
  /** Price including VAT */
  priceInclVat?: Maybe<Scalars['Float']['output']>;
  /** VAT amount */
  priceVat?: Maybe<Scalars['Float']['output']>;
  /** External Brenger shipment identifier */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** Generic shipment tracking URL (v2) */
  shipmentUrl?: Maybe<Scalars['String']['output']>;
  /** Current state of the shipment (v1) */
  state?: Maybe<Scalars['String']['output']>;
  /** Current v2 shipment status */
  status?: Maybe<BrengerShipmentStatus>;
  /** When the status was last updated */
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A status change event for a Brenger shipment */
export type BrengerShipmentEvent = {
  __typename?: 'BrengerShipmentEvent';
  /** Unique event identifier */
  id: Scalars['ID']['output'];
  /** Status at time of event */
  status: BrengerShipmentStatus;
  /** When the event occurred */
  timestamp: Scalars['DateTime']['output'];
};

/** Shipment status values from Brenger v2 API */
export enum BrengerShipmentStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Expired = 'EXPIRED',
  PickedUp = 'PICKED_UP',
  RescheduleSeller = 'RESCHEDULE_SELLER',
  ScheduleBuyer = 'SCHEDULE_BUYER',
  ScheduleSeller = 'SCHEDULE_SELLER',
  SchedulingComplete = 'SCHEDULING_COMPLETE'
}

/** A 5-minute token the web page holds in memory, minted from the session cookie (WHO-6344) */
export type BrowserToken = {
  __typename?: 'BrowserToken';
  /** Member token for HTTP and WebSocket calls; cannot mint further tokens */
  accessToken: Scalars['String']['output'];
  /** When the ticket expires */
  expiresAt: Scalars['DateTime']['output'];
};

/** Buyer view of a reservation. Never carries anything about the seller. */
export type BuyerReservation = {
  __typename?: 'BuyerReservation';
  /**
   * While ACCEPTED: the lower of the price frozen at acceptance and the current
   * buy-now or Pro Buyer price. Null otherwise. Converted to its `currency`
   * argument like the buy-now price it is compared with (multi-currency,
   * WHO-5141, WHO-5947 F26).
   */
  fixedPrice?: Maybe<Price>;
  id: Scalars['UUID']['output'];
  productId: Scalars['UUID']['output'];
  productImage?: Maybe<Scalars['String']['output']>;
  productSlug: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  /**
   * WHO-5959 6e. The buyer's own Pro Buyer project this was reserved for, if it
   * still exists. Null while the `pro_buyer_projects` flag is off or the viewer
   * has no access to projects. There is no project on SellerReservation.
   */
  project?: Maybe<ReservationProject>;
  requestExpiresAt: Scalars['DateTime']['output'];
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  status: ReservationStatus;
};


/** Buyer view of a reservation. Never carries anything about the seller. */
export type BuyerReservationFixedPriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

export enum CalculationMethod {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

/**
 * Block for displaying interactive call-to-action elements.
 * Used for creating prominent buttons and links with translated text.
 */
export type CallToActionBlock = {
  __typename?: 'CallToActionBlock';
  /** Text displayed on the button */
  buttonText: Scalars['String']['output'];
  /** Unique identifier for the CTA block */
  id: Scalars['UUID']['output'];
  /** Main text content of the CTA */
  text: Scalars['String']['output'];
  /** Target URL for the CTA */
  url: Scalars['String']['output'];
};


/**
 * Block for displaying interactive call-to-action elements.
 * Used for creating prominent buttons and links with translated text.
 */
export type CallToActionBlockButtonTextArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Block for displaying interactive call-to-action elements.
 * Used for creating prominent buttons and links with translated text.
 */
export type CallToActionBlockTextArgs = {
  lang?: InputMaybe<Language>;
};

/** Input for canceling an existing bid */
export type CancelBidInput = {
  /** Custom reason if 'OTHER' is selected */
  customReason?: InputMaybe<Scalars['String']['input']>;
  /** ID of the bid to cancel */
  id: Scalars['UUID']['input'];
  /** Predefined reason for cancellation */
  reason?: InputMaybe<BidCancellationReason>;
};

/** Type representing a shopping cart */
export type Cart = {
  __typename?: 'Cart';
  /**
   * @deprecated Use billing_address and shipping_address
   * Legacy address field
   * @deprecated Use billing_address and shipping_address
   */
  address?: Maybe<Address>;
  /** List of coupon codes available for this cart */
  available_coupon_codes: Array<CouponCode>;
  /** Billing address for the order */
  billing_address?: Maybe<Address>;
  /**
   * @deprecated Use buyer_protection in cart item
   * Legacy buyer protection flag
   * @deprecated Use buyer_protection in cart item
   */
  buyer_protection?: Maybe<Scalars['Boolean']['output']>;
  /** Applied coupon code if any */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** When the cart was created */
  created: Scalars['DateTime']['output'];
  /**
   * Stripe Customer Session for client-side SDK access (e.g., Payment Element).
   * Cached until expiry, automatically refreshed when expired.
   */
  customerSession?: Maybe<CustomerSession>;
  /**
   * @deprecated Use delivery_method in cart item
   * Legacy delivery method
   * @deprecated Use delivery_method in cart item
   */
  delivery_method: DeliveryMethod;
  /** Unique identifier for the cart */
  id: Scalars['UUID']['output'];
  /** Items in the cart */
  items: Array<CartItem>;
  /**
   * @deprecated Use payment in orderGroup
   * Legacy payment information
   * @deprecated Use payment in orderGroup
   */
  payment?: Maybe<CartPayment>;
  /**
   * The Stripe payment-method configuration (pmc_…) checkout uses for this cart's delivery address.
   * Pass it as `paymentMethodConfiguration` to the Payment Element so it offers the same methods the
   * PaymentIntent accepts. Set for a US delivery address (cards, Apple Pay and Google Pay); null
   * everywhere else, meaning Stripe's default methods as today.
   */
  paymentMethodConfiguration?: Maybe<Scalars['String']['output']>;
  /** Selected payment method */
  payment_method: PaymentMethod;
  /** Shipping address for the order */
  shipping_address?: Maybe<Address>;
  /**
   * @deprecated Use totals2
   * Legacy totals calculation
   * @deprecated Use totals2
   */
  totals?: Maybe<OrderTotals>;
  /** Current cart totals */
  totals2?: Maybe<CartTotals>;
  /** When the cart was last updated */
  updated: Scalars['DateTime']['output'];
};

/** Type representing an item in the shopping cart */
export type CartItem = {
  __typename?: 'CartItem';
  /** Services available for this item */
  available_services: Array<CartItemService>;
  /** Associated bid if the item was added from a bid */
  bid?: Maybe<Bid>;
  /**
   * @deprecated Use shippingOptions instead
   * Legacy delivery method
   * @deprecated Use shippingOptions instead
   */
  delivery_method?: Maybe<DeliveryMethod>;
  /**
   * @deprecated Use shippingOptions instead
   * Legacy external shipping cost field
   * @deprecated Use shippingOptions instead
   */
  externalShippingCost?: Maybe<Price>;
  /**
   * @deprecated Use shippingOptions instead
   * Legacy external delivery flag
   * @deprecated Use shippingOptions instead
   */
  external_delivery?: Maybe<Scalars['Boolean']['output']>;
  /**
   * @deprecated Use shippingOptions instead
   * Legacy external delivery availability flag
   * @deprecated Use shippingOptions instead
   */
  external_delivery_available?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the cart item */
  id: Scalars['UUID']['output'];
  /** The regular buy-now price. Set only when the Pro Buyer price is applied. */
  listPrice?: Maybe<Price>;
  /** WHO-6309 D7: the line price excl. VAT; null unless the viewer is a business merchant and the item is STANDARD. */
  priceExclVat?: Maybe<Price>;
  /**
   * True when this line's subtotal went up since the previous recalculation
   * (seller switched the discount off, or Pro Buyer status revoked).
   */
  priceIncreased: Scalars['Boolean']['output'];
  /** listPrice minus subtotal; null when the Pro Buyer price is not applied. */
  proBuyerDiscount?: Maybe<Price>;
  /** The seller's Pro Buyer percentage applied to this line; null when not applied. */
  proBuyerPct?: Maybe<Scalars['Int']['output']>;
  /** WHO-6629 R9. The project this line is bought for (cart owner only; null otherwise). */
  proBuyerProject?: Maybe<ProBuyerProjectRef>;
  /** WHO-6629 R9. The viewer's live projects that hold this product (cart owner only). */
  proBuyerProjectsWithProduct?: Maybe<Array<ProBuyerProjectRef>>;
  /** The product being purchased */
  product: Product;
  /**
   * @deprecated Not needed anymore
   * Legacy service type field
   * @deprecated Not needed anymore
   */
  service_type?: Maybe<ServiceType>;
  /** Selected shipping cost if applicable */
  shipping?: Maybe<Price>;
  /**
   * @deprecated Use shippingOptions instead
   * Legacy shipping cost field
   * @deprecated Use shippingOptions instead
   */
  shippingCost?: Maybe<Price>;
  /**
   * Available shipping options for this item
   * Can be filtered by language
   */
  shippingOptions: Array<ShippingOption>;
  /** Price of the item before shipping and services */
  subtotal: Price;
  /** Total price including item, shipping, and services */
  total: Price;
  /** WHO-6309: the item's effective VAT regime. Null while the flag is off. */
  vatRegime?: Maybe<VatRegime>;
};


/** Type representing an item in the shopping cart */
export type CartItemShippingOptionsArgs = {
  lang?: InputMaybe<Language>;
};

/** The import-charges estimate checkout showed for one cart line. */
export type CartItemImportChargesEstimateInput = {
  /** Estimated import VAT plus duty, in EUR. Not charged by Whoppah. */
  amount: Scalars['Float']['input'];
  cartItemId: Scalars['UUID']['input'];
};

/** Type representing a service attached to a cart item */
export type CartItemService = {
  __typename?: 'CartItemService';
  /** Whether this service is currently active for the item */
  active: Scalars['Boolean']['output'];
  /** Whether this service can be applied to the item */
  eligible: Scalars['Boolean']['output'];
  /** Unique identifier for this service instance */
  id: Scalars['String']['output'];
  /** Error message if service application failed */
  ineligibleError?: Maybe<Scalars['String']['output']>;
  /** Reason why the service cannot be applied, if ineligible */
  ineligibleReason?: Maybe<Scalars['String']['output']>;
  /** Price of the service if applicable */
  price?: Maybe<Price>;
  /** The service configuration */
  service: Service;
};


/** Type representing a service attached to a cart item */
export type CartItemServiceIneligibleErrorArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing a service attached to a cart item */
export type CartItemServiceIneligibleReasonArgs = {
  lang?: InputMaybe<Language>;
};

/** Type representing payment details for a cart */
export type CartPayment = {
  __typename?: 'CartPayment';
  /** Client secret for processing the payment */
  payment_client_secret: Scalars['String']['output'];
  /** ID of the payment intent (e.g., Stripe payment intent) */
  payment_intent_id: Scalars['String']['output'];
};

/** Type representing the total costs breakdown for a cart */
export type CartTotals = {
  __typename?: 'CartTotals';
  /**
   * The total in `currency`, a guide shown small next to the EUR total, with a
   * line that the buyer's bank converts at its own rate (WHO-5991 decision 5).
   * Converted once from the EUR total, never summed from converted lines, and a
   * guide only. On a cart the total is a preview of the charge, not a quote: the
   * orders can still differ (for example VAT removed for a reverse-VAT business
   * buyer). On an order (`Order.totals`) it is what that order charged. Every
   * other amount here stays EUR. Null when `currency` is omitted, is EUR, or has
   * no rate.
   */
  convertedTotal?: Maybe<Price>;
  /**
   * On a cart: the promo code (coupon) discount only, without the buyer's merchant discount (see
   * `merchantDiscount`). On an order (`Order.totals`): every discount on that order, coupon and
   * merchant discount together, as it is stored.
   */
  discount?: Maybe<Price>;
  /**
   * On a cart: the buyer's merchant (B2B) discount, set per buying merchant; zero when there is none.
   * Shown as its own line, never as a promo code (WHO-6060). Null on an order, whose `discount`
   * already includes it.
   */
  merchantDiscount?: Maybe<Price>;
  /** Total cost of all selected services */
  serviceCost?: Maybe<Price>;
  /** Breakdown of service costs */
  services: Array<CartTotalsServices>;
  /** Total shipping costs */
  shipping?: Maybe<Price>;
  /** Sum of all item prices before additional costs */
  subtotal?: Maybe<Price>;
  /** Final total including all costs and discounts */
  total?: Maybe<Price>;
};


/** Type representing the total costs breakdown for a cart */
export type CartTotalsConvertedTotalArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** Type representing service costs in cart totals */
export type CartTotalsServices = {
  __typename?: 'CartTotalsServices';
  /** Cost of the service */
  price: Price;
  /** Service configuration */
  service: Service;
};

/**
 * Block for displaying category navigation and listings.
 * Used for creating category browsing interfaces and navigation menus.
 */
export type CategoriesBlock = {
  __typename?: 'CategoriesBlock';
  /** List of categories to display */
  categories: Array<Category>;
  /** Unique identifier for the categories block */
  id: Scalars['UUID']['output'];
};

/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type Category = MediaQueries & {
  __typename?: 'Category';
  /** Child categories under this category */
  children?: Maybe<Array<Maybe<Category>>>;
  /** Detailed description of the category */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon identifier for the category */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the category */
  id: Scalars['UUID']['output'];
  /** Single image of specified type */
  image?: Maybe<Image>;
  /** All images of specified type */
  images: Array<Image>;
  /**
   * Legacy field for child categories
   * @deprecated Use Category.children.
   */
  items: Array<Category>;
  /** Depth level in the category hierarchy */
  level?: Maybe<Scalars['Int']['output']>;
  /** Optional URL that the category links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Associated listing page configuration */
  listingPage: ListingPage;
  /** All media assets associated with this category */
  media: Array<Media>;
  /** Parent category if this is a subcategory */
  parent?: Maybe<Category>;
  /** URL route for the category in the specified language */
  route?: Maybe<Scalars['String']['output']>;
  /** URL-friendly identifier in the specified language */
  slug: Scalars['String']['output'];
  /** SVG icon content or identifier */
  svgIcon?: Maybe<Scalars['String']['output']>;
  /** Name of the category in the specified language */
  title: Scalars['String']['output'];
  /** Single video of specified type */
  video?: Maybe<Video>;
  /** All videos of specified type */
  videos: Array<Video>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  popular?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryImageArgs = {
  type?: InputMaybe<ImageType>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryImagesArgs = {
  type?: InputMaybe<ImageType>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryMediaArgs = {
  type?: InputMaybe<MediaType>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryRouteArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategorySlugArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryTitleArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryVideoArgs = {
  type?: InputMaybe<VideoType>;
};


/**
 * Represents a product category in the system.
 * Categories form a hierarchical tree structure and can contain media assets.
 * Implements MediaQueries for handling associated media content.
 */
export type CategoryVideosArgs = {
  type?: InputMaybe<VideoType>;
};

/**
 * Block for displaying product categories.
 * Used for category navigation and browsing interfaces.
 */
export type CategoryBlock = AbstractBlock & {
  __typename?: 'CategoryBlock';
  /** List of product categories to display */
  categories: Array<Category>;
  /** Unique identifier for the category block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the block's content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/**
 * Input type for filtering categories.
 * Used to specify filter criteria when querying categories.
 */
export type CategoryFilter = {
  /** The attribute key to filter by */
  key: CategoryFilterKey;
  /** The value to match against the chosen key */
  value: Scalars['String']['input'];
};

/**
 * Filter keys available for querying categories.
 * Used to search and filter product categories.
 */
export enum CategoryFilterKey {
  /** Filter by category depth level */
  Level = 'LEVEL',
  /** Filter by parent category */
  Parent = 'PARENT',
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG'
}

/**
 * Paginated result type for category queries.
 * Contains both the matched categories and pagination metadata.
 */
export type CategoryResult = {
  __typename?: 'CategoryResult';
  /** List of categories matching the query criteria */
  items: Array<Category>;
  /** Pagination information including total count and page data */
  pagination: PaginationResult;
};

/**
 * Available sorting options for category listings.
 * Determines how categories are ordered in queries.
 */
export enum CategorySort {
  /** Sort by creation timestamp */
  Created = 'CREATED',
  /** Default sorting behavior */
  Default = 'DEFAULT',
  /** Sort by hierarchy level */
  Level = 'LEVEL',
  /** Sort by left value (tree structure) */
  Lft = 'LFT',
  /** Sort alphabetically by name */
  Name = 'NAME',
  /** Sort by tree identifier */
  TreeId = 'TREE_ID',
  /** Sort by last update timestamp */
  Updated = 'UPDATED'
}

export type ChatScreenParams = {
  __typename?: 'ChatScreenParams';
  threadId: Scalars['String']['output'];
};

/** Response type for email availability check */
export type CheckEmailExistsResponse = {
  __typename?: 'CheckEmailExistsResponse';
  /** Status indicating email availability */
  status?: Maybe<CheckEmailExistsStatus>;
};

/** Possible states when checking email availability */
export enum CheckEmailExistsStatus {
  /** Email is available for registration */
  Available = 'AVAILABLE',
  /** Email is banned from registration */
  Banned = 'BANNED',
  /** Email is already registered */
  Unavailable = 'UNAVAILABLE'
}

/** Options for cloneProduct. Every field is optional. */
export type CloneProductInput = {
  /** Title for the copy. When set, titleStyle is ignored. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to NUMBERED */
  titleStyle?: InputMaybe<CloneProductTitleStyle>;
};

/** How a duplicated listing is titled */
export enum CloneProductTitleStyle {
  /** Original title plus the next free Roman numeral among the seller's listings: "Chair I", "Chair II", ... */
  Numbered = 'NUMBERED',
  /** Exactly the original title */
  Same = 'SAME'
}

/**
 * Represents a curated collection of items.
 * Collections are used to group and organize products into themed or categorical sets.
 * They support internationalization for title and description.
 */
export type Collection = {
  __typename?: 'Collection';
  /**
   * Description of the collection in the specified language.
   * Provides context and details about the collection's theme or purpose.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Unique identifier of the collection.
   * Used as the primary key for collection records.
   */
  id: Scalars['UUID']['output'];
  /**
   * Featured image for the collection.
   * Primary visual representation used in collection listings and headers.
   */
  image: Scalars['String']['output'];
  /**
   * Associated listing page configuration.
   * Contains settings for how the collection's products are displayed and filtered.
   */
  listingPage?: Maybe<ListingPage>;
  /**
   * URL-friendly identifier of the collection.
   * Used in URLs and for SEO-friendly links to the collection.
   */
  slug: Scalars['String']['output'];
  /**
   * Title of the collection in the specified language.
   * Supports multiple languages for international markets.
   */
  title: Scalars['String']['output'];
};


/**
 * Represents a curated collection of items.
 * Collections are used to group and organize products into themed or categorical sets.
 * They support internationalization for title and description.
 */
export type CollectionDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Represents a curated collection of items.
 * Collections are used to group and organize products into themed or categorical sets.
 * They support internationalization for title and description.
 */
export type CollectionTitleArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Block for displaying curated collections of products.
 * Used for featuring themed product groups and special collections.
 */
export type CollectionBlock = {
  __typename?: 'CollectionBlock';
  /** The featured collection */
  collection: Collection;
  /** Unique identifier for the collection block */
  id: Scalars['UUID']['output'];
  /** Products in the collection with optional limit */
  products: Array<Product>;
  /** Whether to display the collection's featured image */
  showCollectionImage: Scalars['Boolean']['output'];
};


/**
 * Block for displaying curated collections of products.
 * Used for featuring themed product groups and special collections.
 */
export type CollectionBlockProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Color = AbstractAttribute & {
  __typename?: 'Color';
  description?: Maybe<Scalars['String']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ColorMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type ColorSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type ColorTitleArgs = {
  lang?: InputMaybe<Language>;
};

/** Type representing a coming soon alert in the system */
export type ComingSoonAlert = {
  __typename?: 'ComingSoonAlert';
  /** Timestamp when the alert was created */
  created: Scalars['DateTime']['output'];
  /** Unique identifier for the alert */
  id: Scalars['UUID']['output'];
  /** The product that the alert is for */
  product: Product;
};

/** Input for creating a new coming soon alert */
export type ComingSoonAlertInput = {
  /** ID of the product to be alerted about */
  product_id: Scalars['UUID']['input'];
};

/** Paginated result of coming soon alerts */
export type ComingSoonAlertResult = {
  __typename?: 'ComingSoonAlertResult';
  /** List of alerts in the current page */
  items: Array<ComingSoonAlert>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** WHO-6321: an AI agent pays for the member's cart with a Stripe Shared Payment Token. */
export type CompleteAgentCheckoutInput = {
  /** Total in cents the member confirmed in the assistant. Any other fresh total refuses the payment. */
  expectedAmountCents: Scalars['Int']['input'];
  /** Client-chosen key (8 to 128 chars). A retry with the same key returns the same order group. */
  idempotencyKey: Scalars['String']['input'];
  /** Stripe Shared Payment Token (spt_...) the assistant's platform granted for this purchase */
  sharedPaymentToken: Scalars['String']['input'];
};

export type Config = {
  __typename?: 'Config';
  /**
   * ISO-3166-1 alpha-2 codes a buyer can add a delivery address in and check out to:
   * every `supportedCountries` code, plus `US` once US checkout opens (WHO-4751).
   *
   * For buyer address pickers only. Seller address and create-ad pickers keep reading
   * `supportedCountries`, which never lists the US: selling from the US stays closed.
   * Deliberately not `Country`, so released app builds that read that enum never meet
   * a new value.
   */
  deliveryCountries: Array<Scalars['String']['output']>;
  /**
   * ISO-3166-1 alpha-2 codes a parcel can be collected in, i.e. the seller address
   * countries for which the postal shipping method can be offered at all.
   *
   * Deliberately not `Country`: the postal carrier's origin coverage and Whoppah's
   * supported-country enum are different sets (Norway is an origin but not a `Country`),
   * and this list grows as the carrier enables origins.
   */
  postalOriginCountries: Array<Scalars['String']['output']>;
  supportedCountries: Array<SupportedCountry>;
};

/**
 * One photo attached to a contact-form submission, inline.
 *
 * Inline base64 rather than a separate upload endpoint: the receiving contract
 * (`InboundAttachment` in whoppah-cs-channel-adapters) takes inline bytes, which
 * is the path every ordinary email attachment already travels, and five photos at
 * 1 MB is 5 MB against a 16 MB body limit here and 40 MB at the receiver. The
 * receiver forwards inline bytes up to 25 MB, and conversation-service keeps them
 * in the message row up to 8 MB and offloads anything larger to B2 by itself, so
 * this cap is ours to choose and not a property of the inbound path. An upload
 * endpoint would add a public unauthenticated upload surface for no gain at this
 * size.
 *
 * `contentType` is what the browser claimed. It is checked against the actual
 * leading bytes and a submission whose bytes disagree is refused, because a
 * support agent opens these files.
 */
export type ContactAttachmentInput = {
  /** The file, base64-encoded. Max 1 MB decoded. The client resizes to fit. */
  base64: Scalars['String']['input'];
  /** Claimed media type: image/jpeg or image/png. Verified against the bytes. */
  contentType: Scalars['String']['input'];
  /** Original filename. Sanitised server-side to a bare, safe filename. */
  filename: Scalars['String']['input'];
};

/**
 * The subject a contact-form submission is about.
 *
 * The label a support agent reads in the subject line is derived from this enum
 * server-side. It is deliberately NOT a caller-supplied string: the previous
 * implementation accepted a free-text `topicLabel` from the browser with no
 * allowlist and no length cap, straight into a subject line rendered under an
 * official-looking `[Contact form]` prefix.
 */
export enum ContactTopic {
  Account = 'ACCOUNT',
  Order = 'ORDER',
  Other = 'OTHER',
  Payments = 'PAYMENTS',
  Returns = 'RETURNS',
  Selling = 'SELLING'
}

export enum ContentType {
  Merchant = 'MERCHANT',
  Message = 'MESSAGE',
  Product = 'PRODUCT'
}

/** Input for creating a counter-offer to an existing bid */
export type CounterBidInput = {
  /** Counter-offer amount and currency. A non-listing-currency amount is converted to the auction's currency at the live rate at placement */
  amount: PriceInput;
  /** ID of the auction being bid on */
  auction_id: Scalars['UUID']['input'];
  /** ID of the original bidder */
  buyer_id: Scalars['UUID']['input'];
};

export enum Country {
  At = 'AT',
  Be = 'BE',
  Ch = 'CH',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  Hu = 'HU',
  It = 'IT',
  Lu = 'LU',
  Mc = 'MC',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Se = 'SE',
  Si = 'SI',
  Sk = 'SK'
}

export enum CountrySupportLevel {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

/** Type representing a coupon code and its associated discount */
export type CouponCode = {
  __typename?: 'CouponCode';
  /** The coupon code string */
  code: Scalars['String']['output'];
  /** Discount configuration for this coupon */
  discount: CouponCodeDiscount;
  /** Expiration date of the coupon */
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

/** Type representing a discount applied through a coupon code */
export type CouponCodeDiscount = {
  __typename?: 'CouponCodeDiscount';
  /**
   * The monetary discount as a typed amount — present only when `type` is AMOUNT, null for PERCENT.
   * Carries the voucher's own currency (EUR today) and is deliberately never display-converted:
   * a voucher is a fixed nominal credit applied server-side in that currency.
   */
  amount?: Maybe<Price>;
  /** Type of discount (percentage, fixed amount, etc.) */
  type: DiscountType;
  /**
   * Value of the discount: the percentage when `type` is PERCENT, the monetary amount when it is AMOUNT.
   * For AMOUNT discounts prefer `amount`, which carries the currency.
   */
  value: Scalars['Float']['output'];
};

/** Input for creating a draft product */
export type CreateDraftProductInput = {
  /** Initial product title. Optional: defaults to "Untitled draft" (create-ad v2 has no title before generation). */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMessageInput = {
  body: Scalars['String']['input'];
  threadId: Scalars['UUID']['input'];
};

/**
 * Input for recording an Open Home deal: a buyer made an offer on a piece in the seller's home
 * that was never listed. The piece becomes a product with an accepted bid, so the buyer checks
 * out exactly like any other accepted bid.
 */
export type CreateOpenHomeDealInput = {
  /** Address ID for pickup/delivery, as in ProductInput.address */
  address?: InputMaybe<Scalars['UUID']['input']>;
  /** Agreed price. Becomes the buy-now price, the minimum bid and the accepted bid amount. */
  amount: PriceInput;
  /** Merchant ID of the buyer (the same ID a Bid's buyer references) */
  buyerMerchantId: Scalars['UUID']['input'];
  /** Category ID */
  categoryId: Scalars['UUID']['input'];
  /** Product condition state */
  condition?: InputMaybe<ProductCondition>;
  /** Custom shipping prices, as in ProductInput.customShippingPrices */
  customShippingPrices?: InputMaybe<Array<CustomShippingPriceInput>>;
  /** Delivery method, as in ProductInput.delivery_method */
  delivery_method?: InputMaybe<DeliveryMethod>;
  /** Depth in centimeters. Required when the piece can be shipped. */
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Detailed product description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Height in centimeters. Required when the piece can be shipped. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Size category for postal shipping, as in ProductInput.postalPackageSize */
  postalPackageSize?: InputMaybe<PostalPackageSize>;
  /** Product quality level */
  quality?: InputMaybe<ProductQuality>;
  /** Shipping method ID, as in ProductInput.shipping_method */
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  /** Product title/name */
  title: Scalars['String']['input'];
  /** Whether the seller confirmed the piece fits the postal package, as in ProductInput.user_confirmed_postal_fit */
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight in kilograms. Required when the piece can be shipped. */
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** Width in centimeters. Required when the piece can be shipped. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating an order group for a cart */
export type CreateOrderGroupForCartInput = {
  /**
   * The buyer ticked the box accepting that, on a delivery crossing a customs border (into the
   * UK or Switzerland, or out of them into the EU), they pay the import VAT, any duty and the
   * courier's clearance fee on delivery, and that Whoppah collects none of it. Send true only
   * when the box was shown and ticked. False refuses the checkout with
   * IMPORT_CHARGES_NOT_ACCEPTED; omitted is accepted for clients that predate the box, and
   * nothing is stored.
   */
  importChargesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The import-charges estimate the checkout showed per delivery line, in EUR. Stored on the
   * order with the acceptance as what the buyer agreed to. Lines that cross no customs border
   * are ignored.
   */
  importChargesEstimates?: InputMaybe<Array<CartItemImportChargesEstimateInput>>;
  /**
   * ID of the payment method to use
   * Note - Used in apps
   */
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a payment for boost promotions */
export type CreatePaymentForBoostInput = {
  /**
   * @deprecated Use paymentMethodId instead
   * Legacy payment method enum
   * @deprecated Use paymentMethodId instead
   */
  paymentMethod?: InputMaybe<PaymentMethod>;
  /**
   * ID of the payment method to use (e.g., Stripe payment method ID)
   * Note - Used in apps
   */
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a payment for a listing fee package */
export type CreatePaymentForListingFeeInput = {
  /** ID of the listing fee package being purchased */
  listingFeePackageId: Scalars['UUID']['input'];
  /**
   * ID of the payment method to use (e.g., Stripe payment method ID).
   * Note - Used in apps.
   */
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product the listing fee applies to */
  productId: Scalars['UUID']['input'];
};

export type CreateThreadInput = {
  merchantId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
};

/** Type representing curator feedback */
export type CurationFeedback = {
  __typename?: 'CurationFeedback';
  /** Feedback message */
  message: Scalars['String']['output'];
  /** Feedback severity level */
  severity: CurationFeedbackSeverity;
};

/** Severity levels for curation feedback */
export enum CurationFeedbackSeverity {
  /** Critical issues that must be fixed */
  Error = 'ERROR',
  /** Suggestions for improvement */
  Warning = 'WARNING'
}

/** Type representing curation feedback reason */
export type CurationReason = {
  __typename?: 'CurationReason';
  /** Feedback message from curator */
  message?: Maybe<Scalars['String']['output']>;
  /** Standardized reason code */
  reason?: Maybe<Scalars['String']['output']>;
};

export enum Currency {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CursorPaginationInput = {
  from?: InputMaybe<Scalars['UUID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CursorPaginationResult = {
  __typename?: 'CursorPaginationResult';
  hasMore: Scalars['Boolean']['output'];
};

export type CustomShippingPrice = {
  __typename?: 'CustomShippingPrice';
  country: Country;
  price: Price;
};


export type CustomShippingPricePriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

export type CustomShippingPriceInput = {
  country: Country;
  price: PriceInput;
};

/** Type representing a Stripe Customer Session for client-side SDK access */
export type CustomerSession = {
  __typename?: 'CustomerSession';
  /** Single-use client secret for granting client-side API access */
  clientSecret: Scalars['String']['output'];
  /** Unix timestamp when the session expires */
  expiresAt: Scalars['Int']['output'];
};

/** Input for providing full delivery address data */
export type DeliveryAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use countryCode instead */
  country?: InputMaybe<Country>;
  countryCode: Scalars['CountryCode']['input'];
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
};

/** Input for selecting a delivery address by one strategy */
export type DeliveryAddressSelectorInput = {
  address?: InputMaybe<DeliveryAddressInput>;
  /** @deprecated Use address instead */
  country?: InputMaybe<Country>;
  /** @deprecated Use address instead */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Available delivery methods for orders */
export enum DeliveryMethod {
  /** Seller delivers to buyer */
  Delivery = 'DELIVERY',
  /** Buyer picks up from seller */
  Pickup = 'PICKUP',
  /** Combination of pickup and delivery options */
  PickupDelivery = 'PICKUP_DELIVERY'
}

/**
 * The buyer's own delivery quote. Never carries anything about the seller or the
 * courier.
 */
export type DeliveryQuote = {
  __typename?: 'DeliveryQuote';
  city: Scalars['String']['output'];
  deliveryType: DeliveryQuoteDeliveryType;
  /**
   * The delivery fee the buyer pays, set while QUOTED, PAID or EXPIRED; null while
   * REQUESTED. Charged in EUR; converted to the `currency` argument as a guide.
   */
  fee?: Maybe<Price>;
  id: Scalars['UUID']['output'];
  /** ZIP code the quote is for. */
  postalCode: Scalars['String']['output'];
  /** US state the quote is for. */
  region: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  status: DeliveryQuoteStatus;
  /** Until when the fee can be paid; null while REQUESTED. */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * The buyer's own delivery quote. Never carries anything about the seller or the
 * courier.
 */
export type DeliveryQuoteFeeArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

export enum DeliveryQuoteDeliveryType {
  /** Delivered to the front door. */
  Door = 'DOOR',
  /** Carried into the room of choice. */
  Room = 'ROOM'
}

/**
 * WHO-6499: US delivery by quote for courier listings (D7 as replaced on 28 Oct).
 * A signed-in US buyer asks for a quote; ops ask the courier and enter the fee in
 * the dashboard; the buyer pays it at checkout as Whoppah's delivery line. The fee
 * is never the seller's. Everything here is behind the gateway's
 * `US_CHECKOUT_ENABLED` switch: while it is off every field resolves null or false
 * and the mutation fails with FEATURE_DISABLED.
 */
export enum DeliveryQuoteStatus {
  /** The fee was not paid before `validUntil`; the buyer can request again. */
  Expired = 'EXPIRED',
  /** Someone else bought the item first; the quote is closed. */
  ItemSold = 'ITEM_SOLD',
  /** Paid with an order. */
  Paid = 'PAID',
  /** A fee is entered and can be paid until `validUntil`. */
  Quoted = 'QUOTED',
  /** Asked for; ops have not entered a fee yet. */
  Requested = 'REQUESTED'
}

/** Type representing a product designer */
export type Designer = AbstractActor & {
  __typename?: 'Designer';
  country_of_origin?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** Associated listing page for the designer */
  listingPage?: Maybe<ListingPage>;
  media: Array<Media>;
  /** Whether this is a popular designer */
  popular: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  /** Whether this is a super popular designer */
  superPopular: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


/** Type representing a product designer */
export type DesignerDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing a product designer */
export type DesignerMediaArgs = {
  type?: InputMaybe<MediaType>;
};

/** Filter input for designer queries */
export type DesignersFilter = {
  /** Filter for popular designers */
  popular?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for super popular designers */
  superPopular?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The Dimensions of a product. */
export type Dimensions = {
  __typename?: 'Dimensions';
  depth?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  seatHeight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']['output']>;
  type: CalculationMethod;
};

export enum DiscountType {
  Amount = 'AMOUNT',
  Percent = 'PERCENT'
}

export enum DisputeReason {
  NotAsAdvertised = 'NOT_AS_ADVERTISED',
  Other = 'OTHER',
  TransportDamage = 'TRANSPORT_DAMAGE'
}

/** Represents a document asset in the system */
export type Document = {
  __typename?: 'Document';
  /** Unique identifier of the document */
  id: Scalars['UUID']['output'];
  /** Get thumbnail image URL for the document */
  thumbnail: Scalars['String']['output'];
  /** Type of the document */
  type: DocumentType;
  /** URL to access the document file */
  url: Scalars['String']['output'];
};


/** Represents a document asset in the system */
export type DocumentThumbnailArgs = {
  size?: InputMaybe<Size>;
};

/** Why Whoppah asked Stripe for an extra identity document */
export enum DocumentRequestReason {
  /** Asked before the first payout: self-arranged shipping or a flagged bank */
  Immediate = 'IMMEDIATE',
  /** Lifetime payouts passed the volume threshold */
  Volume = 'VOLUME'
}

/** Types of document assets supported by the system */
export enum DocumentType {
  Default = 'DEFAULT',
  PassportBack = 'PASSPORT_BACK',
  PassportFront = 'PASSPORT_FRONT'
}

/**
 * Dynamic-pricing variant of ListingFeePackage (WHO-4942, opt-in). Identical to
 * ListingFeePackage except `price` is the asking-price-derived dynamic fee (bracket
 * rate, clamped to a floor and per-plan cap) rather than the static package price.
 * Returned only by `dynamicListingFeePackages`.
 */
export type DynamicListingFeePackage = {
  __typename?: 'DynamicListingFeePackage';
  /** ID of the listing fee package */
  id: Scalars['UUID']['output'];
  /** Stable identifier of the package (e.g. PLUSBUSINESS) */
  identifier: Scalars['String']['output'];
  /** Whether the package is currently selectable */
  isActive: Scalars['Boolean']['output'];
  /** Whether the package should be highlighted as most popular */
  isPopular: Scalars['Boolean']['output'];
  /** Merchant type the package applies to */
  merchantType: MerchantType;
  /**
   * Dynamic up-front price, computed from the product's asking price (bracket
   * rate, clamped to a floor and per-plan cap).
   */
  price: Price;
  /** Commission (percentage) charged on sale when this package is active */
  reducedFeeAmount: Scalars['Float']['output'];
  /**
   * Display title of the package (e.g. "Plus (Business)"). Pass `lang`
   * to fetch the localized title; falls back to English if missing.
   */
  title: Scalars['String']['output'];
};


/**
 * Dynamic-pricing variant of ListingFeePackage (WHO-4942, opt-in). Identical to
 * ListingFeePackage except `price` is the asking-price-derived dynamic fee (bracket
 * rate, clamped to a floor and per-plan cap) rather than the static package price.
 * Returned only by `dynamicListingFeePackages`.
 */
export type DynamicListingFeePackageTitleArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Dynamic-pricing variant of ListingFeePackageOption (WHO-4942, opt-in). The wrapped
 * `package` carries the dynamic `price`. Served by `dynamicListingFeePackages`.
 */
export type DynamicListingFeePackageOption = {
  __typename?: 'DynamicListingFeePackageOption';
  /**
   * The ad's asking price incl. VAT, rounded to the cent. Show it as is instead of
   * working it out from the other amounts (WHO-6156).
   */
  askingPrice: Price;
  /**
   * True when VAT is charged on top of the commission: a business seller who pays
   * VAT on fees. Show `feeVat` as its own line then (WHO-6156).
   */
  chargesVatOnFee: Scalars['Boolean']['output'];
  /**
   * Commission the merchant pays on sale on the ad's own terms (the Standard
   * row): ex VAT for a seller who pays VAT on fees (the VAT is `feeVat`),
   * else the VAT-inclusive fee. Worked out like `payoutQuote` (WHO-6156).
   */
  defaultCommission: Price;
  /**
   * The VAT charged on top of this row's commission: zero unless the seller is a
   * business that pays VAT on fees (`chargesVatOnFee`). The same amount the sale
   * charges and `payoutQuote.feeVat` returns for this rate (WHO-6156).
   */
  feeVat: Price;
  /** The selectable package, with its dynamic up-front `price`. */
  package: DynamicListingFeePackage;
  /**
   * Commission the merchant would pay on sale if this package were applied,
   * shown like `defaultCommission`.
   */
  packageCommission: Price;
  /**
   * What the merchant receives on sale if this package were applied: after the
   * commission and, for a seller who pays VAT on fees, `feeVat`. Matches
   * `payoutQuote` with the package applied (WHO-6156). Does not subtract the
   * up-front price.
   */
  payout: Price;
  /**
   * What the merchant keeps extra on sale with this package, the VAT on the
   * fee included. Does not subtract the up-front price.
   */
  savings: Price;
};

/** Response type for email token-based login */
export type EmailTokenLoginResponse = {
  __typename?: 'EmailTokenLoginResponse';
  /** URL to redirect the user after successful login */
  redirectUrl: Scalars['String']['output'];
  /** Authentication token for subsequent requests */
  token: Scalars['String']['output'];
  /** User details */
  user: Member;
};

/** Block for displaying an embedded message placement on the homepage. */
export type EmbeddedMessageBlock = {
  __typename?: 'EmbeddedMessageBlock';
  /** Unique identifier for the embedded message block */
  id: Scalars['UUID']['output'];
  /** External embedded message placement identifier */
  placementId: Scalars['Int']['output'];
};

/**
 * Empty type used as a placeholder for filters without associated models
 * TODO: Consider alternative design patterns to eliminate this workaround
 */
export type Empty = {
  __typename?: 'Empty';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export enum Entity {
  Category = 'CATEGORY',
  FavoriteCollection = 'FAVORITE_COLLECTION',
  Merchant = 'MERCHANT',
  Product = 'PRODUCT'
}

export enum Event {
  Bid = 'BID',
  Buy = 'BUY',
  Like = 'LIKE',
  Message = 'MESSAGE',
  Question = 'QUESTION',
  Share = 'SHARE',
  View = 'VIEW'
}

export type ExternalBankAccount = {
  __typename?: 'ExternalBankAccount';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_name: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Currency;
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  /**
   * Stripe's status for the account payouts go to. `new` is the normal state;
   * `errored` means the last payout to it bounced and Stripe has stopped scheduled
   * payouts until the details change. Null for an account only stored on Whoppah
   * so far.
   */
  status?: Maybe<Scalars['String']['output']>;
};

export type ExternalBankAccountInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
};

/** Type representing an external shipping method */
export type ExternalShippingMethod = {
  __typename?: 'ExternalShippingMethod';
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Shipping cost */
  price: Price;
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** Display name */
  title: Scalars['String']['output'];
};


/** Type representing an external shipping method */
export type ExternalShippingMethodPriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** Type representing a favorited item */
export type Favorite = {
  __typename?: 'Favorite';
  /** Collection this favorite belongs to (if any) */
  collection?: Maybe<FavoriteCollection>;
  /** Timestamp when the favorite was created */
  created: Scalars['DateTime']['output'];
  /** Unique identifier for the favorite */
  id: Scalars['UUID']['output'];
  /** The favorited item (Product or Merchant) */
  item: FavoriteItem;
};

/** Type representing a collection of favorites */
export type FavoriteCollection = {
  __typename?: 'FavoriteCollection';
  /** Unique identifier for the collection */
  id: Scalars['UUID']['output'];
  /** List of favorites in this collection */
  items: Array<Maybe<Favorite>>;
  /** Name of the collection */
  title: Scalars['String']['output'];
};

/** Input for creating or updating a favorite collection */
export type FavoriteCollectionInput = {
  /** Name of the favorite collection */
  title: Scalars['String']['input'];
};

/** Input for creating a new favorite */
export type FavoriteInput = {
  /** Optional collection to add the favorite to */
  collection?: InputMaybe<Scalars['UUID']['input']>;
  /** Type of content being favorited (PRODUCT or MERCHANT) */
  content_type: ContentType;
  /** ID of the item being favorited */
  object_id: Scalars['UUID']['input'];
};

/** Union type for items that can be favorited */
export type FavoriteItem = Merchant | Product;

/** Paginated result of favorites */
export type FavoriteResult = {
  __typename?: 'FavoriteResult';
  /** List of favorites in the current page */
  items: Array<Favorite>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** Sort options for favorite queries */
export enum FavoriteSort {
  /** Sort by creation date */
  Created = 'CREATED'
}

export type Fee = {
  __typename?: 'Fee';
  amount: Scalars['Float']['output'];
  type: CalculationMethod;
};

/**
 * Input for filtering search results
 * Use comma-separated values for multiple values
 * Use comma-separated numbers for ranges (e.g. "0,100" for price)
 */
export type FilterInput = {
  /** The type of filter to apply */
  key?: InputMaybe<SearchFilterKey>;
  /** Filter value(s) or range */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterObject = Brand | Category | Color | Label | Material | ProductBlock | Style;

/** Output representation of an applied filter */
export type FilterOutput = {
  __typename?: 'FilterOutput';
  /** Type of filter applied */
  key?: Maybe<SearchFilterKey>;
  /**
   * Associated model for the filter
   * @deprecated Use models field instead which supports multiple models
   * @deprecated Use models instead as it provides multiple models.
   */
  model?: Maybe<FilterOutputModel>;
  /** Associated models for the filter */
  models?: Maybe<Array<FilterOutputModel>>;
  /** Filter value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Union of possible filter model types */
export type FilterOutputModel = Brand | Category | Color | Designer | Empty | Material | Style;

/** Input for initiating password reset process */
export type ForgotPasswordInput = {
  /** Email address associated with the account */
  email: Scalars['String']['input'];
};

/** Response type for forgot password request */
export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Result of the password reset request */
  status: ForgotPasswordResult;
};

/** Possible outcomes of a forgot password request */
export enum ForgotPasswordResult {
  /** No account found with provided email */
  EmailNotFound = 'EMAIL_NOT_FOUND',
  /** Reset instructions sent successfully */
  EmailSent = 'EMAIL_SENT'
}

/** Gender the bag is targeted at. */
export enum Gender {
  Men = 'MEN',
  Unisex = 'UNISEX',
  Women = 'WOMEN'
}

/** Input for generating Iterable JWT token */
export type GenerateIterableJwtInput = {
  /** Optional user ID to generate token for. If not provided, uses authenticated user */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Response containing Iterable JWT token */
export type GenerateIterableJwtResponse = {
  __typename?: 'GenerateIterableJwtResponse';
  /** JWT token for Iterable integration */
  token: Scalars['String']['output'];
};

export type GetMessagesInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  threadId: Scalars['UUID']['input'];
};

export type GetMessagesResult = {
  __typename?: 'GetMessagesResult';
  items: Array<Message>;
  pagination: CursorPaginationResult;
};

/** Input for fetching all product shipping options */
export type GetProductShippingDetailsInput = {
  /** Delivery address details */
  deliveryAddress?: InputMaybe<DeliveryAddressSelectorInput>;
  /** Include unsupported options in response */
  includeUnsupported?: InputMaybe<Scalars['Boolean']['input']>;
  /** Product ID to check shipping for */
  product: ProductSelectorInput;
};

export type GetThreadsInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type GetThreadsResult = {
  __typename?: 'GetThreadsResult';
  items: Array<Thread>;
  pagination: CursorPaginationResult;
};

/** Type representing a cart for non-logged-in users */
export type GuestCart = {
  __typename?: 'GuestCart';
  /** Products in the guest cart */
  products: Array<Product>;
};

/** Input for creating a guest cart */
export type GuestCartInput = {
  /** IDs of products to include */
  productIds: Array<Scalars['UUID']['input']>;
};

/** Type representing a bag's hardware (metal) finish color. */
export type HardwareColor = AbstractAttribute & {
  __typename?: 'HardwareColor';
  description?: Maybe<Scalars['String']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** Type representing a bag's hardware (metal) finish color. */
export type HardwareColorMediaArgs = {
  type?: InputMaybe<MediaType>;
};


/** Type representing a bag's hardware (metal) finish color. */
export type HardwareColorSlugArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing a bag's hardware (metal) finish color. */
export type HardwareColorTitleArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * A published help article with its body and locale alternates.
 *
 * Returned by `helpArticle`. List/search use `HelpArticleListItem` instead.
 */
export type HelpArticle = {
  __typename?: 'HelpArticle';
  /** Sanitized HTML body. Already passed through help-service's HTML sanitizer. */
  bodyHtml: Scalars['String']['output'];
  /** Slug of the article's category in this locale. Null if the category is unpublished. */
  categorySlug?: Maybe<Scalars['String']['output']>;
  /** Translated category title in this locale. Null if the category is unpublished. */
  categoryTitle?: Maybe<Scalars['String']['output']>;
  /** Plain-text excerpt for cards, search snippets and meta descriptions. */
  excerpt: Scalars['String']['output'];
  /** Published translations of this article, including the requested locale. */
  hreflang: Array<HelpHreflangAlternate>;
  /** Stable id from help-service. The same id is used for `sendHelpFeedback`. */
  id: Scalars['ID']['output'];
  /** Whether this article is marked featured (top questions). */
  isFeatured: Scalars['Boolean']['output'];
  /** Next published article in the same category. Null if this is the last. */
  next?: Maybe<HelpArticleNeighbour>;
  /** Previous published article in the same category. Null if this is the first. */
  previous?: Maybe<HelpArticleNeighbour>;
  /** Estimated reading time in minutes, at least 1. */
  readingTimeMinutes: Scalars['Int']['output'];
  /** Up to four related published articles. Empty when none were found. */
  related: Array<HelpArticleListItem>;
  /** Locale-specific slug used in help URLs. */
  slug: Scalars['String']['output'];
  /** Short summary. Empty string when none was set. */
  summary: Scalars['String']['output'];
  /** Translated title in the requested locale. */
  title: Scalars['String']['output'];
  /** When help-service last updated the article. Null if the public API omitted it. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A published help article in list and search results.
 *
 * The body is omitted here: list and search are meant to be cheap and cacheable.
 * Fetch `helpArticle` for `bodyHtml` and hreflang.
 */
export type HelpArticleListItem = {
  __typename?: 'HelpArticleListItem';
  /** Slug of the article's category in this locale. Null if the category is unpublished. */
  categorySlug?: Maybe<Scalars['String']['output']>;
  /** Plain-text excerpt for cards, search snippets and meta descriptions. */
  excerpt: Scalars['String']['output'];
  /** Stable id from help-service. The same id is used for `sendHelpFeedback`. */
  id: Scalars['ID']['output'];
  /** Estimated reading time in minutes, at least 1. */
  readingTimeMinutes: Scalars['Int']['output'];
  /** Locale-specific slug used in help URLs. */
  slug: Scalars['String']['output'];
  /** Short summary for cards and search snippets. Empty string when none was set. */
  summary: Scalars['String']['output'];
  /** Translated title in the requested locale. */
  title: Scalars['String']['output'];
  /** When help-service last updated this translation. Null if the public API omitted it. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Previous or next published article in the same category.
 *
 * Used for in-article navigation. Ordered by help-service article `order`, then
 * title. Null on `HelpArticle` when the current article is first or last.
 */
export type HelpArticleNeighbour = {
  __typename?: 'HelpArticleNeighbour';
  /** Slug of this neighbour's category in this locale. */
  categorySlug: Scalars['String']['output'];
  /** Locale-specific slug used in help URLs. */
  slug: Scalars['String']['output'];
  /** Translated title in the requested locale. */
  title: Scalars['String']['output'];
};

/**
 * One page of published help articles.
 *
 * `pageSize` is chosen by help-service (default 20). This API only exposes `page`
 * so clients cannot request arbitrary page sizes through the gateway.
 */
export type HelpArticlePage = {
  __typename?: 'HelpArticlePage';
  /** Articles on this page, in help-service order. */
  items: Array<HelpArticleListItem>;
  /** 1-based page index that was fetched. */
  page: Scalars['Int']['output'];
  /** Page size applied by help-service. */
  pageSize: Scalars['Int']['output'];
  /** Total matching articles across all pages. */
  total: Scalars['Int']['output'];
};

/**
 * A published help-center category in one locale.
 *
 * `children` is the subtree in display order. `articleCount` is the number of
 * published, non-internal articles in this category and its descendants, matching
 * what the help site shows next to each node.
 */
export type HelpCategory = {
  __typename?: 'HelpCategory';
  /** Published, non-internal articles in this node and its descendants. */
  articleCount: Scalars['Int']['output'];
  /** Child categories, already sorted. Empty at a leaf. */
  children: Array<HelpCategory>;
  /** Optional translated description for the category page. Null when none was set. */
  description?: Maybe<Scalars['String']['output']>;
  /** Stable id from help-service. Not a monolith UUID. */
  id: Scalars['ID']['output'];
  /** Display order among siblings. Lower first. */
  order: Scalars['Int']['output'];
  /** Locale-specific slug used in help URLs. */
  slug: Scalars['String']['output'];
  /** Translated title in the requested locale. */
  title: Scalars['String']['output'];
};

/**
 * A language alternate of a help article, for hreflang and locale switchers.
 *
 * `categorySlug` is the category slug in THAT locale, which can differ from the
 * requested locale because category slugs are translated.
 */
export type HelpHreflangAlternate = {
  __typename?: 'HelpHreflangAlternate';
  /** Category slug in this locale. */
  categorySlug: Scalars['String']['output'];
  /** Locale of this alternate, e.g. `nl`. */
  locale: Scalars['String']['output'];
  /** Article slug in this locale. */
  slug: Scalars['String']['output'];
};

/** One hit from help-center full-text search. */
export type HelpSearchResult = {
  __typename?: 'HelpSearchResult';
  /** Slug of the article's category in this locale. */
  categorySlug: Scalars['String']['output'];
  /** Plain-text excerpt for the result row. */
  excerpt: Scalars['String']['output'];
  /** Stable id from help-service. */
  id: Scalars['ID']['output'];
  /** Locale-specific slug used in help URLs. */
  slug: Scalars['String']['output'];
  /** Short summary for the result row. Empty string when none was set. */
  summary: Scalars['String']['output'];
  /** Translated title in the requested locale. */
  title: Scalars['String']['output'];
};

/**
 * Represents the website's homepage configuration.
 * Special page type with dedicated configuration for the main landing page.
 */
export type Homepage = {
  __typename?: 'Homepage';
  /** List of content blocks displayed on the homepage */
  blocks: Array<Block>;
  /** Unique identifier for the homepage */
  id: Scalars['UUID']['output'];
  /** URL-friendly identifier for the homepage */
  slug: Scalars['String']['output'];
  /** Human-readable title of the homepage */
  title: Scalars['String']['output'];
};

/** A freshly selected paid homepage card with its own placement ticket. */
export type HomepagePromotion = {
  __typename?: 'HomepagePromotion';
  product: Product;
  promotion: ProductPromotion;
};

/** Represents an image asset with its various properties and variants */
export type Image = {
  __typename?: 'Image';
  /** Aspect ratio of the image (width/height) */
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  /** Background color of the image, useful for thumbnails */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Height of the original image in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier of the image */
  id: Scalars['UUID']['output'];
  /** Orientation of the image (PORTRAIT, LANDSCAPE, or SQUARE) */
  orientation?: Maybe<ImageOrientation>;
  /** Position index for ordering multiple images */
  position: Scalars['Int']['output'];
  /**
   * Rotation angle of the image
   * @deprecated Not being used in the system
   * @deprecated Because is isn't being used or needed anywhere
   */
  rotation: Scalars['Int']['output'];
  /** Type of the image (e.g., DEFAULT, THUMBNAIL, etc.) */
  type: ImageType;
  /** Get URL for a specific image type, size and language */
  url: Scalars['String']['output'];
  /** Available size variants of the image */
  variants: Array<ImageVariant>;
  /** Width of the original image in pixels */
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents an image asset with its various properties and variants */
export type ImageUrlArgs = {
  lang?: InputMaybe<Language>;
  size?: InputMaybe<Size>;
  type?: InputMaybe<ImageType>;
};

/**
 * Block for displaying images and image galleries.
 * Used for visual content presentation across the platform.
 */
export type ImageBlock = AbstractBlock & {
  __typename?: 'ImageBlock';
  /** Unique identifier for the image block */
  id: Scalars['UUID']['output'];
  /** List of images to display */
  images: Array<Image>;
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the image content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** The feedback for the analyzed product image. */
export type ImageFeedback = {
  __typename?: 'ImageFeedback';
  /** The unique identifier for the product image. */
  id: Scalars['UUID']['output'];
  /** The reason for the feedback. Only provided if the status is BAD. */
  reasons: Array<Scalars['String']['output']>;
  /** The feedback of the product */
  status: ImageQualityStatus;
};

/** Possible orientations of an image */
export enum ImageOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Square = 'SQUARE'
}

/** The status of the image feedback. */
export enum ImageQualityStatus {
  /** The image is of poor quality and not suitable for submission. */
  Bad = 'BAD',
  /** The image is of good quality and suitable for submission */
  Good = 'GOOD'
}

/** Types of image assets with different aspect ratios and cropping behaviors */
export enum ImageType {
  Avatar = 'AVATAR',
  Cover = 'COVER',
  Default = 'DEFAULT',
  Detail = 'DETAIL',
  Thumbnail = 'THUMBNAIL'
}

/** Represents a specific size variant of an image */
export type ImageVariant = {
  __typename?: 'ImageVariant';
  /** File format of the image */
  format: Scalars['String']['output'];
  /** Height of the image in pixels */
  height: Scalars['Int']['output'];
  /** URL to access the image variant */
  url: Scalars['String']['output'];
  /** Width of the image in pixels */
  width: Scalars['Int']['output'];
};


/** Represents a specific size variant of an image */
export type ImageVariantUrlArgs = {
  lang?: InputMaybe<Language>;
};

/** Input for impersonating a user */
export type ImpersonateUserInput = {
  /** Email of the user to impersonate */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User ID of the user to impersonate */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Response type for impersonating a user */
export type ImpersonateUserResponse = {
  __typename?: 'ImpersonateUserResponse';
  /** Access token for the impersonated user */
  accessToken: Scalars['String']['output'];
};

/** Input for inviting a user to join a merchant account */
export type InviteUserInput = {
  email: Scalars['String']['input'];
};

/** Result of user invitation process */
export type InviteUserResult = {
  __typename?: 'InviteUserResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type KnownItemHint = {
  __typename?: 'KnownItemHint';
  country?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  designer?: Maybe<Scalars['String']['output']>;
  dimensionsVary: Scalars['Boolean']['output'];
  era?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  maker?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  seatHeight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Label = AbstractAttribute & {
  __typename?: 'Label';
  /** @deprecated Field no longer supported */
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type LabelMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type LabelSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type LabelTitleArgs = {
  lang?: InputMaybe<Language>;
};

/** Supported languages for translation */
export enum Lang {
  /** German */
  De = 'DE',
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** French */
  Fr = 'FR',
  /** Dutch */
  Nl = 'NL'
}

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Nl = 'NL'
}

/** Represents a category-specific listing page with product counts and navigation context. */
export type ListingCategoryPage = {
  __typename?: 'ListingCategoryPage';
  /** Number of currently active products */
  activeProductCount: Scalars['Int']['output'];
  /** Unique identifier for the category page */
  id: Scalars['Int']['output'];
  /** Hierarchical relationship to current page */
  listingLevel: ListingLevel;
  /** Total number of products in this category */
  productCount: Scalars['Int']['output'];
  /** Localized title of the category page */
  title: Scalars['String']['output'];
  /** URL for the category page */
  url: Scalars['String']['output'];
};


/** Represents a category-specific listing page with product counts and navigation context. */
export type ListingCategoryPageTitleArgs = {
  lang?: InputMaybe<Language>;
};


/** Represents a category-specific listing page with product counts and navigation context. */
export type ListingCategoryPageUrlArgs = {
  lang?: InputMaybe<Language>;
};

/** What to ask for the product's current category, and what it usually measures. Derived on every response. */
export type ListingDimensionGuide = {
  __typename?: 'ListingDimensionGuide';
  depth?: Maybe<ListingDimensionRange>;
  /** False for art other than sculpture and glass art, which is hung, not stood. */
  depthRequired: Scalars['Boolean']['output'];
  /** For rugs this is the length (heightIsLength). */
  height?: Maybe<ListingDimensionRange>;
  /** Rugs and carpets: the height column holds the length; label it Length. */
  heightIsLength: Scalars['Boolean']['output'];
  seatHeight?: Maybe<ListingDimensionRange>;
  /** Seating: a seat height is asked (optional). */
  seatHeightAsked: Scalars['Boolean']['output'];
  width?: Maybe<ListingDimensionRange>;
};

/** A typical range in whole centimetres, from accepted listings in the category (5th to 95th percentile). */
export type ListingDimensionRange = {
  __typename?: 'ListingDimensionRange';
  /** The largest value accepted for this side (whole cm); above it setListingField refuses with reason hard_high. */
  hardMax: Scalars['Int']['output'];
  /** The smallest value accepted for this side (whole cm); below it setListingField refuses with reason hard_low. */
  hardMin: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

/**
 * A selectable listing fee package (e.g. Plus, Premium). Merchants pay the
 * package price up-front when listing a product in exchange for a reduced
 * commission on the sale.
 */
export type ListingFeePackage = {
  __typename?: 'ListingFeePackage';
  /** ID of the listing fee package */
  id: Scalars['UUID']['output'];
  /** Stable identifier of the package (e.g. PLUSBUSINESS) */
  identifier: Scalars['String']['output'];
  /** Whether the package is currently selectable */
  isActive: Scalars['Boolean']['output'];
  /** Whether the package should be highlighted as most popular */
  isPopular: Scalars['Boolean']['output'];
  /** Merchant type the package applies to */
  merchantType: MerchantType;
  /** Up-front price of the package */
  price: Price;
  /** Commission (percentage) charged on sale when this package is active */
  reducedFeeAmount: Scalars['Float']['output'];
  /**
   * Display title of the package (e.g. "Plus (Business)"). Pass `lang`
   * to fetch the localized title; falls back to English if missing.
   */
  title: Scalars['String']['output'];
};


/**
 * A selectable listing fee package (e.g. Plus, Premium). Merchants pay the
 * package price up-front when listing a product in exchange for a reduced
 * commission on the sale.
 */
export type ListingFeePackageTitleArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * A listing fee package paired with the per-product commission, savings and
 * payout amounts that result from applying it to a specific product.
 */
export type ListingFeePackageOption = {
  __typename?: 'ListingFeePackageOption';
  /**
   * Commission the merchant currently pays on sale of the product, using
   * the merchant's default seller fee (`product price * default fee`).
   */
  defaultCommission: Price;
  /** The selectable package. */
  package: ListingFeePackage;
  /**
   * Commission the merchant would pay on sale if this package were applied
   * (`product price * package reducedFeeAmount`).
   */
  packageCommission: Price;
  /**
   * Net payout the merchant receives on sale if this package were applied
   * (`product price - packageCommission`). Does not subtract the up-front
   * package price.
   */
  payout: Price;
  /**
   * Commission saved by using this package
   * (`defaultCommission - packageCommission`). Does not subtract the
   * up-front package price.
   */
  savings: Price;
};

/** A Stripe payment intent created for a listing fee package purchase */
export type ListingFeePayment = {
  __typename?: 'ListingFeePayment';
  paymentClientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

/** Type of fee calculation for an applied listing fee */
export enum ListingFeeType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type ListingFieldCheck = {
  __typename?: 'ListingFieldCheck';
  /** The seller confirmed the unusual value. */
  confirmed: Scalars['Boolean']['output'];
  /** Seller-facing explanation in the request language, e.g. 'A 3-5 seater sofa is usually 170 to 310 cm wide. Check the width.' */
  message?: Maybe<Scalars['String']['output']>;
  status: ListingFieldCheckStatus;
};

/** How a seller-entered value compares with what listings in its category usually have (DIMENSIONS). */
export enum ListingFieldCheckStatus {
  /** Within what this category usually measures. */
  Ok = 'OK',
  /** Possible but unusual for this category. The seller must confirm it (setListingField with confirm: true) before publishing. */
  Unusual = 'UNUSUAL'
}

export enum ListingFieldKey {
  /** Art only, instead of BRAND: the artist (catalogue artist, a typed name kept as a suggestion, or unknown). */
  Artist = 'ARTIST',
  Brand = 'BRAND',
  /** Optional seller text after the AI result ("What else should a buyer know?"); shown below the description on the ad. */
  BuyerNote = 'BUYER_NOTE',
  Category = 'CATEGORY',
  Colors = 'COLORS',
  /** The buyer-facing description. Generated from the photos and the seller's notes; the seller can rewrite it. */
  Description = 'DESCRIPTION',
  Designer = 'DESIGNER',
  Dimensions = 'DIMENSIONS',
  Materials = 'MATERIALS',
  Model = 'MODEL',
  NewPrice = 'NEW_PRICE',
  NumberOfItems = 'NUMBER_OF_ITEMS',
  Quality = 'QUALITY',
  Styles = 'STYLES',
  Title = 'TITLE',
  UsageSigns = 'USAGE_SIGNS'
}

export enum ListingFieldSource {
  Edited = 'EDITED',
  Generated = 'GENERATED',
  Seller = 'SELLER'
}

export type ListingGeneration = {
  __typename?: 'ListingGeneration';
  /**
   * The fields the current category uses, in the order to show them: art has ARTIST and no BRAND, DESIGNER or
   * MODEL; bags have no DESIGNER or STYLES. A key not listed does not apply and is not shown or asked. Without a
   * category, the general set. Derived on every response, like missing.
   */
  applicableKeys: Array<ListingFieldKey>;
  /** What to ask for the dimensions in the current category and its typical ranges; null without a category. */
  dimensionGuide?: Maybe<ListingDimensionGuide>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Seller-facing reason when status is FAILED after a read; null for an ad filled in by hand. */
  failureReason?: Maybe<Scalars['String']['output']>;
  fields: Array<ListingGenerationField>;
  generatedAt: Scalars['DateTime']['output'];
  knownItem?: Maybe<KnownItemHint>;
  /** Keys that still need the seller (empty value or below threshold). Always includes DIMENSIONS unless a non-varying known item filled them. */
  missing: Array<ListingFieldKey>;
  /** Model id used, e.g. gemini-2.5-flash */
  model?: Maybe<Scalars['String']['output']>;
  runs: Scalars['Int']['output'];
  /** The seller's own notes from Start, as last sent to generateListing, so a reopened draft can show them again. */
  sellerNotes?: Maybe<Scalars['String']['output']>;
  status: ListingGenerationStatus;
};

export type ListingGenerationField = {
  __typename?: 'ListingGenerationField';
  /** Plausibility of a seller-entered value against the category (DIMENSIONS); null when not checked. */
  check?: Maybe<ListingFieldCheck>;
  /** 0..1 for generated fields; null for seller-supplied. */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Human-readable value for the overview, in the request language (e.g. 'Furniture › Sofas › 3-seater sofa', 'Ligne Roset'). */
  display?: Maybe<Scalars['String']['output']>;
  key: ListingFieldKey;
  /** Short reason shown under the value, e.g. 'catalogue match', 'known item'. */
  note?: Maybe<Scalars['String']['output']>;
  source: ListingFieldSource;
  /** Machine value: ids for taxonomy keys, {width,height,depth,seatHeight} for DIMENSIONS, number for NUMBER_OF_ITEMS/NEW_PRICE, string for TITLE/MODEL. BRAND and ARTIST: {id} for a catalogue match, {suggestion} for a typed name, {unknown: true} when the seller does not know. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export enum ListingGenerationStatus {
  /** The latest read filled the fields. */
  Done = 'DONE',
  /**
   * The latest read produced nothing usable (failureReason says why), or the seller fills the ad in by hand
   * (startListingManually, or setListingField before any read; failureReason null). Either way `missing` is the
   * manual set until the seller fills it.
   */
  Failed = 'FAILED'
}

/**
 * Indicates the hierarchical relationship between listing pages.
 * Used to determine navigation structure and behavior.
 */
export enum ListingLevel {
  /**
   * Listing is under the current listing.
   * Used for subcategories or child sections.
   */
  Child = 'CHILD',
  /**
   * This is current listing.
   * Represents the active page being viewed.
   */
  Current = 'CURRENT',
  /**
   * Listing is on the level above current and has back option.
   * Used for parent categories or sections.
   */
  Parent = 'PARENT',
  /**
   * Listing is on the same level as current listing but does not have back option.
   * Used for related or sibling categories.
   */
  Sibling = 'SIBLING'
}

/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPage = {
  __typename?: 'ListingPage';
  /** Associated brand if this is a brand listing */
  brand?: Maybe<Brand>;
  /** Breadcrumb navigation path */
  breadcrumbs: Array<ListingPage>;
  /** Associated category if this is a category listing */
  category?: Maybe<Category>;
  /** Category pages within this listing */
  categoryPages: Array<ListingCategoryPage>;
  /** Associated product collection */
  collection?: Maybe<ProductBlock>;
  /** Page description in the specified language */
  description?: Maybe<Scalars['String']['output']>;
  /** Active filters for the listing */
  filters: Array<ListingPageFilterItem>;
  /** Featured image for the listing page */
  image?: Maybe<Scalars['String']['output']>;
  /** Whether to prevent search engine indexing */
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  /** Default sort order for products */
  order?: Maybe<Ordering>;
  /** Whether to show recommended products */
  recommended?: Maybe<Scalars['Boolean']['output']>;
  /** Related listing pages */
  relatedListingPages: Array<RelatedListingPage>;
  /** Default sort field for products */
  sort?: Maybe<SearchSort>;
  /** Subcategory listing pages */
  subcategoryPages: Array<ListingPage>;
  /** Page title in the specified language */
  title: Scalars['String']['output'];
  /** URL of the listing page */
  url: Scalars['String']['output'];
  /** Sort weight/priority of the page */
  weight?: Maybe<Scalars['Int']['output']>;
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageFiltersArgs = {
  lang: Language;
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageRelatedListingPagesArgs = {
  lang: Language;
  limit?: Scalars['Int']['input'];
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageTitleArgs = {
  lang?: InputMaybe<Language>;
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageUrlArgs = {
  lang?: InputMaybe<Language>;
};


/** Main listing page type containing all product listing configuration and metadata. */
export type ListingPageWeightArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Input for querying listing pages by multiple filters.
 * Allows combining multiple filter criteria.
 */
export type ListingPageByFiltersInput = {
  /** List of filters to apply */
  filters: Array<ListingPageFilterInput>;
};

/**
 * Input for filtering listing pages.
 * Defines a single filter criterion with key and value.
 */
export type ListingPageFilterInput = {
  /** Type of filter to apply */
  key: ListingPageFilterKey;
  /** Value to filter by */
  value: Scalars['String']['input'];
};

/** Represents a single filter criterion on a listing page. */
export type ListingPageFilterItem = {
  __typename?: 'ListingPageFilterItem';
  /** Type of filter */
  key: ListingPageFilterKey;
  /** Filter value */
  value: Scalars['String']['output'];
};

/**
 * Available filter keys for listing pages.
 * Used to filter products on listing pages by various criteria.
 */
export enum ListingPageFilterKey {
  /** Filter by product brand */
  Brand = 'BRAND',
  /** Filter by product category */
  Category = 'CATEGORY',
  /** Filter by collection */
  Collection = 'COLLECTION',
  /** Filter by product color */
  Color = 'COLOR',
  /** Filter by product condition */
  Condition = 'CONDITION',
  /** Filter by product designer */
  Designer = 'DESIGNER',
  /** Filter products in showroom */
  InShowroom = 'IN_SHOWROOM',
  /** Filter by product material */
  Material = 'MATERIAL',
  /** Filter products on sale */
  OnSale = 'ON_SALE',
  /** Filter products in showroom model */
  ShowroomModel = 'SHOWROOM_MODEL',
  /** Filter by product style */
  Style = 'STYLE'
}

/**
 * Input for retrieving a listing page.
 * Used to specify the URL and language for the requested listing page.
 */
export type ListingPageInput = {
  /** Language code for localized content */
  lang: Language;
  /** URL of the listing page to retrieve */
  url: Scalars['String']['input'];
};

/**
 * Types of relationships between listing pages.
 * Used to categorize related listings by their relationship type.
 */
export enum ListingPageRelationType {
  /** Related by brand */
  Brand = 'BRAND',
  /** Related by category */
  Category = 'CATEGORY',
  /** Related by color */
  Color = 'COLOR',
  /** Custom relationship */
  Custom = 'CUSTOM',
  /** Related by material */
  Material = 'MATERIAL',
  /** Related by style */
  Style = 'STYLE'
}

/**
 * The Locale enum represents the possible locality settings for the
 * current merchant.
 */
export enum Locale {
  /** @deprecated Use DE_DE instead */
  DeAt = 'DE_AT',
  DeDe = 'DE_DE',
  /** @deprecated Use EN_US instead */
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  /** @deprecated Use FR_FR instead */
  FrBe = 'FR_BE',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  /** @deprecated Use NL_NL instead */
  NlBe = 'NL_BE',
  NlNl = 'NL_NL'
}

export type LocalizedUrl = {
  __typename?: 'LocalizedUrl';
  status: LocalizedUrlStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export enum LocalizedUrlStatus {
  Found = 'FOUND',
  NotFound = 'NOT_FOUND',
  Redirect = 'REDIRECT'
}

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Supported third-party authentication providers */
export enum LoginProvider {
  /** Apple Sign In authentication */
  Apple = 'APPLE',
  /**
   * Facebook OAuth authentication (deprecated)
   * @deprecated Field no longer supported
   */
  Facebook = 'FACEBOOK',
  /** Google OAuth authentication */
  Google = 'GOOGLE'
}

/** Response type for successful login */
export type LoginResponse = {
  __typename?: 'LoginResponse';
  /** JWT token for authentication */
  access_token: Scalars['String']['output'];
  /** Authenticated user details */
  user: Member;
};

export type Material = AbstractAttribute & {
  __typename?: 'Material';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type MaterialMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type MaterialSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type MaterialTitleArgs = {
  lang?: InputMaybe<Language>;
};

/** Input for updating current member's profile */
export type MeInput = {
  /** Updated business name */
  business_name?: InputMaybe<Scalars['String']['input']>;
  /** Updated country of birth */
  country_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Updated date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** Updated email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Updated last name */
  family_name?: InputMaybe<Scalars['String']['input']>;
  /** Updated first name */
  given_name?: InputMaybe<Scalars['String']['input']>;
  /** Updated locale preference */
  locale?: InputMaybe<Locale>;
  /** Updated display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** OTP code for phone verification */
  otp?: InputMaybe<Scalars['String']['input']>;
  /** Updated phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Updated place of birth */
  place_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** UUID of referring member */
  referralId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * @deprecated Please use referralId instead
   * @deprecated Please use referralId instead
   */
  referrer?: InputMaybe<Referrer>;
  /** Updated merchant type */
  type?: InputMaybe<MerchantType>;
};

/** Union of all possible media asset types */
export type Media = ArObject | Audio | Document | Image | Video;

/** Filter input for querying media assets */
export type MediaFilter = {
  key?: InputMaybe<MediaFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Available filter keys for media queries */
export enum MediaFilterKey {
  MimeType = 'MIME_TYPE',
  State = 'STATE',
  Type = 'TYPE'
}

/** Interface for types that can have associated media assets */
export type MediaQueries = {
  /** Get a single image of a specific type */
  image?: Maybe<Image>;
  /** Get all images of a specific type */
  images: Array<Image>;
  /** Get all media assets of a specific type */
  media: Array<Media>;
  /** Get a single video of a specific type */
  video?: Maybe<Video>;
  /** Get all videos of a specific type */
  videos: Array<Video>;
};


/** Interface for types that can have associated media assets */
export type MediaQueriesImageArgs = {
  type?: InputMaybe<ImageType>;
};


/** Interface for types that can have associated media assets */
export type MediaQueriesImagesArgs = {
  type?: InputMaybe<ImageType>;
};


/** Interface for types that can have associated media assets */
export type MediaQueriesMediaArgs = {
  type?: InputMaybe<MediaType>;
};


/** Interface for types that can have associated media assets */
export type MediaQueriesVideoArgs = {
  type?: InputMaybe<VideoType>;
};


/** Interface for types that can have associated media assets */
export type MediaQueriesVideosArgs = {
  type?: InputMaybe<VideoType>;
};

/** Paginated result of media queries */
export type MediaResult = {
  __typename?: 'MediaResult';
  items: Array<Media>;
  pagination: PaginationResult;
};

/** Available sorting options for media assets */
export enum MediaSort {
  Created = 'CREATED',
  State = 'STATE'
}

/** Processing states for media assets */
export enum MediaState {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

/** Types of media assets supported by the system */
export enum MediaType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

/** Input for updating media asset properties */
export type MediaUpdateInput = {
  content_type?: InputMaybe<ContentType>;
  object_id?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Type representing a member in the system */
export type Member = {
  __typename?: 'Member';
  /** Member's country of birth */
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date when the member joined */
  date_joined: Scalars['DateTime']['output'];
  /** Member's date of birth */
  dob?: Maybe<Scalars['Date']['output']>;
  /** Member's email address */
  email: Scalars['String']['output'];
  /** Member's last name */
  family_name: Scalars['String']['output'];
  /** Member's first name */
  given_name: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Last used payment method */
  lastUsedPaymentMethod?: Maybe<PaymentMethod>;
  /** Last login timestamp */
  last_login?: Maybe<Scalars['DateTime']['output']>;
  /** Preferred locale for the member */
  locale: Locale;
  /** List of merchants associated with the member */
  merchants: Array<Merchant>;
  /** Member's place of birth */
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  /**
   * Preferred DISPLAY currency chosen by the member; null until chosen. Never
   * applied server-side — read it after login and pass it back as the explicit
   * `currency` argument on price-returning queries. Distinct from
   * Merchant.currency (the seller/listing currency).
   */
  preferred_currency?: Maybe<Currency>;
  /**
   * Whether the viewer's own merchant has Pro Buyer status (set by CS in the
   * CMS). Only resolved for the logged-in member's own profile (`me`); null on
   * any other Member payload (chat senders and the like). Independent of the
   * `pro_buyer_program` flag, so CS can approve accounts before launch.
   */
  proBuyer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the viewer may open Pro Buyer-projecten (access FULL or READ_ONLY).
   * Only resolved for the logged-in member's own profile (`me`); null on any other Member.
   */
  proBuyerProjects?: Maybe<Scalars['Boolean']['output']>;
  /**
   * NONE: not a Pro Buyer (or the `pro_buyer_projects` flag is off), send to /pro-buyer.
   * READ_ONLY: switched off by CS but has projects. FULL: approved Pro Buyer.
   * Only resolved for `me`; null on any other Member.
   */
  proBuyerProjectsAccess?: Maybe<ProBuyerProjectsAccess>;
};

/**
 * Block for displaying member profiles and information.
 * Used for showcasing community members, user highlights, and testimonials.
 */
export type MemberBlock = AbstractBlock & {
  __typename?: 'MemberBlock';
  /** Unique identifier for the member block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** List of members to display */
  members: Array<Member>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the member content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** Filter input for member queries */
export type MemberFilter = {
  /** Filter key to apply */
  key?: InputMaybe<MemberFilterKey>;
  /** Value to filter by */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Available filter keys for member queries */
export enum MemberFilterKey {
  /** Filter members by email address */
  Email = 'EMAIL'
}

/** Input for creating a new member */
export type MemberInput = {
  /** Date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** Member's email address */
  email: Scalars['String']['input'];
  /** Member's last name */
  family_name: Scalars['String']['input'];
  /** Member's first name */
  given_name: Scalars['String']['input'];
  /** Preferred locale for the member */
  locale?: InputMaybe<Locale>;
  /** Optional password (may be omitted for social logins) */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of member queries */
export type MemberResult = {
  __typename?: 'MemberResult';
  /** List of members in the current page */
  items: Array<Member>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** Sort options for member queries */
export enum MemberSort {
  /** Sort by creation date */
  Created = 'CREATED',
  /** Default sorting order */
  Default = 'DEFAULT',
  /** Sort by email address */
  Email = 'EMAIL',
  /** Sort by last update date */
  Updated = 'UPDATED'
}

/** Represents a merchant account in the system */
export type Merchant = MediaQueries & {
  __typename?: 'Merchant';
  /**
   * List of addresses associated with the merchant. Anyone but the merchant's own
   * members gets only the city and country of each, under a stable stand-in id
   * that differs from the address's real id; the other fields are empty.
   */
  addresses: Array<Address>;
  /** Bank account details for payouts (protected by @sensitive) */
  bank_account?: Maybe<BankAccount>;
  /** Merchant's description or profile */
  biography?: Maybe<Scalars['String']['output']>;
  /** Business name for merchant accounts of type BUSINESS */
  business_name?: Maybe<Scalars['String']['output']>;
  /**
   * List of completed payouts to the merchant.
   * Contains sensitive information.
   */
  completed_payouts?: Maybe<Array<MerchantPayment>>;
  /** Merchant verification level (0 = unverified, > 0 is verified) */
  compliance_level?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the merchant account was created */
  created: Scalars['DateTime']['output'];
  /** Currency used by the merchant */
  currency: Currency;
  /** WHO-6309 D6: the merchant's default VAT regime, read-only (set in the CMS). Own merchant only; null otherwise. */
  defaultVatRegime?: Maybe<VatRegime>;
  /**
   * The default delivery address. Set as soon as the merchant has an address;
   * preselected in checkout and the sell flow. Null for a merchant without
   * addresses, and for anyone but the merchant's own members.
   */
  default_shipping_address?: Maybe<Address>;
  /** Whether the merchant disables contact seller feature */
  disableContactSeller: Scalars['Boolean']['output'];
  /** Merchant's discount configuration (protected by @sensitive) */
  discount?: Maybe<Discount>;
  /** Contact email address (protected by @sensitive) */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the merchant is designated as an expert seller */
  expert_seller?: Maybe<Scalars['Boolean']['output']>;
  /** Favorite collections that include this merchant */
  favoriteCollections: Array<FavoriteCollection>;
  /**
   * Users who have favorited this merchant
   * Limited to 50 most recent favorites
   */
  favorites: Array<Favorite>;
  /** Merchant's fee configuration (protected by @sensitive) */
  fee?: Maybe<Fee>;
  /** Unique identifier for the merchant */
  id: Scalars['UUID']['output'];
  /** Primary image of the merchant */
  image?: Maybe<Image>;
  /** All images associated with the merchant */
  images: Array<Image>;
  /** WHO-6309 D1: when the seller accepted the invoicing mandate. Own merchant only; null otherwise. */
  invoiceMandateAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The address the merchant's own purchases are invoiced to, ONLY when the
   * merchant explicitly picked one that differs from the delivery default.
   * Null means "the same as the default delivery address" and follows it.
   * Always null for anyone but the merchant's own members.
   */
  invoice_address?: Maybe<Address>;
  /** Media items associated with the merchant */
  media: Array<Media>;
  /** Members with access to this merchant account (protected by @sensitive) */
  members?: Maybe<Array<Maybe<Member>>>;
  /** Display name of the merchant */
  name: Scalars['String']['output'];
  /** Total number of active listings by the merchant */
  number_of_ads?: Maybe<Scalars['Int']['output']>;
  /** Total number of bids placed by the merchant */
  number_of_bids?: Maybe<Scalars['Int']['output']>;
  /** Total number of purchases made by the merchant */
  number_of_buys?: Maybe<Scalars['Int']['output']>;
  /** Number of times this merchant has been favorited */
  number_of_favorites?: Maybe<Scalars['Int']['output']>;
  /** Total number of items sold by the merchant */
  number_of_sells?: Maybe<Scalars['Int']['output']>;
  /** List of actions requiring merchant attention (protected by @sensitive) */
  pendingActions: Array<PendingAction>;
  /**
   * Current pending balance for the merchant.
   * Contains sensitive information.
   */
  pending_balance: Price;
  /**
   * List of pending payouts to the merchant.
   * Contains sensitive information.
   */
  pending_payouts?: Maybe<Array<MerchantPayment>>;
  /**
   * Required documentation or information still needed from the merchant.
   * Contains sensitive information.
   */
  pending_requirements?: Maybe<Array<MerchantRequirement>>;
  /** Contact phone number (protected by @sensitive) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Whether the phone number has been verified */
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Average rating of the merchant (1-5) */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Merchant's referral code for the referral program */
  referral_code?: Maybe<Scalars['String']['output']>;
  /** Total number of reviews received */
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the merchant is a showroom model */
  showroomModel: Scalars['Boolean']['output'];
  /** URL-friendly version of the merchant name */
  slug: Scalars['String']['output'];
  /** Stripe account details for the merchant */
  stripeAccount: StripeAccount;
  /** Error message from Stripe customer creation/update if any */
  stripe_customer_error?: Maybe<Scalars['String']['output']>;
  /** Tax identification number (protected by @sensitive) */
  tax_id?: Maybe<Scalars['String']['output']>;
  tradeDiscount?: Maybe<MerchantTradeDiscount>;
  /**
   * Type of merchant account (INDIVIDUAL or BUSINESS)
   * Transformed to uppercase via @upper directive
   */
  type: MerchantType;
  /** Merchant's website URL */
  url?: Maybe<Scalars['String']['output']>;
  /** Timestamp when vacation mode disable was requested */
  vacationModeDisableRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when vacation mode enable was requested */
  vacationModeEnableRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when vacation mode was enabled */
  vacationModeEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date when vacation mode will end */
  vacationModeEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** VAT identification number (protected by @sensitive) */
  vat_id?: Maybe<Scalars['String']['output']>;
  /** Authority that registered the VAT ID (protected by @sensitive) */
  vat_id_registrar?: Maybe<Scalars['String']['output']>;
  /** Whether the merchant has been verified */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /** Primary video of the merchant */
  video?: Maybe<Video>;
  /** All videos associated with the merchant */
  videos: Array<Video>;
};


/** Represents a merchant account in the system */
export type MerchantImageArgs = {
  type?: InputMaybe<ImageType>;
};


/** Represents a merchant account in the system */
export type MerchantImagesArgs = {
  type?: InputMaybe<ImageType>;
};


/** Represents a merchant account in the system */
export type MerchantMediaArgs = {
  type?: InputMaybe<MediaType>;
};


/** Represents a merchant account in the system */
export type MerchantVideoArgs = {
  type?: InputMaybe<VideoType>;
};


/** Represents a merchant account in the system */
export type MerchantVideosArgs = {
  type?: InputMaybe<VideoType>;
};

/**
 * Block for displaying merchant profiles and information.
 * Used for showcasing sellers, stores, and business profiles.
 */
export type MerchantBlock = AbstractBlock & {
  __typename?: 'MerchantBlock';
  /** Unique identifier for the merchant block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** List of merchants to display */
  merchants: Array<Merchant>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the merchant content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/** Filter input for querying merchants */
export type MerchantFilter = {
  key?: InputMaybe<MerchantFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Available filter keys for merchant queries */
export enum MerchantFilterKey {
  Email = 'EMAIL',
  Name = 'NAME',
  Slug = 'SLUG',
  Type = 'TYPE'
}

/** Input for creating/updating merchant information */
export type MerchantInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  type: MerchantType;
  url?: InputMaybe<Scalars['String']['input']>;
  vat_id?: InputMaybe<Scalars['String']['input']>;
  vat_id_registrar?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a payment transaction for a merchant.
 * Records payment details and status.
 */
export type MerchantPayment = Node & {
  __typename?: 'MerchantPayment';
  /** Payment amount with currency */
  amount: Price;
  /** When the payment was created */
  created: Scalars['DateTime']['output'];
  /** Payment destination (e.g., bank account) */
  destination: Scalars['String']['output'];
  /** Unique identifier for the payment */
  id: Scalars['UUID']['output'];
  /** When the payment was last updated */
  updated: Scalars['DateTime']['output'];
};

/** Required merchant documentation and information */
export enum MerchantRequirement {
  /** Physical address */
  Address = 'ADDRESS',
  /** Date of birth */
  DateOfBirth = 'DATE_OF_BIRTH',
  /** Email address */
  Email = 'EMAIL',
  /** Last name */
  FamilyName = 'FAMILY_NAME',
  /** First name */
  GivenName = 'GIVEN_NAME',
  /** Identity verification document */
  IdentifyDocument = 'IDENTIFY_DOCUMENT',
  /** Business owner documentation */
  OwnerDocument = 'OWNER_DOCUMENT',
  /** Tax identification number */
  TaxId = 'TAX_ID',
  /** VAT identification number */
  VatId = 'VAT_ID'
}

/** Paginated result of merchant queries */
export type MerchantResult = {
  __typename?: 'MerchantResult';
  items: Array<Merchant>;
  pagination: PaginationResult;
};

/** Roles that can be assigned to merchant members */
export enum MerchantRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

/** Available sorting options for merchants */
export enum MerchantSort {
  Created = 'CREATED',
  Name = 'NAME',
  Updated = 'UPDATED'
}

/**
 * WHO-5654. The one shop-wide Pro Buyer discount a business seller offers.
 * Own-merchant only: `Merchant.tradeDiscount` is @sensitive, so anonymous and
 * non-owner payloads carry null. Null as well while the `pro_buyer_program`
 * feature flag (monolith, be_admin_featureflag) is off.
 */
export type MerchantTradeDiscount = {
  __typename?: 'MerchantTradeDiscount';
  /**
   * Listings the discount applies to right now: curated accepted with a live
   * auction (published, coming soon or bid only).
   */
  activeListingCount: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  /**
   * One of 10, 15, 20, 25, 30, 35, 40. Also returned while `enabled` is false:
   * the stored percentage is kept so the seller can switch back on in one click.
   * Only apply it when `enabled` is true. Null when never set.
   */
  pct?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Types of merchant accounts */
export enum MerchantType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL'
}

export type Message = {
  __typename?: 'Message';
  body?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /** @deprecated Use `rejectionReason` field instead. */
  flaggedReasons?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  item?: Maybe<MessageItem>;
  merchant: Merchant;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rejectionReason?: Maybe<MessageRejectionReason>;
  sender: Member;
  status?: Maybe<MessageStatus>;
  subscriber?: Maybe<Subscriber>;
  thread: Thread;
  threadId: Scalars['UUID']['output'];
  unread: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type MessageBodyArgs = {
  lang?: InputMaybe<Language>;
};

export type MessageFilter = {
  key?: InputMaybe<MessageFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageFilterKey {
  Sender = 'SENDER',
  Thread = 'THREAD'
}

export enum MessageFlaggedReason {
  BidIntent = 'BID_INTENT',
  CommunicationOutsidePlatform = 'COMMUNICATION_OUTSIDE_PLATFORM',
  PersonalInformationShared = 'PERSONAL_INFORMATION_SHARED',
  ProductViewAppointment = 'PRODUCT_VIEW_APPOINTMENT',
  Safe = 'SAFE',
  SpamPhishing = 'SPAM_PHISHING',
  TransactionOutsidePlatform = 'TRANSACTION_OUTSIDE_PLATFORM'
}

export type MessageItem = Audio | Bid | Document | Image | Order | Product | Shipment | Video;

export type MessageRejectionReason = {
  __typename?: 'MessageRejectionReason';
  description: Scalars['String']['output'];
  showChatRules: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type MessageRejectionReasonDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type MessageRejectionReasonTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type MessageResult = {
  __typename?: 'MessageResult';
  items: Array<Message>;
  pagination: PaginationResult;
};

export enum MessageSort {
  Created = 'CREATED',
  Sender = 'SENDER',
  Updated = 'UPDATED'
}

export enum MessageStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Root Mutation type for all write operations in the API */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accept a bid on an auction.
   * Marks the bid as accepted and initiates the order process.
   * Requires authentication.
   */
  acceptBid: Bid;
  /**
   * Accept a proposed delivery date
   * Requires authentication
   */
  acceptBrengerProposedDate: BrengerProposedDate;
  /**
   * Accept the chat terms of service for the merchant account
   * Requires authentication
   * Returns the updated merchant
   * @deprecated Use acceptChatTosForThread mutation instead
   */
  acceptChatTos: Merchant;
  /**
   * Accept the chat terms of service for a thread.
   * Requires authentication.
   * Returns the updated thread.
   */
  acceptChatTosForThread: Thread;
  /**
   * WHO-6309 D1: the seller accepts the third-party invoicing mandate (T&C version,
   * e.g. "2026-10"). FEATURE_DISABLED while the `seller_invoice_v1` flag is off.
   */
  acceptInvoiceMandate: Scalars['Boolean']['output'];
  acceptReservation: SellerReservation;
  /**
   * Accept the terms of service for the merchant account
   * Requires authentication
   * Returns the updated merchant
   */
  acceptTos: Merchant;
  /** Add a boost package to the package cart. Requires authentication. */
  addBoostToPackageCart: PackageCart;
  /** Add a listing-fee (PPL) package to the package cart. Requires authentication. */
  addListingFeeToPackageCart: PackageCart;
  /** Adds the pieces to the viewer's cart through the normal add-to-cart rules and marks those lines with the project. */
  addProBuyerProjectItemsToCart: ProBuyerProjectCartResult;
  /** Add a single product to the cart */
  addProductToCart: Cart;
  /** Add multiple products to the cart */
  addProductsToCart: Cart;
  /**
   * Also creates the normal favorite when missing (R3). Up to 100 products; the
   * viewer's own listings and listings that are not public are skipped. With a
   * roomId a piece already in the project moves to that room. Returns the project.
   * Errors: PROJECT_ITEM_LIMIT (500 pieces per project).
   */
  addProductsToProBuyerProject: ProBuyerProject;
  /** Attach an owned immutable promotion quote to the grouped package cart. */
  addPromotionToPackageCart: PackageCart;
  /** Add a referral code to merchant account */
  addReferralCode: AddReferralCodeResult;
  /**
   * Add a product to the boost cart
   * Requires authentication
   * @deprecated Use addBoostToPackageCart — the multi-item package cart replaces the single-item boost cart.
   */
  addToBoostCart: BoostCart;
  /**
   * Admits one anonymous value check before whoppah-web runs the photo recognition. Verifies the
   * visitor's Turnstile token (whoppah-web forwards it as `X-Turnstile-Token`) and takes one check
   * from the visitor's hourly and daily allowance and from the site-wide daily cap
   * (`VALUE_CHECK_DAILY_CAP`). `visitorIp` is the address Vercel recorded for the visitor; only a hash
   * of it is kept, for at most a day. whoppah-web's server only.
   */
  admitValueCheck: ValueCheckAdmission;
  /**
   * Analyze image of a product, returns the image id
   * we can use to search for similar products.
   */
  analyzeProductImage?: Maybe<AnalyzeProductImageResult>;
  /**
   * Analyze the images of a product, returns the
   * analysis result.
   */
  analyzeProductImages?: Maybe<AnalyzeProductImagesResult>;
  /**
   * Analyze the title and images of a product, returns the
   * analysis result.
   */
  analyzeProductTitleAndImages?: Maybe<AnalyzeProductTitleAndImagesResult>;
  /** The member approves the request. Requires a recent sign-in. */
  approveAgentAuthorization: AgentAuthorizationDecision;
  /**
   * Ask a question about a product
   * Authentication required
   */
  askProductQuestion: Thread;
  /**
   * Puts the purchase in the project, moving it out of any other project (one
   * project per purchase). Idempotent. Returns the target project.
   * Errors: entityNotFound (project or purchase not the viewer's),
   * PURCHASE_NOT_ELIGIBLE (cancelled, expired or service order).
   */
  assignPurchaseToProBuyerProject: ProBuyerProject;
  /** Freeze all reviewed lines and return one recoverable payment. */
  beginPackageCheckout: PackageCheckout;
  /**
   * Cancel a bid with a specific reason.
   * Allows users to cancel their bids while providing a reason for cancellation.
   * Requires authentication.
   */
  cancelBid?: Maybe<Bid>;
  /** Release an unpaid native preparation after the store reports definite user cancellation; false if payment already exists. */
  cancelNativePromotionPreparation: Scalars['Boolean']['output'];
  /**
   * Cancel an existing order.
   * Legacy mutation - no longer used by applications.
   * Refuses a paid order (one with a captured payment): those must go through
   * `cancelOrderAsSeller`, which refunds the buyer (WHO-5590). Only unpaid
   * orders can still be cancelled here.
   * Requires authentication.
   * @deprecated Not used by the apps anymore. Paid orders: use cancelOrderAsSeller.
   */
  cancelOrder: Order;
  /**
   * Seller cancels their own sale and the buyer is refunded the purchase price (WHO-5590).
   * Two clicks: call with `confirmed: false` first for the preview (amount and
   * breakdown, guards evaluated, nothing written), then `confirmed: true` to
   * execute. The refund is the purchase price (subtotal minus discount) plus
   * shipping for non-pickup orders; the buyer protection / service fee and the
   * payment fee are NOT refunded (`breakdown.excluded`). It runs only
   * when no payout to the seller has been made or is pending; otherwise the
   * preview reports `refundable: false` with `refusalCode`, and the confirmed
   * call fails with a GraphQL error carrying the same code (`SELLER_PAYOUT_EXISTS`,
   * `ORDER_NOT_CANCELLABLE`, `ORDER_ALREADY_CANCELLED`, `ORDER_NOT_PAID`,
   * `NOTHING_TO_REFUND`, `UNSUPPORTED_CURRENCY` for non-EUR orders).
   * Idempotent: a second confirm returns `alreadyRefunded: true` and moves no money.
   * Requires authentication as the order's seller.
   */
  cancelOrderAsSeller: SellerOrderCancellation;
  /** Cancel only an unpaid provider payment, then release all of its prepared services. */
  cancelPackageCheckout: PackageCheckout;
  /**
   * Cancel a stuck or incorrect SendCloud parcel **on the seller's behalf** (CS or
   * the support orchestrator). Authenticated by the `x-whoppah-service-token`
   * header. Allowed only pre-handover — a parcel that is already moving refuses
   * with `csLabel.alreadyHandedOver`. On success the shipment returns to the
   * "no label yet" state and a follow-up `createPostalShipmentForSeller` may buy
   * a fresh label. `reason` is recorded on the shipment and in the audit trail.
   */
  cancelPostalShipmentForSeller?: Maybe<PostalShipment>;
  /**
   * Cancel a product listing
   * Authentication required
   */
  cancelProduct: Product;
  /** Check if an email address is available for registration */
  checkEmailExists: CheckEmailExistsResponse;
  /** Begin a web payment using the quoted amount. Explicit agreement to the stated terms and immediate start is required. */
  checkoutPromotion: PromotionCheckout;
  /** Clear all items from the cart */
  clearCart: Cart;
  /** Remove all items from the package cart. Requires authentication. */
  clearPackageCart: PackageCart;
  /**
   * Copy one of the caller's products into a new draft.
   * Keeps photos, description, attributes and price; resets curation, boost, stats and sales data.
   * By default the copy is titled "{title} I", then "{title} II", and so on; see CloneProductInput.
   * Authentication required
   */
  cloneProduct: Product;
  /**
   * WHO-6321: pay for the cart from an AI assistant (agent token with the checkout:pay scope only).
   * Same checks and order group as createOrderGroupForCart; the PaymentIntent is charged on the
   * platform and confirmed with the Shared Payment Token. Fails with AGENT_CHECKOUT_AMOUNT_CHANGED,
   * CART_PRICE_CHANGED or AGENT_CHECKOUT_REQUIRES_ACTION without charging.
   */
  completeAgentCheckout: OrderGroup;
  confirmNativePromotionPurchase: NativePromotionConfirmation;
  /**
   * Create a new abuse report for content or user behavior that violates platform rules.
   * Requires authentication and creates a record in the abuse report system.
   * Returns true if the report was successfully created.
   */
  createAbuseReport: Scalars['Boolean']['output'];
  /**
   * Create a new address for an authenticated merchant
   * Returns the newly created address. The merchant's first address becomes the
   * default delivery address automatically.
   */
  createAddress: Address;
  /**
   * Create a new auction for a product
   * Requires authentication
   * Returns the created auction
   */
  createAuction: Auction;
  /**
   * Create a new bid on an auction.
   * Places a bid with the specified amount on the given auction.
   * Requires authentication.
   */
  createBid: Bid;
  /** Mint a 5-minute browser token from a web session token */
  createBrowserToken: BrowserToken;
  /**
   * Create a new coming soon alert for a product
   * Requires authentication
   * Returns the created alert
   */
  createComingSoonAlert: ComingSoonAlert;
  /**
   * Create a counter-offer bid in response to an existing bid.
   * Allows merchants to negotiate by making counter-offers.
   * Requires authentication.
   */
  createCounterBid: Bid;
  /**
   * Create a draft product
   * Authentication required
   */
  createDraftProduct: Product;
  /**
   * Add an item to favorites
   * Requires authentication
   */
  createFavorite: Favorite;
  /**
   * Create a new collection to organize favorites
   * Requires authentication
   */
  createFavoriteCollection: FavoriteCollection;
  /**
   * Create feedback for an order.
   * Records delivery status and optional dispute information.
   * Requires authentication.
   */
  createFeedback: Order;
  /** Create a new member (requires authentication) */
  createMember: Member;
  /** Create a new merchant account */
  createMerchant: Merchant;
  /**
   * Create a new message in a thread.
   * Sends a message to the specified thread with the given content.
   * Requires authentication.
   */
  createMessage?: Maybe<Message>;
  /**
   * Record an Open Home deal as the seller: creates an accepted, unlisted product with a
   * published auction, places the buyer's bid for the agreed amount and accepts it through
   * the regular bid acceptance. From then on the buyer checks out as with any accepted bid.
   * Authentication required
   * @deprecated Open Home items exist from openHomeSaveRecognition on: use openHomeMakeOffer and acceptBid.
   */
  createOpenHomeDeal: OpenHomeDeal;
  createOrUpdateBankAccount: ExternalBankAccount;
  /**
   * Create an order group for the cart
   * The cart is re-priced first (accepted bid, then Pro Buyer price, then buy-now
   * price, with fresh eligibility) and the Stripe amount always equals that fresh
   * total. While the pro_buyer_program flag is on, if any line's price differs
   * from the cart's last recalculation, no order is created and nothing is
   * charged: the recalculated cart is saved (lines that went up have
   * CartItem.priceIncreased = true) and the mutation fails with
   * extensions.code CART_PRICE_CHANGED. Refetch the cart and show the new total.
   */
  createOrderGroupForCart: OrderGroup;
  /**
   * Create a payment intent for the boost cart
   * Requires authentication
   * @deprecated Use createPaymentForPackageCart — the multi-item package cart replaces the single-item boost cart.
   */
  createPaymentForBoost: BoostPayment;
  /**
   * Dynamic-pricing variant of `createPaymentForListingFee` (WHO-4942, opt-in).
   * Charges the asking-price-derived fee instead of the flat package price.
   * Requires authentication.
   */
  createPaymentForDynamicListingFee: ListingFeePayment;
  /**
   * Create a payment intent for a listing fee package purchase.
   * Creates the underlying OrderGroup + Order + ProductListingFee upfront,
   * and links the Stripe PaymentIntent to the OrderGroup. The webhook will
   * accept the OrderGroup on payment success.
   * Requires authentication.
   */
  createPaymentForListingFee: ListingFeePayment;
  /** Create a payment intent for the whole package cart. Requires authentication. */
  createPaymentForPackageCart: PackagePayment;
  /**
   * Create a postal shipment (label) for an order. Routes to the order's pinned
   * provider (Wuunder or SendCloud). Requires authentication.
   */
  createPostalShipment?: Maybe<PostalShipment>;
  /**
   * Create the postal label for an order **on the seller's behalf**, for a CS agent
   * or the support orchestrator helping a seller who cannot create it themselves.
   *
   * Authenticated by the `x-whoppah-service-token` header, not by a member session:
   * the caller is a service acting on a named order, and has no merchant identity.
   * Ownership is therefore not checked against the caller — the order names its own
   * seller, and every seller is helped, consumer or business alike.
   *
   * Deliberately narrow. It creates a label only where one is already paid for and
   * merely missing: an existing SendCloud postal shipment on an accepted or shipped
   * order. An order with no shipment, a non-postal method, a wrong state, or a
   * previous failed attempt returns an error whose `extensions.code` names the
   * reason, so the caller hands off to a human instead of substituting something
   * the buyer did not buy. If the label already exists it is returned as-is; a
   * second parcel is never bought.
   */
  createPostalShipmentForSeller?: Maybe<PostalShipment>;
  /**
   * Errors: FEATURE_DISABLED, PRO_BUYER_REQUIRED, PROJECT_NAME_INVALID (empty or
   * over 40 characters), PROJECT_NAME_TAKEN, PROJECT_NAME_CONTACT_DETAILS (an
   * e-mail address or a link; digits are allowed).
   */
  createProBuyerProject: ProBuyerProject;
  /**
   * Errors: ROOM_NAME_INVALID (empty or over 40 characters), ROOM_NAME_TAKEN,
   * ROOM_NAME_CONTACT_DETAILS (an e-mail address or a link), ROOM_LIMIT (30 per project).
   */
  createProBuyerProjectRoom: ProBuyerProjectRoom;
  /**
   * Create a new product
   * Authentication required
   */
  createProduct: Product;
  /** Create a server-priced quote for an owned listing. */
  createPromotionQuote: PromotionQuote;
  /**
   * Create a new review for a completed order
   * Requires authentication
   */
  createReview: Review;
  /**
   * Create a new saved search
   * Requires authentication
   */
  createSavedSearch: SavedSearch;
  /**
   * Create a new shipment record.
   * Links an order with tracking information.
   * Requires authentication.
   */
  createShipment: Shipment;
  createStripeAccountLink: StripeAccountLink;
  /**
   * Create a Stripe customer session.
   * Generates a session for Stripe Checkout.
   * This is used for payment processing.
   * Requires authentication.
   */
  createStripeCustomerSession: StripeCustomerSession;
  /**
   * Create a new message thread for a product.
   * Initiates a conversation between a user and a merchant about a specific product.
   * Requires authentication.
   */
  createThread: Thread;
  /**
   * Create a new Wuunder shipment for an order
   * Requires authentication
   * @param orderId - ID of the order to create shipment for
   * @returns The created shipment details
   * @deprecated Use createPostalShipment instead
   */
  createWuunderShipment?: Maybe<WuunderShipment>;
  declineReservation: SellerReservation;
  /** Soft-deletes the project. Its purchases stay in Aankopen without a project; orders and invoices never change. */
  deleteProBuyerProject: Scalars['Boolean']['output'];
  /** Its pieces stay in the project without a room. */
  deleteProBuyerProjectRoom: Scalars['Boolean']['output'];
  /**
   * Delete a message thread.
   * Returns true if successfully deleted.
   * Requires authentication.
   */
  deleteThread: Scalars['Boolean']['output'];
  /** The member declines the request. */
  denyAgentAuthorization: AgentAuthorizationDecision;
  /**
   * Disable automatic translation for a thread.
   * Messages will be shown in their original language.
   * Requires authentication.
   */
  disableThreadTranslation: Thread;
  /** Initiate password reset process for forgotten passwords */
  forgotPassword: ForgotPasswordResponse;
  /** Generate a JWT token for Iterable integration */
  generateIterableJwt: GenerateIterableJwtResponse;
  /**
   * Reads the draft's uploaded photos (and the seller's notes in `description`, optional: the v4 flow sends none),
   * generates the listing, including the buyer-facing description, and writes it onto the product.
   * Seller-owned fields (source SELLER or EDITED from a previous run) are kept. Synchronous; 25 s server timeout.
   */
  generateListing: ListingGeneration;
  /** Impersonate a user */
  impersonateUser: ImpersonateUserResponse;
  /** Invite a user to join the merchant account */
  inviteUser: InviteUserResult;
  /** Authenticate a user with email and password */
  login: LoginResponse;
  /** Authenticate using a one-time email token */
  loginWithEmailToken: EmailTokenLoginResponse;
  /** Authenticate a user using a third-party provider (Google, Apple) */
  loginWithProvider: LoginResponse;
  /** Sign out this device */
  logout: Scalars['Boolean']['output'];
  /** Sign out every device, this one included */
  logoutEverywhere: Scalars['Boolean']['output'];
  /** Stores what the owner has now seen (prices, availability, reactions). Does not bump updated. Reads: FULL or READ_ONLY. */
  markProBuyerProjectSeen: ProBuyerProject;
  /**
   * Mark a thread as read.
   * Returns thread
   * Requires authentication.
   */
  markThreadAsRead: Thread;
  /**
   * Moves the piece (note and saved price travel, the room does not; client
   * reactions stay behind, they were made on the source project's link). When
   * the target already holds the product the source piece is removed. Returns the
   * target project. Errors: PROJECT_ITEM_LIMIT.
   */
  moveProBuyerProjectItem: ProBuyerProject;
  /**
   * A signed preference-center token for the signed-in member, for links in
   * the app and in emails.
   */
  notificationPreferencesToken: Scalars['String']['output'];
  /**
   * Add one photo to a room. Atomic append, so concurrent uploads never overwrite each
   * other; a photo ID already in the room is refused. Owner only.
   *
   * @deprecated: use POST /api/v1/open-home/rooms/:roomId/photos (private storage, WHO-6035).
   */
  openHomeAddRoomPhoto: OpenHomeRoom;
  /**
   * Set the dimensions, weight, delivery and condition of an item with an accepted offer,
   * after which the buyer checks out as with any accepted bid. Owner only.
   */
  openHomeCompleteDeal: OpenHomeItem;
  /** Open a new room (at most 10 per member). Authentication required; not for Pro Buyers. */
  openHomeCreateRoom: OpenHomeRoom;
  /** Delete a room and its unsold items. Refused while an item has an open offer. Owner only. */
  openHomeDeleteRoom: Scalars['Boolean']['output'];
  /**
   * Make an offer on an approved item. Creates a regular bid. An amount below the item's
   * minimumOffer is refused (no bid is created). Accept, decline and counter use the regular bid
   * mutations. Authentication required; not for Pro Buyers.
   */
  openHomeMakeOffer: Bid;
  /**
   * Move a photo and its pieces to another room of the owner or to a new one (at most 10 rooms).
   * Returns the room the photo is in now. Owner only.
   */
  openHomeMovePhoto: OpenHomeRoom;
  /** Remove one photo from a room (atomic). Owner only. */
  openHomeRemoveRoomPhoto: OpenHomeRoom;
  /**
   * Replace a room photo with a new version: pieces move, the owner's removals go, the old photo
   * follows once nothing is shown in it. Owner only.
   */
  openHomeReplacePhoto: OpenHomeRoom;
  /**
   * Save a recognition run: replaces the room's photos, removes the items still DETECTED and
   * creates the new ones as products with a published auction without expiry. Owner only.
   */
  openHomeSaveRecognition: OpenHomeRoom;
  /**
   * Save another member's live room to the viewer's Favorites. Saving a saved room changes
   * nothing; the viewer's own rooms cannot be saved. Authentication required.
   */
  openHomeSaveRoom: OpenHomeRoom;
  /** Approve an item for offers or keep it. Owner only. */
  openHomeSetItemStatus: OpenHomeItem;
  /**
   * Remove a room from the viewer's Favorites, also when the room is no longer live. Returns
   * whether the room was saved. Authentication required.
   */
  openHomeUnsaveRoom: Scalars['Boolean']['output'];
  /** Correct an item's details or set its minimum offer. Owner only. */
  openHomeUpdateItem: OpenHomeItem;
  /** Rename, publish or hide a room. Owner only. */
  openHomeUpdateRoom: OpenHomeRoom;
  prepareNativePromotionPurchase: NativePromotionIntent;
  /**
   * Propose dates for a Brenger delivery appointment
   * Requires authentication
   */
  proposeBrengerAppointmentDates: BrengerProposedDates;
  /**
   * Publish a draft product
   * Authentication required
   */
  publishProduct: Product;
  /**
   * Public. reaction null clears this browser's reaction. entityNotFound when the
   * link is off, reactions are off or the piece is not on the client page.
   * RATE_LIMITED past 120 an hour from one address or 600 an hour on one link.
   */
  reactToProBuyerSelectionItem: Scalars['Boolean']['output'];
  /**
   * Reactivate an expiring/expired product
   * Authentication required
   */
  reactivateProduct: Product;
  /**
   * Mark a thread as read.
   * Returns true if successful.
   * Requires authentication.
   * @deprecated Please use markThreadAsRead mutation.
   */
  readThread: Scalars['Boolean']['output'];
  /** Register a Firebase Cloud Messaging token for push notifications */
  registerFCMToken: Scalars['Boolean']['output'];
  /**
   * Cancel the current label and buy a replacement on a different carrier **on the
   * seller's behalf**, for a label that exists but is unusable. `carrier` is the
   * SendCloud carrier code (e.g. `postnl`, `dhl`, `dpd`). The route, package and
   * delivery type stay exactly what the buyer paid for; only the carrier changes,
   * and only to one SendCloud quotes for this route right now. Service-point
   * shipments refuse with `csLabel.servicePointNotSupported` (the collection
   * point is carrier-specific). Returns the shipment with the new `labelUrl`
   * and `trackAndTraceCode`.
   */
  reissuePostalShipmentForSeller?: Maybe<PostalShipment>;
  /**
   * Reject a bid on an auction.
   * Marks the bid as rejected and notifies relevant parties.
   * Requires authentication.
   */
  rejectBid: Bid;
  releaseReservation: BuyerReservation;
  /**
   * Delete an address by ID
   * Requires authentication and ownership of the address
   * Returns true if deletion was successful. Rejected for the default delivery
   * address while another address exists; deleting the pinned invoice address
   * makes the invoice address follow the delivery default again.
   */
  removeAddress: Scalars['Boolean']['output'];
  /**
   * Remove a bid from the system.
   * Permanently deletes the specified bid.
   * Requires authentication.
   */
  removeBid: Scalars['Boolean']['output'];
  /**
   * Remove an item from the cart
   * Returns the removed cart item
   */
  removeCartItem: CartItem;
  /**
   * Remove a coming soon alert by ID
   * Requires authentication
   * Returns true if deletion was successful
   */
  removeComingSoonAlert: Scalars['Boolean']['output'];
  /**
   * Remove an item from favorites
   * Requires authentication
   */
  removeFavorite: Scalars['Boolean']['output'];
  /**
   * Delete a favorite collection
   * Requires authentication
   */
  removeFavoriteCollection: Scalars['Boolean']['output'];
  /** Remove an item from the package cart. Requires authentication. */
  removeFromPackageCart: PackageCart;
  /** Remove a media asset from the system */
  removeMedia: Scalars['Boolean']['output'];
  /**
   * @deprecated Not needed
   * Remove a member by ID
   * @deprecated Not needed
   */
  removeMember: Scalars['Boolean']['output'];
  /** Delete a merchant account */
  removeMerchant: Scalars['Boolean']['output'];
  /**
   * Remove a product
   * Authentication required
   */
  removeProduct: Scalars['Boolean']['output'];
  /** Never removes the favorite (R2). Idempotent. */
  removeProductFromProBuyerProject: ProBuyerProject;
  /** Takes the purchase out of its project. True when it was in one. */
  removePurchaseFromProBuyerProject: Scalars['Boolean']['output'];
  /**
   * Delete a saved search
   * Requires authentication
   */
  removeSavedSearch: Scalars['Boolean']['output'];
  /** Same errors as create, plus entityNotFound. */
  renameProBuyerProject: ProBuyerProject;
  /** Mint a 30-day web session token from the current one. revokePrevious denies the calling token. */
  renewWebSession: WebSession;
  /** Sets position = index for these items of the project (other ids are ignored). */
  reorderProBuyerProjectItems: Scalars['Boolean']['output'];
  /** Sets position = index for these rooms of the project. Returns all rooms in the new order. */
  reorderProBuyerProjectRooms: Array<ProBuyerProjectRoom>;
  /**
   * Republish a product for an order.
   * Requires authentication.
   */
  republishProductByOrderId: Order;
  /** Request account deletion for the authenticated merchant */
  requestAccountDeletion: RequestAccountDeletionResponse;
  /**
   * Ask for a US delivery quote. Returns the open quote when there already is
   * one; after EXPIRED or ITEM_SOLD it opens a new one. Errors:
   * FEATURE_DISABLED, INVALID_ADDRESS, OWN_LISTING, LISTING_NOT_QUOTABLE,
   * LIMIT_REACHED (too many open quotes across listings), NOT_FOUND,
   * DELIVERY_QUOTE_FAILED. Rate-limited per user: each request costs ops a
   * courier quote.
   */
  requestDeliveryQuote: DeliveryQuote;
  /** Request a one-time email token for authentication */
  requestEmailToken: Scalars['String']['output'];
  /**
   * Request an OTP for phone number update
   * Rate limited to 5 requests per 60 seconds
   */
  requestPhoneUpdateOTP: RequestPhoneUpdateOtpResponse;
  /** Stop delivery immediately and request a human refund assessment. */
  requestPromotionWithdrawal: PromotionCampaign;
  /**
   * `projectId` (WHO-5959 6e, optional): one of the viewer's own live Pro Buyer
   * projects. Needs the `pro_buyer_projects` flag and FULL access; else
   * FEATURE_DISABLED, PRO_BUYER_REQUIRED or entityNotFound (foreign or deleted).
   * When the reserved piece is paid, the order gets this project if it has none.
   */
  requestReservation: BuyerReservation;
  /**
   * Disable vacation mode for the merchant
   * Requires authentication
   * Returns the updated merchant
   */
  requestVacationModeDisable: Merchant;
  /**
   * Enable vacation mode for the merchant with a specified end date
   * Requires authentication
   * Returns the updated merchant
   */
  requestVacationModeEnable: Merchant;
  resumePromotionCheckout: PromotionResumeCheckout;
  /**
   * Retry creating the postal label after a failed attempt, as the seller. Clears
   * the recorded provider error and re-runs the same creation path as
   * `createPostalShipment`. Refuses when the order is not ACCEPTED, does not ship
   * by post, already has a label, or the parcel has been handed over.
   * Requires authentication.
   */
  retryPostalShipmentLabel: PostalShipment;
  /** Disconnect an AI assistant. Its tokens stop working immediately. */
  revokeAgentGrant: Scalars['Boolean']['output'];
  /**
   * Deliver a contact-form submission into the Whoppah Maison inbox.
   *
   * Callable without an account: the contact page is public. The gateway holds the
   * mesh signing secret and signs the forward itself, so no browser can sign a
   * message. Protected by Turnstile, rate limited per IP by the directive, and
   * additionally per email address inside the service.
   *
   * Identity is never asserted. A public form can claim any address, so the
   * message is delivered with every authentication verdict unverified, matching
   * what the service's own form-relay unwrap produces for Elevio submissions.
   *
   * Fails closed: an unconfigured secret or an unreachable inbox is an error the
   * form shows as its fallback, never a silent success.
   */
  sendContactMessage: SendContactMessageResponse;
  /**
   * Record whether a help article was useful.
   *
   * Callable without an account: article feedback is public. The gateway holds
   * the mesh signing secret and signs the forward itself, so no browser can sign
   * a request. Protected by Turnstile and rate limited per IP by the directive,
   * the same abuse gates as `sendContactMessage`.
   *
   * Returns true when help-service accepted the feedback. An unknown article is
   * user input; an unconfigured or unreachable help-service is an error.
   */
  sendHelpFeedback: Scalars['Boolean']['output'];
  /**
   * Send an OTP to the authenticated user
   * Rate limited to 5 requests per 60 seconds
   * Requires authentication
   */
  sendOtp: SendOtpResponse;
  /**
   * Submit platform feedback
   * Authentication required
   */
  sendPlatformFeedback?: Maybe<Scalars['Boolean']['output']>;
  /** projectId null clears it. The line must be in the viewer's cart. */
  setCartItemProBuyerProject: CartItem;
  /**
   * Make one of the merchant's own addresses the default delivery address.
   * The previous default keeps existing as an ordinary address. A pinned invoice
   * address that is the new or the previous default is cleared, so the invoice
   * address keeps following the delivery address.
   */
  setDefaultShippingAddress: Merchant;
  /**
   * Pin the invoice address for the merchant's purchases, or pass null to make it
   * follow the default delivery address again. Must be one of the merchant's own
   * addresses.
   */
  setInvoiceAddress: Merchant;
  /**
   * Seller sets or corrects one field. Writes the product and marks the field SELLER (was missing) or EDITED (was generated).
   * On a draft without a record yet (no read, or the read never answered), it first starts one filled in by hand, as
   * startListingManually does.
   */
  setListingField: ListingGeneration;
  /**
   * Set the shop-wide Pro Buyer discount of the caller's own merchant.
   * Errors: INVALID_TRADE_DISCOUNT (pct off the ladder, or enabled without pct),
   * NOT_BUSINESS_ACCOUNT, FEATURE_DISABLED. Every change writes one row to the
   * merchant's discount history (source web).
   * `pct` is required when enabling. When disabling, `pct: null` (or omitted)
   * keeps the stored percentage; a ladder value replaces it. A private
   * (non-business) account without an active discount cannot store one:
   * disabling is then a no-op that writes nothing. A merchant that changes from
   * business to individual via `updateMerchant` has its discount switched off
   * automatically (history source system).
   */
  setMerchantTradeDiscount: Merchant;
  /**
   * Set the member's preferred DISPLAY currency (WHO-5140). Pass null to clear
   * it. Persistence only: the server never applies this preference — clients
   * read it back via `me` and pass it as the `currency` query argument.
   */
  setPreferredCurrency: Member;
  /** projectId null = personal. roomId must belong to the project. */
  setProBuyerActiveProject: ProBuyerWorkspace;
  /** Register a new user account */
  signup: SignupResponse;
  /** Subscribe an email to the newsletter */
  signupForNewsletter: Scalars['Boolean']['output'];
  /**
   * Fund the buyer cash balance for an existing order group in testing.
   * Only available in testing.
   */
  simulateBankTransferForOrderGroup: OrderGroup;
  /**
   * "Fill it in myself": the seller fills the draft in by hand, with no read or after one (failed, or not their
   * piece). Returns a record with status FAILED, failureReason null and no generated fields, so `missing` is the
   * manual set. Whatever the seller already set or edited (and the buyer note) stays; values earlier reads
   * generated are taken off the product. `lang` as in generateListing (default: the account's language). Reading
   * again later (generateListing) works as a regeneration and keeps the seller's fields.
   */
  startListingManually: ListingGeneration;
  /**
   * Basic health check endpoint for mutations
   * Returns status code indicating API health
   */
  status?: Maybe<Scalars['Int']['output']>;
  /**
   * Apply for Pro Buyer status. Posts the application to the CS Slack channel
   * and stores nothing. Inputs are trimmed; all three are required, max 120 / 40
   * / 200 characters, no format checks.
   * Errors: FEATURE_DISABLED (pro_buyer_program off), INVALID_INPUT (empty or too
   * long), ALREADY_PRO_BUYER, RATE_LIMITED (3 per merchant per rolling 24 hours),
   * SUBMIT_FAILED (Slack unreachable or not configured; nothing was sent).
   */
  submitProBuyerApplication: ProBuyerApplicationResult;
  /**
   * Legacy mutation to mark a thread as read.
   * @deprecated Use readThread mutation instead.
   * @deprecated Please use the readThread mutation.
   */
  touch: Thread;
  /** Track an add-to-cart event */
  trackAddToCart: Scalars['Boolean']['output'];
  /**
   * Track a user interaction event with a platform entity.
   * Used for analytics and user behavior tracking.
   *
   * Returns true if the event was successfully recorded.
   */
  trackEvent: Scalars['Boolean']['output'];
  /**
   * Translate reviews into a specified language
   * Returns translated reviews
   */
  translateReviews?: Maybe<Array<Review>>;
  /**
   * Enable translation for a thread to a specified language.
   * Messages will be automatically translated to the target language.
   * Requires authentication.
   */
  translateThread: Thread;
  /** Unregister a Firebase Cloud Messaging token */
  unregisterFCMToken: Scalars['Boolean']['output'];
  /**
   * One-click unsubscribe (RFC 8058) from the email identified by `templateId`
   * (`campaignId` is attribution only): switches off only that email's message
   * type. Returns false when there is no templateId or it maps to no switchable type,
   * so every unsubscribe link must carry {{templateId}}.
   */
  unsubscribeFromEmail: Scalars['Boolean']['output'];
  /**
   * Update an existing address by ID
   * Requires authentication and ownership of the address
   * Returns the updated address
   */
  updateAddress: Address;
  /** Update the cart settings */
  updateCart: Cart;
  /**
   * Update a cart item's configuration
   * Returns the updated cart item
   */
  updateCartItem: CartItem;
  /**
   * Update a favorite (deprecated)
   * @deprecated Not needed
   * Requires authentication
   * @deprecated Not needed
   */
  updateFavorite: Favorite;
  /**
   * Update an existing favorite collection
   * Requires authentication
   */
  updateFavoriteCollection: FavoriteCollection;
  /** Update password using reset token */
  updateForgottenPassword: UpdateForgottenPasswordResponse;
  /** Update current member's profile */
  updateMe: Member;
  /** Update properties of a media asset */
  updateMedia: Media;
  /**
   * @deprecated Please use updateMe instead
   * Update a member's profile by ID
   * @deprecated Please use updateMe instead
   */
  updateMember: Member;
  /** Update current member's password */
  updateMemberPassword?: Maybe<Member>;
  /** Update merchant account information */
  updateMerchant: Merchant;
  /** Update merchant's bank account details */
  updateMerchantBankAccount: Merchant;
  /**
   * Save the member's message-type preferences. Only the listed keys change;
   * always-on types are never written as unsubscribed.
   */
  updateNotificationPreferences: NotificationPreferences;
  /**
   * Confirm pickup for an order.
   * Marks the order as picked up by the buyer or seller.
   * Requires authentication.
   */
  updateOrderPickupConfirmation: Order;
  /**
   * Updates the state of the order by the users.
   * Requires authentication and ownership of the order.
   */
  updateOrderState: Order;
  /**
   * Update phone number with OTP verification
   * Rate limited to 5 attempts per 60 seconds
   */
  updatePhoneWithOTP: UpdatePhoneWithOtpResponse;
  /**
   * Fix the contact fields blocking label creation **on the seller's behalf**:
   * the seller's phone number and the pickup address lines (decision D3 — wider
   * than the postcode-only rule, same constraints). Single-purpose: refuses with
   * `csLabel.fixNotBlockingLabel` once a label exists, touches only the seller
   * side of this order, audits every field with before/after, and clears the
   * recorded failed attempt so the follow-up create gets exactly one retry.
   */
  updatePostalShipmentContactForSeller?: Maybe<PostalShipment>;
  /** Errors: BRAND_PROFILE_INVALID (the field is named in the message), LOGO_INVALID. */
  updateProBuyerBrandProfile: ProBuyerBrandProfile;
  /** Errors: NOTE_INVALID. */
  updateProBuyerProjectItem: ProBuyerProjectItem;
  /** Errors: PROPOSAL_INVALID (the field is named in the message). */
  updateProBuyerProjectProposal: ProBuyerProjectProposal;
  /** Same name errors as create, plus ROOM_DESCRIPTION_INVALID (over 140 characters). */
  updateProBuyerProjectRoom: ProBuyerProjectRoom;
  /** Turning on creates a NEW token; off kills it at once. Errors: SHARE_MESSAGE_INVALID. */
  updateProBuyerProjectShare: ProBuyerProjectShare;
  /**
   * Update an existing product
   * Authentication required
   */
  updateProduct: Product;
  /**
   * Update an existing review
   * Requires authentication and ownership of the review
   */
  updateReview: Review;
  /**
   * Update an existing saved search
   * Requires authentication
   */
  updateSavedSearch: SavedSearch;
  /**
   * Update the end date of an active vacation mode
   * Requires authentication
   * Returns the updated merchant
   */
  updateVacationModeEndDate: Merchant;
  /**
   * Validate a voucher code for an order.
   * Checks if the voucher can be applied to the given amount.
   */
  validateVoucher: ValidateVoucherResult;
  /**
   * Verify an OTP provided by the user
   * Rate limited to 5 attempts per 60 seconds
   * Requires authentication
   */
  verifyOtp: VerifyOtpResponse;
  /**
   * Legacy mutation to withdraw a bid.
   * @deprecated Use cancelBid mutation instead for more detailed cancellation reasons.
   * @deprecated Please use the cancelBid mutation instead.
   */
  withdrawBid: Bid;
  /**
   * Withdraw a product from sale
   * Authentication required
   */
  withdrawProduct: Product;
};


/** Root Mutation type for all write operations in the API */
export type MutationAcceptBidArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAcceptBrengerProposedDateArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAcceptChatTosForThreadArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAcceptInvoiceMandateArgs = {
  version: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAcceptReservationArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAddBoostToPackageCartArgs = {
  input: AddBoostToPackageCartInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddListingFeeToPackageCartArgs = {
  input: AddListingFeeToPackageCartInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddProBuyerProjectItemsToCartArgs = {
  itemIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAddProductToCartArgs = {
  input: AddProductToCart;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddProductsToCartArgs = {
  input: AddProductsToCart;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddProductsToProBuyerProjectArgs = {
  productIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
  roomId?: InputMaybe<Scalars['UUID']['input']>;
  source: ProBuyerProjectItemSource;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddPromotionToPackageCartArgs = {
  input: AddPromotionToPackageCartInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddReferralCodeArgs = {
  input?: InputMaybe<AddReferralCodeInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationAddToBoostCartArgs = {
  input: AddToBoostCartInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAdmitValueCheckArgs = {
  visitorIp: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAnalyzeProductImageArgs = {
  input: AnalyzeProductImageInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAnalyzeProductImagesArgs = {
  input: AnalyzeProductImagesInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAnalyzeProductTitleAndImagesArgs = {
  input: AnalyzeProductTitleAndImagesInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationApproveAgentAuthorizationArgs = {
  input: AgentAuthorizationInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationAskProductQuestionArgs = {
  body: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationAssignPurchaseToProBuyerProjectArgs = {
  orderId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationBeginPackageCheckoutArgs = {
  input: BeginPackageCheckoutInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelBidArgs = {
  input: CancelBidInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelNativePromotionPreparationArgs = {
  intentId: Scalars['ID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelOrderArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelOrderAsSellerArgs = {
  buyerRequested?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed: Scalars['Boolean']['input'];
  orderId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelPackageCheckoutArgs = {
  id: Scalars['ID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelPostalShipmentForSellerArgs = {
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCancelProductArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCheckEmailExistsArgs = {
  email: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCheckoutPromotionArgs = {
  idempotencyKey: Scalars['String']['input'];
  immediateStartConsent: Scalars['Boolean']['input'];
  quoteId: Scalars['ID']['input'];
  termsVersion: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCloneProductArgs = {
  id: Scalars['UUID']['input'];
  input?: InputMaybe<CloneProductInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationCompleteAgentCheckoutArgs = {
  input: CompleteAgentCheckoutInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationConfirmNativePromotionPurchaseArgs = {
  channel: PromotionChannel;
  receipt: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateAbuseReportArgs = {
  input: AbuseReportInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateAddressArgs = {
  input: AddressInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateAuctionArgs = {
  input: AuctionInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateBidArgs = {
  input: BidInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateComingSoonAlertArgs = {
  input: ComingSoonAlertInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateCounterBidArgs = {
  values: CounterBidInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateDraftProductArgs = {
  input: CreateDraftProductInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateFavoriteArgs = {
  input: FavoriteInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateFavoriteCollectionArgs = {
  input: FavoriteCollectionInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateFeedbackArgs = {
  disputeReason?: InputMaybe<DisputeReason>;
  id: Scalars['UUID']['input'];
  received: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateMemberArgs = {
  input: MemberInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateMerchantArgs = {
  input: MerchantInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateOpenHomeDealArgs = {
  input: CreateOpenHomeDealInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateOrUpdateBankAccountArgs = {
  input: ExternalBankAccountInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateOrderGroupForCartArgs = {
  input?: InputMaybe<CreateOrderGroupForCartInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePaymentForBoostArgs = {
  input: CreatePaymentForBoostInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePaymentForDynamicListingFeeArgs = {
  input: CreatePaymentForListingFeeInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePaymentForListingFeeArgs = {
  input: CreatePaymentForListingFeeInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePaymentForPackageCartArgs = {
  paymentMethodId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePostalShipmentArgs = {
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePostalShipmentForSellerArgs = {
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateProBuyerProjectArgs = {
  name: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateProBuyerProjectRoomArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateProductArgs = {
  input: ProductInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreatePromotionQuoteArgs = {
  channel?: InputMaybe<PromotionChannel>;
  labelAttested?: InputMaybe<Scalars['Boolean']['input']>;
  labelCode?: InputMaybe<Scalars['String']['input']>;
  offerCode: Scalars['String']['input'];
  pack?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  purchaseContext?: InputMaybe<PromotionPurchaseContext>;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateSavedSearchArgs = {
  input: SavedSearchInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateShipmentArgs = {
  input: ShipmentInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateStripeAccountLinkArgs = {
  input: StripeAccountLinkInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationCreateWuunderShipmentArgs = {
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationDeclineReservationArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationDeleteProBuyerProjectArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationDeleteProBuyerProjectRoomArgs = {
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationDeleteThreadArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationDenyAgentAuthorizationArgs = {
  input: AgentAuthorizationInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationDisableThreadTranslationArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationGenerateIterableJwtArgs = {
  input?: InputMaybe<GenerateIterableJwtInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationGenerateListingArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  numberOfItems?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationInviteUserArgs = {
  input?: InputMaybe<InviteUserInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationLoginWithEmailTokenArgs = {
  cookie: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationLoginWithProviderArgs = {
  platform: Scalars['String']['input'];
  provider: LoginProvider;
  token: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationMarkProBuyerProjectSeenArgs = {
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationMarkThreadAsReadArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationMoveProBuyerProjectItemArgs = {
  itemId: Scalars['UUID']['input'];
  toProjectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeAddRoomPhotoArgs = {
  photo: OpenHomeRoomPhotoInput;
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeCompleteDealArgs = {
  input: OpenHomeCompleteDealInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeCreateRoomArgs = {
  input: OpenHomeCreateRoomInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeDeleteRoomArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeMakeOfferArgs = {
  amount: PriceInput;
  itemId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeMovePhotoArgs = {
  input: OpenHomeMovePhotoInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeRemoveRoomPhotoArgs = {
  photoId: Scalars['String']['input'];
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeReplacePhotoArgs = {
  input: OpenHomeReplacePhotoInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeSaveRecognitionArgs = {
  input: OpenHomeSaveRecognitionInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeSaveRoomArgs = {
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeSetItemStatusArgs = {
  id: Scalars['UUID']['input'];
  status: OpenHomeOwnerStatus;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeUnsaveRoomArgs = {
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeUpdateItemArgs = {
  id: Scalars['UUID']['input'];
  input: OpenHomeUpdateItemInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationOpenHomeUpdateRoomArgs = {
  id: Scalars['UUID']['input'];
  input: OpenHomeUpdateRoomInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationPrepareNativePromotionPurchaseArgs = {
  channel: PromotionChannel;
  idempotencyKey: Scalars['String']['input'];
  immediateStartConsent: Scalars['Boolean']['input'];
  labelAttested?: InputMaybe<Scalars['Boolean']['input']>;
  labelCode?: InputMaybe<Scalars['String']['input']>;
  offerCode: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  purchaseContext?: InputMaybe<PromotionPurchaseContext>;
  termsVersion: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationProposeBrengerAppointmentDatesArgs = {
  input: BrengerDatesProposalInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationPublishProductArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReactToProBuyerSelectionItemArgs = {
  itemId: Scalars['UUID']['input'];
  reaction?: InputMaybe<ProBuyerClientReactionValue>;
  token: Scalars['String']['input'];
  visitorId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReactivateProductArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReadThreadArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRegisterFcmTokenArgs = {
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReissuePostalShipmentForSellerArgs = {
  carrier: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRejectBidArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReleaseReservationArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveAddressArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveBidArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveCartItemArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveComingSoonAlertArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveFavoriteArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveFavoriteCollectionArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveFromPackageCartArgs = {
  kind: PackageKind;
  productId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveMediaArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveMemberArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveMerchantArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveProductArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveProductFromProBuyerProjectArgs = {
  productId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemovePurchaseFromProBuyerProjectArgs = {
  orderId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRemoveSavedSearchArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRenameProBuyerProjectArgs = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRenewWebSessionArgs = {
  revokePrevious?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationReorderProBuyerProjectItemsArgs = {
  itemIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationReorderProBuyerProjectRoomsArgs = {
  projectId: Scalars['UUID']['input'];
  roomIds: Array<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationRepublishProductByOrderIdArgs = {
  orderId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestDeliveryQuoteArgs = {
  input: RequestDeliveryQuoteInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestEmailTokenArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestPhoneUpdateOtpArgs = {
  input: RequestPhoneUpdateOtpInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestPromotionWithdrawalArgs = {
  campaignId: Scalars['ID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestReservationArgs = {
  productId: Scalars['UUID']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationRequestVacationModeEnableArgs = {
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationResumePromotionCheckoutArgs = {
  campaignId: Scalars['ID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRetryPostalShipmentLabelArgs = {
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationRevokeAgentGrantArgs = {
  id: Scalars['ID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSendContactMessageArgs = {
  input: SendContactMessageInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationSendHelpFeedbackArgs = {
  articleId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  helpful: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSendPlatformFeedbackArgs = {
  input: PlatformFeedbackInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationSetCartItemProBuyerProjectArgs = {
  cartItemId: Scalars['UUID']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationSetDefaultShippingAddressArgs = {
  addressId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSetInvoiceAddressArgs = {
  addressId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationSetListingFieldArgs = {
  input: SetListingFieldInput;
  productId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSetMerchantTradeDiscountArgs = {
  enabled: Scalars['Boolean']['input'];
  pct?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationSetPreferredCurrencyArgs = {
  currency?: InputMaybe<Currency>;
};


/** Root Mutation type for all write operations in the API */
export type MutationSetProBuyerActiveProjectArgs = {
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  roomId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationSignupArgs = {
  input: SignupInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationSignupForNewsletterArgs = {
  email: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSimulateBankTransferForOrderGroupArgs = {
  input: SimulateBankTransferForOrderGroupInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationStartListingManuallyArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  numberOfItems?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationSubmitProBuyerApplicationArgs = {
  companyName: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
  website: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationTouchArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationTrackAddToCartArgs = {
  input: TrackAddToCart;
};


/** Root Mutation type for all write operations in the API */
export type MutationTrackEventArgs = {
  entity?: InputMaybe<Entity>;
  event?: InputMaybe<Event>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationTranslateReviewsArgs = {
  ids: Array<Scalars['UUID']['input']>;
  lang: Language;
};


/** Root Mutation type for all write operations in the API */
export type MutationTranslateThreadArgs = {
  input: TranslateThreadInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUnregisterFcmTokenArgs = {
  token: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUnsubscribeFromEmailArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateAddressArgs = {
  id: Scalars['UUID']['input'];
  input: AddressInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateCartArgs = {
  input?: InputMaybe<UpdateCartInput>;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateCartItemArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateCartItemInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateFavoriteArgs = {
  id: Scalars['UUID']['input'];
  input: FavoriteInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateFavoriteCollectionArgs = {
  id: Scalars['UUID']['input'];
  input: FavoriteCollectionInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateForgottenPasswordArgs = {
  input: UpdateForgottenPasswordInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMeArgs = {
  input: MeInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMediaArgs = {
  id: Scalars['UUID']['input'];
  input: MediaUpdateInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMemberArgs = {
  id: Scalars['UUID']['input'];
  input: MemberInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMemberPasswordArgs = {
  input?: InputMaybe<UpdateMemberPassword>;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMerchantArgs = {
  id: Scalars['UUID']['input'];
  input: MerchantInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateMerchantBankAccountArgs = {
  id: Scalars['UUID']['input'];
  input: BankAccountInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateNotificationPreferencesArgs = {
  input: Array<NotificationPreferenceInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateOrderPickupConfirmationArgs = {
  input: UpdateOrderPickupConfirmationInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateOrderStateArgs = {
  input: UpdateOrderStateInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdatePhoneWithOtpArgs = {
  input: UpdatePhoneWithOtpInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdatePostalShipmentContactForSellerArgs = {
  input: PostalShipmentContactFixInput;
  orderId: Scalars['String']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProBuyerBrandProfileArgs = {
  input: ProBuyerBrandProfileInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProBuyerProjectItemArgs = {
  input: ProBuyerProjectItemInput;
  itemId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProBuyerProjectProposalArgs = {
  input: ProBuyerProjectProposalInput;
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProBuyerProjectRoomArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProBuyerProjectShareArgs = {
  input: ProBuyerProjectShareInput;
  projectId: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateProductArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateProductInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateReviewArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateReviewInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateSavedSearchArgs = {
  id: Scalars['UUID']['input'];
  input: SavedSearchInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationUpdateVacationModeEndDateArgs = {
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationValidateVoucherArgs = {
  code: Scalars['String']['input'];
  currency?: InputMaybe<Currency>;
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
};


/** Root Mutation type for all write operations in the API */
export type MutationVerifyOtpArgs = {
  input: VerifyOtpInput;
};


/** Root Mutation type for all write operations in the API */
export type MutationWithdrawBidArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Mutation type for all write operations in the API */
export type MutationWithdrawProductArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<ProductWithdrawReason>;
};

export type NativePromotionConfirmation = {
  __typename?: 'NativePromotionConfirmation';
  campaign: PromotionCampaign;
  finishTransaction: Scalars['Boolean']['output'];
};

export type NativePromotionIntent = {
  __typename?: 'NativePromotionIntent';
  accountToken: Scalars['String']['output'];
  channel: PromotionChannel;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  storeProductId: Scalars['String']['output'];
  termsVersion: Scalars['String']['output'];
};

export type Node = {
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * One message type with its per-channel state. Iterable is the source of truth for
 * email and push; WhatsApp is the merchant's own setting and only exists on Bidding.
 */
export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  /** Order, shipping, payout, account and legal mail can never be switched off. */
  alwaysOn: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  /** Stable key of the message type, e.g. NEWSLETTER. Send it back in the input. */
  key: Scalars['String']['output'];
  push: Scalars['Boolean']['output'];
  section: NotificationPreferenceSection;
  /** Null when the message type has no WhatsApp variant. */
  whatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPreferenceInput = {
  email: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  push: Scalars['Boolean']['input'];
  /** Ignored for message types without a WhatsApp variant. */
  whatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A group of message types as the preference center shows them (WHO-5615). */
export enum NotificationPreferenceSection {
  Transactional = 'TRANSACTIONAL',
  UserActions = 'USER_ACTIONS',
  WhoppahActions = 'WHOPPAH_ACTIONS'
}

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  preferences: Array<NotificationPreference>;
};

/** Available methods for OTP delivery */
export enum OtpMethod {
  /** Send OTP via SMS */
  Sms = 'SMS',
  /** Send OTP via WhatsApp */
  Whatsapp = 'WHATSAPP'
}

/** Where an item sits in a room photo, as fractions (0..1) of the photo's width and height. */
export type OpenHomeBox = {
  __typename?: 'OpenHomeBox';
  bottom: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  photoId?: Maybe<Scalars['String']['output']>;
  right: Scalars['Float']['output'];
  top: Scalars['Float']['output'];
};

export type OpenHomeBoxInput = {
  bottom: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  photoId?: InputMaybe<Scalars['String']['input']>;
  right: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export type OpenHomeBrowseFilters = {
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /** Only items of this member's rooms */
  merchantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive title search */
  query?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The details an item with an accepted offer needs before the buyer can check out, as in ProductInput. */
export type OpenHomeCompleteDealInput = {
  address?: InputMaybe<Scalars['UUID']['input']>;
  condition: ProductCondition;
  customShippingPrices?: InputMaybe<Array<CustomShippingPriceInput>>;
  delivery_method: DeliveryMethod;
  depth?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['UUID']['input'];
  postalPackageSize?: InputMaybe<PostalPackageSize>;
  quality?: InputMaybe<ProductQuality>;
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenHomeCreateRoomInput = {
  name: Scalars['String']['input'];
};

/**
 * An Open Home deal: the product, its auction and the accepted bid the buyer checks out with.
 * Images are uploaded afterwards to the product, through the same media upload as any product.
 */
export type OpenHomeDeal = {
  __typename?: 'OpenHomeDeal';
  auctionId: Scalars['UUID']['output'];
  bid: Bid;
  bidId: Scalars['UUID']['output'];
  product: Product;
  productId: Scalars['UUID']['output'];
};

/**
 * An item in an Open Home room. It is a regular product (open_home) with a published
 * auction without expiry, so offers are regular bids.
 */
export type OpenHomeItem = {
  __typename?: 'OpenHomeItem';
  /** Whether members can make offers below the price. Off means the piece only sells at buyNowPrice. */
  allowOffers: Scalars['Boolean']['output'];
  auction: Auction;
  box?: Maybe<OpenHomeBox>;
  /**
   * The owner's price, if set. A member who takes it gets the piece at that price at once (the
   * offer is accepted); the owner then adds the details and the buyer checks out, as after any
   * accepted offer. Never a direct checkout.
   */
  buyNowPrice?: Maybe<Price>;
  /** Color attribute slugs, as on any product */
  colors: Array<Scalars['String']['output']>;
  condition?: Maybe<ProductCondition>;
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The era: the decade style slug among the styles (e.g. 1960), if any */
  era?: Maybe<Scalars['String']['output']>;
  /** The product ID */
  id: Scalars['UUID']['output'];
  /** Whether the viewer owns the item */
  isOwner: Scalars['Boolean']['output'];
  /** Material attribute slugs, as on any product */
  materials: Array<Scalars['String']['output']>;
  /**
   * The owner's minimum offer, if set. Shown to every member who can see the item;
   * openHomeMakeOffer refuses a lower amount.
   */
  minimumOffer?: Maybe<Price>;
  /** The viewer's latest offer on the item, if any */
  myOffer?: Maybe<Bid>;
  /** Open (new or accepted) offers on the item. Only returned to the owner; empty for others. */
  offers: Array<Bid>;
  /**
   * Sold-price range of comparable realised sales on Whoppah, for the owner only (null for
   * anyone else). Same pricing-service answer and cache as Query.priceRecommendation with
   * surface DETAIL (may live-score), but without the asking-price rule: `OK` whenever the
   * engine answers with MEDIUM or HIGH confidence, `REFUSED` otherwise. An item without a
   * quality is scored at the lowest and the highest quality class and gets one broad range
   * (low of the lowest, high of the highest, expected their midpoint) with
   * `conditionDependent: true`. Without a level-1 category, the item's own (recognition)
   * category is used; only an item with no category at all is refused.
   */
  priceRange?: Maybe<PriceRecommendation>;
  product: Product;
  quality?: Maybe<ProductQuality>;
  /** The recognition record (brand claim, confidence, corrections). Only returned to the owner. */
  recognition?: Maybe<Scalars['JSON']['output']>;
  room?: Maybe<OpenHomeRoom>;
  status: OpenHomeItemStatus;
  /** Style attribute slugs, including the era style if set */
  styles: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OpenHomeItemPage = {
  __typename?: 'OpenHomeItemPage';
  items: Array<OpenHomeItem>;
  pagination: PaginationResult;
};

/**
 * Where an Open Home item is in its life. Items are created DETECTED when the room's
 * recognition finishes; the owner then approves (open to offers) or keeps each one.
 */
export enum OpenHomeItemStatus {
  /** Open to offers from members */
  Approved = 'APPROVED',
  /** Recognised in the room photo, the owner has not decided yet */
  Detected = 'DETECTED',
  /** The owner keeps it: visible in the room, no offers */
  Kept = 'KEPT',
  /** At least one offer is open or accepted and not yet paid */
  OfferPending = 'OFFER_PENDING',
  /** Upgraded by CS to a regular listing; no longer an Open Home item */
  Published = 'PUBLISHED',
  /** Paid by the buyer */
  Sold = 'SOLD'
}

/**
 * Move one photo, with the pieces whose main view is in it, to another room of the owner or to
 * a new room. Pieces keep their offers; the photo keeps its privacy processing.
 */
export type OpenHomeMovePhotoInput = {
  newRoomName?: InputMaybe<Scalars['String']['input']>;
  photoId: Scalars['String']['input'];
  roomId: Scalars['UUID']['input'];
  /** An existing room of the owner. Leave empty to open a new room named newRoomName. */
  toRoomId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The statuses an owner can set directly. */
export enum OpenHomeOwnerStatus {
  Approved = 'APPROVED',
  Kept = 'KEPT'
}

/**
 * One piece seen again: its new place, in the new photo (box.photoId empty) or in another photo of
 * the room it was also seen in (box.photoId).
 */
export type OpenHomePieceMoveInput = {
  box: OpenHomeBoxInput;
  itemId: Scalars['UUID']['input'];
};

/** One item the recognition found in the room photos. */
export type OpenHomeRecognizedItemInput = {
  box: OpenHomeBoxInput;
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /** Color attribute slugs. Unknown slugs are dropped (kept in recognition.droppedAttributes). */
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Era as a decade style slug (e.g. 1960), stored as one of the styles. Dropped when not a decade. */
  era?: InputMaybe<Scalars['String']['input']>;
  /** Material attribute slugs. Unknown slugs are dropped (kept in recognition.droppedAttributes). */
  materials?: InputMaybe<Array<Scalars['String']['input']>>;
  quality?: InputMaybe<ProductQuality>;
  /** Brand claim, confidence and anything else the recognition returned */
  recognition?: InputMaybe<Scalars['JSON']['input']>;
  /** Style attribute slugs. Unknown slugs are dropped (kept in recognition.droppedAttributes). */
  styles?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

/**
 * A new version of a room photo. The new photo is already uploaded to the room. Pieces seen
 * again move to their new place; pieces the owner says are gone are removed (never one with a
 * live offer or a sale). The old photo goes once no piece is shown in it anymore; a sold piece
 * does not hold it.
 */
export type OpenHomeReplacePhotoInput = {
  moves: Array<OpenHomePieceMoveInput>;
  newPhotoId: Scalars['String']['input'];
  oldPhotoId: Scalars['String']['input'];
  removeItemIds: Array<Scalars['UUID']['input']>;
  roomId: Scalars['UUID']['input'];
};

/** A room a member opened up: its photos and the items recognised in them. */
export type OpenHomeRoom = {
  __typename?: 'OpenHomeRoom';
  /** City of the owner's default address (never the street or postcode). Null unless the viewer owns the room or is staff. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country code of the owner's default address. Null unless the viewer owns the room or is staff. */
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /** Paused by the owner */
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** Whether the viewer owns the room */
  isOwner: Scalars['Boolean']['output'];
  /**
   * Items in the room. The owner sees every item; other members see the approved, kept,
   * offer-pending and sold items of a published room.
   */
  items: Array<OpenHomeItem>;
  merchant: Merchant;
  /** The lister's room name, e.g. Living room */
  name: Scalars['String']['output'];
  photos: Array<OpenHomeRoomPhoto>;
  /** Live for members */
  published: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
};

/** A privacy-processed room photo. */
export type OpenHomeRoomPhoto = {
  __typename?: 'OpenHomeRoomPhoto';
  /** Regions blurred for privacy, as produced by the web's photo processing */
  blurredRegions?: Maybe<Scalars['JSON']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * Where to load the photo. A photo in private storage gives the gateway-relative path
   * /api/v1/open-home/rooms/<roomId>/photos/<photoId> (authenticated members only); an older
   * photo gives its stored URL.
   */
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type OpenHomeRoomPhotoInput = {
  blurredRegions?: InputMaybe<Scalars['JSON']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenHomeSaveRecognitionInput = {
  items: Array<OpenHomeRecognizedItemInput>;
  /** Replaces the room's photos */
  photos: Array<OpenHomeRoomPhotoInput>;
  roomId: Scalars['UUID']['input'];
  /** Model, ms, tokens and cost_usd of this recognition run */
  run?: InputMaybe<Scalars['JSON']['input']>;
};

export type OpenHomeUpdateItemInput = {
  /** Offers below the price on or off. Off needs a price. */
  allowOffers?: InputMaybe<Scalars['Boolean']['input']>;
  box?: InputMaybe<OpenHomeBoxInput>;
  /** The owner confirmed the recognised brand (recognition record) */
  brandConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['UUID']['input']>;
  /** The owner is unsure about the brand (recognition record) */
  brandUnsure?: InputMaybe<Scalars['Boolean']['input']>;
  /** The owner's price in the item's currency, shown to members. Null clears it (offers then stay on). */
  buyNowPrice?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /** Color attribute slugs; replaces the item's colors. Unknown slugs are refused. */
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<ProductCondition>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Era as a decade style slug (e.g. 1960), stored as one of the styles. Null removes it. */
  era?: InputMaybe<Scalars['String']['input']>;
  /** The owner's size estimate, kept in the recognition record */
  estimatedSize?: InputMaybe<Scalars['String']['input']>;
  /** Material attribute slugs; replaces the item's materials. Unknown slugs are refused. */
  materials?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Minimum offer in the item's currency, shown to members. Null clears it. */
  minimumOffer?: InputMaybe<Scalars['Float']['input']>;
  quality?: InputMaybe<ProductQuality>;
  /** Merged (shallow) into the recognition record */
  recognition?: InputMaybe<Scalars['JSON']['input']>;
  /** Style attribute slugs; replaces the item's styles. Unknown slugs are refused. */
  styles?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OpenHomeUpdateRoomInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a purchase order in the system.
 * Contains all information about a transaction including buyer, seller, product, and delivery details.
 */
export type Order = {
  __typename?: 'Order';
  /** Why the sale needs action; null unless sellerStatus is ACTION_NEEDED. */
  actionNeededCause?: Maybe<ActionNeededCause>;
  /** Delivery address for the order (snapshot taken at checkout) */
  address?: Maybe<OrderAddress>;
  /** Associated auction */
  auction: Auction;
  /** Associated bid if purchase was through bidding */
  bid?: Maybe<Bid>;
  /** Boost package being purchased */
  boostPackage?: Maybe<BoostPackage>;
  /** Brenger delivery appointment */
  brengerAppointment?: Maybe<BrengerAppointment>;
  /** Bumbal delivery service buyer ID */
  bumbal_buyer_uuid?: Maybe<Scalars['String']['output']>;
  /** Bumbal delivery service seller ID */
  bumbal_seller_uuid?: Maybe<Scalars['String']['output']>;
  /** Buyer merchant details */
  buyer: Merchant;
  /** ID of the buyer merchant */
  buyerId: Scalars['UUID']['output'];
  /** Whether the buyer has confirmed pickup */
  buyerPickupConfirmationStatus?: Maybe<OrderPickupConfirmationStatus>;
  /**
   * Buyer protection fee (incl. VAT) as a typed price; zero when buyer protection was not taken.
   * Buyer money in the order currency (EUR), never display-converted: it is what was charged (WHO-5991 decision 5).
   */
  buyerProtectionAmount: Price;
  /** Buyer protection fees excluding VAT */
  buyer_protection_excl_vat: Scalars['Float']['output'];
  /**
   * Buyer protection fees including VAT
   * @deprecated Use buyerProtectionAmount
   */
  buyer_protection_incl_vat: Scalars['Float']['output'];
  /** URL to buyer's receipt */
  buyer_receipt?: Maybe<Scalars['String']['output']>;
  /** Buyer's tracking number */
  buyer_track_and_trace?: Maybe<Scalars['String']['output']>;
  /** Whether the product can be republished */
  canRepublishProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the order is eligible for pickup confirmation */
  canUpdatePickupConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * WHO-6309: Whoppah's commission invoice at /api/v1/order/commission-invoice/<pk>/. Seller of a
   * paid sale on which commission was charged; false while the flag is off (except in the preview).
   */
  commissionInvoiceAvailable: Scalars['Boolean']['output'];
  /**
   * The commission rate this sale was charged, in percent, from the order's own
   * fee snapshot: the rate for a percentage fee, null for a fixed fee. Same
   * meaning as `PayoutQuote.commissionPercent`. Null unless the viewer is the
   * seller.
   */
  commissionPercent?: Maybe<Scalars['Float']['output']>;
  /** When the order was created */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Credit card processing fees excluding VAT */
  credit_card_cost_excl_vat: Scalars['Float']['output'];
  /** Credit card processing fees including VAT */
  credit_card_cost_incl_vat: Scalars['Float']['output'];
  /** Currency of the transaction */
  currency: Currency;
  /**
   * Tracking link or transporter details the seller shared when marking a custom
   * delivery as on its way. Optional; never a precondition for the buyer's receipt
   * confirmation (WHO-5520).
   */
  customDeliveryTracking?: Maybe<Scalars['String']['output']>;
  /** URL to damage report form */
  damageFormUrl?: Maybe<Scalars['String']['output']>;
  /** Feedback about the delivery */
  delivery_feedback?: Maybe<Scalars['String']['output']>;
  /** Method of delivery */
  delivery_method: DeliveryMethod;
  /**
   * Applied discounts (incl. VAT) as a typed price.
   * Buyer money in the order currency (EUR), never display-converted: it is what was charged (WHO-5991 decision 5).
   */
  discountAmount: Price;
  /** Applied discounts excluding VAT */
  discount_excl_vat: Scalars['Float']['output'];
  /**
   * Applied discounts including VAT
   * @deprecated Use discountAmount
   */
  discount_incl_vat: Scalars['Float']['output'];
  /** Reason if order is disputed */
  disputeReason?: Maybe<Scalars['String']['output']>;
  /** When the order was completed */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** When the order will expire */
  expiry_date: Scalars['DateTime']['output'];
  /** Whether delivery is handled externally */
  external_delivery?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Platform fee (incl. VAT) as a typed price.
   * Seller settlement money: never display-converted — the currency is the settlement currency.
   */
  feeAmount: Price;
  /**
   * The VAT charged on top of the platform fee (fee incl. VAT − fee excl. VAT),
   * rounded to the cent; zero unless the sale was made by a business seller who
   * pays VAT on fees (the order's own snapshot, so it matches the seller's
   * `payoutQuote.feeVat` and does not change when the account does). For the
   * seller's breakdown, so clients do not subtract (WHO-6000). Null unless the
   * viewer is the seller. Seller settlement money: never display-converted.
   */
  feeVatAmount?: Maybe<Price>;
  /** Platform fees excluding VAT */
  fee_excl_vat: Scalars['Float']['output'];
  /**
   * Platform fees including VAT
   * @deprecated Use feeAmount
   */
  fee_incl_vat: Scalars['Float']['output'];
  /** Unique identifier for the order */
  id: Scalars['UUID']['output'];
  /** Human-readable order identifier */
  identifier: Scalars['String']['output'];
  /** WHO-6309: the viewer is the seller of a paid order and may upload or replace the invoice PDF. */
  invoiceUploadAllowed: Scalars['Boolean']['output'];
  /**
   * Invoice address for the order, snapshot taken at checkout (WHO-5532).
   * Null means it was the same as the delivery address.
   */
  invoice_address?: Maybe<OrderAddress>;
  isProBuyerPurchase: Scalars['Boolean']['output'];
  /** Snapshot at payment: the regular buy-now price. Null unless Pro Buyer purchase. */
  listPrice?: Maybe<Price>;
  /** Seller merchant details */
  merchant: Merchant;
  /** ID of the seller merchant */
  merchantId: Scalars['UUID']['output'];
  /** External shipping provider if used */
  outsourceShippingMethod?: Maybe<Scalars['String']['output']>;
  /** Stripe payment processing details */
  payment?: Maybe<StripePayment>;
  /** Live Stripe PaymentIntent while the order is awaiting payment */
  paymentIntent?: Maybe<StripePaymentIntent>;
  /**
   * Legacy payment cost excluding VAT
   * @deprecated Field no longer supported
   */
  payment_excl_vat: Scalars['Float']['output'];
  /**
   * Legacy payment cost including VAT
   * @deprecated Field no longer supported
   */
  payment_incl_vat: Scalars['Float']['output'];
  /** Current payment processing status */
  payment_status?: Maybe<PaymentStatus>;
  /**
   * Amount to be paid out to seller
   * @deprecated Use payoutAmount
   */
  payout: Scalars['Float']['output'];
  /**
   * Amount to be paid out to the seller, as a typed price.
   * Seller settlement money: never display-converted — the currency is the settlement currency.
   */
  payoutAmount: Price;
  /**
   * Get detailed payout information.
   * Includes status, timing, and localized descriptions.
   */
  payoutDetails?: Maybe<PayoutDetails>;
  /**
   * Estimated payout date (deprecated)
   * @deprecated Use payoutDetails.eta instead
   */
  payout_eta?: Maybe<Scalars['Date']['output']>;
  /**
   * Legacy payout status field
   * @deprecated Use payoutDetails.status instead
   */
  payout_status?: Maybe<PayoutStatus>;
  /** Stripe payout reference ID */
  payout_trace_id?: Maybe<Scalars['String']['output']>;
  /** PayPal processing fees excluding VAT */
  paypal_cost_excl_vat: Scalars['Float']['output'];
  /** PayPal processing fees including VAT */
  paypal_cost_incl_vat: Scalars['Float']['output'];
  /** Postal shipment details (Wuunder or SendCloud). Provider-neutral. */
  postalShipment?: Maybe<PostalShipment>;
  /** Snapshot at payment: listPrice minus the item price. Null unless Pro Buyer purchase. */
  proBuyerDiscount?: Maybe<Price>;
  /** Snapshot at payment: the Pro Buyer percentage. Null unless Pro Buyer purchase. */
  proBuyerPct?: Maybe<Scalars['Int']['output']>;
  /**
   * Product being purchased. Always present: `sales_order.product_id` is NOT NULL with an
   * enforced foreign key to `catalog_product`, and soft-deleted products still resolve because
   * the lookup includes deleted rows. Keep this non-null: every client compiles against it.
   */
  product: Product;
  /** How the product was purchased (bid or direct) */
  purchase_type: PurchaseType;
  /** Brenger return delivery appointment */
  returnBrengerAppointment?: Maybe<BrengerAppointment>;
  /** Status of return case if applicable */
  returnCaseStatus?: Maybe<Scalars['String']['output']>;
  /** Method used for return shipping */
  returnShippingMethod?: Maybe<Scalars['String']['output']>;
  /** Buyer's review of the purchase */
  review?: Maybe<Review>;
  /**
   * WHO-6309: the seller's download of /api/v1/order/invoice/<pk>/ is the Sales confirmation
   * (the sales overview, Whoppah named only on the commission line). Seller only; false on a
   * Boost or plan order and while the flag is off (except in the Statsig preview).
   */
  salesConfirmationAvailable: Scalars['Boolean']['output'];
  /**
   * WHO-6309: the generated seller invoice can be downloaded from
   * /api/v1/order/seller-invoice/<pk>/ (buyer or seller, GENERATED mode, number assigned).
   * False while the `seller_invoice_v1` flag is off.
   */
  sellerInvoiceAvailable: Scalars['Boolean']['output'];
  /** WHO-6309: NONE while the flag is off or the viewer is neither buyer nor seller. */
  sellerInvoiceMode: SellerInvoiceMode;
  /** WHO-6309: `<seller.identifier>-<YYYY>-<000001>`, once assigned at payment. Buyer or seller only. */
  sellerInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** WHO-6309: the seller's uploaded invoice, for buyer and seller. Null when there is none. */
  sellerInvoiceUpload?: Maybe<SellerInvoiceUpload>;
  /** Whether the seller has confirmed pickup */
  sellerPickupConfirmationStatus?: Maybe<OrderPickupConfirmationStatus>;
  /**
   * What this sale is to its seller in My sales (WHO-6062). Null when the viewer
   * is not the seller, or when the sale is not in My sales: an unpaid (NEW) or
   * expired order, the two states the `sales` list leaves out.
   */
  sellerStatus?: Maybe<SellerSaleStatus>;
  /** URL to seller's receipt */
  seller_receipt?: Maybe<Scalars['String']['output']>;
  /** Seller's tracking number */
  seller_track_and_trace?: Maybe<Scalars['String']['output']>;
  /** Service fees excluding VAT */
  service_cost_excl_vat: Scalars['Float']['output'];
  /** Service fees including VAT */
  service_cost_incl_vat: Scalars['Float']['output'];
  /** Target product for service orders */
  service_target?: Maybe<Product>;
  /** Shipment tracking details */
  shipment?: Maybe<Shipment>;
  /**
   * Shipping cost (incl. VAT) as a typed price.
   * Buyer money in the order currency (EUR), never display-converted: it is what was charged (WHO-5991 decision 5).
   */
  shippingAmount: Price;
  /** Shipping cost excluding VAT */
  shipping_excl_vat: Scalars['Float']['output'];
  /**
   * Shipping cost including VAT
   * @deprecated Use shippingAmount
   */
  shipping_incl_vat: Scalars['Float']['output'];
  /** Selected shipping method */
  shipping_method?: Maybe<ShippingMethod>;
  /** Current state of the order */
  state: OrderState;
  /**
   * Subtotal (incl. VAT) as a typed price.
   * Buyer money in the order currency (EUR), never display-converted: it is what was charged (WHO-5991 decision 5).
   */
  subtotalAmount: Price;
  /** Subtotal excluding VAT */
  subtotal_excl_vat: Scalars['Float']['output'];
  /**
   * Subtotal including VAT
   * @deprecated Use subtotalAmount
   */
  subtotal_incl_vat: Scalars['Float']['output'];
  /** Message thread between buyer and seller */
  thread?: Maybe<Thread>;
  /**
   * Final total (incl. VAT) as a typed price.
   * Buyer money in the order currency (EUR), never display-converted: it is what was charged (WHO-5991 decision 5).
   */
  totalAmount: Price;
  /** Final total excluding VAT */
  total_excl_vat: Scalars['Float']['output'];
  /**
   * Final total including VAT
   * @deprecated Use totalAmount
   */
  total_incl_vat: Scalars['Float']['output'];
  /** Comprehensive cost breakdown */
  totals?: Maybe<CartTotals>;
  /** WHO-6309: the Whoppah invoice (courier shipping, buyer protection) at /api/v1/order/whoppah-invoice/<pk>/. Buyer only. */
  whoppahInvoiceAvailable: Scalars['Boolean']['output'];
  /**
   * Wuunder shipment details. Deprecated alias for postalShipment.
   * @deprecated Use postalShipment instead
   */
  wuunderShipment?: Maybe<WuunderShipment>;
};


/**
 * Represents a purchase order in the system.
 * Contains all information about a transaction including buyer, seller, product, and delivery details.
 */
export type OrderDamageFormUrlArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Represents a purchase order in the system.
 * Contains all information about a transaction including buyer, seller, product, and delivery details.
 */
export type OrderPayoutDetailsArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Address information for order delivery or billing.
 * Contains all components needed for shipping or invoicing.
 */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** City name */
  city: Scalars['String']['output'];
  /** Country code */
  country: Scalars['String']['output'];
  /** Primary address line */
  line1: Scalars['String']['output'];
  /** Secondary address line (optional) */
  line2?: Maybe<Scalars['String']['output']>;
  /** Full name of the recipient */
  name: Scalars['String']['output'];
  /** Postal/ZIP code */
  postal_code: Scalars['String']['output'];
  /** State/province/region */
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Methods available for order delivery.
 * Defines how products will be delivered to buyers.
 */
export enum OrderDeliveryMethod {
  /** Standard delivery service */
  Delivery = 'DELIVERY',
  /** Third-party delivery service */
  ExternalDelivery = 'EXTERNAL_DELIVERY',
  /** Buyer picks up from seller */
  Pickup = 'PICKUP'
}

export type OrderFilter = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};

/**
 * Available filter keys for querying orders.
 * Used to search and filter orders by various criteria.
 */
export enum OrderFilterKey {
  /** Filter by auction */
  Auction = 'AUCTION',
  /** Filter by associated bid */
  Bid = 'BID',
  /** Filter by bid state */
  BidState = 'BID__STATE',
  /** Filter by buyer */
  Buyer = 'BUYER',
  /** Filter by delivery method */
  DeliveryMethod = 'DELIVERY_METHOD',
  /** Filter by seller merchant */
  Merchant = 'MERCHANT',
  /** Filter by product */
  Product = 'PRODUCT',
  /** Filter by product title */
  ProductTitle = 'PRODUCT__TITLE',
  /** Filter by shipping method */
  ShippingMethod = 'SHIPPING_METHOD',
  /** Filter by order state */
  State = 'STATE'
}

/**
 * Groups multiple related orders together.
 * Used for handling multiple products or services purchased together.
 */
export type OrderGroup = {
  __typename?: 'OrderGroup';
  /** Billing address for payment */
  billingAddress?: Maybe<OrderAddress>;
  /** Customer who placed the order */
  buyer: Merchant;
  /** Applied coupon code if any */
  couponCode?: Maybe<Scalars['String']['output']>;
  /** When the order group was created */
  created?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Legacy field for external delivery status
   * @deprecated Shouldn't be used anymore
   */
  hasExternalDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the order group */
  id: Scalars['UUID']['output'];
  /** Individual orders in this group */
  orders: Array<Order>;
  /** Payment processing details */
  payment?: Maybe<OrderGroupPayment>;
  /** Live Stripe PaymentIntent while the order group is awaiting payment */
  paymentIntent?: Maybe<StripePaymentIntent>;
  /** Selected payment method */
  paymentMethod: PaymentMethod;
  /** Human-readable order group identifier */
  readableId?: Maybe<Scalars['String']['output']>;
  /** Delivery address for the orders */
  shippingAddress?: Maybe<OrderAddress>;
  /** Cost breakdown for the entire group */
  totals: OrderGroupTotals;
  /** Type of orders in this group */
  type: OrderGroupType;
};

/** Represents the cost breakdown for additional services in an order group. */
export type OrderGroupAddonTotals = {
  __typename?: 'OrderGroupAddonTotals';
  /** The additional service being charged */
  addon: Service;
  /** Cost of the addon service */
  price: Price;
};

/**
 * Payment information for an order group.
 * Contains Stripe payment intent details.
 */
export type OrderGroupPayment = {
  __typename?: 'OrderGroupPayment';
  /** Client secret for Stripe payment processing */
  paymentClientSecret: Scalars['String']['output'];
  /** Stripe payment intent identifier */
  paymentIntentId: Scalars['String']['output'];
};

/**
 * Comprehensive cost breakdown for an order group.
 * Includes all components that make up the final price.
 */
export type OrderGroupTotals = {
  __typename?: 'OrderGroupTotals';
  /** List of additional service costs */
  addons: Array<OrderGroupAddonTotals>;
  /**
   * The total in `currency`, a guide shown small next to the EUR total, with a
   * line that the buyer's bank converts at its own rate (WHO-5991 decision 5).
   * Converted once from the EUR total, so it is the honest conversion of what is
   * charged. Every other amount here stays EUR. Null when `currency` is omitted,
   * is EUR, or has no rate.
   */
  convertedTotal?: Maybe<Price>;
  /** Applied discounts */
  discount: Price;
  /** Service fees */
  serviceCost: Price;
  /** Shipping costs */
  shipping: Price;
  /** Pre-tax subtotal */
  subtotal: Price;
  /** Total tax amount */
  tax: Price;
  /** Final total including all costs and discounts */
  total: Price;
};


/**
 * Comprehensive cost breakdown for an order group.
 * Includes all components that make up the final price.
 */
export type OrderGroupTotalsConvertedTotalArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/**
 * Types of order groups that can be created in the system.
 * Each type represents a different kind of purchase or service request.
 */
export enum OrderGroupType {
  /** Advertisement boost purchase */
  BoostAd = 'BOOST_AD',
  /** Courier service request */
  Courier = 'COURIER',
  /** Standard product purchases */
  Products = 'PRODUCTS',
  /** Request for showroom services */
  ShowroomRequest = 'SHOWROOM_REQUEST'
}

export type OrderInput = {
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  bid_id?: InputMaybe<Scalars['UUID']['input']>;
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  /** @deprecated Please use `shippingMethod` and `shippingProvider` instead. */
  delivery_method?: InputMaybe<DeliveryMethod>;
  external_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  external_shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_method?: InputMaybe<PaymentMethod>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['UUID']['input']>;
  purchase_type?: PurchaseType;
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
  shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  use_payment_intents?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderPickupConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Denied = 'DENIED'
}

export type OrderResult = {
  __typename?: 'OrderResult';
  items: Array<Order>;
  pagination: PaginationResult;
};

/**
 * Available sorting options for order listings.
 * Determines how orders are ordered in queries.
 */
export enum OrderSort {
  /** Sort by creation timestamp */
  Created = 'CREATED',
  /** Default sorting behavior */
  Default = 'DEFAULT',
  /** Sort by completion date */
  EndDate = 'END_DATE',
  /** Sort by expiration date */
  ExpiryDate = 'EXPIRY_DATE',
  /** Sort by payout amount */
  Payout = 'PAYOUT',
  /** Sort by product title */
  ProductTitle = 'PRODUCT__TITLE',
  /** Sort by total price including VAT */
  TotalInclVat = 'TOTAL_INCL_VAT'
}

/**
 * Possible states of an order throughout its lifecycle.
 * Tracks the order from creation to completion or cancellation.
 */
export enum OrderState {
  /** Order has been accepted by the seller */
  Accepted = 'ACCEPTED',
  /** Order has been canceled */
  Canceled = 'CANCELED',
  /** Order has been successfully completed */
  Completed = 'COMPLETED',
  /** Order has been delivered to the buyer */
  Delivered = 'DELIVERED',
  /** Order is under dispute */
  Disputed = 'DISPUTED',
  /** Order has expired without completion */
  Expired = 'EXPIRED',
  /** Newly created order */
  New = 'NEW',
  /** Order has been shipped */
  Shipped = 'SHIPPED'
}

/**
 * Detailed cost breakdown for an order.
 * Includes all price components with and without VAT.
 */
export type OrderTotals = {
  __typename?: 'OrderTotals';
  /** Buyer protection fees excluding VAT */
  buyer_protection_excl_vat: Scalars['Float']['output'];
  /** Buyer protection fees including VAT */
  buyer_protection_incl_vat: Scalars['Float']['output'];
  /** Credit card processing fees excluding VAT */
  credit_card_cost_excl_vat: Scalars['Float']['output'];
  /** Credit card processing fees including VAT */
  credit_card_cost_incl_vat: Scalars['Float']['output'];
  /** Applied discounts excluding VAT */
  discount_excl_vat: Scalars['Float']['output'];
  /** Applied discounts including VAT */
  discount_incl_vat: Scalars['Float']['output'];
  /**
   * Legacy payment cost excluding VAT
   * @deprecated Field no longer supported
   */
  payment_excl_vat: Scalars['Float']['output'];
  /**
   * Legacy payment cost including VAT
   * @deprecated Field no longer supported
   */
  payment_incl_vat: Scalars['Float']['output'];
  /** PayPal processing fees excluding VAT */
  paypal_cost_excl_vat: Scalars['Float']['output'];
  /** PayPal processing fees including VAT */
  paypal_cost_incl_vat: Scalars['Float']['output'];
  /** Service fees excluding VAT */
  service_cost_excl_vat: Scalars['Float']['output'];
  /** Service fees including VAT */
  service_cost_incl_vat: Scalars['Float']['output'];
  /** Shipping cost excluding VAT */
  shipping_excl_vat: Scalars['Float']['output'];
  /** Shipping cost including VAT */
  shipping_incl_vat: Scalars['Float']['output'];
  /** Subtotal excluding VAT */
  subtotal_excl_vat: Scalars['Float']['output'];
  /** Subtotal including VAT */
  subtotal_incl_vat: Scalars['Float']['output'];
  /** Final total excluding VAT */
  total_excl_vat: Scalars['Float']['output'];
  /** Final total including VAT */
  total_incl_vat: Scalars['Float']['output'];
};

export enum Ordering {
  Asc = 'ASC',
  Desc = 'DESC',
  Rand = 'RAND'
}

/** A merchant's cart holding zero or more boost and/or listing-fee (PPL) packages. */
export type PackageCart = {
  __typename?: 'PackageCart';
  /** Most recent unfinished checkout, retained independently of current cart edits. */
  checkout?: Maybe<PackageCheckout>;
  /** Optional estimate only; the payment remains in EUR. */
  convertedTotal?: Maybe<Price>;
  /** Fingerprint of the current authoritative lines and prices. Checkout rejects a stale review. */
  fingerprint: Scalars['String']['output'];
  /** Items in the cart. */
  items: Array<PackageCartItem>;
  /** Total cost for all items in the cart. */
  total: Price;
};


/** A merchant's cart holding zero or more boost and/or listing-fee (PPL) packages. */
export type PackageCartConvertedTotalArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** A single package (boost or listing fee) in the cart, applied to one product. */
export type PackageCartItem = {
  __typename?: 'PackageCartItem';
  /** Stable cart line identity. */
  id: Scalars['ID']['output'];
  /** Whether this is a boost or a listing-fee (PPL) package. */
  kind: PackageKind;
  /**
   * Details of the purchased package (boost or listing-fee/PPL). For PPL the
   * package's `price` is the dynamic, asking-price-derived fee.
   */
  package: PackageDetails;
  /**
   * Price for this item. For listing-fee items this is recomputed from the product's
   * current asking price and is authoritative only at checkout.
   */
  price: Price;
  /** The product the package applies to. */
  product: Product;
  /** Immutable terms for a promotion line; null for other package kinds. */
  promotionQuote?: Maybe<PromotionQuote>;
};

/** Durable purchase of the reviewed package cart, recoverable after cart edits or navigation. */
export type PackageCheckout = {
  __typename?: 'PackageCheckout';
  /** Campaigns belonging to this payment, one per purchased promotion quote. */
  campaigns: Array<PromotionCampaign>;
  /** Optional estimate of the frozen aggregate payment; settlement remains EUR. */
  convertedTotal?: Maybe<Price>;
  /** Stable checkout identifier. */
  id: Scalars['ID']['output'];
  /** Frozen per-listing purchase lines, retained after cart edits or payment. */
  items: Array<PackageCheckoutItem>;
  /** Existing accounting order group. */
  orderGroupId: Scalars['ID']['output'];
  /** The original provider secret for the authenticated owner; null once terminal. */
  paymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
  /** Current payment and fulfillment state. */
  status: PackageCheckoutStatus;
  /** Frozen amount actually charged in EUR. */
  total: Price;
};


/** Durable purchase of the reviewed package cart, recoverable after cart edits or navigation. */
export type PackageCheckoutConvertedTotalArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** One immutable accounting line of a shared package purchase. */
export type PackageCheckoutItem = {
  __typename?: 'PackageCheckoutItem';
  /** Service kind. */
  kind: PackageKind;
  /** Stable accounting order. */
  orderId: Scalars['ID']['output'];
  /** Original charged line amount. */
  price: Price;
  /** The listing this service applies to. */
  product: Product;
  /** Original promotion choice and terms, null for listing fees and legacy boosts. */
  promotionQuote?: Maybe<PromotionQuote>;
  /** Purchased service title frozen at checkout. */
  title: Scalars['String']['output'];
};

/** Lifecycle of an immutable shared package payment. */
export enum PackageCheckoutStatus {
  /** The same payment can be resumed. */
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** The provider definitively canceled the payment. */
  Cancelled = 'CANCELLED',
  /** The provider confirmed the exact total. */
  Paid = 'PAID',
  /** A late payment or reversal needs financial review. */
  ReviewRequired = 'REVIEW_REQUIRED'
}

/**
 * The purchased package for a cart item: a boost package, or a (dynamically priced)
 * listing-fee / PPL package. Select with an inline fragment on the concrete type.
 */
export type PackageDetails = BoostPackage | DynamicListingFeePackage | PromotionOffer;

/** The kind of package held by a cart item. */
export enum PackageKind {
  /** A boost promotion for the target product. */
  Boost = 'BOOST',
  /** A pay-per-listing (PPL) / listing-fee package for the target product. */
  ListingFee = 'LISTING_FEE',
  /** An immutable promotion quote for this listing. */
  Promotion = 'PROMOTION'
}

/** A payment intent for a package cart, used for client-side payment processing. */
export type PackagePayment = {
  __typename?: 'PackagePayment';
  /** Client secret for processing the payment with the provider's SDK. */
  paymentClientSecret: Scalars['String']['output'];
  /** ID of the payment intent (e.g., Stripe payment intent ID). */
  paymentIntentId: Scalars['String']['output'];
};

/** Explicit agreement bound to one immutable promotion quote. */
export type PackagePromotionConsentInput = {
  /** Affirmative unchecked-by-default immediate-start agreement. */
  immediateStartConsent: Scalars['Boolean']['input'];
  /** The exact quote reviewed in the cart. */
  quoteId: Scalars['ID']['input'];
  /** The version of the terms shown with that quote. */
  termsVersion: Scalars['String']['input'];
};

/**
 * Represents a content page in the system.
 * Pages are containers for structured content blocks that make up the website's content.
 */
export type Page = {
  __typename?: 'Page';
  /** Ordered list of content blocks that make up the page */
  blocks: Array<Block>;
  /** Unique identifier for the page */
  id: Scalars['UUID']['output'];
  /**
   * Legacy child pages
   * @deprecated Not needed
   */
  items: Array<Page>;
  /**
   * Legacy parent page reference
   * @deprecated Not needed
   */
  parent?: Maybe<Page>;
  /** URL-friendly identifier for the page */
  slug: Scalars['String']['output'];
  /** Human-readable title of the page */
  title: Scalars['String']['output'];
};


/**
 * Represents a content page in the system.
 * Pages are containers for structured content blocks that make up the website's content.
 */
export type PageBlocksArgs = {
  location?: InputMaybe<BlockLocation>;
};

/**
 * Filter input for querying pages.
 * Enables flexible filtering of pages based on key-value pairs.
 */
export type PageFilter = {
  /** The attribute key to filter by */
  key?: InputMaybe<AttributeFilterKey>;
  /** The value to match against the chosen key */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filter keys available for page queries.
 * Used to search and filter pages in the content management system.
 */
export enum PageFilterKey {
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG'
}

/**
 * Paginated result type for page queries.
 * Provides both pagination information and the matched pages.
 */
export type PageResult = {
  __typename?: 'PageResult';
  /** List of pages matching the query criteria */
  items: Array<Page>;
  /** Pagination metadata including total count and page information */
  pagination: PaginationResult;
};

/**
 * Available sorting options for page listings.
 * Determines the order in which pages are returned in queries.
 */
export enum PageSort {
  /** Sort pages alphabetically by title */
  Title = 'TITLE'
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Pagination information */
export type PaginationOutput = {
  __typename?: 'PaginationOutput';
  /** Number of items per page */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Current page number */
  page?: Maybe<Scalars['Int']['output']>;
};

export type PaginationParams = {
  __typename?: 'PaginationParams';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
};

/** Available payment methods for processing transactions */
export enum PaymentMethod {
  /** Apple Pay payment */
  ApplePay = 'APPLE_PAY',
  /** Bancontact payment system (Belgium) */
  Bancontact = 'BANCONTACT',
  /** Credit/debit card payment */
  Card = 'CARD',
  /** Customer balance */
  CustomerBalance = 'CUSTOMER_BALANCE',
  /** Giropay payment system (Germany) */
  Giropay = 'GIROPAY',
  /** Google Pay payment */
  GooglePay = 'GOOGLE_PAY',
  /** iDEAL payment system (Netherlands) */
  Ideal = 'IDEAL',
  /** Klarna payment service */
  Klarna = 'KLARNA',
  /** Payment link */
  Link = 'LINK',
  /** PayPal payment service */
  Paypal = 'PAYPAL',
  /** SEPA direct debit */
  SepaDebit = 'SEPA_DEBIT',
  /** Sofort banking payment */
  Sofort = 'SOFORT',
  /**
   * Legacy order groups from before the payment method was recorded (empty or
   * unrecognised `sales_ordergroup.payment_method`). Never written for new orders.
   */
  Unknown = 'UNKNOWN'
}

export enum PaymentStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  NotPaid = 'NOT_PAID',
  RefundCanceled = 'REFUND_CANCELED',
  RefundFailed = 'REFUND_FAILED',
  RefundPending = 'REFUND_PENDING',
  RefundSucceeded = 'REFUND_SUCCEEDED',
  Shipped = 'SHIPPED'
}

/** Type representing a single payout transaction */
export type Payout = {
  __typename?: 'Payout';
  /** Amount of money that was paid out */
  amount: Scalars['Float']['output'];
  /** Timestamp when the payout was created/processed */
  created: Scalars['DateTime']['output'];
  /** Currency code of the payout (e.g., EUR, USD) */
  currency: Scalars['String']['output'];
};

/**
 * Detailed information about a payout.
 * Includes status information and localized descriptions.
 */
export type PayoutDetails = {
  __typename?: 'PayoutDetails';
  /** Estimated payout date */
  eta?: Maybe<Scalars['Date']['output']>;
  /**
   * What the payout waits for: the seller's Stripe account, or something on this
   * order (a dispute, a return, a damage claim, a refund). NONE when nothing holds it.
   */
  hold_reason: PayoutHoldReason;
  /**
   * True only once Stripe's payout.paid webhook confirmed the money reached the
   * bank. `status` can read SUCCEEDED before that (calendar arithmetic in the
   * monolith), so only this may be shown as "paid out".
   */
  paid_confirmed: Scalars['Boolean']['output'];
  /** Current status of the payout */
  status: PayoutStatus;
  /** Detailed status description */
  statusDescription?: Maybe<Scalars['String']['output']>;
  /** Whether the status description is marked as important */
  statusDescriptionImportant?: Maybe<Scalars['Boolean']['output']>;
  /** Localized status label */
  statusLabel: Scalars['String']['output'];
};


/**
 * Detailed information about a payout.
 * Includes status information and localized descriptions.
 */
export type PayoutDetailsStatusDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Detailed information about a payout.
 * Includes status information and localized descriptions.
 */
export type PayoutDetailsStatusLabelArgs = {
  lang?: InputMaybe<Language>;
};

export enum PayoutHoldReason {
  Account = 'ACCOUNT',
  Damage = 'DAMAGE',
  Dispute = 'DISPUTE',
  None = 'NONE',
  Refund = 'REFUND',
  Return = 'RETURN'
}

/**
 * What a seller receives for an asking price: the commission and the payout,
 * worked out by the same calculation a real sale uses (calculateSellerFee,
 * WHO-6000), so the create-ad price step and the My ads payout card promise what
 * the order pays. Seller money: never display-converted.
 *
 * Shipping is not included. For a delivery the seller ships, the sale adds the
 * shipping cost to the payout.
 */
export type PayoutQuote = {
  __typename?: 'PayoutQuote';
  /** The asking price this quote is for, incl. VAT. */
  askingPrice: Price;
  /**
   * True when VAT is charged on top of the commission: a business seller who pays
   * VAT on fees. Show `feeExclVat` and `feeVat` then; otherwise show `fee`, which
   * is VAT-inclusive.
   */
  chargesVatOnFee: Scalars['Boolean']['output'];
  /**
   * The commission rate in percent for a percentage fee; null for a fixed fee.
   * Same meaning as `Order.commissionPercent`.
   */
  commissionPercent?: Maybe<Scalars['Float']['output']>;
  /** The commission charged, incl. VAT. */
  fee: Price;
  /** The commission excl. VAT. */
  feeExclVat: Price;
  /** The VAT charged on top of the commission; zero unless `chargesVatOnFee`. */
  feeVat: Price;
  /** What the seller receives: askingPrice − fee. */
  payout: Price;
};

export type PayoutQuoteInput = {
  /**
   * The asking price incl. VAT, in EUR. A plain amount, not a PriceInput: seller
   * prices are always EUR, whatever currency the viewer browses in.
   */
  askingPrice: Scalars['Float']['input'];
  /**
   * The categories picked in the ad form, so the category rate a save gives
   * applies (Bags and its subcategories: 5%) instead of the seller's own rate.
   * Pass every picked category id; an id outside a category rule changes
   * nothing. With `productId` they quote the edited ad as its next save will
   * charge it: its applied plan still wins, otherwise the rate these categories
   * select replaces the ad's stored fee. Leave them out with `productId` to quote
   * the ad as it is saved.
   */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * The ad being priced, so its applied pay-per-listing plan and its own fee
   * apply (with `categoryIds`, see there). Omitted for a new ad: the seller's own
   * rate applies, or the category rate `categoryIds` select.
   */
  productId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum PayoutStatus {
  /** The payout was canceled. */
  Canceled = 'CANCELED',
  /** @deprecated Field no longer supported */
  Completed = 'COMPLETED',
  /** @deprecated Field no longer supported */
  Delivered = 'DELIVERED',
  /** @deprecated Field no longer supported */
  Disputed = 'DISPUTED',
  /** @deprecated Field no longer supported */
  Expired = 'EXPIRED',
  /** The payout failed. */
  Failed = 'FAILED',
  /** The payout is in transit. */
  InTransit = 'IN_TRANSIT',
  /** The payout is pending. */
  Pending = 'PENDING',
  /** @deprecated Same as PENDING */
  PendingTransfer = 'PENDING_TRANSFER',
  /** The payout succeeded. */
  Succeeded = 'SUCCEEDED',
  /** @deprecated Renamed to IN_TRANSIT */
  TransferInTransit = 'TRANSFER_IN_TRANSIT',
  /** @deprecated Same as PENDING */
  WaitingForConfirmation = 'WAITING_FOR_CONFIRMATION'
}

/** Type representing all payout-related information for a merchant */
export type Payouts = {
  __typename?: 'Payouts';
  /**
   * Whether payouts are enabled for this merchant
   * Can be false if merchant hasn't completed required verification
   */
  enabled: Scalars['Boolean']['output'];
  /** List of all payouts made to the merchant */
  items: Array<Payout>;
};

/** Actions requiring merchant attention */
export enum PendingAction {
  AcceptChatTos = 'ACCEPT_CHAT_TOS',
  AcceptTos = 'ACCEPT_TOS'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

/** Input for submitting platform feedback */
export type PlatformFeedbackInput = {
  /** App version */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Feedback content */
  body: Scalars['String']['input'];
  /** Feedback topic/category */
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** Available video streaming playlist formats */
export enum PlaylistType {
  Hls = 'HLS',
  Mpegdash = 'MPEGDASH'
}

/**
 * Whether a postal shipping option delivers to the buyer's home address or to a
 * carrier service point (pickup point). Only populated for SendCloud postal
 * options. V2 only.
 */
export enum PostalDeliveryTypeEnum {
  /** Delivered to the buyer's home address */
  Home = 'HOME',
  /** Collected by the buyer from a carrier service point */
  ServicePoint = 'SERVICE_POINT'
}

/** Why a postal label could not be created. */
export type PostalLabelFailure = {
  __typename?: 'PostalLabelFailure';
  category: PostalLabelFailureCategory;
  /** When the failed attempt was recorded */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** First human-readable detail from the provider, when available */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Coarse classification of a carrier's label-creation error, derived from the
 * stored provider error.
 */
export enum PostalLabelFailureCategory {
  Address = 'ADDRESS',
  Carrier = 'CARRIER',
  Dimensions = 'DIMENSIONS',
  ServicePoint = 'SERVICE_POINT',
  Unknown = 'UNKNOWN',
  Weight = 'WEIGHT'
}

/** Standard postal package size categories */
export enum PostalPackageSize {
  /** L — Standard parcel (50 × 30 × 20 cm) */
  L = 'L',
  /**
   * Deprecated: equivalent to XXL (100 × 50 × 50 cm)
   * @deprecated Use XXL instead
   */
  Large = 'LARGE',
  /** M — Shoebox (30 × 20 × 15 cm) */
  M = 'M',
  /**
   * Deprecated: equivalent to XL (75 × 40 × 35 cm)
   * @deprecated Use XL instead
   */
  Medium = 'MEDIUM',
  /** S — Mailbox (38 × 26 × 3 cm) */
  S = 'S',
  /**
   * Deprecated: equivalent to S (38 × 26 × 3 cm)
   * @deprecated Use S instead
   */
  Small = 'SMALL',
  /** XL — Large (75 × 40 × 35 cm) */
  Xl = 'XL',
  /** XXL — Maximum (100 × 50 × 50 cm) */
  Xxl = 'XXL'
}

/**
 * Postal package size option with dimensions.
 * Used by clients to render available package sizes.
 */
export type PostalPackageSizeOption = {
  __typename?: 'PostalPackageSizeOption';
  /** Height in cm */
  height: Scalars['Int']['output'];
  /** Length in cm */
  length: Scalars['Int']['output'];
  /** Maximum weight in kg */
  maxWeightKg: Scalars['Float']['output'];
  /** Size category (S, M, L, XL, XXL) */
  size: PostalPackageSize;
  /** Width in cm */
  width: Scalars['Int']['output'];
};

/**
 * A postal/parcel shipment, backed by whichever provider created it (Wuunder or
 * SendCloud). Provider-neutral successor to WuunderShipment; both map to the same
 * underlying record.
 */
export type PostalShipment = {
  __typename?: 'PostalShipment';
  /** Whether seller missed the shipping deadline */
  failedToSend: Scalars['Boolean']['output'];
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** Set when the last label-creation attempt failed and no label exists */
  labelFailure?: Maybe<PostalLabelFailure>;
  /** When the shipping label was generated */
  labelGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL to download shipping label */
  labelUrl?: Maybe<Scalars['String']['output']>;
  /** Associated order details */
  order: Order;
  /** URL to view available parcel points in specified language */
  parcelPointsUrl?: Maybe<Scalars['String']['output']>;
  /** Shipping provider backing this shipment */
  provider: ShippingProviderEnum;
  /** Carrier handling the shipment */
  rateCarrier: Scalars['String']['output'];
  /** Code identifying the selected shipping rate */
  rateCode: Scalars['String']['output'];
  /** Price of the selected shipping rate */
  ratePrice: Scalars['String']['output'];
  /** Buyer-selected service point, when applicable (SendCloud) */
  selectedServicePoint?: Maybe<ServicePoint>;
  /** Deadline for sending the package */
  sendByDate: Scalars['DateTime']['output'];
  /** Whether parties should be reminded of pending actions */
  shouldRemind: Scalars['Boolean']['output'];
  /** Current status of the shipment */
  status?: Maybe<PostalShipmentStatus>;
  /** Tracking code for the shipment */
  trackAndTraceCode?: Maybe<Scalars['String']['output']>;
  /** URL to track the shipment */
  trackAndTraceUrl?: Maybe<Scalars['String']['output']>;
};


/**
 * A postal/parcel shipment, backed by whichever provider created it (Wuunder or
 * SendCloud). Provider-neutral successor to WuunderShipment; both map to the same
 * underlying record.
 */
export type PostalShipmentParcelPointsUrlArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Contact fields a service caller may fix on a shipment pre-label. At least one
 * field must be provided. `pickupLine2: null` clears the second address line.
 */
export type PostalShipmentContactFixInput = {
  /** Pickup address line 1 (street + number) */
  pickupLine1?: InputMaybe<Scalars['String']['input']>;
  /** Pickup address line 2; pass null to clear it */
  pickupLine2?: InputMaybe<Scalars['String']['input']>;
  /** Seller phone number in international format, as the carrier validates it */
  sellerPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a postal shipment (provider-neutral). */
export enum PostalShipmentStatus {
  /** Package is at a service point/parcel shop, awaiting buyer collection */
  AwaitingPickup = 'AWAITING_PICKUP',
  /** Package has been delivered */
  Delivered = 'DELIVERED',
  /** Package is in transit */
  InTransit = 'IN_TRANSIT',
  /** There is a problem with the shipment */
  Issue = 'ISSUE',
  /** Label generated but package not yet picked up */
  NotSent = 'NOT_SENT'
}

/**
 * A money amount with at most two decimals. Clients show it as sent and never
 * round or recompute it (price display policy WHO-5991 decision 8).
 *
 * - In the charge currency (EUR), it is final: rounded once, half up, to the
 *   cent where it is created (fees, discounts, buyer protection, shipping rates,
 *   payouts, totals), and it is exactly what is stored and charged. Order lines
 *   stored with more decimals by older code are rounded to the cent when read.
 * - Converted to a display currency, it is a guide only: rounded up to the cent,
 *   never stored or charged.
 */
export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Currency;
  /**
   * The price before display-currency conversion, in the listing's own currency
   * (EUR today), when this price was converted; null otherwise — no display
   * currency, the same currency, a missing rate, or the viewer's own listing.
   *
   * Shown small next to the converted amount on cards and the product page
   * ($1,004 with €925 under it, price display policy WHO-5991 decision 7). The
   * converted amount is a guide; this is the price in the currency it was set in.
   * For a buy-now price that is also what is charged, but not every converted
   * field is a charge (a minimum bid, a recommended price, a bid's display
   * amount). Rounded by the same `precision` as the converted amount. Its own
   * `unconverted` is always null.
   */
  unconverted?: Maybe<Price>;
};

/** How often Smart Drop lowers the price. */
export enum PriceDropPace {
  /** On the same day of the next calendar month. */
  Month = 'MONTH',
  /** Every 14 days. */
  TwoWeeks = 'TWO_WEEKS',
  /** Every 7 days. */
  Week = 'WEEK'
}

/** Why automatic price drops are paused right now. */
export enum PriceDropPause {
  /** An offer is waiting for the seller's answer. */
  OfferWaiting = 'OFFER_WAITING',
  /** A sale is in progress. */
  SaleInProgress = 'SALE_IN_PROGRESS'
}

export type PriceDropPreviewInput = {
  /** The asking price incl. VAT in EUR, as typed. */
  askingPrice: Scalars['Float']['input'];
  /**
   * Never lower than, in EUR, kept to the cent (rounded half up); default 70% of the asking price (whole euros, rounded
   * down). Must be below the asking price.
   */
  floor?: InputMaybe<Scalars['Float']['input']>;
  /** Default TWO_WEEKS. */
  pace?: InputMaybe<PriceDropPace>;
  /** The ad being priced (showroom listings round to 10). */
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /** 1 to 25; default 10. */
  stepPercent?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Smart Drop: the price drops by stepPercent of the base price every pace, down to the seller's floor
 * ("Never lower than"), which is also the lowest bid that reaches the seller. Paused while an offer waits for an
 * answer or a sale is in progress; a price change by the seller restarts it from the new price.
 */
export type PriceDropSchedule = {
  __typename?: 'PriceDropSchedule';
  /** The price the drops count from. */
  basePrice: Price;
  /** Never lower than: the last drop lands here, and bids below it do not reach the seller. */
  floor: Price;
  /** The lowest price the schedule reaches (the floor, or the asking price when no drops remain). */
  lowestPrice: Price;
  /** How often the price drops. */
  pace: PriceDropPace;
  /** Why drops are paused now; null when they are not. */
  pausedReason?: Maybe<PriceDropPause>;
  /** Each drop takes this percentage of the base price off (1 to 25). */
  stepPercent: Scalars['Int']['output'];
  /** Drops still to come, in order; empty when the lowest price is reached. */
  upcoming: Array<PriceDropStep>;
};

/** The ad's Smart Drop settings as stored (defaults filled in), for any state including drafts. */
export type PriceDropSettings = {
  __typename?: 'PriceDropSettings';
  /** Smart Drop on (automatic price drops); false = Fixed price. */
  enabled: Scalars['Boolean']['output'];
  /** Never lower than; null when none is stored and the ad has no asking price to derive the default from. */
  floor?: Maybe<Price>;
  pace: PriceDropPace;
  stepPercent: Scalars['Int']['output'];
};

/** Smart Drop settings for an ad. enabled false = Fixed price: no drops. */
export type PriceDropSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  /**
   * Never lower than, in EUR; required when enabled. Stored to the cent as typed (rounded half up). Must be above 0 and
   * below the asking price. Also becomes the auction's minimum bid while bids are allowed, so bids below it never reach
   * the seller.
   */
  floor?: InputMaybe<Scalars['Float']['input']>;
  /** Default TWO_WEEKS. */
  pace?: InputMaybe<PriceDropPace>;
  /** 1 to 25; default 10. */
  stepPercent?: InputMaybe<Scalars['Int']['input']>;
};

/** One automatic price drop still to come. */
export type PriceDropStep = {
  __typename?: 'PriceDropStep';
  at: Scalars['DateTime']['output'];
  price: Price;
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
};

/**
 * How exact a returned price is, by where the client shows it (price display
 * policy, WHO-5991). Every buyer-facing price field (`@displayPrice`) takes an
 * optional `precision` argument, next to its optional `currency`; the gateway
 * does the rounding, so clients never round.
 *
 * Omitted means `CENT`. Pass `WHOLE` from list and card fragments (search
 * results, home, collections, favourites). Because it is a field argument it
 * is part of the client's normalized-cache key, so a card's rounded price and
 * the product page's exact price for the same product never overwrite each other.
 * Checkout, order and payout money (`@unconvertedPrice`) has no `precision`
 * argument: it is always exact.
 *
 * One shared type is the exception: `ShippingOption.price` takes `precision`
 * because the deprecated `Product.shippingOptions` returns it, but
 * `CartItem.shippingOptions` returns the same type with EUR checkout money. Never
 * pass `WHOLE` on cart or checkout shipping options.
 */
export enum PricePrecision {
  /** Exact to the cent, the default. Product page, chat, My ads: anywhere that is not a list or a card. */
  Cent = 'CENT',
  /**
   * A whole amount, rounded half up after any display-currency conversion
   * (€ 449,95 → € 450, $448.06 → $448). Lists and cards only; never charged.
   * One exception: a minimum bid (`Auction.minimum_bid`) rounds up (€ 314,30 →
   * € 315), so a card never shows a bid below the minimum.
   */
  Whole = 'WHOLE'
}

/**
 * A sold-price range for one of the seller's own ads, from comparable realised
 * sales on Whoppah.
 *
 * Only ever shown when the current asking price is strictly above `high`: the
 * seller is told what similar items actually sold for, never that their price is
 * "in range" or should go up. When `status` is `REFUSED` every other field is
 * null.
 */
export type PriceRecommendation = {
  __typename?: 'PriceRecommendation';
  /** Short description of which comparables were used, for the tooltip. */
  basis?: Maybe<Scalars['String']['output']>;
  /** Number of comparable sales the range was computed from. */
  comparableSales?: Maybe<Scalars['Int']['output']>;
  /**
   * True when the range spans every quality class because the item has no quality yet
   * (Open Home items): a more precise range depends on the condition. Always false for
   * regular listings and for `REFUSED`.
   */
  conditionDependent: Scalars['Boolean']['output'];
  /** How much the range can be trusted. `LOW` is never returned with `OK`; it is refused. */
  confidence?: Maybe<PriceRecommendationConfidence>;
  /** Median of comparable realised sale prices. */
  expected?: Maybe<Price>;
  /** 75th percentile of comparable realised sale prices. */
  high?: Maybe<Price>;
  /** 25th percentile of comparable realised sale prices. */
  low?: Maybe<Price>;
  /** `OK` when a range may be shown; `REFUSED` otherwise, with every other field null. */
  status: PriceRecommendationStatus;
};

/**
 * How much the pricing service trusts the range, from the number and closeness
 * of comparable realised sales.
 */
export enum PriceRecommendationConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Whether a recommendation may be shown to the seller. */
export enum PriceRecommendationStatus {
  /** A recommendation is available and the seller's asking price is above it. */
  Ok = 'OK',
  /**
   * Nothing to show. Covers every other case on purpose: the asking price is at or
   * below the recommended range, the pricing service had too few comparable sales,
   * it was unavailable, or the caller does not own the product.
   */
  Refused = 'REFUSED'
}

/**
 * Where the recommendation is shown, which decides how hard the gateway works
 * for an answer.
 */
export enum PriceRecommendationSurface {
  /** Create-ad: allowed on drafts, live scoring allowed, no asking-price rule: OK whenever the engine answers with MEDIUM or HIGH confidence. */
  Create = 'CREATE',
  /**
   * The ad detail page. Falls back to live scoring when there is no fresh
   * precomputed answer.
   */
  Detail = 'DETAIL',
  /**
   * List semantics, as `Product.priceRecommendation` uses. Only a precomputed
   * answer is used: the Redis cache and the pricing service's stored
   * recommendation. A listing that has not been scored yet is `REFUSED` here,
   * never live-scored.
   */
  List = 'LIST'
}

/**
 * WHO-5688. Outcome of submitProBuyerApplication. Nothing is stored: the
 * application is posted to the CS Slack channel and CS decides by hand.
 */
export type ProBuyerApplicationResult = {
  __typename?: 'ProBuyerApplicationResult';
  ok: Scalars['Boolean']['output'];
};

/** WHO-6629. The proposal letterhead (per account). Defaults come from the account when never saved. */
export type ProBuyerBrandProfile = {
  __typename?: 'ProBuyerBrandProfile';
  /** #RRGGBB. */
  accentColor: Scalars['String']['output'];
  addressLine: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  city: Scalars['String']['output'];
  /** Chamber of commerce / company registration number. */
  cocNumber: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fontStyle: ProBuyerProposalFontStyle;
  /** The entity. */
  legalName: Scalars['String']['output'];
  /** data: URI or null. */
  logo?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  /** False while nothing was ever saved (the values are prefilled from the account). */
  saved: Scalars['Boolean']['output'];
  vatNumber: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type ProBuyerBrandProfileInput = {
  /** #RRGGBB. */
  accentColor?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fontStyle?: InputMaybe<ProBuyerProposalFontStyle>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** A data: URI (png, jpeg or webp, at most 300 KB decoded). Omit to keep the current logo. */
  logo?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  /** http(s); https:// is added when the scheme is missing. */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** WHO-6629 R15. */
export enum ProBuyerClientReactionValue {
  No = 'NO',
  Yes = 'YES'
}

/** WHO-6629 R16. Client reactions on one piece, across the browsers that reacted. */
export type ProBuyerClientReactions = {
  __typename?: 'ProBuyerClientReactions';
  lastReactedAt?: Maybe<Scalars['DateTime']['output']>;
  no: Scalars['Int']['output'];
  yes: Scalars['Int']['output'];
};

/** WHO-6629. The viewer's live projects that hold one product. */
export type ProBuyerFavoriteProjects = {
  __typename?: 'ProBuyerFavoriteProjects';
  productId: Scalars['UUID']['output'];
  projects: Array<ProBuyerProjectRef>;
};

/** WHO-6629 R4. Favorites in one project. */
export type ProBuyerFavoritesProjectCount = {
  __typename?: 'ProBuyerFavoritesProjectCount';
  count: Scalars['Int']['output'];
  project: ProBuyerProjectRef;
};

/** WHO-6629 R4. Counted like the Favorieten list (only favorites the product page can open). */
export type ProBuyerFavoritesSummary = {
  __typename?: 'ProBuyerFavoritesSummary';
  notInProject: Scalars['Int']['output'];
  /** Every live project, most recently changed first. */
  projects: Array<ProBuyerFavoritesProjectCount>;
  total: Scalars['Int']['output'];
};

/**
 * WHO-5743. The price an approved Pro Buyer pays at a participating seller:
 * floor(buy-now price * (100 - pct) / 100) in whole units of the listing's
 * currency. Viewer-scoped: computed per request for the logged-in viewer and
 * never cached across viewers.
 */
export type ProBuyerPrice = {
  __typename?: 'ProBuyerPrice';
  /** The seller's shop-wide Pro Buyer discount percentage. */
  pct: Scalars['Int']['output'];
  price: Price;
};


/**
 * WHO-5743. The price an approved Pro Buyer pays at a participating seller:
 * floor(buy-now price * (100 - pct) / 100) in whole units of the listing's
 * currency. Viewer-scoped: computed per request for the logged-in viewer and
 * never cached across viewers.
 */
export type ProBuyerPricePriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/**
 * WHO-5959 6b. A Pro Buyer's own grouping of purchases per client. Private to the
 * buyer's account: never on a seller-facing query, in the chat or in Iterable.
 */
export type ProBuyerProject = {
  __typename?: 'ProBuyerProject';
  changes: ProBuyerProjectChanges;
  /** Up to 4 photo URLs (newest saved pieces, then purchases) for collages. */
  coverImages: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /**
   * WHO-5959 6d. Counting purchases in this project that have a buyer invoice
   * (the ones "Alle facturen ({n})" downloads).
   */
  invoiceCount: Scalars['Int']['output'];
  /**
   * WHO-5959 6d. The zip downloads for those invoices, at most 50 invoices per
   * zip, oldest purchase first; empty when `invoiceCount` is 0. Each URL needs
   * the viewer's bearer token, like `Order.buyer_receipt`.
   */
  invoiceZipParts: Array<ProBuyerProjectInvoiceZipPart>;
  /** R10. Saved pieces in this project. 0 while a flag is off. */
  itemCount: Scalars['Int']['output'];
  /** Newest first. At most 500. Empty while a flag is off. */
  items: Array<ProBuyerProjectItem>;
  /** When the owner last opened the board (`markProBuyerProjectSeen`). */
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Trimmed, 1 to 40 characters, unique per account (case-insensitive). */
  name: Scalars['String']['output'];
  /** Up to 3 orders for the card photos, newest first. */
  previewOrders: Array<Order>;
  proposal: ProBuyerProjectProposal;
  purchaseCount: Scalars['Int']['output'];
  /** Newest first (order date). */
  purchases: Array<ProBuyerProjectPurchase>;
  /** WHO-5959 6e. Of `reservationCount`, the requests still waiting for the seller; null while reservations are off. */
  reservationAwaitingSellerCount?: Maybe<Scalars['Int']['output']>;
  /** WHO-5959 6e. Live requests plus reservations for this project (card chip); null while reservations are off. */
  reservationCount?: Maybe<Scalars['Int']['output']>;
  /**
   * WHO-5959 6e. Live requests and reservations made for this project, shortest
   * time left first. Empty while the `pro_buyer_reservations` flag is off.
   */
  reservations: Array<BuyerReservation>;
  /** In position order. Empty while a flag is off. */
  rooms: Array<ProBuyerProjectRoom>;
  /** Disabled while a flag is off. */
  share: ProBuyerProjectShare;
  /** One entry per currency with counting purchases; empty when none count. */
  totals: Array<ProBuyerProjectTotal>;
  /** Pieces without a room. */
  unassignedItemCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * WHO-5959 6c. The project one of the viewer's own purchases is in (Aankopen
 * chip and action menu). Never resolved for anyone but the buyer.
 */
export type ProBuyerProjectAssignment = {
  __typename?: 'ProBuyerProjectAssignment';
  /** False for a cancelled, expired or service order: it cannot be put in a project. */
  eligible: Scalars['Boolean']['output'];
  orderId: Scalars['UUID']['output'];
  /** Null when the purchase is in no project. */
  projectId?: Maybe<Scalars['UUID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

/** WHO-6629. Result of adding project pieces to the cart. */
export type ProBuyerProjectCartResult = {
  __typename?: 'ProBuyerProjectCartResult';
  added: Scalars['Int']['output'];
  /** Already in the cart; their line now carries this project. */
  alreadyInCart: Scalars['Int']['output'];
  cartCount: Scalars['Int']['output'];
  /** Item ids that could not go in the cart (sold, offline, held for someone else, own listing). */
  skippedItemIds: Array<Scalars['UUID']['output']>;
};

/** WHO-6629 R11/R16. Changes since the owner last opened the board (`markProBuyerProjectSeen`). */
export type ProBuyerProjectChanges = {
  __typename?: 'ProBuyerProjectChanges';
  /** Pieces for sale whose regular price is now lower than when the owner last looked. */
  priceDropped: Scalars['Int']['output'];
  /** Distinct pieces with a client reaction created or changed since the last visit. */
  reactedItems: Scalars['Int']['output'];
  reactionsNo: Scalars['Int']['output'];
  reactionsYes: Scalars['Int']['output'];
  /** Pieces that were for sale when the owner last looked and are UNAVAILABLE now. */
  unavailable: Scalars['Int']['output'];
};

/** WHO-5959 6d. One zip of a project's invoices: purchases `from` to `to` (1-based, inclusive, oldest first). */
export type ProBuyerProjectInvoiceZipPart = {
  __typename?: 'ProBuyerProjectInvoiceZipPart';
  count: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** WHO-6629. A saved piece in a project. Owner only. */
export type ProBuyerProjectItem = {
  __typename?: 'ProBuyerProjectItem';
  clientReactions: ProBuyerClientReactions;
  createdAt: Scalars['DateTime']['output'];
  /** The saved-piece id. */
  id: Scalars['UUID']['output'];
  /** 0 to 140 characters. */
  note: Scalars['String']['output'];
  /** Shown on the moodboard, the client page and the proposal. */
  onMoodboard: Scalars['Boolean']['output'];
  /** The viewer's OTHER live projects that hold this product. */
  otherProjects: Array<ProBuyerProjectRef>;
  /** Moodboard order (ascending); ties newest first. */
  position: Scalars['Int']['output'];
  /** Regular (public) buy-now price when saved. */
  priceAtSave?: Maybe<Price>;
  /** The viewer's Pro Buyer price now (same rules and code path as Product.proBuyerPrice). */
  proBuyerPrice?: Maybe<ProBuyerPrice>;
  product: Product;
  purchase?: Maybe<ProBuyerProjectItemPurchase>;
  /** Regular (public) buy-now price now; null when the listing has none. */
  regularPrice?: Maybe<Price>;
  reservationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** True while the viewer's reservation request waits for the seller. */
  reservationRequested: Scalars['Boolean']['output'];
  room?: Maybe<ProBuyerProjectRoom>;
  status: ProBuyerProjectItemStatus;
};

export type ProBuyerProjectItemInput = {
  /** Takes the piece out of its room. */
  clearRoom?: InputMaybe<Scalars['Boolean']['input']>;
  /** 0 to 140 characters (NOTE_INVALID). */
  note?: InputMaybe<Scalars['String']['input']>;
  onMoodboard?: InputMaybe<Scalars['Boolean']['input']>;
  /** A room of the same project. */
  roomId?: InputMaybe<Scalars['UUID']['input']>;
};

/** WHO-6629. The viewer's own order for a saved piece. */
export type ProBuyerProjectItemPurchase = {
  __typename?: 'ProBuyerProjectItemPurchase';
  orderGroupId?: Maybe<Scalars['UUID']['output']>;
  orderId: Scalars['UUID']['output'];
  state: OrderState;
};

/** WHO-6629. Where a save came from (logging only). */
export enum ProBuyerProjectItemSource {
  Board = 'BOARD',
  Cart = 'CART',
  Favorites = 'FAVORITES',
  Heart = 'HEART'
}

/** WHO-6629 R7. Live status of a saved piece. Computed per request, never stored. */
export enum ProBuyerProjectItemStatus {
  /** For sale. The web offers Reserveren + Kopen when `proBuyerPrice` is set, else Kopen. */
  Available = 'AVAILABLE',
  /** The viewer has an order for it (`purchase`), any state except canceled/expired. */
  BoughtByYou = 'BOUGHT_BY_YOU',
  /** For sale and the regular price is lower than `priceAtSave`. */
  PriceDropped = 'PRICE_DROPPED',
  /** Someone else holds an accepted reservation. */
  ReservedByOther = 'RESERVED_BY_OTHER',
  /** The viewer holds an accepted reservation (`reservationExpiresAt`). */
  ReservedByYou = 'RESERVED_BY_YOU',
  /** Sold to someone else, offline, rejected or removed. */
  Unavailable = 'UNAVAILABLE'
}

/** WHO-5959 6b. One page of the overview, most recently changed first. */
export type ProBuyerProjectPage = {
  __typename?: 'ProBuyerProjectPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ProBuyerProject>;
};

/** WHO-5959 6b. How a purchase was priced (spec S3 labels). */
export enum ProBuyerProjectPriceKind {
  Bid = 'BID',
  ProBuyer = 'PRO_BUYER',
  Regular = 'REGULAR'
}

/** WHO-6629. Proposal settings of a project. */
export type ProBuyerProjectProposal = {
  __typename?: 'ProBuyerProjectProposal';
  /** "Voor ..." on the cover (0 to 80 characters). */
  clientName: Scalars['String']['output'];
  /** Leave out sold and offline pieces (and pieces reserved by someone else). */
  hideUnavailable: Scalars['Boolean']['output'];
  /** Include the pieces without a room. */
  includeUnassigned: Scalars['Boolean']['output'];
  /** 0 to 1000 characters. */
  intro: Scalars['String']['output'];
  /**
   * The PDF download (needs the viewer's bearer token, like invoiceZipParts).
   * Takes `?lang=nl|en|de|fr|it|es`.
   */
  pdfUrl: Scalars['String']['output'];
  /** The rooms in the proposal; empty = all rooms. */
  roomIds: Array<Scalars['UUID']['output']>;
  showDimensions: Scalars['Boolean']['output'];
  showNotes: Scalars['Boolean']['output'];
  showTotals: Scalars['Boolean']['output'];
  /** Empty = the localized "Voorstel" (0 to 80 characters). */
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type ProBuyerProjectProposalInput = {
  clearValidUntil?: InputMaybe<Scalars['Boolean']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  hideUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  /** Rooms of the project; unknown ids are dropped. Empty = all rooms. */
  roomIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  showDimensions?: InputMaybe<Scalars['Boolean']['input']>;
  showNotes?: InputMaybe<Scalars['Boolean']['input']>;
  showTotals?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

/** WHO-5959 6b. One purchase in a project. */
export type ProBuyerProjectPurchase = {
  __typename?: 'ProBuyerProjectPurchase';
  /** False for a cancelled or expired order: still listed with its status, never in the totals. */
  countsTowardTotals: Scalars['Boolean']['output'];
  fullyRefunded: Scalars['Boolean']['output'];
  /** The buyer's own order. */
  order: Order;
  /** The order group, for the purchase detail link in Aankopen (/account/purchases/{group}?order={id}). */
  orderGroupId?: Maybe<Scalars['UUID']['output']>;
  /** Item price paid minus succeeded refunds (0 on a full refund, or when not counting). */
  paid: Price;
  priceKind: ProBuyerProjectPriceKind;
  /** The Pro Buyer percentage stored on the order; null unless `priceKind` is PRO_BUYER. */
  proBuyerPct?: Maybe<Scalars['Int']['output']>;
  /** The stored Pro Buyer discount; null when nothing was saved (shown as "Geen"). */
  saved?: Maybe<Price>;
};

/** WHO-5959 6b. A purchase the picker may offer, with the project it is in now (if any). */
export type ProBuyerProjectPurchaseOption = {
  __typename?: 'ProBuyerProjectPurchaseOption';
  order: Order;
  projectId?: Maybe<Scalars['UUID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

/** WHO-6629. A light reference to one of the viewer's projects. */
export type ProBuyerProjectRef = {
  __typename?: 'ProBuyerProjectRef';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/** WHO-6629. A room in a project. */
export type ProBuyerProjectRoom = {
  __typename?: 'ProBuyerProjectRoom';
  /** The "sfeer" line on the moodboard, the client page and the proposal (0 to 140 characters). */
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  itemCount: Scalars['Int']['output'];
  /** Trimmed, 1 to 40 characters, unique per project (case-insensitive). */
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** WHO-6629 R12/R13. The client link. */
export type ProBuyerProjectShare = {
  __typename?: 'ProBuyerProjectShare';
  allowReactions: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  /** The optional message to the client (0 to 500 characters). */
  message: Scalars['String']['output'];
  showNotes: Scalars['Boolean']['output'];
  /** Show the REGULAR price on the client page (never the Pro Buyer price). */
  showPrices: Scalars['Boolean']['output'];
  /** The secret part of the link; null when off. The web builds /<locale>/selectie/<token>. */
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProBuyerProjectShareInput = {
  allowReactions?: InputMaybe<Scalars['Boolean']['input']>;
  /** true creates a new token when the link is off; false kills the token at once. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 0 to 500 characters (SHARE_MESSAGE_INVALID). */
  message?: InputMaybe<Scalars['String']['input']>;
  showNotes?: InputMaybe<Scalars['Boolean']['input']>;
  showPrices?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * WHO-5959 6b. Money in one currency. Spent is the item price paid
 * (`Order.subtotalInclVat`) minus succeeded refunds, 0 on a full refund.
 * Saved is only the Pro Buyer discount stored on the order, 0 on a full refund;
 * bids, regular prices and discount codes never add to it. Cancelled, expired
 * and service orders count for neither.
 */
export type ProBuyerProjectTotal = {
  __typename?: 'ProBuyerProjectTotal';
  /** The part of `spent` bought at a Pro Buyer price. */
  proBuyerSpent: Price;
  /** Counting purchases in this currency. */
  purchaseCount: Scalars['Int']['output'];
  saved: Price;
  spent: Price;
};

/** WHO-5959 6b. FULL may create and add; READ_ONLY (switched off by CS, has projects) may only look and download. */
export enum ProBuyerProjectsAccess {
  Full = 'FULL',
  None = 'NONE',
  ReadOnly = 'READ_ONLY'
}

/**
 * WHO-5959 6b. The four overview figures, across all projects and the purchases
 * without a project: counting purchases since the account became a Pro Buyer,
 * plus older purchases that were put in a project.
 */
export type ProBuyerProjectsOverview = {
  __typename?: 'ProBuyerProjectsOverview';
  purchaseCount: Scalars['Int']['output'];
  /** Of `reservedCount`, the requests still waiting for the seller; null while that flag is off. */
  reservedAwaitingSellerCount?: Maybe<Scalars['Int']['output']>;
  /** Live reservations and requests; null while the `pro_buyer_reservations` flag is off (tile hidden). */
  reservedCount?: Maybe<Scalars['Int']['output']>;
  /** One entry per currency; empty when nothing counts. */
  totals: Array<ProBuyerProjectTotal>;
  /** Purchases in scope that are in no project (the "Zonder project" card). */
  unassignedPurchaseCount: Scalars['Int']['output'];
};

/** WHO-6629. The proposal typography: MODERN (Inter) or CLASSIC (Cormorant Garamond headings, Inter body). */
export enum ProBuyerProposalFontStyle {
  Classic = 'CLASSIC',
  Modern = 'MODERN'
}

/** WHO-6629. One project in the heart menu. */
export type ProBuyerSaveTarget = {
  __typename?: 'ProBuyerSaveTarget';
  /** Whether the product is already in this project. */
  contains: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  /** The saved piece (pro_projects_item.id) when `contains`, else null. */
  itemId?: Maybe<Scalars['UUID']['output']>;
  project: ProBuyerProjectRef;
  /** The room it is in there, if any. */
  roomId?: Maybe<Scalars['UUID']['output']>;
  rooms: Array<ProBuyerProjectRoom>;
};

/** WHO-6629 R14. The public client page. */
export type ProBuyerSelection = {
  __typename?: 'ProBuyerSelection';
  allowReactions: Scalars['Boolean']['output'];
  curatorLogo?: Maybe<Scalars['String']['output']>;
  /** Brand name, else the business name, else the account name. */
  curatorName: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  /** Rooms in position order (only rooms with on-moodboard pieces), then the pieces without a room as a room with name ''. */
  rooms: Array<ProBuyerSelectionRoom>;
  showPrices: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** WHO-6629 R14. What the client page may say about a piece. */
export enum ProBuyerSelectionAvailability {
  Available = 'AVAILABLE',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

/** WHO-6629 R14. A piece on the public client page. NEVER the product id, the Pro Buyer price, the seller, the shop or a link. */
export type ProBuyerSelectionItem = {
  __typename?: 'ProBuyerSelectionItem';
  availability: ProBuyerSelectionAvailability;
  condition?: Maybe<ProductCondition>;
  depth?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** The saved-piece id (pro_projects_item.id). */
  id: Scalars['UUID']['output'];
  /** Up to 4 image URLs. */
  images: Array<Scalars['String']['output']>;
  /** This browser's reaction (by visitorId). */
  myReaction?: Maybe<ProBuyerClientReactionValue>;
  /** Only when the owner shows notes and the note is not empty. */
  note?: Maybe<Scalars['String']['output']>;
  /** The piece's quality (what buyers see as "staat": Uitstekend, Heel goed, Goed). */
  quality?: Maybe<ProductQuality>;
  /** Only when the owner shows prices and the piece is available: the REGULAR price. */
  regularPrice?: Maybe<Price>;
  /** In the requested `lang`, else the original title. */
  title: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

/** WHO-6629 R14. A room on the client page; the pieces without a room come last with name ''. */
export type ProBuyerSelectionRoom = {
  __typename?: 'ProBuyerSelectionRoom';
  description: Scalars['String']['output'];
  items: Array<ProBuyerSelectionItem>;
  name: Scalars['String']['output'];
};

/** WHO-6629. The workspace switcher. */
export type ProBuyerWorkspace = {
  __typename?: 'ProBuyerWorkspace';
  /** Null = personal (no active project). */
  activeProject?: Maybe<ProBuyerProject>;
  activeRoomId?: Maybe<Scalars['UUID']['output']>;
  /** Live projects, most recently changed first, at most 100. */
  projects: Array<ProBuyerProject>;
};

export type Product = MediaQueries & {
  __typename?: 'Product';
  activeBoost?: Maybe<ProductBoost>;
  /** The currently applied listing fee for this product, if any. */
  activeListingFee?: Maybe<ProductListingFee>;
  address?: Maybe<Address>;
  all_categories: Array<Category>;
  arobject?: Maybe<ArObject>;
  arobjects: Array<ArObject>;
  art_orientation?: Maybe<ArtOrientation>;
  art_size?: Maybe<ArtSize>;
  artistUnknown?: Maybe<Scalars['Boolean']['output']>;
  artist_suggestion?: Maybe<Scalars['String']['output']>;
  attributes: Array<Attribute>;
  auction?: Maybe<Auction>;
  auctions: Array<Auction>;
  audio?: Maybe<Audio>;
  audios: Array<Audio>;
  auto_discount?: Maybe<Scalars['Boolean']['output']>;
  /** Bag-specific fields. Only meaningful when isBag is true. */
  bag_model?: Maybe<Scalars['String']['output']>;
  /**
   * When the running boost ends: the last push plus the boost package's days.
   * Null unless boostStatus is ACTIVE. Derived from the boost order, so it is
   * also set for boosts that have no ProductBoost record.
   */
  boostEndsAt?: Maybe<Scalars['DateTime']['output']>;
  boostStatus?: Maybe<BoostStatus>;
  brand?: Maybe<Brand>;
  brandUnknown?: Maybe<Scalars['Boolean']['output']>;
  brand_suggestion?: Maybe<Scalars['String']['output']>;
  breadcrumbs: Array<Category>;
  /** @deprecated Use product.auction.buy_now_price */
  buy_now_price?: Maybe<Price>;
  /** @deprecated Has behaviour of breadcrumbs so use it instead, or all_categories for actual product categories */
  categories: Array<Category>;
  cleaningServiceAvailable: Scalars['Boolean']['output'];
  coming_soon_alert?: Maybe<ComingSoonAlert>;
  condition: ProductCondition;
  created?: Maybe<Scalars['DateTime']['output']>;
  curated_at?: Maybe<Scalars['DateTime']['output']>;
  curated_by?: Maybe<Member>;
  /** @deprecated Field no longer supported */
  curated_custom?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  curated_reason?: Maybe<CurationReason>;
  curation_feedback?: Maybe<CurationFeedback>;
  customShippingPrices?: Maybe<Array<CustomShippingPrice>>;
  /** @deprecated Use customShippingPrices instead */
  custom_shipping_cost?: Maybe<Price>;
  /**
   * Whether a US buyer gets "Request a quote" instead of a delivery price: a
   * US-shippable listing that ships by courier, not by post. False while
   * US_CHECKOUT_ENABLED is off.
   */
  deliveryByQuote: Scalars['Boolean']['output'];
  /** @deprecated Use shippingOptions instead */
  delivery_method: DeliveryMethod;
  depth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designer_suggestion?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use shippingOptions instead */
  externalDeliveryAllowed: Scalars['Boolean']['output'];
  externalShippingMethods: Array<ExternalShippingMethod>;
  favorite?: Maybe<Favorite>;
  favorite_count: Scalars['Int']['output'];
  /**
   * Buyers who saved this product, newest first. Owner only: anyone else
   * gets an empty list. Deleted, banned and deactivated accounts are left out.
   */
  favoriters: Array<ProductFavoriter>;
  gender?: Maybe<Gender>;
  gone: Scalars['Boolean']['output'];
  ground_floor_only_delivery?: Maybe<Scalars['Boolean']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  hardware_color?: Maybe<HardwareColor>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  image?: Maybe<Image>;
  images: Array<Image>;
  /**
   * Whether the product is a bag listing. Server-set when the product is in the
   * Bags category tree.
   */
  isBag?: Maybe<Scalars['Boolean']['output']>;
  isBoostable?: Maybe<Scalars['Boolean']['output']>;
  isBoosted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this product is considered curated. True when it was curated by a
   * Whoppah staff member, when it belongs to a trusted merchant, when it passed
   * authentication, or when someone ticked `show_curated_label` in the dashboard
   * admin. That last one exists because automatic moderation accepts listings
   * without a curator, so an auto-accepted listing matches none of the others.
   */
  isCurated: Scalars['Boolean']['output'];
  isDesignerItem?: Maybe<Scalars['Boolean']['output']>;
  isInCart: Scalars['Boolean']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer used */
  is_in_showroom?: Maybe<Scalars['Boolean']['output']>;
  lastBoosted?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Please use lastBoosted */
  last_boost?: Maybe<Scalars['DateTime']['output']>;
  link: Scalars['String']['output'];
  /** Whether the caller may purchase a listing fee package for this product. */
  listingFeeEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Generation record for the owning merchant; null for anyone else and for listings made without generation. */
  listingGeneration?: Maybe<ListingGeneration>;
  media: Array<Media>;
  merchant: Merchant;
  merchant_fee?: Maybe<Fee>;
  mpn?: Maybe<Scalars['String']['output']>;
  /**
   * The viewer's newest delivery quote on this listing, in any status, so the
   * product page can show requested, quoted, expired (request again) or item
   * sold. Null for guests, without a quote, or while US_CHECKOUT_ENABLED is off.
   */
  myDeliveryQuote?: Maybe<DeliveryQuote>;
  /** The viewer's own live request or reservation on this listing (REQUESTED or ACCEPTED), else null. */
  myReservation?: Maybe<BuyerReservation>;
  newPrice?: Maybe<Price>;
  note_for_curator?: Maybe<Scalars['String']['output']>;
  number_of_items?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether this is an Open Home item. Open Home items can sit in the regular favorites;
   * the client then labels them and links to the Open Home item page (openHomeItem).
   */
  openHome: Scalars['Boolean']['output'];
  order?: Maybe<Order>;
  orders: Array<Order>;
  original_price?: Maybe<Price>;
  postalPackageSize?: Maybe<PostalPackageSize>;
  /** @deprecated Use postalPackageSize (S/M/L/XL/XXL) instead. */
  postal_package_size?: Maybe<PostalPackageSize>;
  postal_package_weight_kg?: Maybe<Scalars['Float']['output']>;
  /** Owner only: the schedule while automatic price drops are on and the ad is live; null otherwise. */
  priceDropSchedule?: Maybe<PriceDropSchedule>;
  /** Owner only: the Smart Drop settings, in every state (drafts too); null for non-owners. */
  priceDropSettings?: Maybe<PriceDropSettings>;
  /**
   * WHO-6309 D7: the asking price excl. VAT at the seller-country rate. Null unless
   * the viewer is a business merchant and the item is STANDARD.
   */
  priceExclVat?: Maybe<Price>;
  /**
   * Sold-price recommendation for this listing, for the owning merchant only.
   * Null for anyone else: `Product` is a public type, and nothing is looked up
   * for a non-owner.
   *
   * For the owner this is the same answer as `Query.priceRecommendation` with
   * `surface: LIST`: served from the cache and the pricing service's
   * precomputed recommendation only, never live-scored, and batched so a whole
   * My ads page costs one Redis read. A listing that has not been scored yet, or
   * that has no price, is `REFUSED`. On the ad page use `Query.priceRecommendation`
   * (surface `DETAIL`), which may live-score.
   *
   * Bounded so it cannot slow the products response down by more than about
   * 1.5 s: a row the pricing service does not answer in time, or past the
   * request's budget of 50 pricing-service reads, is `REFUSED` for this view
   * and tried again on the next one. No rate limit of its own: it rides on the
   * query that loads the products.
   */
  priceRecommendation?: Maybe<PriceRecommendation>;
  /**
   * The Pro Buyer price of this listing for the viewer. Null unless all hold:
   * the `pro_buyer_program` flag is on, the viewer is logged in and an approved
   * Pro Buyer, the seller's Pro Buyer discount is on, the listing is live with a
   * buy-now price (not bid only, sold, reserved or coming soon), the viewer is
   * not the owner, and the viewer has no accepted bid on it. Errors resolve to
   * null. Public payloads (structured data, previews, mails) must keep the
   * regular price.
   */
  proBuyerPrice?: Maybe<ProBuyerPrice>;
  product_type?: Maybe<ProductType>;
  promotion?: Maybe<ProductPromotion>;
  push_to_top_count?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<ProductQuality>;
  /** @deprecated No longer used */
  recommended_price?: Maybe<Price>;
  relatedListingPages: Array<ListingPage>;
  /**
   * Whether the viewer may request a reservation; null when the flag is off, the
   * viewer is not logged in or is not a Pro Buyer.
   */
  reservationEligibility?: Maybe<ReservationEligibility>;
  /** Public: end date of a live accepted reservation, 'YYYY-MM-DD' (Europe/Amsterdam). Null otherwise. */
  reservedUntilDate?: Maybe<Scalars['String']['output']>;
  seat_height?: Maybe<Scalars['Int']['output']>;
  /** Owner only: live REQUESTED rows plus the live ACCEPTED row. [] for everyone else. */
  sellerReservations: Array<SellerReservation>;
  shape?: Maybe<Shape>;
  /** @deprecated Use product.link */
  share_link: Scalars['String']['output'];
  /** @deprecated Use getProductShippingDetails for each product instead. Shipping options are not available for all products. */
  shippingOptions: Array<ShippingOption>;
  /** @deprecated Use shippingOptions.price instead */
  shipping_cost: Price;
  /** @deprecated Use shippingOptions instead */
  shipping_method?: Maybe<ShippingMethod>;
  /** @deprecated Use shippingOptions instead */
  shipping_method_prices: Array<ShippingMethodCountryPrice>;
  /** @deprecated No longer used */
  showroom?: Maybe<Showroom>;
  showroomModel: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  showroom_service_order?: Maybe<Order>;
  /** @deprecated No longer used */
  showroom_state?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used */
  showroom_zone?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: ProductState;
  status: ProductStatus;
  title: Scalars['String']['output'];
  /**
   * The Pro Buyer price of this listing, for the owning merchant only. Null for
   * anyone else, when the flag is off, when the merchant has no discount, or
   * when the listing is not active. floor(price * (1 - pct / 100)) in whole
   * units of the product's own currency (returned in `currency`); never stored.
   */
  tradeDiscountPreviewPrice?: Maybe<Price>;
  two_man_delivery?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether the listing ships to the US: the seller is a business seller, the
   * listing can be bought straight away (not bid-only, buy-now allowed), it offers
   * shipping (not pickup only), and the buy-now price, converted to EUR, is at
   * least the US minimum (a dashboard setting). Automatic, no seller opt-in. The
   * same rule checkout applies.
   */
  usShippable: Scalars['Boolean']['output'];
  usage_signs_description?: Maybe<Scalars['String']['output']>;
  user_confirmed_postal_fit?: Maybe<Scalars['Boolean']['output']>;
  /** WHO-6309: the item's effective VAT regime (product override, else the merchant default). Null while the flag is off. */
  vatRegime?: Maybe<VatRegime>;
  video?: Maybe<Video>;
  videos: Array<Video>;
  view_count: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  year_of_purchase?: Maybe<Scalars['Int']['output']>;
};


export type ProductArobjectArgs = {
  platform?: InputMaybe<ArPlatform>;
};


export type ProductArobjectsArgs = {
  platform?: InputMaybe<ArPlatform>;
};


export type ProductAttributesArgs = {
  type?: InputMaybe<AttributeType>;
};


export type ProductAuctionsArgs = {
  state?: InputMaybe<AuctionState>;
};


export type ProductAudioArgs = {
  type?: InputMaybe<AudioType>;
};


export type ProductAudiosArgs = {
  type?: InputMaybe<AudioType>;
};


export type ProductBuy_Now_PriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductCuration_FeedbackArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductCustom_Shipping_CostArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductImageArgs = {
  type?: InputMaybe<ImageType>;
};


export type ProductImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ImageType>;
};


export type ProductMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type ProductNewPriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductOriginal_PriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductPromotionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductRecommended_PriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductShippingOptionsArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductShipping_CostArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};


export type ProductSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductTitleArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductUsage_Signs_DescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type ProductVideoArgs = {
  type?: InputMaybe<VideoType>;
};


export type ProductVideosArgs = {
  type?: InputMaybe<VideoType>;
};

/**
 * Block for displaying product listings and details.
 * Used for featuring products, collections, and creating product showcases.
 * This block type supports internationalization for title and description.
 */
export type ProductBlock = AbstractBlock & {
  __typename?: 'ProductBlock';
  /** Detailed description in the specified language */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the product block */
  id: Scalars['UUID']['output'];
  /** Featured image for the product block */
  image: Scalars['String']['output'];
  /**
   * Legacy link field
   * @deprecated Not needed
   */
  link?: Maybe<Scalars['String']['output']>;
  /** Associated listing page configuration */
  listingPage?: Maybe<ListingPage>;
  /**
   * Legacy location field
   * @deprecated Not needed
   */
  location?: Maybe<BlockLocation>;
  /**
   * Legacy products list
   * @deprecated Use searchProducts with Collection filter
   */
  products: Array<Product>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /**
   * Brief description of the product content (deprecated)
   * @deprecated Use description
   */
  summary?: Maybe<Scalars['String']['output']>;
  /** Title of the block in the specified language */
  title: Scalars['String']['output'];
};


/**
 * Block for displaying product listings and details.
 * Used for featuring products, collections, and creating product showcases.
 * This block type supports internationalization for title and description.
 */
export type ProductBlockDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Block for displaying product listings and details.
 * Used for featuring products, collections, and creating product showcases.
 * This block type supports internationalization for title and description.
 */
export type ProductBlockTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type ProductBoost = {
  __typename?: 'ProductBoost';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastPushedAt?: Maybe<Scalars['DateTime']['output']>;
  remainingPushes: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  status: ProductBoostStatus;
  totalPushes: Scalars['Int']['output'];
};

export enum ProductBoostStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Product condition states */
export enum ProductCondition {
  /** Brand new, unused */
  New = 'NEW',
  /** New but open box/package */
  Openbox = 'OPENBOX',
  /** Professionally restored */
  Refurbished = 'REFURBISHED',
  /** Previously used */
  Used = 'USED'
}

/** Type representing product status count */
export type ProductCountByStatus = {
  __typename?: 'ProductCountByStatus';
  /** Number of products in this status */
  count: Scalars['Int']['output'];
  /**
   * Product status
   * Transformed to uppercase via @upper directive
   */
  status: ProductStatus;
};

/** One buyer who saved a product, as shown to the product's owner. */
export type ProductFavoriter = {
  __typename?: 'ProductFavoriter';
  /** When the buyer saved the product. */
  favorited_at: Scalars['DateTime']['output'];
  /** The buyer's merchant account. */
  merchant: Merchant;
  /** The chat thread between owner and buyer about this product, if one exists. */
  thread_id?: Maybe<Scalars['UUID']['output']>;
};

/** Filter input for product queries */
export type ProductFilter = {
  /** Filter key to apply */
  key: ProductFilterKey;
  /** Value to filter by */
  value: Scalars['String']['input'];
};

/** Available filter keys for product queries */
export enum ProductFilterKey {
  /** Filter by artist */
  Artist = 'ARTIST',
  /** Filter by auction state */
  AuctionState = 'AUCTION_STATE',
  /** Filter by brand */
  Brand = 'BRAND',
  /** Filter by product category */
  Category = 'CATEGORY',
  /** Filter by color */
  Color = 'COLOR',
  /** Filter by description */
  Description = 'DESCRIPTION',
  /** Filter by designer */
  Designer = 'DESIGNER',
  /** Filter expiring products */
  Expiring = 'EXPIRING',
  /** Filter by expiration date */
  ExpiryDate = 'EXPIRY_DATE',
  /** Filter by product group */
  Group = 'GROUP',
  /** Filter by showroom status */
  IsInShowroom = 'IS_IN_SHOWROOM',
  /** Filter by label */
  Label = 'LABEL',
  /** Filter by material */
  Material = 'MATERIAL',
  /** Filter by merchant */
  Merchant = 'MERCHANT',
  /** Filter premium products (true | false) */
  Premium = 'PREMIUM',
  /** Filter by price */
  Price = 'PRICE',
  /** Filter by internal product state */
  ProductState = 'PRODUCT_STATE',
  /** Filter by product status */
  ProductStatus = 'PRODUCT_STATUS',
  /** Filter by shape (round | square | organic | rectangle) */
  Shape = 'SHAPE',
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG',
  /** Filter by product style */
  Style = 'STYLE',
  /** Filter by subject */
  Subject = 'SUBJECT',
  /** Filter by tag */
  Tag = 'TAG',
  /** Filter by product title */
  Title = 'TITLE',
  /** Filter by title or description */
  TitleOrDescription = 'TITLE_OR_DESCRIPTION'
}

/** The input for analyzing product images. */
export type ProductImageInput = {
  /** The base64 encoded image data. */
  base64: Scalars['Base64']['input'];
  /** The unique identifier for the product image. */
  id: Scalars['UUID']['input'];
};

/** Input for creating or updating a product */
export type ProductInput = {
  /** Additional info IDs */
  additional_info?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Address ID for pickup/delivery */
  address?: InputMaybe<Scalars['UUID']['input']>;
  /** Allow bidding on product */
  allow_bid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow immediate purchase */
  allow_buy_now?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether product was advertised elsewhere */
  already_advertised_on_whoppah?: InputMaybe<Scalars['Boolean']['input']>;
  /** Artwork orientation */
  art_orientation?: InputMaybe<ArtOrientation>;
  /** Whether the artist is unknown */
  artistUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  /** Suggested artist if not found */
  artist_suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Artist IDs */
  artists?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Enable automatic discounts */
  auto_discount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bag model name (e.g. "Birkin 30"). Only used for bag listings. */
  bag_model?: InputMaybe<Scalars['String']['input']>;
  /** Brand ID */
  brand?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the brand is unknown */
  brandUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  /** Suggested brand if not found */
  brand_suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Immediate purchase price */
  buy_now_price?: InputMaybe<PriceInput>;
  /** Promotional campaign code */
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  /** Category IDs */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Color IDs */
  colors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Product condition state */
  condition?: InputMaybe<ProductCondition>;
  /** Custom shipping prices */
  customShippingPrices?: InputMaybe<Array<CustomShippingPriceInput>>;
  /** Delivery method */
  delivery_method?: InputMaybe<DeliveryMethod>;
  /** Depth in centimeters */
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Detailed product description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Suggested designer if not found */
  designer_suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Designer IDs */
  designers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Gender the bag is targeted at. */
  gender?: InputMaybe<Gender>;
  /** Global trade item number */
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** Hardware (metal) finish color for the bag. */
  hardware_color?: InputMaybe<Scalars['UUID']['input']>;
  /** Height in centimeters */
  height?: InputMaybe<Scalars['Int']['input']>;
  /**
   * @deprecated No longer used
   * Legacy showroom flag
   * @deprecated No longer used
   */
  is_in_showroom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Material IDs */
  materials?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Merchant ID selling the product */
  merchant?: InputMaybe<Scalars['UUID']['input']>;
  /** Minimum bid amount */
  minimum_bid?: InputMaybe<PriceInput>;
  /** Manufacturer part number */
  mpn?: InputMaybe<Scalars['String']['input']>;
  /** New discounted price */
  new_price?: InputMaybe<PriceInput>;
  /** Note for the curator */
  note_for_curator?: InputMaybe<Scalars['String']['input']>;
  /** Number of items in the set */
  number_of_items?: InputMaybe<Scalars['Int']['input']>;
  /** Original price before discount */
  original_price?: InputMaybe<PriceInput>;
  /** Size category for postal shipping (S/M/L/XL/XXL). Preferred over postal_package_size. */
  postalPackageSize?: InputMaybe<PostalPackageSize>;
  /**
   * Size category for postal shipping (legacy enum: SMALL/MEDIUM/LARGE).
   * Accepted for backwards compatibility; takes effect only when postalPackageSize is not provided.
   * @deprecated Use postalPackageSize (S/M/L/XL/XXL) instead.
   */
  postal_package_size?: InputMaybe<PostalPackageSize>;
  /** Weight in kg for postal shipping */
  postal_package_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  /** Product quality level */
  quality?: InputMaybe<ProductQuality>;
  /** Number of items available */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Reactivate expired listing */
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Seat height in centimeters */
  seat_height?: InputMaybe<Scalars['Int']['input']>;
  /** Product shape */
  shape?: InputMaybe<Shape>;
  /**
   * Shipping cost details
   * @deprecated Use customShippingPrices instead
   */
  shipping_cost?: InputMaybe<PriceInput>;
  /** Shipping method ID */
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the product is a showroom model */
  showroomModel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stock keeping unit */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Style IDs */
  styles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Subject IDs */
  subject?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Product title/name */
  title: Scalars['String']['input'];
  /** Usage sign IDs */
  usage_signs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Description of product's usage signs */
  usage_signs_description?: InputMaybe<Scalars['String']['input']>;
  /** User confirmed product fits postal requirements */
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * @deprecated Clients should not be allowed to update weight
   * Weight in kilograms
   * @deprecated Clients should not be allowed to update weight
   */
  weight?: InputMaybe<Scalars['Int']['input']>;
  /** Width in centimeters */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** Year the seller originally purchased the bag. */
  year_of_purchase?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A listing fee applied to a specific product. Created when the merchant
 * purchases a listing fee package for the product.
 */
export type ProductListingFee = {
  __typename?: 'ProductListingFee';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  /** Commission amount (percentage if feeType is PERCENTAGE) charged on sale */
  feeAmount: Scalars['Float']['output'];
  feeType: ListingFeeType;
  id: Scalars['UUID']['output'];
  order?: Maybe<Order>;
  package: ListingFeePackage;
  status: ProductListingFeeStatus;
};

/** Status of a listing fee applied to a product */
export enum ProductListingFeeStatus {
  Applied = 'APPLIED',
  Cancelled = 'CANCELLED'
}

/** Input for checking platform fees */
export type ProductPlatformFeeInput = {
  /** Optional campaign code */
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  /** Product to check fees for */
  product_id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result type for platform fee calculation */
export type ProductPlatformFeeResult = {
  __typename?: 'ProductPlatformFeeResult';
  /** Applied campaign code if any */
  campaign_code?: Maybe<Scalars['String']['output']>;
  /** Calculated platform fee */
  fee: Fee;
};

/** Public presentation of an eligible promotion; contains no purchase details. */
export type ProductPromotion = {
  __typename?: 'ProductPromotion';
  campaignId: Scalars['ID']['output'];
  disclosure: PromotionDisclosure;
  highlight: Scalars['Boolean']['output'];
  label?: Maybe<PromotionLabel>;
  /** A short-lived event ticket; null when tracking is unavailable. */
  token?: Maybe<Scalars['String']['output']>;
};

/** Product quality levels */
export enum ProductQuality {
  /** Product shows normal signs of use */
  Good = 'GOOD',
  /** Product is in very good condition */
  Great = 'GREAT',
  /** Product is in excellent condition */
  Perfect = 'PERFECT'
}

/**
 * Results of a paginated product query.
 * Contains both pagination information and the matched products.
 */
export type ProductResult = {
  __typename?: 'ProductResult';
  /** List of products matching the query criteria */
  items: Array<Product>;
  /** Pagination metadata including total count and page information */
  pagination: PaginationResult;
};

export type ProductScreenParams = {
  __typename?: 'ProductScreenParams';
  slug: Scalars['String']['output'];
};

/** Input for selecting a product (ID or slug) */
export type ProductSelectorInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductShippingDetails = {
  __typename?: 'ProductShippingDetails';
  /** Shipping options for the product */
  shippingOptions: Array<ProductShippingOption>;
};

export type ProductShippingDetailsV2 = {
  __typename?: 'ProductShippingDetailsV2';
  /** Shipping options for the product */
  shippingOptions: Array<ProductShippingOptionV2>;
};

/** Type representing a shipping estimate for a product */
export type ProductShippingEstimate = {
  __typename?: 'ProductShippingEstimate';
  /** Max days (if available) */
  maxDays?: Maybe<Scalars['Int']['output']>;
  /** Min days (if available) */
  minDays?: Maybe<Scalars['Int']['output']>;
};

/**
 * Type representing a shipping option for a product
 * Contains details about the shipping method, cost, and provider.
 */
export type ProductShippingOption = {
  __typename?: 'ProductShippingOption';
  /** Countries that the shipping option is available for */
  availableForCountries?: Maybe<Array<Country>>;
  /** Delivery estimate for this shipping option */
  deliveryEstimate?: Maybe<ProductShippingEstimate>;
  /** Whether this option is currently supported for the current request context */
  isSupported: Scalars['Boolean']['output'];
  /** Cost of the shipping option */
  price?: Maybe<Price>;
  /** Indicates if price requires country, full address, or request a quote */
  requiredForPrice?: Maybe<RequiredForPriceEnum>;
  /** Type of shipping method */
  shippingMethod: ShippingMethodEnum;
  /** Shipping service provider (if applicable, only for courier and parcel) */
  shippingProvider?: Maybe<ShippingProviderEnum>;
  /** Reason why Brenger is unsupported for the current request context */
  unsupportedReason?: Maybe<ShippingOptionUnsupportedReasonEnum>;
};


/**
 * Type representing a shipping option for a product
 * Contains details about the shipping method, cost, and provider.
 */
export type ProductShippingOptionPriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/**
 * V2 shipping option. Same as ProductShippingOption, but SendCloud postal
 * shipping is returned as separate home-delivery and service-point options, each
 * tagged with `deliveryType`.
 */
export type ProductShippingOptionV2 = {
  __typename?: 'ProductShippingOptionV2';
  /** Countries that the shipping option is available for */
  availableForCountries?: Maybe<Array<Country>>;
  /** Delivery estimate for this shipping option */
  deliveryEstimate?: Maybe<ProductShippingEstimate>;
  /**
   * For postal options, whether delivery is to the buyer's home or a service
   * point. Only populated for SendCloud postal options.
   */
  deliveryType?: Maybe<PostalDeliveryTypeEnum>;
  /** Whether this option is currently supported for the current request context */
  isSupported: Scalars['Boolean']['output'];
  /** Cost of the shipping option */
  price?: Maybe<Price>;
  /** Indicates if price requires country, full address, or request a quote */
  requiredForPrice?: Maybe<RequiredForPriceEnum>;
  /** Type of shipping method */
  shippingMethod: ShippingMethodEnum;
  /** Shipping service provider (if applicable, only for courier and parcel) */
  shippingProvider?: Maybe<ShippingProviderEnum>;
  /** Reason why the option is unsupported for the current request context */
  unsupportedReason?: Maybe<ShippingOptionUnsupportedReasonEnum>;
};


/**
 * V2 shipping option. Same as ProductShippingOption, but SendCloud postal
 * shipping is returned as separate home-delivery and service-point options, each
 * tagged with `deliveryType`.
 */
export type ProductShippingOptionV2PriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** Input for shipping options address */
export type ProductShippingOptionsAddressInput = {
  /** Country code for shipping */
  country: Country;
};

/** Input for fetching product shipping options */
export type ProductShippingOptionsInput = {
  /** Delivery address details */
  deliveryAddress?: InputMaybe<ProductShippingOptionsAddressInput>;
  /** Preferred language for shipping info */
  lang?: InputMaybe<Language>;
  /** Product ID to check shipping for */
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /** Product slug to check shipping for */
  productSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Available keys for product slug queries */
export enum ProductSlugKey {
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG'
}

/** Sort options for product queries */
export enum ProductSort {
  /** Sort by asking price */
  AskingPrice = 'ASKING_PRICE',
  /** Sort by creation date */
  Created = 'CREATED',
  /** Default sorting order */
  Default = 'DEFAULT',
  /** Sort by expiry date */
  ExpiryDate = 'EXPIRY_DATE',
  /** Sort by title */
  Title = 'TITLE',
  /** Sort by last update date */
  Updated = 'UPDATED'
}

/** Internal product states */
export enum ProductState {
  /** Accepted by curators */
  Accepted = 'ACCEPTED',
  /** Moved to archive */
  Archive = 'ARCHIVE',
  /** Banned from platform */
  Banned = 'BANNED',
  /** Canceled by seller */
  Canceled = 'CANCELED',
  /** Under review by curators */
  Curation = 'CURATION',
  /** Initial draft state */
  Draft = 'DRAFT',
  /** Rejected by curators */
  Rejected = 'REJECTED',
  /** Updated after acceptance */
  Updated = 'UPDATED'
}

/** User-facing product status */
export enum ProductStatus {
  /** Live and available */
  Active = 'ACTIVE',
  /** Canceled by seller */
  Canceled = 'CANCELED',
  /** Changes requested by curator */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** Declined by curator */
  Declined = 'DECLINED',
  /** Being created */
  Draft = 'DRAFT',
  /** Close to expiration */
  Expiring = 'EXPIRING',
  /** Under review */
  InReview = 'IN_REVIEW',
  /** Successfully sold */
  Sold = 'SOLD'
}

/** Type representing product-specific AR features */
export type ProductType = {
  __typename?: 'ProductType';
  /** AR object for 3D visualization */
  arobject?: Maybe<ArObject>;
};


/** Type representing product-specific AR features */
export type ProductTypeArobjectArgs = {
  platform?: InputMaybe<ArPlatform>;
};

/** Reasons for withdrawing a product from sale */
export enum ProductWithdrawReason {
  /** Expired with no response */
  ExpiredNoResponse = 'EXPIRED_NO_RESPONSE',
  /** Leaving the platform */
  LeavingWhoppah = 'LEAVING_WHOPPAH',
  /** No longer for sale */
  NoLongerSelling = 'NO_LONGER_SELLING',
  /** Other reason */
  Other = 'OTHER',
  /** Sold on 1stDibs */
  Sold_1Stdibs = 'SOLD_1STDIBS',
  /** Sold directly to buyer */
  SoldDirectlyToBuyer = 'SOLD_DIRECTLY_TO_BUYER',
  /** Sold on eBay */
  SoldEbay = 'SOLD_EBAY',
  /** Sold through another platform */
  SoldElsewhere = 'SOLD_ELSEWHERE',
  /** Sold on Marktplaats */
  SoldMarktplaats = 'SOLD_MARKTPLAATS',
  /** Sold on Pamono */
  SoldPamono = 'SOLD_PAMONO',
  /** Sold on Selency */
  SoldSelency = 'SOLD_SELENCY',
  /** Sold on Tweedehands */
  SoldTweedehands = 'SOLD_TWEEDEHANDS',
  /** Sold through Whoppah */
  SoldWhoppah = 'SOLD_WHOPPAH'
}

/** Promotional offer details */
export type Promotion = {
  __typename?: 'Promotion';
  code: Scalars['String']['output'];
  discount: CouponCodeDiscount;
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

/** A component before purchase; listPrice is the undiscounted web reference price. */
export type PromotionBenefitTemplate = {
  __typename?: 'PromotionBenefitTemplate';
  durationDays: Scalars['Int']['output'];
  effect: PromotionEffect;
  listPrice: PromotionMoney;
};

/** One old-style boost package. */
export type PromotionBoostOption = {
  __typename?: 'PromotionBoostOption';
  days: Scalars['Int']['output'];
  /** The usual price, shown struck through when it differs. */
  listPrice: PromotionMoney;
  popular: Scalars['Boolean']['output'];
  /** Price in this catalogue's context (create-ad price for a new ad). */
  price: PromotionMoney;
};

/** An owner's paid promotion and its current delivery state. */
export type PromotionCampaign = {
  __typename?: 'PromotionCampaign';
  benefits: Array<PromotionCampaignBenefit>;
  canResumeCheckout: Scalars['Boolean']['output'];
  canWithdraw: Scalars['Boolean']['output'];
  catalogueVersion: Scalars['Int']['output'];
  effects: Array<PromotionEffect>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Null when measurement is unavailable; zero is an observed empty ledger. */
  metrics?: Maybe<PromotionMetrics>;
  offerTitle: Scalars['String']['output'];
  /** Set when this purchase is the Frame and Must go part of a Stand out pack; its boost is an old-style boost line. */
  pack?: Maybe<PromotionQuotePack>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus: PromotionPaymentStatus;
  price?: Maybe<PromotionMoney>;
  productId: Scalars['ID']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PromotionStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
};

/** One purchased benefit and its independent delivery clock. */
export type PromotionCampaignBenefit = {
  __typename?: 'PromotionCampaignBenefit';
  durationDays: Scalars['Int']['output'];
  effect: PromotionEffect;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  label?: Maybe<PromotionLabel>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PromotionStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
};

/** The owner's available choices and purchase capability. */
export type PromotionCatalogue = {
  __typename?: 'PromotionCatalogue';
  availableEffects: Array<PromotionEffect>;
  /** False while another old-style boost runs or awaits payment on this listing. */
  boostAvailable: Scalars['Boolean']['output'];
  /** The old-style boost (top of its category), sold beside the promotions as its own cart line, priced in this catalogue's context. */
  boostOptions: Array<PromotionBoostOption>;
  catalogueVersion: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  homepageAvailability: PromotionHomepageAvailability;
  labelChoices: Array<PromotionLabel>;
  offers: Array<PromotionOffer>;
  /** The server-approved context used for these prices and store products. */
  purchaseContext: PromotionPurchaseContext;
  /** Why the requested context was unavailable; null when it was accepted. */
  purchaseContextReason?: Maybe<Scalars['String']['output']>;
  purchaseSupported: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /** The 7-day boost with Frame and Must go for one price; null when the boost cannot be bought. */
  standOutPack?: Maybe<PromotionStandOutPack>;
  termsVersion: Scalars['String']['output'];
};

/** The channel used to purchase a promotion. Native purchases require store billing. */
export enum PromotionChannel {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Web = 'WEB'
}

/** Payment confirmation happens through the payment provider; this response does not activate delivery. */
export type PromotionCheckout = {
  __typename?: 'PromotionCheckout';
  campaignId: Scalars['ID']['output'];
  orderGroupId: Scalars['ID']['output'];
  paymentIntentClientSecret: Scalars['String']['output'];
};

/** Observed delivery events for one UTC date. */
export type PromotionDailyMetrics = {
  __typename?: 'PromotionDailyMetrics';
  clicks: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  impressions: Scalars['Int']['output'];
};

/** Why the listing has paid visibility and who purchased it. */
export type PromotionDisclosure = {
  __typename?: 'PromotionDisclosure';
  advertiserName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** A purchased promotion benefit. */
export enum PromotionEffect {
  Highlight = 'HIGHLIGHT',
  Homepage = 'HOMEPAGE',
  Label = 'LABEL'
}

/** Current availability of the finite rotating homepage pool; rechecked before payment. */
export type PromotionHomepageAvailability = {
  __typename?: 'PromotionHomepageAvailability';
  available: Scalars['Boolean']['output'];
  capacity: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  remaining: Scalars['Int']['output'];
};

/** A seller-selected paid label, separate from platform trust or curation badges. */
export type PromotionLabel = {
  __typename?: 'PromotionLabel';
  code: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Recorded delivery events, retained as daily totals; not unique people or incremental sales. */
export type PromotionMetrics = {
  __typename?: 'PromotionMetrics';
  /** Clicks divided by impressions, or null when no impressions were observed. */
  clickThroughRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['Int']['output'];
  daily: Array<PromotionDailyMetrics>;
  impressions: Scalars['Int']['output'];
  /** False when older totals cannot be fully attributed to a surface. Totals remain authoritative. */
  placementBreakdownComplete: Scalars['Boolean']['output'];
  /** Delivery totals by surface; these do not represent unique people. */
  placements: Array<PromotionPlacementMetrics>;
  /** Time the report was calculated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An exact monetary amount in minor units, including VAT. */
export type PromotionMoney = {
  __typename?: 'PromotionMoney';
  amount: Scalars['Int']['output'];
  /** Optional display estimate. The immutable amount and settlement currency do not change. */
  converted?: Maybe<Price>;
  currency: Scalars['String']['output'];
};


/** An exact monetary amount in minor units, including VAT. */
export type PromotionMoneyConvertedArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** A promotion available for this listing. No outcome is guaranteed. */
export type PromotionOffer = {
  __typename?: 'PromotionOffer';
  /** Independently timed benefits in this offer. */
  benefits: Array<PromotionBenefitTemplate>;
  /** Purchase contract version; historical offers retain version 1. */
  catalogueVersion: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  durationDays: Scalars['Int']['output'];
  effects: Array<PromotionEffect>;
  /** Whether this exact selection can currently be purchased. */
  eligible: Scalars['Boolean']['output'];
  price: PromotionMoney;
  /** Stable reason when this selection is unavailable. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Current sum of the separate offers, only for a genuine bundle comparison. */
  separatePrice?: Maybe<PromotionMoney>;
  /** Provider-configured consumable SKU. The native storefront supplies the final localized price. */
  storeProductId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** The payment or refund state of a promotion. */
export enum PromotionPaymentStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RefundRequested = 'REFUND_REQUESTED'
}

/** Observed events attributed to one delivery surface. */
export type PromotionPlacementMetrics = {
  __typename?: 'PromotionPlacementMetrics';
  clicks: Scalars['Int']['output'];
  impressions: Scalars['Int']['output'];
  placement: Scalars['String']['output'];
};

/** The entry point requesting a price; create-ad eligibility is verified by the server. */
export enum PromotionPurchaseContext {
  CreateAd = 'CREATE_AD',
  MyAds = 'MY_ADS'
}

export type PromotionQuote = {
  __typename?: 'PromotionQuote';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Chosen label frozen with this quote; null when no label was selected. */
  label?: Maybe<PromotionLabel>;
  offer: PromotionOffer;
  /** Set when this quote is the Frame and Must go part of a Stand out pack. */
  pack?: Maybe<PromotionQuotePack>;
  price: PromotionMoney;
  /** Server-authorized price context frozen in this quote. */
  purchaseContext: PromotionPurchaseContext;
  tax: PromotionTax;
  termsVersion: Scalars['String']['output'];
};

/** The boost half of a Stand out pack quote, added to the cart as its own old-style boost line. */
export type PromotionQuotePack = {
  __typename?: 'PromotionQuotePack';
  boostDays: Scalars['Int']['output'];
  boostPrice: PromotionMoney;
};

export type PromotionResumeCheckout = {
  __typename?: 'PromotionResumeCheckout';
  campaign: PromotionCampaign;
  checkout?: Maybe<PromotionCheckout>;
  /** Shared payment containing this campaign, including its other listing services. */
  packageCheckout?: Maybe<PackageCheckout>;
};

/** The Stand out pack: the old-style boost for boostDays plus Frame and Must go. */
export type PromotionStandOutPack = {
  __typename?: 'PromotionStandOutPack';
  boostDays: Scalars['Int']['output'];
  /** The whole pack, boost included. */
  price: PromotionMoney;
};

/** Delivery state, independent of whether the purchase has been paid. */
export enum PromotionStatus {
  Active = 'ACTIVE',
  AwaitingListing = 'AWAITING_LISTING',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paused = 'PAUSED',
  RefundRequired = 'REFUND_REQUIRED'
}

/** An immutable price and benefit quote valid until expiresAt. */
export type PromotionTax = {
  __typename?: 'PromotionTax';
  netAmount: Scalars['Int']['output'];
  reverseCharge: Scalars['Boolean']['output'];
  taxAmount: Scalars['Int']['output'];
  vatBasisPoints: Scalars['Int']['output'];
};

/**
 * Methods by which a product can be purchased.
 * Distinguishes between bidding and direct purchases.
 */
export enum PurchaseType {
  /** Purchase through bidding process */
  Bid = 'BID',
  /** Immediate purchase at listed price */
  DirectPurchase = 'DIRECT_PURCHASE'
}

/** Input arguments for the purchases query. */
export type PurchasesInput = {
  /** Sort direction */
  order?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<Pagination>;
  /** Case-insensitive product title search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Field to sort by */
  sort?: InputMaybe<PurchasesSort>;
};

/** Paginated purchase results for the authenticated buyer. */
export type PurchasesResult = {
  __typename?: 'PurchasesResult';
  /** Order groups matching the input */
  items: Array<OrderGroup>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** Sorting options for purchase listings. */
export enum PurchasesSort {
  /** Sort by creation timestamp */
  Created = 'CREATED',
  /** Sort by grouped total amount */
  TotalAmount = 'TOTAL_AMOUNT'
}

/** Root Query type for all read operations in the API */
export type Query = {
  __typename?: 'Query';
  /**
   * The authenticated merchant's account dashboard: open actions, KPIs and
   * recent activity. Requires authentication.
   */
  accountDashboard: AccountDashboard;
  /**
   * Retrieve all addresses associated with the authenticated merchant
   * Returns an array of addresses
   */
  addresses: Array<Address>;
  /** Validates an AI assistant's authorization request for the consent page. */
  agentAuthorizationRequest: AgentAuthorizationRequest;
  /**
   * WHO-6321: the member's cart with its totals recalculated now, for an AI agent's checkout summary
   * (agent token with the checkout:pay scope only). The stored totals on `cart` can be stale; the
   * total here is what completeAgentCheckout charges.
   */
  agentCheckoutCart: Cart;
  /**
   * WHO-6321: the order group an earlier completeAgentCheckout with this idempotency key paid for,
   * or null when no payment finished under that key (agent token with the checkout:pay scope only).
   * Read-only: lets a retried confirm return the same result instead of re-checking a now sold item.
   */
  agentCheckoutResult?: Maybe<OrderGroup>;
  /** The AI assistants the current member has connected. */
  agentGrants: Array<AgentGrant>;
  /**
   * Get an attribute by ID
   * No authentication required
   */
  attribute: Attribute;
  /**
   * Find an attribute by key-value pair
   * No authentication required
   */
  attributeByKey?: Maybe<Attribute>;
  /**
   * Search and filter attributes with pagination
   * No authentication required
   */
  attributes: AttributeResult;
  /**
   * Search attributes scoped to a top-level category, optionally narrowed by
   * attribute type. Returns attributes linked to the given category or any of
   * its descendants.
   * No authentication required
   */
  attributesByCategory: AttributeResult;
  /**
   * Get multiple attributes by their IDs
   * No authentication required
   */
  attributesByID: Array<Maybe<Attribute>>;
  /**
   * Find multiple attributes by key-value pair
   * No authentication required
   */
  attributesByKey: Array<Attribute>;
  /**
   * Get the current balance available for payout
   * Returns the amount and currency
   */
  balance: Price;
  /**
   * Fetch a specific bid by its unique identifier.
   * Returns detailed bid information including buyer, merchant, and auction details.
   * Requires authentication.
   */
  bid?: Maybe<Bid>;
  /**
   * Find a single bid using a key-value lookup.
   * Returns the first matching bid or null if none found.
   * Requires authentication.
   */
  bidByKey?: Maybe<Bid>;
  /**
   * Query bids with filtering, pagination and sorting options.
   * Returns a paginated list of bids matching the specified criteria.
   * Requires authentication.
   */
  bids: BidResult;
  /**
   * Retrieve multiple bids by ID.
   * Returns a list of bids matching the provided ID.
   * Requires authentication.
   */
  bidsByID: Array<Maybe<Bid>>;
  /**
   * Find multiple bids using a key-value lookup.
   * Returns all bids matching the specified criteria.
   * Requires authentication.
   */
  bidsByKey: Array<Bid>;
  /**
   * Retrieve a single block by its ID
   * @deprecated Use other query methods instead
   * @deprecated Not needed
   */
  block: Block;
  /**
   * Find a single block by a specific key-value pair
   * @deprecated Use other query methods instead
   * @deprecated Not needed
   */
  blockByKey?: Maybe<Block>;
  /**
   * Query blocks with filtering, pagination and sorting options
   * @deprecated Use other query methods instead
   * @deprecated Not needed
   */
  blocks: BlockResult;
  /**
   * Retrieve multiple blocks by their IDs
   * @deprecated Use other query methods instead
   * @deprecated Not needed
   */
  blocksByID: Array<Maybe<Block>>;
  /**
   * Find multiple blocks by a specific key-value pair
   * @deprecated Use other query methods instead
   * @deprecated Not needed
   */
  blocksByKey: Array<Block>;
  /** Get the current user's boost cart */
  boostCart: BoostCart;
  /** Get all boost packages */
  boostPackages: Array<BoostPackage>;
  /** Search for brands with optional filters */
  brands: Array<Brand>;
  /** Get the current user's cart */
  cart: Cart;
  /** Get the count of items in the cart */
  cartCount: Scalars['Int']['output'];
  /**
   * Query categories with filtering, pagination and sorting options.
   * Returns a paginated list of categories matching the specified criteria.
   */
  categories: CategoryResult;
  /**
   * Retrieve multiple categories by ID.
   * Returns a list of categories matching the provided ID.
   */
  categoriesByID: Array<Maybe<Category>>;
  /**
   * Find multiple categories using a key-value lookup.
   * Returns all categories matching the specified criteria.
   */
  categoriesByKey: Array<Category>;
  /**
   * Fetch a specific category by its ID.
   * Returns detailed category information including media and subcategories.
   */
  category?: Maybe<Category>;
  /**
   * Find a single category using a key-value lookup.
   * Returns the first matching category or null if none found.
   */
  categoryByKey?: Maybe<Category>;
  /**
   * Validate a VAT identification number.
   * Checks if the provided VAT number is valid and active.
   */
  checkVat?: Maybe<VatCheckResult>;
  /**
   * Get all available collections in the system.
   * Returns a list of all active collections that can be used for product organization and discovery.
   * Collections are returned in their default sort order and include all associated metadata.
   */
  collections: Array<Collection>;
  /**
   * Get all coming soon alerts for the authenticated user with pagination
   * Requires authentication
   */
  comingSoonAlerts: ComingSoonAlertResult;
  config: Config;
  /**
   * Parse a URL into an internal app screen configuration.
   * Used for deep linking and universal link handling to navigate to specific screens in the app.
   *
   * Returns the corresponding app screen configuration if the URL can be parsed, null otherwise.
   */
  deeplink?: Maybe<AppScreen>;
  /** Search for designers with optional filters */
  designers: Array<Designer>;
  /**
   * The plan offer for a product owned by the current user (WHO-4942), used by web
   * and app 3.0.73+. Each plan's up-front price is its package `price`, worked out
   * from the asking price. A plan is listed only when its savings beat that price,
   * and the free Standard row (the ad's own terms) comes last. Empty when no plan
   * beats its price, the ad already has a plan or isn't eligible, or the ad has a
   * fixed fee (a plan takes a rate off, and a fixed fee has none). Requires
   * authentication.
   */
  dynamicListingFeePackages: Array<DynamicListingFeePackageOption>;
  /**
   * Export order overview for administrative purposes.
   * Filtered by shipping method and time period.
   * Requires admin authentication.
   */
  exportOrderOverview?: Maybe<Array<Maybe<Order>>>;
  /**
   * Get all favorites for the authenticated user with pagination and sorting
   * Default sort is by creation date in descending order
   * Requires authentication
   */
  favorites: FavoriteResult;
  /**
   * Get available scheduling options for a Brenger delivery
   * Requires authentication
   */
  getBrengerAppointmentOptions: BrengerAppointmentOptions;
  /**
   * Get proposed dates for a Brenger delivery
   * Requires authentication
   */
  getBrengerProposedDates: BrengerProposedDates;
  /** Get fallback listing page for a given slug */
  getFallbackListingPage: ListingPage;
  /**
   * Fetch messages from a specific thread with cursor-based pagination.
   * Messages are returned in reverse chronological order.
   * Requires authentication.
   */
  getMessages: GetMessagesResult;
  /**
   * Calculate platform fee for a product
   * Authentication required
   */
  getProductPlatformFee: ProductPlatformFeeResult;
  /**
   * Get all available shipping options for a product
   * @deprecated Use getProductShippingDetailsV2, which splits SendCloud postal options by delivery type (home vs service point).
   */
  getProductShippingDetails: ProductShippingDetails;
  /**
   * Get all available shipping options for a product. Unlike
   * getProductShippingDetails, SendCloud postal shipping is returned as two
   * separate options (home delivery and service point), each tagged with
   * `deliveryType`.
   */
  getProductShippingDetailsV2: ProductShippingDetailsV2;
  /**
   * Get available shipping options for a product
   * @deprecated Use getProductShippingDetails instead
   */
  getProductShippingOptions: Array<ShippingOption>;
  /**
   * Generate an ephemeral key for Stripe SDK.
   * Required for mobile client authentication.
   * Requires user authentication.
   */
  getStripeEphemeralKey: Scalars['JSON']['output'];
  /**
   * Fetch message threads with cursor-based pagination.
   * Returns threads ordered by most recent activity.
   * Requires authentication.
   */
  getThreads: GetThreadsResult;
  /**
   * Get the total count of unread messages for the authenticated user.
   * The id parameter is deprecated and no longer used.
   */
  getUnreadMessageCount: Scalars['Int']['output'];
  /** Get a guest cart for non-logged-in users */
  guestCart: GuestCart;
  health: Scalars['Boolean']['output'];
  /**
   * One published help article by locale-specific slug, with body and hreflang.
   *
   * Public and cacheable. Returns null when the slug is unknown, unpublished,
   * or internal, matching a missing page rather than an error.
   */
  helpArticle?: Maybe<HelpArticle>;
  /**
   * Markdown twin of one published help article, for GEO and agent consumers.
   *
   * Public. Returns null when the slug is unknown, unpublished, or internal,
   * matching `helpArticle`. `canonicalBase` is the origin help-service uses to
   * build the Source URL in the markdown (for example `https://www.whoppah.com`).
   */
  helpArticleMarkdown?: Maybe<Scalars['String']['output']>;
  /**
   * Published, non-internal help articles in a locale, optionally in one category.
   *
   * Public and cacheable. `categorySlug` is the locale-specific category slug.
   * An unknown category slug returns an empty page, not an error, matching
   * help-service. `page` is 1-based; omitted means page 1.
   */
  helpArticles: HelpArticlePage;
  /**
   * Published help-category tree for a locale, with article counts.
   *
   * Public and cacheable: no account is required. Unknown or disabled locales
   * fail as user input rather than returning an empty tree, so a bad locale is
   * not confused with an empty help center.
   */
  helpCategories: Array<HelpCategory>;
  /**
   * The whole help center as one markdown file for a locale.
   *
   * Public. `canonicalBase` is the origin help-service uses to build article
   * Source URLs. An unknown or disabled locale fails as user input.
   */
  helpCenterMarkdown: Scalars['String']['output'];
  /**
   * Featured published help articles in a locale, for the overview "top questions".
   *
   * Public and cacheable. `limit` is passed through to help-service; omitted uses
   * that service's default. An unknown or disabled locale fails as user input
   * rather than returning an empty list.
   */
  helpFeaturedArticles: Array<HelpArticleListItem>;
  /**
   * Full-text search over published help articles in a locale.
   *
   * Public and cacheable. Ranking is help-service's Postgres FTS rank; this API
   * returns the hits in that order. An empty query is refused as user input.
   */
  helpSearch: Array<HelpSearchResult>;
  /**
   * Retrieve the website's homepage configuration.
   * Returns the specialized Homepage type containing the main landing page setup.
   */
  homepage?: Maybe<Homepage>;
  /** Fresh rotating sponsored homepage cards. Never cache tickets in editorial feeds or static pages. */
  homepagePromotions: Array<HomepagePromotion>;
  /**
   * Get active listing fee package options available for a product owned by
   * the current user. Each result wraps a package with the per-product
   * commission, savings and payout amounts. Results are filtered to packages
   * whose reducedFeeAmount is lower than the owner's default seller fee, so
   * only packages that actually reduce the commission are returned.
   * Requires authentication.
   * @deprecated Used only by app 3.0.61 to 3.0.72; web and app 3.0.73+ use dynamicListingFeePackages. Its amounts stay price x rate so those builds keep matching their own Standard row (WHO-6156).
   */
  listingFeePackages: Array<ListingFeePackageOption>;
  /**
   * Retrieve a listing page by its URL and language.
   * Returns the listing page configuration including filters, breadcrumbs, and related pages.
   */
  listingPage?: Maybe<ListingPage>;
  listingPageByFilters?: Maybe<ListingPage>;
  /**
   * Get a localized version of a URL based on the user's language settings.
   * Used for internationalizing URLs and handling redirects to localized content.
   *
   * Returns the localized URL and its status (found, not found, or redirect).
   */
  localizeUrl: LocalizedUrl;
  /** Get the currently authenticated member's profile */
  me?: Maybe<Member>;
  /** Get a specific merchant by ID */
  merchant?: Maybe<Merchant>;
  /** The viewer's live REQUESTED and live ACCEPTED reservations. */
  myReservations: Array<BuyerReservation>;
  /**
   * The member's message-type preferences. Signed in, or with the signed token from
   * an email link (`token`), which identifies the member without a session.
   */
  notificationPreferences: NotificationPreferences;
  /** Items open to offers in other members' published rooms. Authentication required; not for Pro Buyers. */
  openHomeBrowse: OpenHomeItemPage;
  /** Open Home items the viewer favorited. Authentication required; not for Pro Buyers. */
  openHomeFavorites: Array<OpenHomeItem>;
  /** One item: the viewer's own, or one in a published room. Authentication required; not for Pro Buyers. */
  openHomeItem?: Maybe<OpenHomeItem>;
  /**
   * The viewer's bids on Open Home items as the buyer, newest first, including the owners'
   * counter offers to the viewer. Authentication required; not for Pro Buyers.
   */
  openHomeMyOffers: Array<Bid>;
  /** The viewer's rooms (at most 10). Authentication required; not for Pro Buyers. */
  openHomeMyRooms: Array<OpenHomeRoom>;
  /** One room: the viewer's own, or a published one. Authentication required; not for Pro Buyers. */
  openHomeRoom?: Maybe<OpenHomeRoom>;
  /**
   * Rooms the viewer saved (the Rooms tab in Favorites), last saved first. Only rooms the viewer
   * can still see: a room its owner unpublished, paused or deleted drops out, and comes back
   * when it is live again. Authentication required.
   */
  openHomeSavedRooms: Array<OpenHomeRoom>;
  /**
   * Fetch a specific order by its ID.
   * Returns detailed order information.
   * Requires authentication.
   */
  order?: Maybe<Order>;
  /**
   * Find a single order using a key-value lookup.
   * Returns the first matching order or null if none found.
   * Requires authentication.
   */
  orderByKey?: Maybe<Order>;
  /**
   * Find an order group by its ID.
   * Requires authentication.
   */
  orderGroupById?: Maybe<OrderGroup>;
  /**
   * Find an order group by its Stripe payment intent ID.
   * Used to look up orders after payment processing.
   * Requires authentication.
   */
  orderGroupByPaymentIntent?: Maybe<OrderGroup>;
  /**
   * Query orders with filtering, pagination and sorting options.
   * Returns a paginated list of orders matching the criteria.
   * Requires authentication.
   */
  orders: OrderResult;
  /**
   * Retrieve multiple orders by ID.
   * Returns a list of orders matching the provided ID.
   * Requires authentication.
   */
  ordersByID: Array<Maybe<Order>>;
  /**
   * Find multiple orders using a key-value lookup.
   * Returns all orders matching the specified criteria.
   * Requires authentication.
   */
  ordersByKey: Array<Order>;
  /** Get the current merchant's package cart. Requires authentication. */
  packageCart: PackageCart;
  /** Recover an owned checkout without rebuilding or repricing its cart. */
  packageCheckout?: Maybe<PackageCheckout>;
  /**
   * Retrieve a single page by its unique identifier.
   * This query is deprecated in favor of more flexible query methods.
   *
   * @deprecated Use alternative page query methods for better flexibility
   * @deprecated Not needed
   */
  page: Page;
  /**
   * Find a single page using a key-value lookup.
   * This query is deprecated in favor of more flexible query methods.
   *
   * @deprecated Use alternative page query methods for better flexibility
   * @deprecated Not needed
   */
  pageByKey?: Maybe<Page>;
  /**
   * Query pages with comprehensive filtering, pagination and sorting options.
   * This query is deprecated in favor of more modern query patterns.
   *
   * @deprecated Use alternative page query methods for better flexibility
   * @deprecated Not needed
   */
  pages: PageResult;
  /**
   * Retrieve multiple pages by their unique identifiers.
   * This query is deprecated in favor of more flexible query methods.
   *
   * @deprecated Use alternative page query methods for better flexibility
   * @deprecated Not needed
   */
  pagesByID: Array<Maybe<Page>>;
  /**
   * Find multiple pages by a specific key-value pair.
   * This query is deprecated in favor of more flexible query methods.
   *
   * @deprecated Use alternative page query methods for better flexibility
   * @deprecated Not needed
   */
  pagesByKey: Array<Page>;
  /**
   * The seller's commission and payout for an asking price (WHO-6000). Cheap
   * enough to call while the seller types; debounce on the client.
   */
  payoutQuote: PayoutQuote;
  /** Get payout status and history for the authenticated merchant */
  payouts: Payouts;
  /**
   * Get available vouchers for a given order amount.
   * Returns coupon codes that can be applied.
   */
  pendingVouchers: Array<CouponCode>;
  /** Get all available postal package sizes with their dimensions. */
  postalPackageSizes: Array<PostalPackageSizeOption>;
  /** The schedule this asking price would get if the ad went live today. Pure computation; cheap enough to call while the seller types (debounce). */
  priceDropPreview: PriceDropSchedule;
  /**
   * Sold-price recommendation for one of the caller's own products.
   *
   * Returns `REFUSED` rather than an error for a product the caller does not own,
   * so the query leaks nothing about other sellers' listings. The raw pricing
   * answer is cached for 6 hours; the asking-price rule is re-applied on every
   * read, so a price change is reflected immediately.
   *
   * For the ad page: `surface` defaults to `DETAIL`, which falls back to live
   * scoring when there is no fresh precomputed answer. The My ads list does not
   * call this per row; it selects `Product.priceRecommendation` on the products
   * it already loads, which answers a whole page in one batch.
   */
  priceRecommendation: PriceRecommendation;
  proBuyerBrandProfile: ProBuyerBrandProfile;
  /** At most 200 product ids. One entry per requested product (projects empty when in none). */
  proBuyerFavoriteProjects: Array<ProBuyerFavoriteProjects>;
  proBuyerFavoritesSummary: ProBuyerFavoritesSummary;
  /** One of the viewer's projects; null when it does not exist or is not theirs. */
  proBuyerProject?: Maybe<ProBuyerProject>;
  /**
   * WHO-5959 6c. For the given orders (at most 100), the project each of the
   * viewer's own purchases is in. Orders that are not the viewer's purchases are
   * left out. Same errors as `proBuyerProjects`.
   */
  proBuyerProjectAssignments: Array<ProBuyerProjectAssignment>;
  /**
   * The viewer's purchases that may go in a project (no cancelled, expired or
   * service orders), newest first, at most 200.
   */
  proBuyerProjectPurchaseOptions: Array<ProBuyerProjectPurchaseOption>;
  /**
   * The viewer's projects, most recently changed first, `limit` (default 24, max 100) per page.
   * Errors: FEATURE_DISABLED, PRO_BUYER_REQUIRED.
   */
  proBuyerProjects: ProBuyerProjectPage;
  /** The four overview figures. Same errors as `proBuyerProjects`. */
  proBuyerProjectsOverview: ProBuyerProjectsOverview;
  /** Projects for the heart menu, the active one first, then most recently changed. */
  proBuyerSaveTargets: Array<ProBuyerSaveTarget>;
  /**
   * Public, no login. Null when the link is off or unknown, the project is deleted,
   * the owner is no longer a Pro Buyer, or a flag is off. RATE_LIMITED past 60
   * requests a minute from one address.
   */
  proBuyerSelection?: Maybe<ProBuyerSelection>;
  /** The workspace switcher (reads: FULL or READ_ONLY). */
  proBuyerWorkspace: ProBuyerWorkspace;
  /**
   * Get a product by ID
   * No authentication required
   */
  product?: Maybe<Product>;
  /** Find a product by DM ID */
  productByDMId?: Maybe<Product>;
  /**
   * Get a product by ID
   * Authentication required
   */
  productById: Product;
  /**
   * Get a product by internal identifier
   * Authentication required
   */
  productByIdentifier: Product;
  /** Find a product by key-value pair */
  productByKey?: Maybe<Product>;
  /** Find a product by SRM slug */
  productBySRMSlug?: Maybe<Product>;
  /**
   * Find a product by its slug
   * Pass `includeWithdrawn: true` to also receive products the seller withdrew or
   * deleted (`state: CANCELED`), so the web can explain they are no longer available
   * instead of redirecting (WHO-6094). Defaults to false: other clients keep seeing null.
   */
  productBySlug?: Maybe<Product>;
  /**
   * Get product counts by status
   * Authentication required
   */
  productCountByStatus: Array<ProductCountByStatus>;
  /**
   * Search and filter products with pagination
   * Authentication required
   */
  products: ProductResult;
  /** Get multiple products by ID */
  productsByID: Array<Maybe<Product>>;
  /** Find multiple products by key-value pair */
  productsByKey: Array<Product>;
  /** A promotion belonging to the signed-in merchant, or null. */
  promotionCampaign?: Maybe<PromotionCampaign>;
  /** Recent promotion history for a listing the signed-in merchant owns. */
  promotionCampaigns: Array<PromotionCampaign>;
  /** Promotion choices for a listing the signed-in merchant owns. */
  promotionOffers: PromotionCatalogue;
  /** Get available promotions for the authenticated merchant */
  promotions: Array<Promotion>;
  /**
   * Retrieve paginated purchase history for the authenticated merchant.
   * Returns order groups where the merchant is the buyer.
   */
  purchases: PurchasesResult;
  /**
   * Get query suggestions based on a partial search term
   * @param query The partial search term to get suggestions for
   * @param size The maximum number of suggestions to return (default: 10)
   * @returns List of suggested search terms
   */
  querySuggestions: Array<Scalars['String']['output']>;
  /**
   * @deprecated Use relatedProducts
   * Get recommended products for a user
   * @deprecated Use relatedProducts
   */
  recommendedProducts: Array<Product>;
  /**
   * Get all available referral types.
   * Returns a list of possible ways merchants can be referred to the platform.
   */
  referralTypes: Array<ReferralType>;
  /** Get products related to a given product */
  relatedProducts: Array<Product>;
  /**
   * Search and filter reviews with pagination
   * No authentication required for reading reviews
   * No authentication required for reading reviews
   */
  reviews: ReviewResult;
  /**
   * Retrieve paginated sales history for the authenticated merchant.
   * Returns orders where the merchant is the seller.
   */
  sales: SalesResult;
  /**
   * The seller's My sales totals and per-status counts (WHO-6062). The totals
   * always cover every sale; `counts(search:)` narrows only the counts.
   */
  salesSummary: SalesSummary;
  /**
   * Get a saved search by its ID
   * Requires authentication
   */
  savedSearch?: Maybe<SavedSearch>;
  /**
   * Get a saved search by its external identifier
   * Public access allowed
   */
  savedSearchByIdentifier?: Maybe<SavedSearch>;
  /**
   * Get a saved search by a specific key-value pair
   * Requires authentication
   */
  savedSearchByKey?: Maybe<SavedSearch>;
  /**
   * Query saved searches with filtering, pagination and sorting
   * Requires authentication
   */
  savedSearches: SavedSearchResult;
  /**
   * Get multiple saved searches by their IDs
   * Requires authentication
   */
  savedSearchesByID: Array<Maybe<SavedSearch>>;
  /**
   * Find saved searches by a specific key-value pair
   * Requires authentication
   */
  savedSearchesByKey: Array<SavedSearch>;
  /**
   * @deprecated Use listingPage.filters instead
   * @deprecated Please use listingPage.filters
   */
  searchFiltersByURL?: Maybe<SearchFiltersByUrlResponse>;
  /** Search for products with advanced filtering and faceting */
  searchProducts?: Maybe<SearchProductsResult>;
  /**
   * @deprecated Use listingPage.subcategoryPages instead
   * @deprecated Please use listingPage.subcategoryPages
   */
  searchSubpages: SearchSubpagesResponse;
  /** Live reservations on the viewer's listings, requests first. */
  sellerReservations: Array<SellerReservation>;
  /** Owner only, any state incl. drafts: what a buyer in `country` would pay for each Whoppah shipping method (courier, postal) for this product's current dimensions, weight and number of items, as if the seller chose that method. A method that can't carry it comes back with isSupported false and unsupportedReason. */
  sellerShippingEstimates: Array<ProductShippingOptionV2>;
  /**
   * Get carrier service points (pickup points) near a location, used by the
   * checkout service-point picker for postal shipping.
   */
  servicePoints: Array<ServicePoint>;
  /**
   * Get all available shipping methods.
   * Returns list of shipping method configurations.
   *
   * Pass `originCountry` (the seller address country, ISO-3166-1 alpha-2) to get only the
   * methods that can actually be fulfilled from there — postal is dropped for a country the
   * postal carrier cannot collect in. Omitting it returns every active method.
   */
  shippingMethods: Array<ShippingMethod>;
  /**
   * @deprecated Use relatedProducts
   * Get products similar to a given product
   * @deprecated Use relatedProducts
   */
  similarProducts: Array<Product>;
  /**
   * Basic health check endpoint
   * Returns status code indicating API health
   */
  status?: Maybe<Scalars['Int']['output']>;
  /**
   * `fresh: true` re-reads the Stripe account before answering even when the
   * mirror is younger than its refresh window: for the page's return from
   * Stripe and its "Check again", where the seller just changed something.
   */
  stripeAccountDetails?: Maybe<StripeAccountDetails>;
  /**
   * Get subcategories based on brand, category, and style criteria.
   * Returns filtered list of subcategories matching the input parameters.
   */
  subcategories: Array<Category>;
  /**
   * Fetch a specific message thread by its ID.
   * Optionally marks the thread as read when fetching.
   * Requires authentication.
   */
  thread?: Maybe<Thread>;
  /**
   * Legacy query to fetch message threads with filtering and sorting.
   * @deprecated Use getThreads query instead for improved pagination and performance.
   * @deprecated Please use the getThreads query.
   */
  threads: ThreadResult;
  /**
   * Indicative sold-price range for a piece from one photo and what the recognition saw in it, from
   * the same pricing engine as create-ad. Call only after `admitValueCheck` admitted the check.
   * whoppah-web's server only.
   */
  valueCheckPrice: ValueCheckPrice;
};


/** Root Query type for all read operations in the API */
export type QueryAgentAuthorizationRequestArgs = {
  input: AgentAuthorizationInput;
};


/** Root Query type for all read operations in the API */
export type QueryAgentCheckoutResultArgs = {
  idempotencyKey: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryAttributeArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryAttributeByKeyArgs = {
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryAttributesArgs = {
  filters?: InputMaybe<Array<InputMaybe<AttributeFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AttributeSort>;
};


/** Root Query type for all read operations in the API */
export type QueryAttributesByCategoryArgs = {
  filters?: InputMaybe<AttributesFilter>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AttributeSort>;
};


/** Root Query type for all read operations in the API */
export type QueryAttributesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryAttributesByKeyArgs = {
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBidArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBidByKeyArgs = {
  key?: InputMaybe<BidFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBidsArgs = {
  filters?: InputMaybe<Array<BidFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BidSort>;
};


/** Root Query type for all read operations in the API */
export type QueryBidsByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBidsByKeyArgs = {
  key?: InputMaybe<BidFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBlockArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBlockByKeyArgs = {
  key?: InputMaybe<BlockFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBlocksArgs = {
  filters?: InputMaybe<Array<InputMaybe<BlockFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BlockSort>;
};


/** Root Query type for all read operations in the API */
export type QueryBlocksByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryBlocksByKeyArgs = {
  key?: InputMaybe<BlockFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryBrandsArgs = {
  filters?: InputMaybe<BrandsFilter>;
};


/** Root Query type for all read operations in the API */
export type QueryCategoriesArgs = {
  filters?: InputMaybe<Array<CategoryFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CategorySort>;
};


/** Root Query type for all read operations in the API */
export type QueryCategoriesByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryCategoriesByKeyArgs = {
  key?: InputMaybe<CategoryFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryCategoryArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryCategoryByKeyArgs = {
  key?: InputMaybe<CategoryFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryCheckVatArgs = {
  input?: InputMaybe<VatCheckInput>;
};


/** Root Query type for all read operations in the API */
export type QueryComingSoonAlertsArgs = {
  pagination?: InputMaybe<Pagination>;
};


/** Root Query type for all read operations in the API */
export type QueryDeeplinkArgs = {
  lang?: InputMaybe<Language>;
  url: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryDesignersArgs = {
  filters?: InputMaybe<DesignersFilter>;
};


/** Root Query type for all read operations in the API */
export type QueryDynamicListingFeePackagesArgs = {
  productId: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryExportOrderOverviewArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryFavoritesArgs = {
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<FavoriteSort>;
};


/** Root Query type for all read operations in the API */
export type QueryGetBrengerAppointmentOptionsArgs = {
  orderId: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryGetBrengerProposedDatesArgs = {
  orderId: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryGetFallbackListingPageArgs = {
  lang: Language;
  slug: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryGetMessagesArgs = {
  input: GetMessagesInput;
};


/** Root Query type for all read operations in the API */
export type QueryGetProductPlatformFeeArgs = {
  input?: InputMaybe<ProductPlatformFeeInput>;
};


/** Root Query type for all read operations in the API */
export type QueryGetProductShippingDetailsArgs = {
  input: GetProductShippingDetailsInput;
};


/** Root Query type for all read operations in the API */
export type QueryGetProductShippingDetailsV2Args = {
  input: GetProductShippingDetailsInput;
};


/** Root Query type for all read operations in the API */
export type QueryGetProductShippingOptionsArgs = {
  input?: InputMaybe<ProductShippingOptionsInput>;
};


/** Root Query type for all read operations in the API */
export type QueryGetStripeEphemeralKeyArgs = {
  version: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryGetThreadsArgs = {
  input?: InputMaybe<GetThreadsInput>;
};


/** Root Query type for all read operations in the API */
export type QueryGetUnreadMessageCountArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryGuestCartArgs = {
  input: GuestCartInput;
};


/** Root Query type for all read operations in the API */
export type QueryHelpArticleArgs = {
  locale: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHelpArticleMarkdownArgs = {
  canonicalBase: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHelpArticlesArgs = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryHelpCategoriesArgs = {
  locale: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHelpCenterMarkdownArgs = {
  canonicalBase: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHelpFeaturedArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHelpSearchArgs = {
  locale: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryHomepagePromotionsArgs = {
  currency?: InputMaybe<Currency>;
  lang?: InputMaybe<Language>;
};


/** Root Query type for all read operations in the API */
export type QueryListingFeePackagesArgs = {
  productId: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryListingPageArgs = {
  input: ListingPageInput;
};


/** Root Query type for all read operations in the API */
export type QueryListingPageByFiltersArgs = {
  input: ListingPageByFiltersInput;
};


/** Root Query type for all read operations in the API */
export type QueryLocalizeUrlArgs = {
  url: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryMerchantArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryNotificationPreferencesArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryOpenHomeBrowseArgs = {
  filters?: InputMaybe<OpenHomeBrowseFilters>;
  pagination?: InputMaybe<Pagination>;
};


/** Root Query type for all read operations in the API */
export type QueryOpenHomeItemArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOpenHomeRoomArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrderByKeyArgs = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrderGroupByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrderGroupByPaymentIntentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrdersArgs = {
  filters?: InputMaybe<Array<OrderFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OrderSort>;
};


/** Root Query type for all read operations in the API */
export type QueryOrdersByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryOrdersByKeyArgs = {
  key: OrderFilterKey;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPackageCheckoutArgs = {
  id: Scalars['ID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPageArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPageByKeyArgs = {
  key?: InputMaybe<PageFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPagesArgs = {
  filters?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PageSort>;
};


/** Root Query type for all read operations in the API */
export type QueryPagesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryPagesByKeyArgs = {
  key?: InputMaybe<PageFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPayoutQuoteArgs = {
  input: PayoutQuoteInput;
};


/** Root Query type for all read operations in the API */
export type QueryPendingVouchersArgs = {
  currency?: InputMaybe<Currency>;
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryPriceDropPreviewArgs = {
  input: PriceDropPreviewInput;
};


/** Root Query type for all read operations in the API */
export type QueryPriceRecommendationArgs = {
  productId: Scalars['UUID']['input'];
  surface?: InputMaybe<PriceRecommendationSurface>;
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerFavoriteProjectsArgs = {
  productIds: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerProjectArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerProjectAssignmentsArgs = {
  orderIds: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerSaveTargetsArgs = {
  productId: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProBuyerSelectionArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductByDmIdArgs = {
  dmId: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductByKeyArgs = {
  key?: InputMaybe<ProductFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductBySrmSlugArgs = {
  srmSlug: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductBySlugArgs = {
  includeWithdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<ProductSlugKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductsArgs = {
  filters?: InputMaybe<Array<ProductFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


/** Root Query type for all read operations in the API */
export type QueryProductsByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryProductsByKeyArgs = {
  key?: InputMaybe<ProductFilterKey>;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPromotionCampaignArgs = {
  id: Scalars['ID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPromotionCampaignsArgs = {
  productId: Scalars['ID']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryPromotionOffersArgs = {
  catalogueVersion?: InputMaybe<Scalars['Int']['input']>;
  channel?: InputMaybe<PromotionChannel>;
  lang?: InputMaybe<Language>;
  productId: Scalars['ID']['input'];
  purchaseContext?: InputMaybe<PromotionPurchaseContext>;
};


/** Root Query type for all read operations in the API */
export type QueryPurchasesArgs = {
  input: PurchasesInput;
};


/** Root Query type for all read operations in the API */
export type QueryQuerySuggestionsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryRecommendedProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryRelatedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QueryReviewsArgs = {
  filters?: InputMaybe<Array<ReviewFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ReviewSort>;
};


/** Root Query type for all read operations in the API */
export type QuerySalesArgs = {
  input: SalesInput;
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchArgs = {
  id: Scalars['UUID']['input'];
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchByKeyArgs = {
  key: SavedSearchFilterKey;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchesArgs = {
  filters?: InputMaybe<Array<InputMaybe<SavedSearchFilter>>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SavedSearchSort>;
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchesByIdArgs = {
  id: Array<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QuerySavedSearchesByKeyArgs = {
  key: SavedSearchFilterKey;
  value: Scalars['String']['input'];
};


/** Root Query type for all read operations in the API */
export type QuerySearchFiltersByUrlArgs = {
  input?: InputMaybe<SearchFiltersByUrlInput>;
};


/** Root Query type for all read operations in the API */
export type QuerySearchProductsArgs = {
  currency?: InputMaybe<Currency>;
  input?: InputMaybe<SearchProductsInput>;
};


/** Root Query type for all read operations in the API */
export type QuerySearchSubpagesArgs = {
  input: SearchSubpagesInput;
};


/** Root Query type for all read operations in the API */
export type QuerySellerShippingEstimatesArgs = {
  input: SellerShippingEstimatesInput;
};


/** Root Query type for all read operations in the API */
export type QueryServicePointsArgs = {
  input: ServicePointsInput;
};


/** Root Query type for all read operations in the API */
export type QueryShippingMethodsArgs = {
  originCountry?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query type for all read operations in the API */
export type QuerySimilarProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  product: Scalars['UUID']['input'];
  user?: InputMaybe<Scalars['UUID']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryStripeAccountDetailsArgs = {
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root Query type for all read operations in the API */
export type QuerySubcategoriesArgs = {
  input?: InputMaybe<SubcategoriesInput>;
};


/** Root Query type for all read operations in the API */
export type QueryThreadArgs = {
  id: Scalars['UUID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root Query type for all read operations in the API */
export type QueryThreadsArgs = {
  filters?: InputMaybe<Array<ThreadFilter>>;
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ThreadSort>;
};


/** Root Query type for all read operations in the API */
export type QueryValueCheckPriceArgs = {
  input: ValueCheckPriceInput;
};

/**
 * Block for displaying dynamic, query-based content.
 * Used for creating dynamic product lists based on search criteria.
 */
export type QueryBlock = AbstractBlock & {
  __typename?: 'QueryBlock';
  /** Unique identifier for the query block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** Products matching the query criteria */
  products: Array<Product>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the query results */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type ReferralType = {
  __typename?: 'ReferralType';
  /** Unique identifier for the referral type */
  id: Scalars['UUID']['output'];
  /** Localized name of the referral type */
  name: Scalars['String']['output'];
};


export type ReferralTypeNameArgs = {
  lang?: InputMaybe<Language>;
};

/** Source through which a member discovered the platform */
export enum Referrer {
  /** Mobile or google advertisement */
  DigitalAdvertisement = 'DIGITAL_ADVERTISEMENT',
  /** Email promotions */
  Email = 'EMAIL',
  /** Fairs, exhibitions, etc. */
  Event = 'EVENT',
  /**
   * @deprecated Please use SOCIAL_MEDIA for facebook/instagram instead
   * @deprecated Please use SOCIAL_MEDIA for facebook/instagram instead
   */
  FacebookInstagram = 'FACEBOOK_INSTAGRAM',
  /** Friend or relative told me about it */
  FamilyFriendsColleagues = 'FAMILY_FRIENDS_COLLEAGUES',
  /**
   * @deprecated Please use SEARCH_ENGINE for google instead
   * @deprecated Please use SEARCH_ENGINE for google instead
   */
  Google = 'GOOGLE',
  /** Some other form */
  Others = 'OTHERS',
  /** Physical advertisement or billboard */
  PhysicalAdvertisement = 'PHYSICAL_ADVERTISEMENT',
  /**
   * @deprecated Please use SOCIAL_MEDIA for pinterest instead
   * @deprecated Please use SOCIAL_MEDIA for pinterest instead
   */
  Pinterest = 'PINTEREST',
  /** News website article */
  PressArticle = 'PRESS_ARTICLE',
  /** I received a referral voucher */
  ReferralVoucher = 'REFERRAL_VOUCHER',
  /** Search engine (Google, Bing, etc.) */
  SearchEngine = 'SEARCH_ENGINE',
  /** Social media (Facebook, Instagram, Pinterest etc.) */
  SocialMedia = 'SOCIAL_MEDIA',
  /** Commercial or program on television */
  Television = 'TELEVISION'
}

/** Represents a related listing page with relationship context. */
export type RelatedListingPage = {
  __typename?: 'RelatedListingPage';
  /** Whether this is a fallback suggestion */
  fallback: Scalars['Boolean']['output'];
  /** The related listing page */
  listingPage: ListingPage;
  /** Type of relationship to the main listing */
  type: ListingPageRelationType;
};

/** Response containing account deletion timing details */
export type RequestAccountDeletionResponse = {
  __typename?: 'RequestAccountDeletionResponse';
  requestedDeletionAt: Scalars['DateTime']['output'];
  scheduledDeletionAt: Scalars['DateTime']['output'];
};

export type RequestDeliveryQuoteInput = {
  city: Scalars['String']['input'];
  deliveryType: DeliveryQuoteDeliveryType;
  /** Optional note for ops (stairs, access). Never shown to the seller. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Five-digit ZIP code (ZIP+4 accepted). */
  postalCode: Scalars['String']['input'];
  productId: Scalars['UUID']['input'];
  /** US state. */
  region: Scalars['String']['input'];
};

/** Input for requesting phone number update OTP */
export type RequestPhoneUpdateOtpInput = {
  /** Preferred OTP delivery method */
  method: OtpMethod;
  /** New phone number to verify */
  newPhone: Scalars['String']['input'];
};

/** Response for OTP request */
export type RequestPhoneUpdateOtpResponse = {
  __typename?: 'RequestPhoneUpdateOTPResponse';
  /** Seconds until OTP expires */
  expiresAfter: Scalars['Int']['output'];
  /** Timestamp when OTP expires */
  expiresAt: Scalars['DateTime']['output'];
  /** Human-readable message about the result */
  message: Scalars['String']['output'];
  /** Seconds until next retry is allowed */
  retryAfter: Scalars['Int']['output'];
  /** Timestamp when next retry is allowed */
  retryAt: Scalars['DateTime']['output'];
  /** Whether the OTP was sent successfully */
  success: Scalars['Boolean']['output'];
};

export enum RequiredForPriceEnum {
  /** Address required */
  AddressRequired = 'ADDRESS_REQUIRED',
  /** Country required */
  CountryRequired = 'COUNTRY_REQUIRED'
}

export type ReservationEligibility = {
  __typename?: 'ReservationEligibility';
  allowed: Scalars['Boolean']['output'];
  /** When allowed: the moment the seller has to answer by if the request is sent now. */
  answerBy?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<ReservationIneligibleReason>;
};

export enum ReservationIneligibleReason {
  AlreadyRequested = 'ALREADY_REQUESTED',
  Cooldown = 'COOLDOWN',
  FeatureDisabled = 'FEATURE_DISABLED',
  LimitReached = 'LIMIT_REACHED',
  NotLoggedIn = 'NOT_LOGGED_IN',
  NotProBuyer = 'NOT_PRO_BUYER',
  NotReservable = 'NOT_RESERVABLE',
  /** WHO-5947 F27: the listing has no Pro Buyer price (the seller offers no Pro Buyer discount). */
  NoProBuyerPrice = 'NO_PRO_BUYER_PRICE',
  OwnListing = 'OWN_LISTING',
  Reserved = 'RESERVED'
}

/** WHO-5959 6e. The buyer's own project on a reservation: only on BuyerReservation. */
export type ReservationProject = {
  __typename?: 'ReservationProject';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**
 * WHO-5947: Pro Buyer reservations (internal name "on hold"). A Pro Buyer asks to
 * reserve a listing for 48 hours without a chat; the seller accepts or declines.
 * Everything here is behind the `pro_buyer_reservations` admin flag: while it is
 * off every field resolves null, [] or false and every mutation fails with
 * FEATURE_DISABLED. Neither view ever carries anything about the other party.
 */
export enum ReservationStatus {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Lifted = 'LIFTED',
  Released = 'RELEASED',
  Requested = 'REQUESTED',
  RequestExpired = 'REQUEST_EXPIRED'
}

/**
 * Status of a return case.
 * Tracks whether a return is being processed or completed.
 */
export enum ReturnCaseStatus {
  /** Return case has been resolved */
  Closed = 'CLOSED',
  /** Return case is being processed */
  Open = 'OPEN'
}

/**
 * Available shipping methods for product returns.
 * Lists approved shipping partners for returns.
 */
export enum ReturnShippingMethod {
  /** Brenger shipping service */
  Brenger = 'BRENGER',
  /** Hoekstra shipping service */
  Hoekstra = 'HOEKSTRA',
  /** Libero Logistics shipping service */
  LiberoLogistics = 'LIBERO_LOGISTICS',
  /** Magic Movers shipping service */
  MagicMovers = 'MAGIC_MOVERS',
  /** Generic outsourced shipping partner */
  OutsourcePartner = 'OUTSOURCE_PARTNER',
  /** SW de Vries shipping service */
  Swdevries = 'SWDEVRIES',
  /** Transpoksi shipping service */
  Transpoksi = 'TRANSPOKSI',
  /** Vintage Express shipping service */
  VintageExpress = 'VINTAGE_EXPRESS'
}

/** Type representing a review in the system */
export type Review = {
  __typename?: 'Review';
  /** Whether the review was posted anonymously */
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the review was created */
  created?: Maybe<Scalars['Date']['output']>;
  /** Unique identifier for the review */
  id: Scalars['UUID']['output'];
  /** The order this review is associated with */
  order: Order;
  /** Review text content, optionally in a specific language */
  review?: Maybe<Scalars['String']['output']>;
  /** The merchant who wrote the review */
  reviewer?: Maybe<Merchant>;
  /** Rating score (typically 1-5) */
  score?: Maybe<Scalars['Int']['output']>;
};


/** Type representing a review in the system */
export type ReviewReviewArgs = {
  lang?: InputMaybe<Language>;
};

/** Filter input for review queries */
export type ReviewFilter = {
  /** Filter key to apply */
  key: ReviewFilterKey;
  /** Value to filter by */
  value: Scalars['String']['input'];
};

/** Available filter keys for review queries */
export enum ReviewFilterKey {
  /** Filter by merchant being reviewed */
  Merchant = 'MERCHANT',
  /** Filter by reviewer */
  Reviewer = 'REVIEWER',
  /** Filter by rating score */
  Score = 'SCORE'
}

/** Input for creating a new review */
export type ReviewInput = {
  /**
   * Whether to post the review anonymously
   * Defaults to false
   */
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the order being reviewed */
  order: Scalars['UUID']['input'];
  /** Review text content */
  review: Scalars['String']['input'];
  /** Rating score (typically 1-5) */
  score: Scalars['Int']['input'];
};

/** Paginated result of review queries */
export type ReviewResult = {
  __typename?: 'ReviewResult';
  /** List of reviews in the current page */
  items: Array<Review>;
  /** Pagination metadata */
  pagination: PaginationResult;
};

/** Sort options for review queries */
export enum ReviewSort {
  /** Sort by creation date */
  Created = 'CREATED',
  /** Default sorting order */
  Default = 'DEFAULT',
  /** Sort by rating score */
  Score = 'SCORE'
}

export type SalesInput = {
  order?: InputMaybe<Ordering>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SalesSort>;
  /**
   * Only the sales whose `Order.sellerStatus` is one of these (WHO-6099), so a
   * status chip can page the list instead of walking the whole history. Null or
   * empty: every sale. `pagination.count` counts the matching sales, the same
   * number `salesSummary.counts(search:)` gives for those statuses.
   */
  status?: InputMaybe<Array<SellerSaleStatus>>;
};

export type SalesResult = {
  __typename?: 'SalesResult';
  items: Array<Order>;
  pagination: PaginationResult;
};

export enum SalesSort {
  Created = 'CREATED',
  /**
   * The seller's payout (`Order.payout`). It compares the bare numbers and ignores
   * the currency: a GBP 100 sale sorts level with a EUR 100 one. Today sellers
   * settle in EUR, so this matters only once a seller has sales in other
   * currencies. Ties: newest first.
   */
  Payout = 'PAYOUT',
  /**
   * The product title as the seller wrote it (the one `search` matches, never a
   * translation), ignoring case. Ties: newest first.
   */
  Title = 'TITLE',
  TotalAmount = 'TOTAL_AMOUNT'
}

/** Sales per seller status. */
export type SalesStatusCounts = {
  __typename?: 'SalesStatusCounts';
  actionNeeded: Scalars['Int']['output'];
  canceled: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  /** All listed sales: the four counts added up. */
  total: Scalars['Int']['output'];
};

/**
 * The seller's My sales totals, over every sale, so clients stop walking the
 * whole history and adding it up (WHO-6062). Seller settlement money: never
 * display-converted. The totals are in EUR and add up the EUR sales only (an
 * order's payout is in its own currency, and sellers settle in EUR until
 * seller-native currencies); `counts` covers every listed sale.
 */
export type SalesSummary = {
  __typename?: 'SalesSummary';
  /**
   * Sales per status. `search` narrows them like the `sales` list's search (the
   * product title); the totals above ignore it.
   */
  counts: SalesStatusCounts;
  /** The blocked-payouts banner amount: failed transfers plus payouts held by the blocked Stripe account. */
  heldTotal: Price;
  /**
   * The payout of every PAID sale: transferred to the seller's Stripe account,
   * or the order is completed. Not proof of a bank payout: the monolith marks a
   * transfer SUCCEEDED once nine days have passed, without asking Stripe.
   */
  paidTotal: Price;
  /**
   * The seller's Stripe account exists and Stripe says payouts are off. False
   * when Stripe cannot be reached: an outage never shows the banner.
   */
  payoutsBlocked: Scalars['Boolean']['output'];
  /** Payouts still to come: the payout of every PENDING sale. */
  pendingTotal: Price;
  /** Show the blocked-payouts banner: payouts are blocked and something is held. */
  showsBlockedBanner: Scalars['Boolean']['output'];
};


/**
 * The seller's My sales totals, over every sale, so clients stop walking the
 * whole history and adding it up (WHO-6062). Seller settlement money: never
 * display-converted. The totals are in EUR and add up the EUR sales only (an
 * order's payout is in its own currency, and sellers settle in EUR until
 * seller-native currencies); `counts` covers every listed sale.
 */
export type SalesSummaryCountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a saved search with notification preferences */
export type SavedSearch = {
  __typename?: 'SavedSearch';
  /** Whether notifications are enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Applied filters */
  filters?: Maybe<Array<Maybe<FilterOutput>>>;
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** External identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Search query string */
  query?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Filter input for querying saved searches */
export type SavedSearchFilter = {
  /** The field to filter on */
  key: SavedSearchFilterKey;
  /** The value to filter by */
  value: Scalars['String']['input'];
};

/** Filter keys available for saved searches */
export enum SavedSearchFilterKey {
  /** Filter by URL-friendly identifier */
  Slug = 'SLUG',
  /** Filter by search title */
  Title = 'TITLE'
}

/** Input for creating or updating a saved search */
export type SavedSearchInput = {
  /** Whether notifications are enabled for this saved search */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Applied search filters */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** The search query string */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Display title for the saved search */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of saved searches */
export type SavedSearchResult = {
  __typename?: 'SavedSearchResult';
  /** List of saved searches */
  items: Array<SavedSearch>;
  /** Pagination information */
  pagination: PaginationResult;
};

/** Available sorting options for saved searches */
export enum SavedSearchSort {
  /** Sort by creation date */
  Created = 'CREATED',
  /** Sort by URL-friendly identifier */
  Slug = 'SLUG',
  /** Sort alphabetically by title */
  Title = 'TITLE'
}

export enum ScreenName {
  About = 'ABOUT',
  AccountOverview = 'ACCOUNT_OVERVIEW',
  Chat = 'CHAT',
  CreateAccount = 'CREATE_ACCOUNT',
  CreateAd = 'CREATE_AD',
  HowItWorks = 'HOW_IT_WORKS',
  HowItWorksBidding = 'HOW_IT_WORKS_BIDDING',
  HowItWorksCuration = 'HOW_IT_WORKS_CURATION',
  HowItWorksPayment = 'HOW_IT_WORKS_PAYMENT',
  HowItWorksShipping = 'HOW_IT_WORKS_SHIPPING',
  Product = 'PRODUCT',
  Search = 'SEARCH',
  UserAds = 'USER_ADS'
}

/** Represents a facet (grouping) in search results with its values and counts */
export type SearchFacet = {
  __typename?: 'SearchFacet';
  /** The type of facet */
  key?: Maybe<SearchFacetKey>;
  /** Facet values with their counts */
  values?: Maybe<Array<Maybe<SearchFacetValue>>>;
};

/** Available facet keys for aggregating search results */
export enum SearchFacetKey {
  Artist = 'ARTIST',
  ArtOrientation = 'ART_ORIENTATION',
  ArtSize = 'ART_SIZE',
  ArtSubject = 'ART_SUBJECT',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Color = 'COLOR',
  Country = 'COUNTRY',
  Designer = 'DESIGNER',
  Gender = 'GENDER',
  HardwareColor = 'HARDWARE_COLOR',
  Label = 'LABEL',
  Material = 'MATERIAL',
  Premium = 'PREMIUM',
  Quality = 'QUALITY',
  Shape = 'SHAPE',
  ShowroomModel = 'SHOWROOM_MODEL',
  Style = 'STYLE'
}

/** Statistics for numeric facets showing value ranges */
export type SearchFacetStats = {
  __typename?: 'SearchFacetStats';
  /** The type of statistic */
  key: SearchFacetsStatKey;
  /** Maximum value in the range */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum value in the range */
  min?: Maybe<Scalars['Float']['output']>;
};

/**
 * A value within a facet, optionally linked to a system type
 * Note: Use attribute linkage carefully as it impacts performance
 */
export type SearchFacetValue = {
  __typename?: 'SearchFacetValue';
  /** Associated attribute (if applicable) */
  attribute?: Maybe<Attribute>;
  /** Associated category (if applicable) */
  category?: Maybe<Category>;
  /** Number of items with this value */
  count?: Maybe<Scalars['Int']['output']>;
  /** Associated merchant (if applicable) */
  merchant?: Maybe<Merchant>;
  /** The facet value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Available statistics keys for numeric facets */
export enum SearchFacetsStatKey {
  Depth = 'DEPTH',
  DiscountPercentage = 'DISCOUNT_PERCENTAGE',
  Height = 'HEIGHT',
  NumberOfItems = 'NUMBER_OF_ITEMS',
  Price = 'PRICE',
  Width = 'WIDTH'
}

export type SearchFilterItem = {
  __typename?: 'SearchFilterItem';
  key: SearchFilterKey;
  value: Scalars['String']['output'];
};

/** Available filter keys for product search */
export enum SearchFilterKey {
  /** Filter items that accept bids */
  AllowBid = 'ALLOW_BID',
  /** Filter by artist */
  Artist = 'ARTIST',
  /** Filter by artwork orientation */
  ArtOrientation = 'ART_ORIENTATION',
  /** Filter by artwork size */
  ArtSize = 'ART_SIZE',
  /** Filter by artwork subject */
  ArtSubject = 'ART_SUBJECT',
  /** Filter by product availability */
  Availability = 'AVAILABILITY',
  /** Filter by product brand */
  Brand = 'BRAND',
  /** Filter by product category */
  Category = 'CATEGORY',
  /** Filter by collection */
  Collection = 'COLLECTION',
  /** Filter by product color */
  Color = 'COLOR',
  /** Filter upcoming items */
  ComingSoon = 'COMING_SOON',
  /** Filter by product condition (new/used) */
  Condition = 'CONDITION',
  /** Filter by country */
  Country = 'COUNTRY',
  /** Filter by curation date */
  CuratedDate = 'CURATED_DATE',
  /** Filter by depth range */
  Depth = 'DEPTH',
  /** Filter by designer */
  Designer = 'DESIGNER',
  /** Filter by discount percentage range */
  DiscountPercentage = 'DISCOUNT_PERCENTAGE',
  /** Filter by expert seller status */
  ExpertSeller = 'EXPERT_SELLER',
  /**
   * Filter by free shipping availability for a specific country.
   * Value should be a lowercase country code (e.g., "nl", "be", "de", "fr").
   */
  FreeShipping = 'FREE_SHIPPING',
  /** Filter by gender (e.g. women, men, unisex) */
  Gender = 'GENDER',
  /** Filter by hardware color attribute slug */
  HardwareColor = 'HARDWARE_COLOR',
  /** Filter items with AR support */
  HasAr = 'HAS_AR',
  /** Filter by height range */
  Height = 'HEIGHT',
  /** Filter items in showroom */
  InShowroom = 'IN_SHOWROOM',
  /** Filter designer items */
  IsDesignerItem = 'IS_DESIGNER_ITEM',
  /** Filter by product label */
  Label = 'LABEL',
  /** Filter by product material */
  Material = 'MATERIAL',
  /** Filter by merchant */
  Merchant = 'MERCHANT',
  /** Filter by number of items */
  NumberOfItems = 'NUMBER_OF_ITEMS',
  /** Filter items on sale */
  OnSale = 'ON_SALE',
  /** Filter premium items */
  Premium = 'PREMIUM',
  /** Filter by price range */
  Price = 'PRICE',
  /** Filter by quality rating */
  Quality = 'QUALITY',
  /** Filter by seat height range */
  SeatHeight = 'SEAT_HEIGHT',
  /** Filter by product shape */
  Shape = 'SHAPE',
  /** Filter by shipping method (courier/parcel/custom/pickup) */
  ShippingMethod = 'SHIPPING_METHOD',
  /** Filter by showroom location */
  Showroom = 'SHOWROOM',
  /** Filter by showroom model */
  ShowroomModel = 'SHOWROOM_MODEL',
  /** Filter by start date */
  StartDate = 'START_DATE',
  /** Filter by product style */
  Style = 'STYLE',
  /** Filter by width range */
  Width = 'WIDTH'
}

export type SearchFiltersByUrlInput = {
  lang: Language;
  url: Scalars['String']['input'];
};

export type SearchFiltersByUrlResponse = {
  __typename?: 'SearchFiltersByURLResponse';
  filters: Array<SearchFilterItem>;
  order?: Maybe<Ordering>;
  sort?: Maybe<SearchSort>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * Block for displaying product search results with filtering and sorting capabilities.
 * Supports internationalization and advanced search features.
 */
export type SearchProductsBlock = {
  __typename?: 'SearchProductsBlock';
  /**
   * Legacy filter options
   * @deprecated Use `url` instead
   */
  filters?: Maybe<Array<ListingPageFilterItem>>;
  /** Unique identifier for the search block */
  id: Scalars['UUID']['output'];
  /**
   * Legacy sort order
   * @deprecated Use `url` instead
   */
  order?: Maybe<Ordering>;
  /** Filtered and paginated product results */
  products: Array<Product>;
  /**
   * Legacy search query
   * @deprecated Use `url` instead
   */
  query?: Maybe<Scalars['String']['output']>;
  /**
   * Legacy recommendation flag
   * @deprecated Use `url` instead
   */
  recommended?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Legacy sort option
   * @deprecated Use `url` instead
   */
  sort?: Maybe<SearchSort>;
  /** Secondary heading for additional context */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Main heading for the search results */
  title: Scalars['String']['output'];
  /** Search URL with encoded parameters */
  url: Scalars['String']['output'];
};


/**
 * Block for displaying product search results with filtering and sorting capabilities.
 * Supports internationalization and advanced search features.
 */
export type SearchProductsBlockProductsArgs = {
  additionalFilters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Block for displaying product search results with filtering and sorting capabilities.
 * Supports internationalization and advanced search features.
 */
export type SearchProductsBlockSubtitleArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Block for displaying product search results with filtering and sorting capabilities.
 * Supports internationalization and advanced search features.
 */
export type SearchProductsBlockTitleArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * Block for displaying product search results with filtering and sorting capabilities.
 * Supports internationalization and advanced search features.
 */
export type SearchProductsBlockUrlArgs = {
  lang?: InputMaybe<Language>;
};

/** Input for product search queries */
export type SearchProductsInput = {
  /** Tags for analytics tracking */
  analyticsTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Curated New-in: newest listings that pass the quality gate, never antique, at least half
   * design/modern, one per seller on the first page. Signed-in viewers never get the items
   * their recommendations show. Ignored when a query or imageId is given.
   */
  curatedNewIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Facets to return (defaults to system defaults if empty) */
  facets?: InputMaybe<Array<InputMaybe<SearchFacetKey>>>;
  /** Statistics to compute for numeric facets */
  facetsStats?: InputMaybe<Array<SearchFacetsStatKey>>;
  /** Filters to apply */
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  /** ID of image for visual search */
  imageId?: InputMaybe<Scalars['String']['input']>;
  /** Sort order */
  order?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<Pagination>;
  /**
   * Only listings of sellers with an active Pro Buyer discount. Ignored unless
   * the viewer is an approved Pro Buyer and the `pro_buyer_program` flag is on.
   */
  proBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search query string */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include recommended items */
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to use semantic search */
  searchType?: InputMaybe<SearchType>;
  /** Sort field */
  sort?: InputMaybe<SearchSort>;
  /**
   * Sorting algorithm to use
   * @deprecated Not relevant
   */
  sortingType?: InputMaybe<SortingType>;
};

/** Container for search results including facets and pagination */
export type SearchProductsResult = {
  __typename?: 'SearchProductsResult';
  /** Available facets for filtering */
  facets?: Maybe<Array<Maybe<SearchFacet>>>;
  /** Statistics for numeric facets */
  facetsStats?: Maybe<Array<Maybe<SearchFacetStats>>>;
  /** Name of the search index used */
  indexName?: Maybe<Scalars['String']['output']>;
  /** Found products */
  items?: Maybe<Array<Maybe<Product>>>;
  /** Pagination information */
  pagination?: Maybe<PaginationResult>;
  /** Search query identifier */
  queryID?: Maybe<Scalars['String']['output']>;
};

export type SearchScreenFilterItem = {
  __typename?: 'SearchScreenFilterItem';
  key: SearchFilterKey;
  value: Scalars['String']['output'];
};

export type SearchScreenParams = {
  __typename?: 'SearchScreenParams';
  facets?: Maybe<Array<Maybe<SearchFacetKey>>>;
  filters: Array<SearchScreenFilterItem>;
  order?: Maybe<Ordering>;
  pagination?: Maybe<PaginationParams>;
  query?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<SearchSort>;
};

/** Available sorting options for search results */
export enum SearchSort {
  /** Sort by creation date */
  Created = 'CREATED',
  /** Default platform-defined sorting */
  Default = 'DEFAULT',
  /** Sort by distance from a location */
  Distance = 'DISTANCE',
  /** Sort by popularity metrics */
  Popularity = 'POPULARITY',
  /** Sort by price */
  Price = 'PRICE',
  /** Sort alphabetically by title */
  Title = 'TITLE'
}

export type SearchSubpage = {
  __typename?: 'SearchSubpage';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SearchSubpagesInput = {
  lang: Language;
  url: Scalars['String']['input'];
};

export type SearchSubpagesResponse = {
  __typename?: 'SearchSubpagesResponse';
  items: Array<SearchSubpage>;
};

export enum SearchType {
  /** Search using hybrid matching (keyword + semantic) */
  Hybrid = 'HYBRID',
  /** Search using keyword matching */
  Keyword = 'KEYWORD',
  /** Search using semantic matching */
  Semantic = 'SEMANTIC'
}

/**
 * The one status a seller sees, derived once here from the live Stripe account,
 * the monolith's mirrored classification and the merchant's recorded blocker, so
 * the dashboard, My sales and the payment settings page never disagree.
 */
export enum SellerAccountStatus {
  /** Whoppah could not create the Stripe account: Stripe refused the seller's address */
  AccountNotCreated = 'ACCOUNT_NOT_CREATED',
  /** Payouts still enabled, but Stripe wants something from the seller */
  ActiveActionNeeded = 'ACTIVE_ACTION_NEEDED',
  /** Payouts disabled; the seller can fix it */
  BlockedActionNeeded = 'BLOCKED_ACTION_NEEDED',
  /** Rejected by Stripe, paused by Whoppah, or a problem on Whoppah's side; the seller cannot fix it */
  BlockedNotFixable = 'BLOCKED_NOT_FIXABLE',
  /** No Stripe account yet, or the seller never finished Stripe's form */
  NotSetUp = 'NOT_SET_UP',
  /** Verified, payouts enabled, nothing to do */
  Ready = 'READY',
  /** Stripe is reviewing what the seller submitted; nothing to do */
  UnderReview = 'UNDER_REVIEW'
}

/**
 * One button of the payment settings page, decided once here from the account
 * status and the open issues, so web, iOS and Android render the same button
 * with the same label. At most one PRIMARY and one SECONDARY, primary first.
 */
export type SellerAction = {
  __typename?: 'SellerAction';
  /** Set when the button must stay disabled, with the sentence that says why */
  disabled_reason?: Maybe<Scalars['String']['output']>;
  emphasis: SellerActionEmphasis;
  kind: SellerActionKind;
  label: Scalars['String']['output'];
  /** Set for STRIPE_LINK */
  link_type?: Maybe<StripeAccountLinkType>;
};


/**
 * One button of the payment settings page, decided once here from the account
 * status and the open issues, so web, iOS and Android render the same button
 * with the same label. At most one PRIMARY and one SECONDARY, primary first.
 */
export type SellerActionDisabled_ReasonArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * One button of the payment settings page, decided once here from the account
 * status and the open issues, so web, iOS and Android render the same button
 * with the same label. At most one PRIMARY and one SECONDARY, primary first.
 */
export type SellerActionLabelArgs = {
  lang?: InputMaybe<Language>;
};

export enum SellerActionEmphasis {
  /** The one solid button of the page */
  Primary = 'PRIMARY',
  /** An outlined button or text link */
  Secondary = 'SECONDARY'
}

/** What a button on the payment settings page does */
export enum SellerActionKind {
  /** The seller's address settings: Stripe refused the address */
  AddressSettings = 'ADDRESS_SETTINGS',
  /** The client's own bank account form or editor */
  BankAccountForm = 'BANK_ACCOUNT_FORM',
  /** Customer service */
  ContactSupport = 'CONTACT_SUPPORT',
  /** Open Stripe's hosted flow with `link_type` */
  StripeLink = 'STRIPE_LINK'
}

export type SellerBalance = {
  __typename?: 'SellerBalance';
  /** Cleared money in the seller's Stripe balance, not yet paid to the bank */
  available: Price;
  /** Money in the Stripe balance still settling */
  pending: Price;
};

/** WHO-6309: how the seller invoice for an order is produced. */
export enum SellerInvoiceMode {
  /** Whoppah issues it on the seller's behalf. */
  Generated = 'GENERATED',
  /** No seller invoice (flag off, or the viewer is neither buyer nor seller). */
  None = 'NONE',
  /** The seller uploads it (sellers established in IT, BE, PL, FR; D9). */
  Upload = 'UPLOAD'
}

/** WHO-6309: the seller's uploaded invoice PDF. The file itself is served by GET /api/v1/order/seller-invoice-upload/<pk>/. */
export type SellerInvoiceUpload = {
  __typename?: 'SellerInvoiceUpload';
  fileName: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

/** Result of `cancelOrderAsSeller`, both for the preview and the executed cancellation. */
export type SellerOrderCancellation = {
  __typename?: 'SellerOrderCancellation';
  /** true when the buyer had already been refunded before this call. */
  alreadyRefunded: Scalars['Boolean']['output'];
  /** Amount refunded (or to be refunded) to the buyer. */
  amount: Scalars['Float']['output'];
  breakdown: SellerOrderCancellationBreakdown;
  currency: Scalars['String']['output'];
  /** true when the order was cancelled and refunded by this call (or earlier). */
  executed: Scalars['Boolean']['output'];
  /** true when Stripe refunded the whole captured payment: a buyerRequested cancellation on an order alone on its payment, or a pre-existing full refund. False for a seller-caused cancellation (purchase price, partial refund). */
  fullRefund: Scalars['Boolean']['output'];
  /** The order as it is after this call (unchanged for a preview). */
  order: Order;
  /** Stripe refund id once executed. */
  refundReference?: Maybe<Scalars['String']['output']>;
  /** true when every guard passed: the refund can (or did) run. */
  refundable: Scalars['Boolean']['output'];
  /** Machine-readable guard reason when refundable is false, e.g. SELLER_PAYOUT_EXISTS. */
  refusalCode?: Maybe<Scalars['String']['output']>;
  /** Human-readable guard reason when refundable is false. */
  refusalReason?: Maybe<Scalars['String']['output']>;
};

/**
 * What is and is not refunded to the buyer on a seller cancellation (WHO-5590 decision 2, 2026-09-10).
 * refundAmount = purchasePrice + shipping. All amounts incl. VAT, per order.
 */
export type SellerOrderCancellationBreakdown = {
  __typename?: 'SellerOrderCancellationBreakdown';
  /** Not refunded: buyer protection and the payment fee. */
  excluded: SellerOrderCancellationExcluded;
  /** Purchase price: subtotal_incl_vat minus the discount that applied to it. */
  purchasePrice: Scalars['Float']['output'];
  /** The amount that is (or would be) refunded to the buyer. */
  refundAmount: Scalars['Float']['output'];
  /** Shipping the buyer paid. 0 for pickup orders; refunded only for non-pickup orders. */
  shipping: Scalars['Float']['output'];
};

/** Amounts the buyer paid for this order that are NOT refunded on a seller cancellation (incl. VAT). */
export type SellerOrderCancellationExcluded = {
  __typename?: 'SellerOrderCancellationExcluded';
  /** Service fee / buyer protection (buyer_protection_incl_vat). */
  buyerProtection: Scalars['Float']['output'];
  /** Payment transaction fee (payment_incl_vat). */
  paymentFee: Scalars['Float']['output'];
};

/** Seller view of a reservation. Never carries anything about the buyer. */
export type SellerReservation = {
  __typename?: 'SellerReservation';
  id: Scalars['UUID']['output'];
  productId: Scalars['UUID']['output'];
  productImage?: Maybe<Scalars['String']['output']>;
  productSlug: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  requestExpiresAt: Scalars['DateTime']['output'];
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  status: ReservationStatus;
};

/**
 * What a sale is to its seller in My sales (WHO-6062), one rule for web and the
 * apps: worked out from both payout fields and whether the seller's Stripe
 * account can receive payouts.
 */
export enum SellerSaleStatus {
  /** The seller has to act: a failed or disputed payout, or a payout held by a blocked Stripe account. */
  ActionNeeded = 'ACTION_NEEDED',
  /** The sale was canceled; it carries no money. */
  Canceled = 'CANCELED',
  /**
   * Whoppah has transferred the payout to the seller's Stripe account (or the
   * order is completed). Not proof the money reached the seller's bank.
   */
  Paid = 'PAID',
  /** The payout is still to come. */
  Pending = 'PENDING'
}

export type SellerShippingEstimatesInput = {
  /** Buyer country to price for; default NL. */
  country?: InputMaybe<Country>;
  productId: Scalars['UUID']['input'];
};

export enum SellerVerificationAction {
  AddBankAccount = 'ADD_BANK_ACCOUNT',
  CompleteOnboarding = 'COMPLETE_ONBOARDING',
  FixTypedDetails = 'FIX_TYPED_DETAILS',
  NonePlatformFixing = 'NONE_PLATFORM_FIXING',
  UploadDocument = 'UPLOAD_DOCUMENT'
}

/**
 * One thing blocking Stripe seller verification, classified server-side from the
 * monolith's webhook mirror. `code` is an open set of stable slugs — render
 * `title`/`description` and switch call-to-actions on `action`; never on `code`.
 */
export type SellerVerificationIssue = {
  __typename?: 'SellerVerificationIssue';
  action: SellerVerificationAction;
  code: Scalars['String']['output'];
  /**
   * Pre-localised label for the button that resolves this issue — one label per
   * `action`, so the copy is identical on web, iOS and Android by construction.
   * For NONE_PLATFORM_FIXING render no button at all (the platform is fixing
   * it); its label exists only as a fail-safe if a client renders one anyway.
   */
  cta_label: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** Set on identity-document-requested: why Whoppah asked for the document */
  document_request_reason?: Maybe<DocumentRequestReason>;
  /**
   * Stripe's error codes this issue absorbed (e.g. verification_document_expired),
   * for copy per reason. An open set; never shown raw.
   */
  reason_codes: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** One pre-localised sentence on why Stripe asks for this; null for an unknown code */
  why?: Maybe<Scalars['String']['output']>;
};


/**
 * One thing blocking Stripe seller verification, classified server-side from the
 * monolith's webhook mirror. `code` is an open set of stable slugs — render
 * `title`/`description` and switch call-to-actions on `action`; never on `code`.
 */
export type SellerVerificationIssueCta_LabelArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * One thing blocking Stripe seller verification, classified server-side from the
 * monolith's webhook mirror. `code` is an open set of stable slugs — render
 * `title`/`description` and switch call-to-actions on `action`; never on `code`.
 */
export type SellerVerificationIssueDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * One thing blocking Stripe seller verification, classified server-side from the
 * monolith's webhook mirror. `code` is an open set of stable slugs — render
 * `title`/`description` and switch call-to-actions on `action`; never on `code`.
 */
export type SellerVerificationIssueTitleArgs = {
  lang?: InputMaybe<Language>;
};


/**
 * One thing blocking Stripe seller verification, classified server-side from the
 * monolith's webhook mirror. `code` is an open set of stable slugs — render
 * `title`/`description` and switch call-to-actions on `action`; never on `code`.
 */
export type SellerVerificationIssueWhyArgs = {
  lang?: InputMaybe<Language>;
};

export enum SellerVerificationStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

/**
 * A contact-form submission from the public contact page (WHO-5320).
 *
 * Every field is normalised, bounded and charset-checked here, because the
 * receiving model forbids unknown fields and this is the last place a bad
 * submission can be turned into a message a human can act on.
 */
export type SendContactMessageInput = {
  /** Up to five photos, inline. */
  attachments?: InputMaybe<Array<ContactAttachmentInput>>;
  /** The address the visitor typed. Unverified by definition: see the mutation. */
  email: Scalars['String']['input'];
  /**
   * The locale the visitor was browsing in, so CS answers in that language.
   * Metadata only: anything outside the six site locales falls back to `en`
   * rather than rejecting the message.
   */
  locale: Scalars['String']['input'];
  /** The visitor's message. Required, max 8000 characters. */
  message: Scalars['String']['input'];
  /**
   * Order number, optional: plenty of questions have no order behind them.
   * Charset-checked rather than only length-checked: a value carrying a CR LF and
   * a second header line fits inside forty characters.
   */
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  /** What the message is about. The agent-facing label is derived from this. */
  topic: ContactTopic;
};

/**
 * The result of a contact-form submission.
 *
 * Says nothing about the inbox it landed in. A reference is returned so support
 * can find the submission if the visitor quotes it.
 */
export type SendContactMessageResponse = {
  __typename?: 'SendContactMessageResponse';
  /** Always true when the message was accepted and delivered. */
  received: Scalars['Boolean']['output'];
  /** Correlation reference for this submission. Safe to show, carries no state. */
  reference: Scalars['String']['output'];
};

/** Response type for OTP sending operation */
export type SendOtpResponse = {
  __typename?: 'SendOtpResponse';
  /** Human-readable message about the operation result */
  message: Scalars['String']['output'];
  /** Whether the OTP was sent successfully */
  success: Scalars['Boolean']['output'];
};

/** Type representing an additional service that can be added to cart items */
export type Service = {
  __typename?: 'Service';
  /** Short description of the service, supports translations */
  description: Scalars['String']['output'];
  /** Detailed description of the service, supports translations */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** Icon identifier for the service */
  icon: Scalars['String']['output'];
  /** Unique identifier for the service */
  id: Scalars['UUID']['output'];
  /** Display name of the service, supports translations */
  name: Scalars['String']['output'];
  /**
   * How the price is worked out, set only when it is a rate on the item's price.
   * A service priced per category charges that amount instead and has no rate.
   */
  rate?: Maybe<ServiceRate>;
  /** URL-friendly identifier for the service */
  slug: Scalars['String']['output'];
};


/** Type representing an additional service that can be added to cart items */
export type ServiceDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing an additional service that can be added to cart items */
export type ServiceFullDescriptionArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing an additional service that can be added to cart items */
export type ServiceNameArgs = {
  lang?: InputMaybe<Language>;
};


/** Type representing an additional service that can be added to cart items */
export type ServiceSlugArgs = {
  lang?: InputMaybe<Language>;
};

/** A carrier service point (pickup/drop-off location), e.g. from SendCloud. */
export type ServicePoint = {
  __typename?: 'ServicePoint';
  /** Carrier code (e.g. postnl, dhl) */
  carrierCode: Scalars['String']['output'];
  /** Carrier display name */
  carrierName: Scalars['String']['output'];
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country code (ISO 3166-1 alpha-2) */
  country: Scalars['String']['output'];
  /** Distance from the search location, in meters */
  distance?: Maybe<Scalars['Float']['output']>;
  /** House number */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Provider service point id */
  id: Scalars['String']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Carrier logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Display name of the location */
  name: Scalars['String']['output'];
  /** Opening hours per weekday (provider-supplied; may be absent) */
  openingHours?: Maybe<Array<ServicePointOpeningHours>>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Street */
  street?: Maybe<Scalars['String']['output']>;
};

/**
 * Opening hours for a single weekday at a service point. `weekday` follows the
 * provider convention (0 = Monday .. 6 = Sunday) and `times` holds the
 * human-readable ranges for that day (e.g. ["09:00 - 17:00"]); an empty list
 * means closed on that day.
 */
export type ServicePointOpeningHours = {
  __typename?: 'ServicePointOpeningHours';
  /** Human-readable opening ranges for the day; empty when closed */
  times: Array<Scalars['String']['output']>;
  /** Weekday index (0 = Monday .. 6 = Sunday) */
  weekday: Scalars['Int']['output'];
};

/** Input for searching carrier service points near a location. */
export type ServicePointsInput = {
  /** Free-text address near which to search */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Carrier code to filter by (e.g. postnl, dhl) */
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  /** City near which to search */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Destination country code (ISO 3166-1 alpha-2) */
  country: Scalars['String']['input'];
  /** House number */
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of results */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Postal code near which to search */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Search radius in meters */
  radius?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The rate behind a service's price, when the price is worked out from the
 * item's price rather than set per category.
 *
 * The checkout prints this under the amount, so a buyer can see what the charge
 * is a percentage of. It is the service's own pricing configuration rather than
 * a sentence, so changing the percentage in the admin changes what the checkout
 * says and the two cannot drift apart.
 */
export type ServiceRate = {
  __typename?: 'ServiceRate';
  /** The floor the percentage is raised to when it lands below it. */
  minimumPrice: Price;
  /** The percentage of the item's price, as a number: 5.9 means 5,9%. */
  percentage: Scalars['Float']['output'];
};

/** Types of additional services that can be added to cart items */
export enum ServiceType {
  /** Service to boost item visibility by pushing it to the top of listings */
  PushToTop = 'PUSH_TO_TOP'
}

export type SetListingFieldInput = {
  /** Keep a value the check calls UNUSUAL: the seller measured again and it is right (DIMENSIONS). */
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  key: ListingFieldKey;
  /** BRAND and ARTIST also take {unknown: true}: the seller does not know (sets brand_unknown / artist_unknown). */
  value: Scalars['JSON']['input'];
};

/** Product shape options */
export enum Shape {
  /** Irregular/natural shape */
  Organic = 'ORGANIC',
  /** Other shapes */
  Other = 'OTHER',
  /** Oval/elliptical shape */
  Oval = 'OVAL',
  /** Rectangular shape */
  Rectangle = 'RECTANGLE',
  /** Circular shape */
  Round = 'ROUND',
  /** Square shape */
  Square = 'SQUARE',
  /** Triangular shape */
  Triangle = 'TRIANGLE'
}

/**
 * Represents a shipment record for an order.
 * Tracks shipping details and status.
 */
export type Shipment = {
  __typename?: 'Shipment';
  /** When the shipment was created */
  created: Scalars['DateTime']['output'];
  /** Unique identifier for the shipment */
  id: Scalars['UUID']['output'];
  /** Merchant handling the shipment */
  merchant: Merchant;
  /** Associated order */
  order: Order;
  /** Return tracking code if applicable */
  return_code?: Maybe<Scalars['String']['output']>;
  /** Tracking code for the shipment */
  tracking_code?: Maybe<Scalars['String']['output']>;
  /** When the shipment was last updated */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Input type for creating a new shipment.
 * Contains order reference and tracking details.
 */
export type ShipmentInput = {
  /** ID of the order to create shipment for */
  order_id: Scalars['UUID']['input'];
  /** Return tracking code if applicable */
  return_code?: InputMaybe<Scalars['String']['input']>;
  /** Tracking code for the shipment */
  tracking_code?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input type for estimating shipping costs.
 * Requires location details.
 */
export type ShippingEstimator = {
  /** Destination city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Destination country code */
  country: Scalars['String']['input'];
  /** Destination postal code */
  postal_code?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a shipping method configuration.
 * Defines pricing and details for a shipping option.
 */
export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  /** Detailed description of the shipping method */
  description?: Maybe<Scalars['String']['output']>;
  /** Enum value for the shipping method */
  enum: ShippingMethodEnum;
  /** Unique identifier for the shipping method */
  id: Scalars['UUID']['output'];
  /**
   * Calculate shipping price based on location and package details
   * Returns the cost including currency
   */
  price: Price;
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** Display name of the shipping method */
  title: Scalars['String']['output'];
};


/**
 * Represents a shipping method configuration.
 * Defines pricing and details for a shipping option.
 */
export type ShippingMethodPriceArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  origin?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** Type representing shipping price by country */
export type ShippingMethodCountryPrice = {
  __typename?: 'ShippingMethodCountryPrice';
  /** Country code */
  country: Scalars['String']['output'];
  /** Shipping price for this country */
  price: Price;
};


/** Type representing shipping price by country */
export type ShippingMethodCountryPricePriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

/** Types of shipping methods available */
export enum ShippingMethodEnum {
  /** Courier delivery service */
  Courier = 'COURIER',
  /** Custom shipping arrangement */
  Custom = 'CUSTOM',
  /** In-person pickup */
  Pickup = 'PICKUP',
  /** Standard postal service */
  Postal = 'POSTAL'
}

/**
 * Represents a shipping option available for an order.
 * Contains details about the shipping method, cost, and provider.
 */
export type ShippingOption = {
  __typename?: 'ShippingOption';
  /** Whether this option is currently available */
  active: Scalars['Boolean']['output'];
  /** Detailed description of the shipping option */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon URL for the shipping option */
  icon?: Maybe<Scalars['String']['output']>;
  /** Additional shipping option details */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Name of the shipping option */
  name: Scalars['String']['output'];
  /**
   * Cost of the shipping option. On a cart item (`CartItem.shippingOptions`) it is
   * checkout money: always EUR, never converted, whatever `currency` asks for
   * (WHO-5991 decision 5). Elsewhere it converts to its `currency` argument.
   */
  price?: Maybe<Price>;
  /** Type of shipping method */
  shippingMethod: ShippingMethodEnum;
  /** Shipping service provider */
  shippingProvider?: Maybe<ShippingProviderEnum>;
};


/**
 * Represents a shipping option available for an order.
 * Contains details about the shipping method, cost, and provider.
 */
export type ShippingOptionPriceArgs = {
  currency?: InputMaybe<Currency>;
  precision?: InputMaybe<PricePrecision>;
};

export enum ShippingOptionUnsupportedReasonEnum {
  DeliveryCountryUnsupported = 'DELIVERY_COUNTRY_UNSUPPORTED',
  DimensionsExceedMax = 'DIMENSIONS_EXCEED_MAX',
  MerchantDisabled = 'MERCHANT_DISABLED',
  MissingDimensions = 'MISSING_DIMENSIONS',
  PickupCountryUnsupported = 'PICKUP_COUNTRY_UNSUPPORTED',
  PriceExceedsMax = 'PRICE_EXCEEDS_MAX',
  QuoteInfeasible = 'QUOTE_INFEASIBLE',
  QuoteUnavailable = 'QUOTE_UNAVAILABLE'
}

/** Supported shipping service providers */
export enum ShippingProviderEnum {
  /** Brenger delivery service */
  Brenger = 'BRENGER',
  /** SendCloud shipping service */
  Sendcloud = 'SENDCLOUD',
  /** Wuunder shipping service */
  Wuunder = 'WUUNDER'
}

/** Represents a physical showroom location where products can be viewed */
export type Showroom = {
  __typename?: 'Showroom';
  /** Physical address of the showroom */
  address?: Maybe<ShowroomAddress>;
  /** Google Maps URL for directions */
  googleMapsUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the showroom */
  id: Scalars['UUID']['output'];
  /** External identifier for the showroom */
  identifier: Scalars['String']['output'];
  /** Featured image of the showroom */
  image: Scalars['String']['output'];
  /** General information about the showroom in specified language */
  info: Scalars['String']['output'];
  /** Opening hours information in specified language */
  openingHours: Scalars['String']['output'];
};


/** Represents a physical showroom location where products can be viewed */
export type ShowroomInfoArgs = {
  lang?: InputMaybe<Language>;
};


/** Represents a physical showroom location where products can be viewed */
export type ShowroomOpeningHoursArgs = {
  lang?: InputMaybe<Language>;
};

/** Address information for a physical showroom location */
export type ShowroomAddress = {
  __typename?: 'ShowroomAddress';
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Country information */
  country?: Maybe<Country>;
  /** Unique identifier for the address */
  id: Scalars['UUID']['output'];
  /** External identifier for the address */
  identifier: Scalars['String']['output'];
  /** Latitude coordinate of the location */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** First line of the address */
  line1?: Maybe<Scalars['String']['output']>;
  /** Second line of the address (optional) */
  line2?: Maybe<Scalars['String']['output']>;
  /** Longitude coordinate of the location */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Postal/ZIP code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Region or state name */
  region?: Maybe<Scalars['String']['output']>;
  /** Display title for the address */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input type for address information during signup process. */
export type SignupAddressInput = {
  /** City name */
  city: Scalars['String']['input'];
  /** Country code (ISO format) */
  country: Scalars['String']['input'];
  /** Primary address line (street and house number) */
  line1: Scalars['String']['input'];
  /** Secondary address line (apartment, suite, etc.) */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Geographic coordinates of the address */
  location?: InputMaybe<LocationInput>;
  /** Postal/ZIP code */
  postal_code: Scalars['String']['input'];
  /** State or province name */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Basic signup input with email and password credentials */
export type SignupInput = {
  /** User's email address, must be unique */
  email: Scalars['String']['input'];
  /** User's password, must meet security requirements */
  password: Scalars['String']['input'];
};

/** Response type for successful signup */
export type SignupResponse = {
  __typename?: 'SignupResponse';
  /** JWT token for authentication */
  access_token: Scalars['String']['output'];
  /** Newly created user details */
  user: Member;
};

/** Input for simulating a bank transfer payment in testing. */
export type SimulateBankTransferForOrderGroupInput = {
  /** Transferred amount in euros */
  amount: Scalars['Float']['input'];
  /** Order group identifier */
  orderGroupId: Scalars['UUID']['input'];
};

/** Available size options for media assets */
export enum Size {
  /** @deprecated Not required */
  All = 'ALL',
  Lg = 'LG',
  Md = 'MD',
  Sm = 'SM',
  Xs = 'XS'
}

/** Type of sorting algorithm to use */
export enum SortingType {
  /** Full exhaustive search considering all parameters */
  Exhaustive = 'EXHAUSTIVE',
  /**
   * Relevance-based search (deprecated)
   * @deprecated We always use EXHAUSTIVE sorting type
   */
  Relevant = 'RELEVANT'
}

/**
 * Represents a Stripe connected account.
 * Used for merchants to receive payments.
 */
export type StripeAccount = {
  __typename?: 'StripeAccount';
  /** ID of the connected Stripe account */
  account_id: Scalars['String']['output'];
  /** Whether the account has completed verification */
  verified: Scalars['Boolean']['output'];
};

export type StripeAccountDetails = {
  __typename?: 'StripeAccountDetails';
  account_created: Scalars['Boolean']['output'];
  account_status: SellerAccountStatus;
  /**
   * The page's buttons: at most one PRIMARY and one SECONDARY, primary first.
   * Empty only when there is nothing to offer.
   */
  actions: Array<SellerAction>;
  /**
   * Money waiting on the seller's account: completed orders Whoppah still holds
   * plus the Stripe balance. Null when nothing is waiting.
   */
  amount_waiting?: Maybe<Price>;
  balance?: Maybe<SellerBalance>;
  bank_account?: Maybe<ExternalBankAccount>;
  /**
   * The blocker family the seller's emails name (postal-code,
   * payout-setup-incomplete, account-verification, bank-account); null when
   * there is nothing to fix. Same value as the Iterable profile field.
   */
  blocker_family?: Maybe<Scalars['String']['output']>;
  /** Stripe's deadline for the open requirements, when it set one; often already in the past */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the seller finished Stripe's form at least once */
  details_submitted: Scalars['Boolean']['output'];
  /** Stripe's own reason for disabling the account, raw; null when enabled */
  disabled_reason?: Maybe<Scalars['String']['output']>;
  payouts_enabled: Scalars['Boolean']['output'];
  /** When Stripe's review of the seller's submission began, as first seen by the mirror */
  pending_since?: Maybe<Scalars['DateTime']['output']>;
  /** Pre-localised explanation for `account_status` */
  status_description: Scalars['String']['output'];
  /** Pre-localised title for `account_status` */
  status_title: Scalars['String']['output'];
  /** When the mirrored account state was last read from Stripe */
  verification_as_of?: Maybe<Scalars['DateTime']['output']>;
  verification_issues: Array<SellerVerificationIssue>;
  /**
   * UNKNOWN when the mirror has no classified data (yet) — render the existing
   * generic fallback in that case, never an empty checklist presented as truth.
   */
  verification_status: SellerVerificationStatus;
};


export type StripeAccountDetailsStatus_DescriptionArgs = {
  lang?: InputMaybe<Language>;
};


export type StripeAccountDetailsStatus_TitleArgs = {
  lang?: InputMaybe<Language>;
};

export type StripeAccountLink = {
  __typename?: 'StripeAccountLink';
  url: Scalars['String']['output'];
};

export type StripeAccountLinkInput = {
  otp?: InputMaybe<Scalars['String']['input']>;
  refresh_url: Scalars['String']['input'];
  return_url: Scalars['String']['input'];
  type: StripeAccountLinkType;
};

export enum StripeAccountLinkType {
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  AccountUpdate = 'ACCOUNT_UPDATE'
}

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a Stripe customer session.
 * Contains session details for payment processing.
 */
export type StripeCustomerSession = {
  __typename?: 'StripeCustomerSession';
  /** Client secret for client-side confirmation */
  clientSecret: Scalars['String']['output'];
};

/**
 * Represents a Stripe payment transaction.
 * Contains IDs and references for tracking the payment in Stripe.
 */
export type StripePayment = {
  __typename?: 'StripePayment';
  /** Client secret for client-side confirmation */
  client_secret_id: Scalars['String']['output'];
  /** ID of the payment intent in Stripe */
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  /** Type of payment method used (card, bank transfer, etc) */
  payment_method: Scalars['String']['output'];
  /** ID of the specific payment method */
  payment_method_id?: Maybe<Scalars['String']['output']>;
  /** ID of the payment source in Stripe */
  payment_source_id?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a live Stripe PaymentIntent.
 * Only exposes the fields required by clients.
 */
export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  /** Client secret for client-side confirmation */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** ID of the payment intent in Stripe */
  id: Scalars['String']['output'];
  /** Next action the client should perform */
  nextAction?: Maybe<StripePaymentIntentNextAction>;
};

export type StripePaymentIntentDisplayBankTransferInstructions = {
  __typename?: 'StripePaymentIntentDisplayBankTransferInstructions';
  /** Still to transfer, in the currency's minor units (cents). Prefer amountRemainingPrice. */
  amountRemaining?: Maybe<Scalars['Int']['output']>;
  /**
   * Still to transfer, as a price (Stripe's cents turned into an amount), so the
   * client shows it as sent instead of dividing by 100 (WHO-6000). Null when
   * Stripe sends no amount or a currency the gateway does not know. It is what
   * the buyer owes: never display-converted.
   */
  amountRemainingPrice?: Maybe<Price>;
  currency?: Maybe<Scalars['String']['output']>;
  financialAddresses?: Maybe<Array<StripePaymentIntentFinancialAddressIban>>;
  hostedInstructionsUrl?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StripePaymentIntentFinancialAddressIban = {
  __typename?: 'StripePaymentIntentFinancialAddressIban';
  accountHolderAddress: StripeAddress;
  accountHolderName: Scalars['String']['output'];
  bankAddress: StripeAddress;
  bic: Scalars['String']['output'];
  country: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type StripePaymentIntentNextAction = {
  __typename?: 'StripePaymentIntentNextAction';
  displayBankTransferInstructions?: Maybe<StripePaymentIntentDisplayBankTransferInstructions>;
  redirectToUrl?: Maybe<StripePaymentIntentRedirectToUrl>;
  type: StripePaymentIntentNextActionType;
};

export enum StripePaymentIntentNextActionType {
  DisplayBankTransferInstructions = 'DISPLAY_BANK_TRANSFER_INSTRUCTIONS',
  RedirectToUrl = 'REDIRECT_TO_URL'
}

export type StripePaymentIntentRedirectToUrl = {
  __typename?: 'StripePaymentIntentRedirectToUrl';
  returnUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Style = AbstractAttribute & {
  __typename?: 'Style';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  listingPage: ListingPage;
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type StyleMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type StyleSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type StyleTitleArgs = {
  lang?: InputMaybe<Language>;
};

/**
 * Input for querying subcategories with specific criteria.
 * Used to find subcategories based on brand, category, and style combinations.
 */
export type SubcategoriesInput = {
  /** Brand name to filter by */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Parent category to filter by */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Style to filter by */
  style?: InputMaybe<Scalars['String']['input']>;
};

export type Subject = AbstractAttribute & {
  __typename?: 'Subject';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SubjectMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type SubjectSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type SubjectTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type Subscriber = {
  __typename?: 'Subscriber';
  id: Scalars['UUID']['output'];
  merchant: Merchant;
  requestedTranslationLanguage?: Maybe<Scalars['String']['output']>;
  role: SubscriberRole;
};

export enum SubscriberRole {
  Bot = 'BOT',
  Curator = 'CURATOR',
  Subscriber = 'SUBSCRIBER',
  Support = 'SUPPORT'
}

/** Root Subscription type for all real-time operations in the API */
export type Subscription = {
  __typename?: 'Subscription';
  healthy: Scalars['Boolean']['output'];
  /**
   * Subscribe to new message notifications.
   * Triggered when a new message is created in any thread the user has access to.
   */
  messageCreated: Message;
  /**
   * Subscribe to message update notifications.
   * Triggered when a message is modified (e.g., marked as read).
   */
  messageUpdated: Message;
  /**
   * Basic health check endpoint for subscriptions
   * Returns status code indicating API health
   */
  status?: Maybe<Scalars['Int']['output']>;
};

export type SupportedCountry = {
  __typename?: 'SupportedCountry';
  code: Country;
  supportLevel: CountrySupportLevel;
};

/**
 * Block for displaying formatted text content with multiple sections.
 * Used for creating rich, multi-section content areas with text, images, and interactive elements.
 */
export type TextBlock = AbstractBlock & {
  __typename?: 'TextBlock';
  /** Unique identifier for the text block */
  id: Scalars['UUID']['output'];
  /** Featured image for the text block */
  image: Scalars['String']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** Ordered list of text sections within the block */
  sections: Array<TextSection>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the text content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
};

/**
 * Represents a section of formatted text content with optional media and interaction elements.
 * Used within TextBlocks to create rich, structured content sections.
 */
export type TextSection = {
  __typename?: 'TextSection';
  /** Text for the call-to-action button */
  button?: Maybe<Scalars['String']['output']>;
  /** Main content text of the section */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the text section */
  id: Scalars['UUID']['output'];
  /** Illustrative image for the section */
  image: Scalars['String']['output'];
  /** URL for the button's action */
  link?: Maybe<Scalars['String']['output']>;
  /** URL-friendly identifier for the section */
  slug: Scalars['String']['output'];
  /** Optional heading for the section */
  title?: Maybe<Scalars['String']['output']>;
};

export type Thread = {
  __typename?: 'Thread';
  canSendImageMessage: Scalars['Boolean']['output'];
  /**
   * Seller side of a product chat: the Pro Buyer price the other participant
   * (the buyer who started the thread) would pay for this listing. Null unless
   * the viewer owns the listing and the same conditions as
   * `Product.proBuyerPrice` hold for the counterpart. Filled on the single
   * `thread` query only; always null on thread lists.
   */
  counterpartProBuyerPrice?: Maybe<ProBuyerPrice>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  item: ThreadItem;
  /** @deprecated Please use the getMessages query. */
  messages: Array<Message>;
  pendingActions: Array<PendingAction>;
  started_by: Merchant;
  subscribers: Array<Subscriber>;
  unread_count: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};


export type ThreadMessagesArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type ThreadFilter = {
  key?: InputMaybe<ThreadFilterKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ThreadFilterKey {
  Item = 'ITEM',
  StartedBy = 'STARTED_BY',
  Thread = 'THREAD'
}

export type ThreadItem = Merchant | Product;

export type ThreadResult = {
  __typename?: 'ThreadResult';
  items: Array<Thread>;
  pagination: PaginationResult;
};

export enum ThreadSort {
  Created = 'CREATED',
  Item = 'ITEM',
  StartedBy = 'STARTED_BY',
  Updated = 'UPDATED'
}

/** The tone of voice to use. */
export enum ToneOfVoice {
  Concise = 'CONCISE',
  Formal = 'FORMAL',
  Informal = 'INFORMAL',
  Informative = 'INFORMATIVE'
}

/** Input for tracking add to cart events */
export type TrackAddToCart = {
  /** ID of product added to cart */
  productId: Scalars['UUID']['input'];
};

export type TranslateThreadInput = {
  id: Scalars['UUID']['input'];
  lang: Language;
};

/** Represents an unavailable delivery date */
export type UnavailableDate = {
  __typename?: 'UnavailableDate';
  /** The unavailable date */
  date: Scalars['Date']['output'];
  /** Reason for unavailability */
  state: UnavailableDateState;
};

/** Reason why a date is unavailable */
export enum UnavailableDateState {
  /** Date was previously rejected */
  Rejected = 'REJECTED',
  /** Date is not available for scheduling */
  Unavailable = 'UNAVAILABLE'
}

/** Input for updating cart settings */
export type UpdateCartInput = {
  /**
   * @deprecated Use shipping_address_id
   * Legacy address ID
   * @deprecated Use shipping_address_id
   */
  address_id?: InputMaybe<Scalars['UUID']['input']>;
  /** ID of the billing address to use */
  billing_address_id?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * @deprecated Moved to CartItem
   * Legacy buyer protection flag
   * @deprecated Moved to CartItem
   */
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Coupon code to apply */
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  /**
   * @deprecated Moved to CartItem
   * Legacy delivery method
   * @deprecated Moved to CartItem
   */
  delivery_method?: InputMaybe<DeliveryMethod>;
  /** Payment method to use */
  payment_method?: InputMaybe<PaymentMethod>;
  /** ID of the shipping address to use */
  shipping_address_id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating a cart item's configuration */
export type UpdateCartItemInput = {
  /**
   * @deprecated Please use shippingMethod and shippingProvider instead
   * Legacy delivery method enum
   * @deprecated Please use `shippingMethod` and `shippingProvider` instead.
   */
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  /**
   * @deprecated Please use shippingMethod and shippingProvider instead
   * Legacy delivery method field
   * @deprecated Please use `shippingMethod` and `shippingProvider` instead.
   */
  delivery_method?: InputMaybe<DeliveryMethod>;
  /**
   * @deprecated Please use shippingMethod and shippingProvider instead
   * Legacy external delivery flag
   * @deprecated Please use `shippingMethod` and `shippingProvider` instead.
   */
  external_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * @deprecated Please use shippingMethod and shippingProvider instead
   * Legacy shipping method ID
   * @deprecated Please use `shippingMethod` and `shippingProvider` instead.
   */
  external_shipping_method_id?: InputMaybe<Scalars['UUID']['input']>;
  /** IDs of services to apply to the item */
  services?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Selected shipping method */
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  /** Additional metadata required by the shipping option */
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Selected shipping provider */
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
};

/** Input for resetting password using reset token */
export type UpdateForgottenPasswordInput = {
  /** New password */
  new_password: Scalars['String']['input'];
  /** Confirmation of new password */
  new_password_confirmation: Scalars['String']['input'];
  /** Password reset token received via email */
  token: Scalars['String']['input'];
  /** User identifier */
  uid: Scalars['String']['input'];
};

/** Response type for password reset operation */
export type UpdateForgottenPasswordResponse = {
  __typename?: 'UpdateForgottenPasswordResponse';
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Result of the password update */
  status: UpdateForgottenPasswordResult;
};

/** Possible outcomes when updating a forgotten password */
export enum UpdateForgottenPasswordResult {
  /** Password update failed */
  Failure = 'FAILURE',
  /** Password updated successfully */
  Success = 'SUCCESS'
}

/** Input for updating member password */
export type UpdateMemberPassword = {
  /** Current password for verification */
  current?: InputMaybe<Scalars['String']['input']>;
  /** New password to set */
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderPickupConfirmationInput = {
  confirmationStatus: OrderPickupConfirmationStatus;
  orderId: Scalars['UUID']['input'];
};

export type UpdateOrderStateInput = {
  orderId: Scalars['UUID']['input'];
  state: OrderState;
  /**
   * Optional tracking link or transporter details, stored when a custom delivery
   * seller marks the item as shipped. Trimmed; at most 500 characters.
   */
  trackingInfo?: InputMaybe<Scalars['String']['input']>;
};

/** Input for verifying phone number with OTP */
export type UpdatePhoneWithOtpInput = {
  /** OTP code received */
  newOtp: Scalars['String']['input'];
  /** New phone number being verified */
  newPhone: Scalars['String']['input'];
};

/** Response for phone number update */
export type UpdatePhoneWithOtpResponse = {
  __typename?: 'UpdatePhoneWithOTPResponse';
  /** Human-readable message about the result */
  message: Scalars['String']['output'];
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
  /** Updated user profile */
  user: Member;
};

export type UpdateProductInput = {
  additional_info?: InputMaybe<Array<Scalars['UUID']['input']>>;
  address?: InputMaybe<Scalars['UUID']['input']>;
  allow_bid?: InputMaybe<Scalars['Boolean']['input']>;
  allow_buy_now?: InputMaybe<Scalars['Boolean']['input']>;
  already_advertised_on_whoppah?: InputMaybe<Scalars['Boolean']['input']>;
  art_orientation?: InputMaybe<ArtOrientation>;
  artistUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  artist_suggestion?: InputMaybe<Scalars['String']['input']>;
  artists?: InputMaybe<Array<Scalars['UUID']['input']>>;
  auto_discount?: InputMaybe<Scalars['Boolean']['input']>;
  bag_model?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['UUID']['input']>;
  brandUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  brand_suggestion?: InputMaybe<Scalars['String']['input']>;
  buy_now_price?: InputMaybe<PriceInput>;
  campaign_code?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  colors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  condition?: InputMaybe<ProductCondition>;
  customShippingPrices?: InputMaybe<Array<CustomShippingPriceInput>>;
  delivery_method?: InputMaybe<DeliveryMethod>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer_suggestion?: InputMaybe<Scalars['String']['input']>;
  designers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gender?: InputMaybe<Gender>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  hardware_color?: InputMaybe<Scalars['UUID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** @deprecated No longer used */
  is_in_showroom?: InputMaybe<Scalars['Boolean']['input']>;
  materials?: InputMaybe<Array<Scalars['UUID']['input']>>;
  merchant?: InputMaybe<Scalars['UUID']['input']>;
  minimum_bid?: InputMaybe<PriceInput>;
  mpn?: InputMaybe<Scalars['String']['input']>;
  new_price?: InputMaybe<PriceInput>;
  note_for_curator?: InputMaybe<Scalars['String']['input']>;
  number_of_items?: InputMaybe<Scalars['Int']['input']>;
  original_price?: InputMaybe<PriceInput>;
  /** Size category for postal shipping (S/M/L/XL/XXL). Preferred over postal_package_size. */
  postalPackageSize?: InputMaybe<PostalPackageSize>;
  /**
   * Size category for postal shipping (legacy enum: SMALL/MEDIUM/LARGE).
   * Accepted for backwards compatibility; takes effect only when postalPackageSize is not provided.
   * @deprecated Use postalPackageSize (S/M/L/XL/XXL) instead.
   */
  postal_package_size?: InputMaybe<PostalPackageSize>;
  postal_package_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  /** Smart Drop (enabled) or Fixed price (disabled). Replaces auto_discount for clients that send it. */
  priceDrop?: InputMaybe<PriceDropSettingsInput>;
  quality?: InputMaybe<ProductQuality>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reactivate?: InputMaybe<Scalars['Boolean']['input']>;
  seat_height?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Shape>;
  /** @deprecated Use customShippingPrices instead */
  shipping_cost?: InputMaybe<PriceInput>;
  shipping_method?: InputMaybe<Scalars['UUID']['input']>;
  showroomModel?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  subject?: InputMaybe<Array<Scalars['UUID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  usage_signs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  usage_signs_description?: InputMaybe<Scalars['String']['input']>;
  user_confirmed_postal_fit?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Clients should not be allowed to update weight */
  weight?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  year_of_purchase?: InputMaybe<Scalars['Int']['input']>;
};

export type UsageSign = AbstractAttribute & {
  __typename?: 'UsageSign';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  media: Array<Media>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type UsageSignMediaArgs = {
  type?: InputMaybe<MediaType>;
};


export type UsageSignSlugArgs = {
  lang?: InputMaybe<Language>;
};


export type UsageSignTitleArgs = {
  lang?: InputMaybe<Language>;
};

export type UserAdsScreenParams = {
  __typename?: 'UserAdsScreenParams';
  merchantId: Scalars['UUID']['output'];
};

export type ValidateVoucherInvalid = {
  __typename?: 'ValidateVoucherInvalid';
  invalid: Scalars['Boolean']['output'];
  invalid_reason: Scalars['String']['output'];
};

export type ValidateVoucherResult = ValidateVoucherInvalid | ValidateVoucherValid;

export type ValidateVoucherValid = {
  __typename?: 'ValidateVoucherValid';
  type: DiscountType;
  value: Scalars['Float']['output'];
};

/** Whether whoppah-web may run one value check (a paid photo recognition) for a visitor. */
export type ValueCheckAdmission = {
  __typename?: 'ValueCheckAdmission';
  admitted: Scalars['Boolean']['output'];
  /** Null when admitted. */
  refusal?: Maybe<ValueCheckRefusal>;
  /** Seconds until the visitor can check again; null when admitted. */
  retryAfterSeconds?: Maybe<Scalars['Int']['output']>;
};

/**
 * What comparable pieces actually sold for on Whoppah: realised sale prices, never the asking-price
 * advice create-ad shows. The visitor's photo says nothing reliable about condition, so the range
 * spans the lowest to the highest quality class (`conditionDependent` is always true unless refused).
 * When `status` is `REFUSED` every other field is null.
 */
export type ValueCheckPrice = {
  __typename?: 'ValueCheckPrice';
  /** Number of comparable sales behind the range. */
  comparableSales?: Maybe<Scalars['Int']['output']>;
  conditionDependent: Scalars['Boolean']['output'];
  /** How much the range can be trusted. `LOW` is never returned with `OK`. */
  confidence?: Maybe<PriceRecommendationConfidence>;
  /** Middle of the range. */
  expected?: Maybe<Price>;
  /** Upper end: comparable pieces in the highest quality class sold for up to this (75th percentile). */
  high?: Maybe<Price>;
  /** Lower end: comparable pieces in the lowest quality class sold for at least this (25th percentile). */
  low?: Maybe<Price>;
  /** `OK` when a range may be shown; `REFUSED` when the engine had too few comparable sales or was unavailable. */
  status: PriceRecommendationStatus;
};

/**
 * What the recognition saw in the visitor's photo, in our own vocabulary. Slugs that do not
 * exist are ignored; an unknown category refuses the price.
 */
export type ValueCheckPriceInput = {
  /** The maker as read, when no brand row matched. */
  brandName?: InputMaybe<Scalars['String']['input']>;
  /** Our brand slug, when the recognition projected the maker onto a brand row. */
  brandSlug?: InputMaybe<Scalars['String']['input']>;
  /** Category leaf slug from our tree (the recognition's category). */
  categorySlug: Scalars['String']['input'];
  /** Material attribute slugs. */
  materialSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The photo as base64 JPEG, at most 4 MB decoded. Sent to the pricing engine only, never stored. */
  photo: Scalars['String']['input'];
  /** English title of the piece, e.g. 'Teak lounge chair'. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Why an anonymous value check was not admitted (WHO-6534). */
export enum ValueCheckRefusal {
  /** The site-wide number of checks for the last 24 hours is used up. */
  DailyCap = 'DAILY_CAP',
  /** This visitor used up their checks for now; `retryAfterSeconds` says when the next one opens. */
  VisitorLimit = 'VISITOR_LIMIT'
}

/** WHO-6309: the VAT regime of one item (D6). Set in the CMS per item, with a merchant default. */
export enum VatRegime {
  /** Small business scheme (KOR): no VAT. */
  ExemptKor = 'EXEMPT_KOR',
  /** Margin scheme for second-hand goods: no VAT shown. */
  Margin = 'MARGIN',
  /** Seller-country standard rate. */
  Standard = 'STANDARD'
}

/** Input for verifying an OTP */
export type VerifyOtpInput = {
  /** The OTP code received by the user */
  otp: Scalars['String']['input'];
};

/** Response type for OTP verification operation */
export type VerifyOtpResponse = {
  __typename?: 'VerifyOtpResponse';
  /** Human-readable message about the verification result */
  message: Scalars['String']['output'];
  /** Whether the OTP was verified successfully */
  success: Scalars['Boolean']['output'];
};

/** Represents a video asset in the system */
export type Video = {
  __typename?: 'Video';
  /** Unique identifier of the video */
  id: Scalars['UUID']['output'];
  /** Get thumbnail image URL for the video */
  thumbnail: Scalars['String']['output'];
  /** Type of the video */
  type: VideoType;
  /** Get URL for video playback in specified playlist format */
  url: Scalars['String']['output'];
};


/** Represents a video asset in the system */
export type VideoThumbnailArgs = {
  size?: InputMaybe<Size>;
};


/** Represents a video asset in the system */
export type VideoUrlArgs = {
  playlist?: InputMaybe<PlaylistType>;
};

/**
 * Block for displaying video content.
 * Used for embedding video players and playlists across the platform.
 */
export type VideoBlock = AbstractBlock & {
  __typename?: 'VideoBlock';
  /** Unique identifier for the video block */
  id: Scalars['UUID']['output'];
  /** Optional URL that the block links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Position of the block within the page layout */
  location?: Maybe<BlockLocation>;
  /** URL-friendly identifier for the block */
  slug: Scalars['String']['output'];
  /** Brief description of the video content */
  summary?: Maybe<Scalars['String']['output']>;
  /** Human-readable title of the block */
  title: Scalars['String']['output'];
  /** List of videos to be played */
  videos: Array<Video>;
};

/** Types of video assets supported by the system */
export enum VideoType {
  Default = 'DEFAULT'
}

export type Voucher = {
  __typename?: 'Voucher';
  code: Scalars['String']['output'];
  valid_upto?: Maybe<Scalars['DateTime']['output']>;
};

/** A session token for whoppah-web's httpOnly cookie (WHO-6344) */
export type WebSession = {
  __typename?: 'WebSession';
  /** 30-day member token; renew before it expires */
  accessToken: Scalars['String']['output'];
  /** When the token expires */
  expiresAt: Scalars['DateTime']['output'];
};

/** Represents a package shipment handled by Wuunder */
export type WuunderShipment = {
  __typename?: 'WuunderShipment';
  /** Whether seller missed the shipping deadline */
  failedToSend: Scalars['Boolean']['output'];
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** When the shipping label was generated */
  labelGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL to download shipping label */
  labelUrl?: Maybe<Scalars['String']['output']>;
  /** Associated order details */
  order: Order;
  /** URL to view available parcel points in specified language */
  parcelPointsUrl?: Maybe<Scalars['String']['output']>;
  /** Carrier handling the shipment */
  rateCarrier: Scalars['String']['output'];
  /** Code identifying the selected shipping rate */
  rateCode: Scalars['String']['output'];
  /** Price of the selected shipping rate */
  ratePrice: Scalars['String']['output'];
  /** Deadline for sending the package */
  sendByDate: Scalars['DateTime']['output'];
  /** Whether parties should be reminded of pending actions */
  shouldRemind: Scalars['Boolean']['output'];
  /** Current status of the shipment */
  status?: Maybe<WuunderShipmentStatus>;
  /** Tracking code for the shipment */
  trackAndTraceCode?: Maybe<Scalars['String']['output']>;
  /** URL to track the shipment */
  trackAndTraceUrl?: Maybe<Scalars['String']['output']>;
};


/** Represents a package shipment handled by Wuunder */
export type WuunderShipmentParcelPointsUrlArgs = {
  lang?: InputMaybe<Language>;
};

/** Status of a Wuunder shipment */
export enum WuunderShipmentStatus {
  /** Package has been delivered */
  Delivered = 'DELIVERED',
  /** Package is in transit */
  InTransit = 'IN_TRANSIT',
  /** There is a problem with the shipment */
  Issue = 'ISSUE',
  /** Label generated but package not yet picked up */
  NotSent = 'NOT_SENT'
}

/** Information about a shipping rate from Wuunder */
export type WuunderShippingRate = {
  __typename?: 'WuunderShippingRate';
  /** Unique code for the carrier */
  carrierCode?: Maybe<Scalars['String']['output']>;
  /** URL to carrier's logo/image */
  carrierImageUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the carrier service */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Product/service code from the carrier */
  carrierProductCode?: Maybe<Scalars['String']['output']>;
  /** Earliest delivery time */
  deliveryAfter?: Maybe<Scalars['String']['output']>;
  /** Latest delivery time */
  deliveryBefore?: Maybe<Scalars['String']['output']>;
  /** Estimated delivery date */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Earliest pickup time */
  pickupAfter?: Maybe<Scalars['String']['output']>;
  /** Latest pickup time */
  pickupBefore?: Maybe<Scalars['String']['output']>;
  /** Scheduled pickup date */
  pickupDate?: Maybe<Scalars['String']['output']>;
  /** Shipping rate price */
  price?: Maybe<Scalars['Float']['output']>;
};

/** Input for updating an existing review */
export type UpdateReviewInput = {
  /** Updated anonymity preference */
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated review text content */
  review?: InputMaybe<Scalars['String']['input']>;
  /** Updated rating score */
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of a VAT number validation check */
export enum VatCheck {
  /** VAT check failed due to service error */
  Failed = 'FAILED',
  /** VAT number is invalid or not found */
  Invalid = 'INVALID',
  /** VAT number is valid */
  Ok = 'OK'
}

/**
 * Input for VAT number validation.
 * Used to check if a VAT number is valid.
 */
export type VatCheckInput = {
  /** VAT identification number to validate */
  vatId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Result of a VAT number validation check.
 * Contains the check status.
 */
export type VatCheckResult = {
  __typename?: 'vatCheckResult';
  /** Result of the VAT validation */
  result?: Maybe<VatCheck>;
};

export type BoostCartFragmentFragment_BoostCart_products_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction_buy_now_price_Price | null };

export type BoostCartFragmentFragment_BoostCart_products_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: BoostCartFragmentFragment_BoostCart_products_Product_image_Image | null, auction?: BoostCartFragmentFragment_BoostCart_products_Product_auction_Auction | null };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_auction_Auction_buy_now_price_Price | null };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_image_Image | null, auction?: BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product_auction_Auction | null };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem_boostPackage_BoostPackage = { __typename?: 'BoostPackage', days: number };

export type BoostCartFragmentFragment_BoostCart_items_BoostCartItem = { __typename?: 'BoostCartItem', product: BoostCartFragmentFragment_BoostCart_items_BoostCartItem_product_Product, boostPackage: BoostCartFragmentFragment_BoostCart_items_BoostCartItem_boostPackage_BoostPackage };

export type BoostCartFragmentFragment_BoostCart_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostCartFragmentFragment = { __typename?: 'BoostCart', products: Array<BoostCartFragmentFragment_BoostCart_products_Product>, items: Array<BoostCartFragmentFragment_BoostCart_items_BoostCartItem>, total: BoostCartFragmentFragment_BoostCart_total_Price };

export type CartFragmentFragment_Cart_payment_CartPayment = { __typename?: 'CartPayment', payment_intent_id: string, payment_client_secret: string };

export type CartFragmentFragment_Cart_shipping_address_Address = { __typename?: 'Address', id: any, city: string, country: string, line1: string, line2?: string | null, postal_code: string, state?: string | null };

export type CartFragmentFragment_Cart_billing_address_Address = { __typename?: 'Address', id: any };

export type CartFragmentFragment_Cart_items_CartItem_shipping_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingCost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_externalShippingCost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service_rate_ServiceRate_minimumPrice_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service_rate_ServiceRate = { __typename?: 'ServiceRate', percentage: number, minimumPrice: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service_rate_ServiceRate_minimumPrice_Price };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service = { __typename?: 'Service', id: any, name: string, icon: string, description: string, fullDescription?: string | null, name_en: string, rate?: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service_rate_ServiceRate | null };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService = { __typename?: 'CartItemService', id: string, eligible: boolean, ineligibleReason?: string | null, ineligibleError?: string | null, active: boolean, service: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_service_Service, price?: CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_address_Address = { __typename?: 'Address', city: string, country: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Artist = { __typename?: 'Artist' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Brand = { __typename?: 'Brand' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Color = { __typename?: 'Color' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Designer = { __typename?: 'Designer' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Label = { __typename?: 'Label' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Subject = { __typename?: 'Subject' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_attributes = CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_AdditionalInfo | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Artist | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Brand | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Color | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Designer | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_HardwareColor | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Label | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Material | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Style | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_Subject | CartFragmentFragment_Cart_items_CartItem_product_Product_attributes_UsageSign;

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, start_date?: any | null, sold_at?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_sold_at_Price | null, buy_now_price?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction_buy_now_price_Price | null };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_images_Image = { __typename?: 'Image', id: any };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, slug: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice = { __typename?: 'ShippingMethodCountryPrice', country: string, price: CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant_addresses_Address = { __typename?: 'Address', id: any, country: string };

export type CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null, addresses: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant_addresses_Address> };

export type CartFragmentFragment_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, status: ProductStatus, view_count: number, favorite_count: number, quality?: ProductQuality | null, showroom_state?: string | null, is_in_showroom?: boolean | null, number_of_items?: number | null, ground_floor_only_delivery?: boolean | null, delivery_method: DeliveryMethod, address?: CartFragmentFragment_Cart_items_CartItem_product_Product_address_Address | null, buy_now_price?: CartFragmentFragment_Cart_items_CartItem_product_Product_buy_now_price_Price | null, categories: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_categories_Category>, attributes: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_attributes>, auction?: CartFragmentFragment_Cart_items_CartItem_product_Product_auction_Auction | null, image?: CartFragmentFragment_Cart_items_CartItem_product_Product_image_Image | null, images: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_images_Image>, custom_shipping_cost?: CartFragmentFragment_Cart_items_CartItem_product_Product_custom_shipping_cost_Price | null, shipping_method?: CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_ShippingMethod | null, shipping_method_prices: Array<CartFragmentFragment_Cart_items_CartItem_product_Product_shipping_method_prices_ShippingMethodCountryPrice>, merchant: CartFragmentFragment_Cart_items_CartItem_product_Product_merchant_Merchant };

export type CartFragmentFragment_Cart_items_CartItem_bid_Bid_order_Order = { __typename?: 'Order', id: any };

export type CartFragmentFragment_Cart_items_CartItem_bid_Bid = { __typename?: 'Bid', id: any, order?: CartFragmentFragment_Cart_items_CartItem_bid_Bid_order_Order | null };

export type CartFragmentFragment_Cart_items_CartItem_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_items_CartItem = { __typename?: 'CartItem', id: any, external_delivery?: boolean | null, external_delivery_available?: boolean | null, service_type?: ServiceType | null, delivery_method?: DeliveryMethod | null, shipping?: CartFragmentFragment_Cart_items_CartItem_shipping_Price | null, shippingCost?: CartFragmentFragment_Cart_items_CartItem_shippingCost_Price | null, externalShippingCost?: CartFragmentFragment_Cart_items_CartItem_externalShippingCost_Price | null, shippingOptions: Array<CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption>, available_services: Array<CartFragmentFragment_Cart_items_CartItem_available_services_CartItemService>, product: CartFragmentFragment_Cart_items_CartItem_product_Product, bid?: CartFragmentFragment_Cart_items_CartItem_bid_Bid | null, total: CartFragmentFragment_Cart_items_CartItem_total_Price, subtotal: CartFragmentFragment_Cart_items_CartItem_subtotal_Price };

export type CartFragmentFragment_Cart_available_coupon_codes_CouponCode_discount_CouponCodeDiscount = { __typename?: 'CouponCodeDiscount', type: DiscountType, value: number };

export type CartFragmentFragment_Cart_available_coupon_codes_CouponCode = { __typename?: 'CouponCode', code: string, valid_upto?: any | null, discount: CartFragmentFragment_Cart_available_coupon_codes_CouponCode_discount_CouponCodeDiscount };

export type CartFragmentFragment_Cart_totals2_CartTotals_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_convertedTotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_serviceCost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_shipping_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_discount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_service_Service = { __typename?: 'Service', id: any, name: string };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices = { __typename?: 'CartTotalsServices', service: CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_service_Service, price: CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices_price_Price };

export type CartFragmentFragment_Cart_totals2_CartTotals = { __typename?: 'CartTotals', total?: CartFragmentFragment_Cart_totals2_CartTotals_total_Price | null, convertedTotal?: CartFragmentFragment_Cart_totals2_CartTotals_convertedTotal_Price | null, subtotal?: CartFragmentFragment_Cart_totals2_CartTotals_subtotal_Price | null, serviceCost?: CartFragmentFragment_Cart_totals2_CartTotals_serviceCost_Price | null, shipping?: CartFragmentFragment_Cart_totals2_CartTotals_shipping_Price | null, discount?: CartFragmentFragment_Cart_totals2_CartTotals_discount_Price | null, services: Array<CartFragmentFragment_Cart_totals2_CartTotals_services_CartTotalsServices> };

export type CartFragmentFragment = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, billing_address?: CartFragmentFragment_Cart_billing_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type CartProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_address_Address = { __typename?: 'Address', city: string, country: string };

export type CartProductFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string };

export type CartProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string };

export type CartProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: CartProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type CartProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type CartProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null };

export type CartProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CartProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, start_date?: any | null, buy_now_price?: CartProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type CartProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type CartProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type CartProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type CartProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type CartProductFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type CartProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type CartProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type CartProductFragmentFragment_Product_attributes = CartProductFragmentFragment_Product_attributes_AdditionalInfo | CartProductFragmentFragment_Product_attributes_Artist | CartProductFragmentFragment_Product_attributes_Brand | CartProductFragmentFragment_Product_attributes_Color | CartProductFragmentFragment_Product_attributes_Designer | CartProductFragmentFragment_Product_attributes_HardwareColor | CartProductFragmentFragment_Product_attributes_Label | CartProductFragmentFragment_Product_attributes_Material | CartProductFragmentFragment_Product_attributes_Style | CartProductFragmentFragment_Product_attributes_Subject | CartProductFragmentFragment_Product_attributes_UsageSign;

export type CartProductFragmentFragment_Product_merchant_Merchant_addresses_Address = { __typename?: 'Address', id: any, country: string };

export type CartProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, addresses: Array<CartProductFragmentFragment_Product_merchant_Merchant_addresses_Address> };

export type CartProductFragmentFragment = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, favorite_count: number, quality?: ProductQuality | null, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price_unconverted_Price | null };

export type DeliveryQuoteFragmentFragment = { __typename?: 'DeliveryQuote', id: any, status: DeliveryQuoteStatus, postalCode: string, region: string, city: string, deliveryType: DeliveryQuoteDeliveryType, requestedAt: any, validUntil?: any | null, fee?: DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price | null };

export type ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField_check_ListingFieldCheck = { __typename?: 'ListingFieldCheck', status: ListingFieldCheckStatus, message?: string | null, confirmed: boolean };

export type ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField = { __typename?: 'ListingGenerationField', key: ListingFieldKey, display?: string | null, value?: any | null, confidence?: number | null, note?: string | null, source: ListingFieldSource, check?: ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField_check_ListingFieldCheck | null };

export type ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint = { __typename?: 'KnownItemHint', maker?: string | null, model?: string | null, designer?: string | null, era?: string | null, country?: string | null, width?: number | null, height?: number | null, depth?: number | null, seatHeight?: number | null, dimensionsVary: boolean };

export type ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_width_ListingDimensionRange = { __typename?: 'ListingDimensionRange', min: number, max: number };

export type ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_height_ListingDimensionRange = { __typename?: 'ListingDimensionRange', min: number, max: number };

export type ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_depth_ListingDimensionRange = { __typename?: 'ListingDimensionRange', min: number, max: number };

export type ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_seatHeight_ListingDimensionRange = { __typename?: 'ListingDimensionRange', min: number, max: number };

export type ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide = { __typename?: 'ListingDimensionGuide', depthRequired: boolean, seatHeightAsked: boolean, heightIsLength: boolean, width?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_width_ListingDimensionRange | null, height?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_height_ListingDimensionRange | null, depth?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_depth_ListingDimensionRange | null, seatHeight?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide_seatHeight_ListingDimensionRange | null };

export type ListingGenerationFragmentFragment = { __typename?: 'ListingGeneration', status: ListingGenerationStatus, model?: string | null, durationMs?: number | null, failureReason?: string | null, generatedAt: any, runs: number, missing: Array<ListingFieldKey>, applicableKeys: Array<ListingFieldKey>, fields: Array<ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField>, knownItem?: ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint | null, dimensionGuide?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide | null };

export type MerchantTradeDiscountFieldsFragment = { __typename?: 'MerchantTradeDiscount', enabled: boolean, pct?: number | null, updatedAt?: any | null, activeListingCount: number };

export type PackageCartFragmentFragment_PackageCart_convertedTotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout = { __typename?: 'PackageCheckout', id: string, status: PackageCheckoutStatus };

export type PackageCartFragmentFragment_PackageCart_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack_boostPrice_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack = { __typename?: 'PromotionQuotePack', boostDays: number, boostPrice: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack_boostPrice_PromotionMoney };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_tax_PromotionTax = { __typename?: 'PromotionTax', netAmount: number, taxAmount: number, vatBasisPoints: number, reverseCharge: boolean };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney_converted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string, converted?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney_converted_Price | null };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate_listPrice_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate = { __typename?: 'PromotionBenefitTemplate', effect: PromotionEffect, durationDays: number, listPrice: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate_listPrice_PromotionMoney };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney_converted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string, converted?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney_converted_Price | null };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_separatePrice_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer = { __typename?: 'PromotionOffer', code: string, title: string, durationDays: number, effects: Array<PromotionEffect>, catalogueVersion: number, eligible: boolean, reason?: string | null, benefits: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate>, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney, separatePrice?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_separatePrice_PromotionMoney | null };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote = { __typename?: 'PromotionQuote', id: string, expiresAt: any, purchaseContext: PromotionPurchaseContext, termsVersion: string, label?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_label_PromotionLabel | null, pack?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack | null, tax: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_tax_PromotionTax, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney, offer: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_auction_Auction_buy_now_price_Price | null };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_image_Image | null, auction?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product_auction_Auction | null };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage_originalPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage_discountedPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_DynamicListingFeePackage_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage = { __typename: 'BoostPackage', id: any, days: number, originalPrice: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage_originalPrice_Price, discountedPrice: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage_discountedPrice_Price };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_DynamicListingFeePackage = { __typename: 'DynamicListingFeePackage', id: any, identifier: string, title: string, isPopular: boolean, reducedFeeAmount: number, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_DynamicListingFeePackage_price_Price };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_PromotionOffer = { __typename: 'PromotionOffer', code: string, title: string, durationDays: number };

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package = PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_BoostPackage | PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_DynamicListingFeePackage | PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package_PromotionOffer;

export type PackageCartFragmentFragment_PackageCart_items_PackageCartItem = { __typename?: 'PackageCartItem', id: string, kind: PackageKind, promotionQuote?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote | null, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_price_Price, product: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_product_Product, package: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_package };

export type PackageCartFragmentFragment = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type PackageCheckoutDetailsFragment_PackageCheckout_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCheckoutDetailsFragment_PackageCheckout_convertedTotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCheckoutDetailsFragment_PackageCheckout_campaigns_PromotionCampaign = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, status: PromotionStatus, paymentStatus: PromotionPaymentStatus };

export type PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_product_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_product_Product_image_Image | null };

export type PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_promotionQuote_PromotionQuote = { __typename?: 'PromotionQuote', id: string, expiresAt: any, purchaseContext: PromotionPurchaseContext, termsVersion: string, label?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_label_PromotionLabel | null, pack?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack | null, tax: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_tax_PromotionTax, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney, offer: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer };

export type PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem = { __typename?: 'PackageCheckoutItem', orderId: string, title: string, kind: PackageKind, price: PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_price_Price, product: PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_product_Product, promotionQuote?: PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem_promotionQuote_PromotionQuote | null };

export type PackageCheckoutDetailsFragment = { __typename?: 'PackageCheckout', id: string, orderGroupId: string, status: PackageCheckoutStatus, paymentIntentClientSecret?: string | null, total: PackageCheckoutDetailsFragment_PackageCheckout_total_Price, convertedTotal?: PackageCheckoutDetailsFragment_PackageCheckout_convertedTotal_Price | null, campaigns: Array<PackageCheckoutDetailsFragment_PackageCheckout_campaigns_PromotionCampaign>, items: Array<PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem> };

export type PostalShipmentFragmentFragment_PostalShipment_selectedServicePoint_ServicePoint = { __typename?: 'ServicePoint', id: string, name: string, carrierName: string, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, country: string };

export type PostalShipmentFragmentFragment = { __typename?: 'PostalShipment', id: any, provider: ShippingProviderEnum, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: PostalShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null, selectedServicePoint?: PostalShipmentFragmentFragment_PostalShipment_selectedServicePoint_ServicePoint | null };

export type PriceDropScheduleFieldsFragment_PriceDropSchedule_basePrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceDropScheduleFieldsFragment_PriceDropSchedule_floor_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceDropScheduleFieldsFragment_PriceDropSchedule_lowestPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep = { __typename?: 'PriceDropStep', at: any, price: PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep_price_Price };

export type PriceDropScheduleFieldsFragment = { __typename?: 'PriceDropSchedule', pace: PriceDropPace, stepPercent: number, pausedReason?: PriceDropPause | null, basePrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_basePrice_Price, floor: PriceDropScheduleFieldsFragment_PriceDropSchedule_floor_Price, lowestPrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_lowestPrice_Price, upcoming: Array<PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep> };

export type PrivateProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_image_Image = { __typename?: 'Image', url: string, id: any };

export type PrivateProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type PrivateProductFragmentFragment_Product_activeBoost_ProductBoost = { __typename?: 'ProductBoost', id: any, status: ProductBoostStatus, activatedAt?: any | null, created: any, lastPushedAt?: any | null, totalPushes: number, remainingPushes: number };

export type PrivateProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type PrivateProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_highest_bid_Bid_amount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_auction_Auction_highest_bid_Bid = { __typename?: 'Bid', id: any, state: BidState, amount: PrivateProductFragmentFragment_Product_auction_Auction_highest_bid_Bid_amount_Price };

export type PrivateProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, bid_count: number, allow_buy_now: boolean, allow_bid: boolean, expiry_date?: any | null, start_date?: any | null, end_date?: any | null, buy_now_price?: PrivateProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null, minimum_bid?: PrivateProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PrivateProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, highest_bid?: PrivateProductFragmentFragment_Product_auction_Auction_highest_bid_Bid | null };

export type PrivateProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice = { __typename?: 'CustomShippingPrice', country: Country, price: PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice_price_Price };

export type PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, enum: ShippingMethodEnum, price: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type PrivateProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type PrivateProductFragmentFragment_Product_merchant_Merchant_fee_Fee = { __typename?: 'Fee', amount: number };

export type PrivateProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, created: any, image?: PrivateProductFragmentFragment_Product_merchant_Merchant_image_Image | null, fee?: PrivateProductFragmentFragment_Product_merchant_Merchant_fee_Fee | null };

export type PrivateProductFragmentFragment_Product_merchant_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type PrivateProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PrivateProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type PrivateProductFragmentFragment_Product_breadcrumbs_Category = { __typename?: 'Category', id: any, slug: string, title: string };

export type PrivateProductFragmentFragment_Product_brand_Brand = { __typename?: 'Brand', id: any, slug: string, title: string };

export type PrivateProductFragmentFragment_Product_hardware_color_HardwareColor = { __typename?: 'HardwareColor', id: any };

export type PrivateProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, hex?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type PrivateProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PrivateProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PrivateProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PrivateProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject' };

export type PrivateProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string };

export type PrivateProductFragmentFragment_Product_attributes = PrivateProductFragmentFragment_Product_attributes_AdditionalInfo | PrivateProductFragmentFragment_Product_attributes_Artist | PrivateProductFragmentFragment_Product_attributes_Brand | PrivateProductFragmentFragment_Product_attributes_Color | PrivateProductFragmentFragment_Product_attributes_Designer | PrivateProductFragmentFragment_Product_attributes_HardwareColor | PrivateProductFragmentFragment_Product_attributes_Label | PrivateProductFragmentFragment_Product_attributes_Material | PrivateProductFragmentFragment_Product_attributes_Style | PrivateProductFragmentFragment_Product_attributes_Subject | PrivateProductFragmentFragment_Product_attributes_UsageSign;

export type PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback = { __typename?: 'CurationFeedback', message: string, severity: CurationFeedbackSeverity };

export type PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee_package_ListingFeePackage = { __typename?: 'ListingFeePackage', id: any, identifier: string, title: string };

export type PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee = { __typename?: 'ProductListingFee', id: any, feeAmount: number, package: PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee_package_ListingFeePackage };

export type PrivateProductFragmentFragment = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, favorite_count: number, quality?: ProductQuality | null, auto_discount?: boolean | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, number_of_items?: number | null, shape?: Shape | null, created?: any | null, curated_at?: any | null, condition: ProductCondition, isBoostable?: boolean | null, isBoosted?: boolean | null, boostStatus?: BoostStatus | null, lastBoosted?: any | null, boostEndsAt?: any | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, link: string, delivery_method: DeliveryMethod, bag_model?: string | null, gender?: Gender | null, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, year_of_purchase?: number | null, usage_signs_description?: string | null, showroomModel: boolean, note_for_curator?: string | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postalPackageSize?: PostalPackageSize | null, postal_package_weight_kg?: number | null, buy_now_price?: PrivateProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductFragmentFragment_Product_original_price_Price | null, newPrice?: PrivateProductFragmentFragment_Product_newPrice_Price | null, image?: PrivateProductFragmentFragment_Product_image_Image | null, images: Array<PrivateProductFragmentFragment_Product_images_Image>, activeBoost?: PrivateProductFragmentFragment_Product_activeBoost_ProductBoost | null, address?: PrivateProductFragmentFragment_Product_address_Address | null, auction?: PrivateProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: PrivateProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: PrivateProductFragmentFragment_Product_merchant_Merchant, merchant_fee?: PrivateProductFragmentFragment_Product_merchant_fee_Fee | null, favorite?: PrivateProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PrivateProductFragmentFragment_Product_categories_Category>, breadcrumbs: Array<PrivateProductFragmentFragment_Product_breadcrumbs_Category>, brand?: PrivateProductFragmentFragment_Product_brand_Brand | null, hardware_color?: PrivateProductFragmentFragment_Product_hardware_color_HardwareColor | null, attributes: Array<PrivateProductFragmentFragment_Product_attributes>, curation_feedback?: PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback | null, activeListingFee?: PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee | null };

export type PrivateProductOverviewFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PrivateProductOverviewFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string, x_small_url: string };

export type PrivateProductOverviewFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, x_small_url: string };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, allow_buy_now: boolean, state: AuctionState, minimum_bid?: PrivateProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, buy_now_price?: PrivateProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PrivateProductOverviewFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type PrivateProductOverviewFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PrivateProductOverviewFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', title: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Color = { __typename?: 'Color' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Label = { __typename?: 'Label', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type PrivateProductOverviewFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject' };

export type PrivateProductOverviewFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type PrivateProductOverviewFragmentFragment_Product_attributes = PrivateProductOverviewFragmentFragment_Product_attributes_AdditionalInfo | PrivateProductOverviewFragmentFragment_Product_attributes_Artist | PrivateProductOverviewFragmentFragment_Product_attributes_Brand | PrivateProductOverviewFragmentFragment_Product_attributes_Color | PrivateProductOverviewFragmentFragment_Product_attributes_Designer | PrivateProductOverviewFragmentFragment_Product_attributes_HardwareColor | PrivateProductOverviewFragmentFragment_Product_attributes_Label | PrivateProductOverviewFragmentFragment_Product_attributes_Material | PrivateProductOverviewFragmentFragment_Product_attributes_Style | PrivateProductOverviewFragmentFragment_Product_attributes_Subject | PrivateProductOverviewFragmentFragment_Product_attributes_UsageSign;

export type PrivateProductOverviewFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string };

export type PrivateProductOverviewFragmentFragment = { __typename?: 'Product', id: any, title: string, slug: string, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PrivateProductOverviewFragmentFragment_Product_favorite_Favorite | null, image?: PrivateProductOverviewFragmentFragment_Product_image_Image | null, images: Array<PrivateProductOverviewFragmentFragment_Product_images_Image>, auction?: PrivateProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PrivateProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PrivateProductOverviewFragmentFragment_Product_attributes>, categories: Array<PrivateProductOverviewFragmentFragment_Product_categories_Category> };

export type ProBuyerBoardProductFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type ProBuyerBoardProductFragment_Product_image_Image = { __typename?: 'Image', id: any, thumbnail_url: string, large_url: string };

export type ProBuyerBoardProductFragment = { __typename?: 'Product', id: any, title: string, slug: string, quality?: ProductQuality | null, width?: number | null, height?: number | null, depth?: number | null, favorite?: ProBuyerBoardProductFragment_Product_favorite_Favorite | null, image?: ProBuyerBoardProductFragment_Product_image_Image | null };

export type ProBuyerBrandProfileFieldsFragment = { __typename?: 'ProBuyerBrandProfile', brandName: string, logo?: string | null, accentColor: string, fontStyle: ProBuyerProposalFontStyle, legalName: string, addressLine: string, postalCode: string, city: string, country: string, email: string, phone: string, website: string, cocNumber: string, vatNumber: string, saved: boolean };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_priceAtSave_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_regularPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice = { __typename?: 'ProBuyerPrice', pct: number, price: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice_price_Price };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_purchase_ProBuyerProjectItemPurchase = { __typename?: 'ProBuyerProjectItemPurchase', orderId: any, orderGroupId?: any | null, state: OrderState };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_clientReactions_ProBuyerClientReactions = { __typename?: 'ProBuyerClientReactions', yes: number, no: number, lastReactedAt?: any | null };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_room_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_otherProjects_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, quality?: ProductQuality | null, width?: number | null, height?: number | null, depth?: number | null, favorite?: ProBuyerBoardProductFragment_Product_favorite_Favorite | null, image?: ProBuyerBoardProductFragment_Product_image_Image | null };

export type ProBuyerProjectItemFieldsFragment = { __typename?: 'ProBuyerProjectItem', id: any, note: string, status: ProBuyerProjectItemStatus, createdAt: any, position: number, onMoodboard: boolean, reservationExpiresAt?: any | null, reservationRequested: boolean, priceAtSave?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_priceAtSave_Price | null, regularPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_regularPrice_Price | null, proBuyerPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice | null, purchase?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_purchase_ProBuyerProjectItemPurchase | null, clientReactions: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_clientReactions_ProBuyerClientReactions, room?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_room_ProBuyerProjectRoom | null, otherProjects: Array<ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_otherProjects_ProBuyerProjectRef>, product: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_product_Product };

export type ProBuyerProjectOrderFragment_Order_product_Product_image_Image = { __typename?: 'Image', id: any, thumbnail_url: string };

export type ProBuyerProjectOrderFragment_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: ProBuyerProjectOrderFragment_Order_product_Product_image_Image | null };

export type ProBuyerProjectOrderFragment = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, currency: Currency, subtotal_incl_vat: number, product: ProBuyerProjectOrderFragment_Order_product_Product };

export type ProBuyerProjectProposalFieldsFragment = { __typename?: 'ProBuyerProjectProposal', title: string, clientName: string, intro: string, validUntil?: any | null, roomIds: Array<any>, includeUnassigned: boolean, showNotes: boolean, showDimensions: boolean, showTotals: boolean, hideUnavailable: boolean, pdfUrl: string, updatedAt?: any | null };

export type ProBuyerProjectReservationFragment_BuyerReservation_fixedPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectReservationFragment = { __typename?: 'BuyerReservation', id: any, status: ReservationStatus, requestExpiresAt: any, reservedUntil?: any | null, productId: any, productTitle: string, productSlug: string, productImage?: string | null, fixedPrice?: ProBuyerProjectReservationFragment_BuyerReservation_fixedPrice_Price | null };

export type ProBuyerProjectRoomFieldsFragment = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerProjectShareFieldsFragment = { __typename?: 'ProBuyerProjectShare', enabled: boolean, token?: string | null, message: string, showPrices: boolean, showNotes: boolean, allowReactions: boolean, updatedAt?: any | null };

export type ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_proBuyerSpent_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal = { __typename?: 'ProBuyerProjectTotal', purchaseCount: number, spent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price, proBuyerSpent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_proBuyerSpent_Price, saved: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price };

export type ProBuyerProjectSummaryFragment = { __typename?: 'ProBuyerProject', id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type ProBuyerProjectTotalsFragment = { __typename?: 'ProBuyerProjectTotal', purchaseCount: number, spent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price, proBuyerSpent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_proBuyerSpent_Price, saved: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price };

export type ProBuyerWorkspaceProjectFragment = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type ProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_brand_Brand = { __typename?: 'Brand', id: any };

export type ProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null, position: number, background_color?: string | null, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type ProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, minimum_bid?: ProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: ProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: ProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type ProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice = { __typename?: 'CustomShippingPrice', country: Country, price: ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice_price_Price };

export type ProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: ProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type ProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type ProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, created: any, image?: ProductFragmentFragment_Product_merchant_Merchant_image_Image | null };

export type ProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type ProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', id: any, slug: string };

export type ProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type ProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type ProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type ProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type ProductFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type ProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type ProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type ProductFragmentFragment_Product_attributes = ProductFragmentFragment_Product_attributes_AdditionalInfo | ProductFragmentFragment_Product_attributes_Artist | ProductFragmentFragment_Product_attributes_Brand | ProductFragmentFragment_Product_attributes_Color | ProductFragmentFragment_Product_attributes_Designer | ProductFragmentFragment_Product_attributes_HardwareColor | ProductFragmentFragment_Product_attributes_Label | ProductFragmentFragment_Product_attributes_Material | ProductFragmentFragment_Product_attributes_Style | ProductFragmentFragment_Product_attributes_Subject | ProductFragmentFragment_Product_attributes_UsageSign;

export type ProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string, platform: ArPlatform };

export type ProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string, platform: ArPlatform };

export type ProductFragmentFragment_Product_product_type_ProductType = { __typename?: 'ProductType', android_arobject?: ProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject | null, ios_arobject?: ProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, auto_discount?: boolean | null, favorite_count: number, showroomModel: boolean, quality?: ProductQuality | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, shape?: Shape | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type ImageFragmentFragment = { __typename?: 'Image', id: any, url: string, position: number, width?: number | null, height?: number | null };

export type PublicProductFragmentFragment_Product_newPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_buy_now_price_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductFragmentFragment_Product_buy_now_price_Price_unconverted_Price | null };

export type PublicProductFragmentFragment_Product_activeBoost_ProductBoost = { __typename?: 'ProductBoost', id: any, status: ProductBoostStatus, remainingPushes: number };

export type PublicProductFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject = { __typename?: 'ARObject', id: any, url: string };

export type PublicProductFragmentFragment_Product_product_type_ProductType = { __typename?: 'ProductType', android_arobject?: PublicProductFragmentFragment_Product_product_type_ProductType_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_product_type_ProductType_ios_arobject_ARObject | null };

export type PublicProductFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, url: string, position: number, width?: number | null, height?: number | null };

export type PublicProductFragmentFragment_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price_unconverted_Price | null };

export type PublicProductFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, created?: any | null, updated?: any | null, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, coming_soon_time?: any | null, minimum_bid?: PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert = { __typename?: 'ComingSoonAlert', id: any, created: any };

export type PublicProductFragmentFragment_Product_custom_shipping_cost_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PublicProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, price: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod_price_Price };

export type PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod = { __typename?: 'ExternalShippingMethod', title: string, price: PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod_price_Price };

export type PublicProductFragmentFragment_Product_merchant_Merchant_image_Image = { __typename?: 'Image', url: string, id: any };

export type PublicProductFragmentFragment_Product_merchant_Merchant_avatar_image_Image = { __typename?: 'Image', url: string, id: any };

export type PublicProductFragmentFragment_Product_merchant_Merchant_addresses_Address = { __typename?: 'Address', id: any, country: string };

export type PublicProductFragmentFragment_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, business_name?: string | null, expert_seller?: boolean | null, rating?: number | null, reviewsCount?: number | null, number_of_ads?: number | null, number_of_sells?: number | null, created: any, type: MerchantType, vacationModeEnabledAt?: any | null, disableContactSeller: boolean, image?: PublicProductFragmentFragment_Product_merchant_Merchant_image_Image | null, avatar_image?: PublicProductFragmentFragment_Product_merchant_Merchant_avatar_image_Image | null, addresses: Array<PublicProductFragmentFragment_Product_merchant_Merchant_addresses_Address> };

export type PublicProductFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PublicProductFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null, title: string };

export type PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice = { __typename?: 'ShippingMethodCountryPrice', country: string, price: PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice_price_Price };

export type PublicProductFragmentFragment_Product_hardware_color_HardwareColor = { __typename?: 'HardwareColor', id: any, title: string };

export type PublicProductFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PublicProductFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type PublicProductFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type PublicProductFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PublicProductFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type PublicProductFragmentFragment_Product_attributes = PublicProductFragmentFragment_Product_attributes_AdditionalInfo | PublicProductFragmentFragment_Product_attributes_Artist | PublicProductFragmentFragment_Product_attributes_Brand | PublicProductFragmentFragment_Product_attributes_Color | PublicProductFragmentFragment_Product_attributes_Designer | PublicProductFragmentFragment_Product_attributes_HardwareColor | PublicProductFragmentFragment_Product_attributes_Label | PublicProductFragmentFragment_Product_attributes_Material | PublicProductFragmentFragment_Product_attributes_Style | PublicProductFragmentFragment_Product_attributes_Subject | PublicProductFragmentFragment_Product_attributes_UsageSign;

export type PublicProductFragmentFragment = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, description?: string | null, usage_signs_description?: string | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, cleaningServiceAvailable: boolean, favorite_count: number, isOwner?: boolean | null, isDesignerItem?: boolean | null, showroomModel: boolean, quality?: ProductQuality | null, two_man_delivery?: boolean | null, ground_floor_only_delivery?: boolean | null, created?: any | null, updated?: any | null, brand_suggestion?: string | null, last_boost?: any | null, isBoosted?: boolean | null, isBoostable?: boolean | null, isCurated: boolean, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, gender?: Gender | null, bag_model?: string | null, year_of_purchase?: number | null, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, slug_es: string, slug_it: string, original_title: string, original_description?: string | null, original_usage_signs_description?: string | null, newPrice?: PublicProductFragmentFragment_Product_newPrice_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_buy_now_price_Price | null, activeBoost?: PublicProductFragmentFragment_Product_activeBoost_ProductBoost | null, original_price?: PublicProductFragmentFragment_Product_original_price_Price | null, android_arobject?: PublicProductFragmentFragment_Product_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_ios_arobject_ARObject | null, product_type?: PublicProductFragmentFragment_Product_product_type_ProductType | null, images: Array<PublicProductFragmentFragment_Product_images_Image>, address?: PublicProductFragmentFragment_Product_address_Address | null, auction?: PublicProductFragmentFragment_Product_auction_Auction | null, coming_soon_alert?: PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert | null, custom_shipping_cost?: PublicProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod | null, externalShippingMethods: Array<PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod>, merchant: PublicProductFragmentFragment_Product_merchant_Merchant, favorite?: PublicProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PublicProductFragmentFragment_Product_categories_Category>, shipping_method_prices: Array<PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice>, hardware_color?: PublicProductFragmentFragment_Product_hardware_color_HardwareColor | null, attributes: Array<PublicProductFragmentFragment_Product_attributes> };

export type ImageOverviewFragmentFragment = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PublicProductOverviewFragmentFragment_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type PublicProductOverviewFragmentFragment_Product_images_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price_unconverted_Price | null };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price_unconverted_Price | null };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price_unconverted_Price | null };

export type PublicProductOverviewFragmentFragment_Product_auction_Auction = { __typename?: 'Auction', id: any, allow_bid: boolean, allow_buy_now: boolean, state: AuctionState, sold_at?: PublicProductOverviewFragmentFragment_Product_auction_Auction_sold_at_Price | null, minimum_bid?: PublicProductOverviewFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type PublicProductOverviewFragmentFragment_Product_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type PublicProductOverviewFragmentFragment_Product_original_price_Price_unconverted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PublicProductOverviewFragmentFragment_Product_original_price_Price = { __typename?: 'Price', amount: number, currency: Currency, unconverted?: PublicProductOverviewFragmentFragment_Product_original_price_Price_unconverted_Price | null };

export type PublicProductOverviewFragmentFragment_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Artist = { __typename?: 'Artist', id: any, title: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Brand = { __typename?: 'Brand', id: any, title: string, description?: string | null, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Color = { __typename?: 'Color', id: any, title: string, slug: string, hex?: string | null };

export type PublicProductOverviewFragmentFragment_Product_attributes_Designer = { __typename?: 'Designer', id: any, title: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type PublicProductOverviewFragmentFragment_Product_attributes_Label = { __typename?: 'Label', id: any, title: string, slug: string, color?: string | null };

export type PublicProductOverviewFragmentFragment_Product_attributes_Material = { __typename?: 'Material', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Style = { __typename?: 'Style', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_Subject = { __typename?: 'Subject', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes_UsageSign = { __typename?: 'UsageSign', id: any, title: string, slug: string };

export type PublicProductOverviewFragmentFragment_Product_attributes = PublicProductOverviewFragmentFragment_Product_attributes_AdditionalInfo | PublicProductOverviewFragmentFragment_Product_attributes_Artist | PublicProductOverviewFragmentFragment_Product_attributes_Brand | PublicProductOverviewFragmentFragment_Product_attributes_Color | PublicProductOverviewFragmentFragment_Product_attributes_Designer | PublicProductOverviewFragmentFragment_Product_attributes_HardwareColor | PublicProductOverviewFragmentFragment_Product_attributes_Label | PublicProductOverviewFragmentFragment_Product_attributes_Material | PublicProductOverviewFragmentFragment_Product_attributes_Style | PublicProductOverviewFragmentFragment_Product_attributes_Subject | PublicProductOverviewFragmentFragment_Product_attributes_UsageSign;

export type PublicProductOverviewFragmentFragment_Product_categories_Category = { __typename?: 'Category', slug: string, route?: string | null, level?: number | null };

export type PublicProductOverviewFragmentFragment = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type ShippingOptionFragmentFragment = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant_image_Image = { __typename?: 'Image', url: string };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant = { __typename?: 'Merchant', id: any, email?: string | null, type: MerchantType, expert_seller?: boolean | null, name: string, image?: ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant_image_Image | null };

export type ListThreadFragmentFragment_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', merchant: ListThreadFragmentFragment_Thread_subscribers_Subscriber_merchant_Merchant };

export type ListThreadFragmentFragment_Thread_item_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState };

export type ListThreadFragmentFragment_Thread_item_Product_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type ListThreadFragmentFragment_Thread_item_Product_merchant_Merchant = { __typename?: 'Merchant', id: any };

export type ListThreadFragmentFragment_Thread_item_Merchant = { __typename?: 'Merchant' };

export type ListThreadFragmentFragment_Thread_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, openHome: boolean, auction?: ListThreadFragmentFragment_Thread_item_Product_auction_Auction | null, image?: ListThreadFragmentFragment_Thread_item_Product_image_Image | null, merchant: ListThreadFragmentFragment_Thread_item_Product_merchant_Merchant };

export type ListThreadFragmentFragment_Thread_item = ListThreadFragmentFragment_Thread_item_Merchant | ListThreadFragmentFragment_Thread_item_Product;

export type ListThreadFragmentFragment = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type MessageFragment_Message_rejectionReason_MessageRejectionReason = { __typename?: 'MessageRejectionReason', title: string, description: string, showChatRules: boolean };

export type MessageFragment_Message_sender_Member = { __typename?: 'Member', id: any, email: string };

export type MessageFragment_Message_merchant_Merchant = { __typename?: 'Merchant', id: any };

export type MessageFragment_Message_item_Bid_amount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MessageFragment_Message_item_Bid_displayAmount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MessageFragment_Message_item_Bid_order_Order = { __typename?: 'Order', orderState: OrderState };

export type MessageFragment_Message_item_Order_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', slug: string };

export type MessageFragment_Message_item_Order_address_OrderAddress = { __typename?: 'OrderAddress', name: string, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type MessageFragment_Message_item_Order_postalShipment_PostalShipment = { __typename?: 'PostalShipment', id: any, provider: ShippingProviderEnum, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: PostalShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null, selectedServicePoint?: PostalShipmentFragmentFragment_PostalShipment_selectedServicePoint_ServicePoint | null };

export type MessageFragment_Message_item_Order_product_Product_auction_Auction = { __typename?: 'Auction', state: AuctionState };

export type MessageFragment_Message_item_Order_product_Product = { __typename?: 'Product', id: any, state: ProductState, auction?: MessageFragment_Message_item_Order_product_Product_auction_Auction | null };

export type MessageFragment_Message_item_Audio = { __typename?: 'Audio' };

export type MessageFragment_Message_item_Bid = { __typename?: 'Bid', id: any, state: BidState, is_counter: boolean, buyerId: any, canceledFromState?: BidCanceledFromState | null, amount: MessageFragment_Message_item_Bid_amount_Price, displayAmount: MessageFragment_Message_item_Bid_displayAmount_Price, order?: MessageFragment_Message_item_Bid_order_Order | null };

export type MessageFragment_Message_item_Document = { __typename?: 'Document' };

export type MessageFragment_Message_item_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type MessageFragment_Message_item_Order = { __typename?: 'Order', id: any, delivery_method: DeliveryMethod, currency: Currency, total_incl_vat: number, discount_incl_vat: number, fee_incl_vat: number, shipping_incl_vat: number, subtotal_incl_vat: number, payout: number, created?: any | null, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, orderState: OrderState, externalDelivery?: boolean | null, shipping_method?: MessageFragment_Message_item_Order_shipping_method_ShippingMethod | null, address?: MessageFragment_Message_item_Order_address_OrderAddress | null, postalShipment?: MessageFragment_Message_item_Order_postalShipment_PostalShipment | null, product: MessageFragment_Message_item_Order_product_Product };

export type MessageFragment_Message_item_Product = { __typename?: 'Product' };

export type MessageFragment_Message_item_Shipment = { __typename?: 'Shipment' };

export type MessageFragment_Message_item_Video = { __typename?: 'Video' };

export type MessageFragment_Message_item = MessageFragment_Message_item_Audio | MessageFragment_Message_item_Bid | MessageFragment_Message_item_Document | MessageFragment_Message_item_Image | MessageFragment_Message_item_Order | MessageFragment_Message_item_Product | MessageFragment_Message_item_Shipment | MessageFragment_Message_item_Video;

export type MessageFragment = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, status?: MessageStatus | null, originalBody?: string | null, rejectionReason?: MessageFragment_Message_rejectionReason_MessageRejectionReason | null, sender: MessageFragment_Message_sender_Member, merchant: MessageFragment_Message_merchant_Merchant, item?: MessageFragment_Message_item | null };

export type HelpArticleListItemFieldsFragment = { __typename?: 'HelpArticleListItem', id: string, title: string, slug: string, summary: string, excerpt: string, readingTimeMinutes: number, categorySlug?: string | null };

export type HelpCategoryNodeFragment = { __typename?: 'HelpCategory', id: string, title: string, slug: string, order: number, articleCount: number, description?: string | null };

export type PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack_boostPrice_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack = { __typename?: 'PromotionQuotePack', boostDays: number, boostPrice: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack_boostPrice_PromotionMoney };

export type PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit = { __typename?: 'PromotionCampaignBenefit', effect: PromotionEffect, durationDays: number, status: PromotionStatus, statusReason?: string | null, startsAt?: any | null, endsAt?: any | null, label?: PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit_label_PromotionLabel | null };

export type PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics_daily_PromotionDailyMetrics = { __typename?: 'PromotionDailyMetrics', date: string, impressions: number, clicks: number };

export type PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics_placements_PromotionPlacementMetrics = { __typename?: 'PromotionPlacementMetrics', placement: string, impressions: number, clicks: number };

export type PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics = { __typename?: 'PromotionMetrics', impressions: number, clicks: number, clickThroughRate?: number | null, updatedAt: any, placementBreakdownComplete: boolean, daily: Array<PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics_daily_PromotionDailyMetrics>, placements: Array<PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics_placements_PromotionPlacementMetrics> };

export type PromotionCampaignDetailsFragment = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, effects: Array<PromotionEffect>, catalogueVersion: number, status: PromotionStatus, paymentStatus: PromotionPaymentStatus, startsAt?: any | null, endsAt?: any | null, paidAt?: any | null, statusReason?: string | null, canResumeCheckout: boolean, canWithdraw: boolean, pack?: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack | null, benefits: Array<PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit>, price?: PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney | null, metrics?: PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics | null };

export type PromotionOfferDetailsFragment = { __typename?: 'PromotionOffer', code: string, title: string, durationDays: number, effects: Array<PromotionEffect>, catalogueVersion: number, eligible: boolean, reason?: string | null, benefits: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate>, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney, separatePrice?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_separatePrice_PromotionMoney | null };

export type PromotionQuoteDetailsFragment = { __typename?: 'PromotionQuote', id: string, expiresAt: any, purchaseContext: PromotionPurchaseContext, termsVersion: string, label?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_label_PromotionLabel | null, pack?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack | null, tax: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_tax_PromotionTax, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney, offer: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer };

export type AcceptTosMutation_acceptTos_Merchant = { __typename?: 'Merchant', id: any, pendingActions: Array<PendingAction> };

export type AcceptTosMutation_Mutation = { __typename?: 'Mutation', acceptTos: AcceptTosMutation_acceptTos_Merchant };


export type AcceptTosMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTosMutation = AcceptTosMutation_Mutation;

export type AddProductToCartMutation_addProductToCart_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, favorite_count: number, quality?: ProductQuality | null, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type AddProductToCartMutation_addProductToCart_Cart_items_CartItem = { __typename?: 'CartItem', id: any, product: AddProductToCartMutation_addProductToCart_Cart_items_CartItem_product_Product };

export type AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals = { __typename?: 'CartTotals', subtotal?: AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals_subtotal_Price | null };

export type AddProductToCartMutation_addProductToCart_Cart = { __typename?: 'Cart', id: any, items: Array<AddProductToCartMutation_addProductToCart_Cart_items_CartItem>, totals2?: AddProductToCartMutation_addProductToCart_Cart_totals2_CartTotals | null };

export type AddProductToCartMutation_Mutation = { __typename?: 'Mutation', addProductToCart: AddProductToCartMutation_addProductToCart_Cart };


export type AddProductToCartMutationVariables = Exact<{
  product_id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AddProductToCartMutation = AddProductToCartMutation_Mutation;

export type AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, favorite_count: number, quality?: ProductQuality | null, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem = { __typename?: 'CartItem', product: AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem_product_Product };

export type AddProductsToCartMutation_addProductsToCart_Cart = { __typename?: 'Cart', id: any, items: Array<AddProductsToCartMutation_addProductsToCart_Cart_items_CartItem> };

export type AddProductsToCartMutation_Mutation = { __typename?: 'Mutation', addProductsToCart: AddProductsToCartMutation_addProductsToCart_Cart };


export type AddProductsToCartMutationVariables = Exact<{
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AddProductsToCartMutation = AddProductsToCartMutation_Mutation;

export type AddReferralCodeMutation_addReferralCode_AddReferralCodeResult = { __typename?: 'AddReferralCodeResult', success: boolean };

export type AddReferralCodeMutation_Mutation = { __typename?: 'Mutation', addReferralCode: AddReferralCodeMutation_addReferralCode_AddReferralCodeResult };


export type AddReferralCodeMutationVariables = Exact<{
  referral_code: Scalars['String']['input'];
}>;


export type AddReferralCodeMutation = AddReferralCodeMutation_Mutation;

export type ApproveAgentAuthorizationMutation_approveAgentAuthorization_AgentAuthorizationDecision = { __typename?: 'AgentAuthorizationDecision', redirectUrl: string };

export type ApproveAgentAuthorizationMutation_Mutation = { __typename?: 'Mutation', approveAgentAuthorization: ApproveAgentAuthorizationMutation_approveAgentAuthorization_AgentAuthorizationDecision };


export type ApproveAgentAuthorizationMutationVariables = Exact<{
  input: AgentAuthorizationInput;
}>;


export type ApproveAgentAuthorizationMutation = ApproveAgentAuthorizationMutation_Mutation;

export type DenyAgentAuthorizationMutation_denyAgentAuthorization_AgentAuthorizationDecision = { __typename?: 'AgentAuthorizationDecision', redirectUrl: string };

export type DenyAgentAuthorizationMutation_Mutation = { __typename?: 'Mutation', denyAgentAuthorization: DenyAgentAuthorizationMutation_denyAgentAuthorization_AgentAuthorizationDecision };


export type DenyAgentAuthorizationMutationVariables = Exact<{
  input: AgentAuthorizationInput;
}>;


export type DenyAgentAuthorizationMutation = DenyAgentAuthorizationMutation_Mutation;

export type RevokeAgentGrantMutation_Mutation = { __typename?: 'Mutation', revokeAgentGrant: boolean };


export type RevokeAgentGrantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeAgentGrantMutation = RevokeAgentGrantMutation_Mutation;

export type AnalyzeProductImagesMutation_analyzeProductImages_AnalyzeProductImagesResult_results_ImageFeedback = { __typename?: 'ImageFeedback', id: any, status: ImageQualityStatus, reasons: Array<string> };

export type AnalyzeProductImagesMutation_analyzeProductImages_AnalyzeProductImagesResult = { __typename?: 'AnalyzeProductImagesResult', results: Array<AnalyzeProductImagesMutation_analyzeProductImages_AnalyzeProductImagesResult_results_ImageFeedback> };

export type AnalyzeProductImagesMutation_Mutation = { __typename?: 'Mutation', analyzeProductImages?: AnalyzeProductImagesMutation_analyzeProductImages_AnalyzeProductImagesResult | null };


export type AnalyzeProductImagesMutationVariables = Exact<{
  input: AnalyzeProductImagesInput;
}>;


export type AnalyzeProductImagesMutation = AnalyzeProductImagesMutation_Mutation;

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_category_Category = { __typename?: 'Category', id: any };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_brand_Brand = { __typename?: 'Brand', id: any };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_colors_Color = { __typename?: 'Color', id: any };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_materials_Material = { __typename?: 'Material', id: any };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_usageSigns_UsageSign = { __typename?: 'UsageSign', id: any };

export type AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult = { __typename?: 'AnalyzeProductTitleAndImagesResult', description?: string | null, brandSuggestion?: string | null, quality?: ProductQuality | null, category?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_category_Category | null, brand?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_brand_Brand | null, colors: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_colors_Color>, materials: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_materials_Material>, usageSigns: Array<AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult_usageSigns_UsageSign> };

export type AnalyzeMutation_Mutation = { __typename?: 'Mutation', analyzeProductTitleAndImages?: AnalyzeMutation_analyzeProductTitleAndImages_AnalyzeProductTitleAndImagesResult | null };


export type AnalyzeMutationVariables = Exact<{
  input: AnalyzeProductTitleAndImagesInput;
}>;


export type AnalyzeMutation = AnalyzeMutation_Mutation;

export type AskProductQuestionMutation_askProductQuestion_Thread = { __typename?: 'Thread', id: any };

export type AskProductQuestionMutation_Mutation = { __typename?: 'Mutation', askProductQuestion: AskProductQuestionMutation_askProductQuestion_Thread };


export type AskProductQuestionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  body: Scalars['String']['input'];
}>;


export type AskProductQuestionMutation = AskProductQuestionMutation_Mutation;

export type AcceptBrengerProposedDateMutation_acceptBrengerProposedDate_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any, state: BrengerProposedDateState, date: any };

export type AcceptBrengerProposedDateMutation_Mutation = { __typename?: 'Mutation', acceptBrengerProposedDate: AcceptBrengerProposedDateMutation_acceptBrengerProposedDate_BrengerProposedDate };


export type AcceptBrengerProposedDateMutationVariables = Exact<{
  dateId: Scalars['UUID']['input'];
}>;


export type AcceptBrengerProposedDateMutation = AcceptBrengerProposedDateMutation_Mutation;

export type ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates_proposedDates_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any };

export type ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates = { __typename?: 'BrengerProposedDates', proposedDates: Array<ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates_proposedDates_BrengerProposedDate> };

export type ProposeBrengerAppointmentDatesMutation_Mutation = { __typename?: 'Mutation', proposeBrengerAppointmentDates: ProposeBrengerAppointmentDatesMutation_proposeBrengerAppointmentDates_BrengerProposedDates };


export type ProposeBrengerAppointmentDatesMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  dates: Array<Scalars['Date']['input']> | Scalars['Date']['input'];
}>;


export type ProposeBrengerAppointmentDatesMutation = ProposeBrengerAppointmentDatesMutation_Mutation;

export type AcceptBidMutation_acceptBid_Bid = { __typename?: 'Bid', id: any };

export type AcceptBidMutation_Mutation = { __typename?: 'Mutation', acceptBid: AcceptBidMutation_acceptBid_Bid };


export type AcceptBidMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AcceptBidMutation = AcceptBidMutation_Mutation;

export type CancelBidMutation_cancelBid_Bid = { __typename?: 'Bid', id: any, state: BidState };

export type CancelBidMutation_Mutation = { __typename?: 'Mutation', cancelBid?: CancelBidMutation_cancelBid_Bid | null };


export type CancelBidMutationVariables = Exact<{
  input: CancelBidInput;
}>;


export type CancelBidMutation = CancelBidMutation_Mutation;

export type CreateBidMutation_createBid_Bid_auction_Auction_product_Product_brand_Brand = { __typename?: 'Brand', title: string };

export type CreateBidMutation_createBid_Bid_auction_Auction_product_Product = { __typename?: 'Product', id: any, title: string, brand?: CreateBidMutation_createBid_Bid_auction_Auction_product_Product_brand_Brand | null };

export type CreateBidMutation_createBid_Bid_auction_Auction = { __typename?: 'Auction', product: CreateBidMutation_createBid_Bid_auction_Auction_product_Product };

export type CreateBidMutation_createBid_Bid_thread_Thread = { __typename?: 'Thread', id: any };

export type CreateBidMutation_createBid_Bid = { __typename?: 'Bid', id: any, auction: CreateBidMutation_createBid_Bid_auction_Auction, thread?: CreateBidMutation_createBid_Bid_thread_Thread | null };

export type CreateBidMutation_Mutation = { __typename?: 'Mutation', createBid: CreateBidMutation_createBid_Bid };


export type CreateBidMutationVariables = Exact<{
  auctionId: Scalars['UUID']['input'];
  amount: Scalars['Float']['input'];
  currency: Currency;
}>;


export type CreateBidMutation = CreateBidMutation_Mutation;

export type CreateCounterBidMutation_createCounterBid_Bid = { __typename?: 'Bid', id: any };

export type CreateCounterBidMutation_Mutation = { __typename?: 'Mutation', createCounterBid: CreateCounterBidMutation_createCounterBid_Bid };


export type CreateCounterBidMutationVariables = Exact<{
  auctionId: Scalars['UUID']['input'];
  amount: Scalars['Float']['input'];
  buyerId: Scalars['UUID']['input'];
  currency: Currency;
}>;


export type CreateCounterBidMutation = CreateCounterBidMutation_Mutation;

export type RejectBidMutation_rejectBid_Bid = { __typename?: 'Bid', id: any };

export type RejectBidMutation_Mutation = { __typename?: 'Mutation', rejectBid: RejectBidMutation_rejectBid_Bid };


export type RejectBidMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RejectBidMutation = RejectBidMutation_Mutation;

export type WithdrawProductMutation_withdrawProduct_Product = { __typename?: 'Product', id: any };

export type WithdrawProductMutation_Mutation = { __typename?: 'Mutation', withdrawProduct: WithdrawProductMutation_withdrawProduct_Product };


export type WithdrawProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<ProductWithdrawReason>;
}>;


export type WithdrawProductMutation = WithdrawProductMutation_Mutation;

export type AcceptChatTosForThreadMutation_acceptChatTosForThread_Thread = { __typename?: 'Thread', id: any, pendingActions: Array<PendingAction> };

export type AcceptChatTosForThreadMutation_Mutation = { __typename?: 'Mutation', acceptChatTosForThread: AcceptChatTosForThreadMutation_acceptChatTosForThread_Thread };


export type AcceptChatTosForThreadMutationVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type AcceptChatTosForThreadMutation = AcceptChatTosForThreadMutation_Mutation;

export type CreateMessageMutation_createMessage_Message = { __typename?: 'Message', id: any, body?: string | null, updated?: any | null };

export type CreateMessageMutation_Mutation = { __typename?: 'Mutation', createMessage?: CreateMessageMutation_createMessage_Message | null };


export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = CreateMessageMutation_Mutation;

export type CreateThreadMutation_createThread_Thread = { __typename?: 'Thread', id: any };

export type CreateThreadMutation_Mutation = { __typename?: 'Mutation', createThread: CreateThreadMutation_createThread_Thread };


export type CreateThreadMutationVariables = Exact<{
  input: CreateThreadInput;
}>;


export type CreateThreadMutation = CreateThreadMutation_Mutation;

export type DeleteThreadMutation_Mutation = { __typename?: 'Mutation', deleteThread: boolean };


export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type DeleteThreadMutation = DeleteThreadMutation_Mutation;

export type DisableThreadTranslationMutation_disableThreadTranslation_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null };

export type DisableThreadTranslationMutation_disableThreadTranslation_Thread = { __typename?: 'Thread', id: any, subscribers: Array<DisableThreadTranslationMutation_disableThreadTranslation_Thread_subscribers_Subscriber> };

export type DisableThreadTranslationMutation_Mutation = { __typename?: 'Mutation', disableThreadTranslation: DisableThreadTranslationMutation_disableThreadTranslation_Thread };


export type DisableThreadTranslationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DisableThreadTranslationMutation = DisableThreadTranslationMutation_Mutation;

export type ReadThreadMutation_Mutation = { __typename?: 'Mutation', readThread: boolean };


export type ReadThreadMutationVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type ReadThreadMutation = ReadThreadMutation_Mutation;

export type RepublishProductByOrderIdMutation_republishProductByOrderId_Order_product_Product_auction_Auction = { __typename?: 'Auction', state: AuctionState };

export type RepublishProductByOrderIdMutation_republishProductByOrderId_Order_product_Product = { __typename?: 'Product', id: any, state: ProductState, auction?: RepublishProductByOrderIdMutation_republishProductByOrderId_Order_product_Product_auction_Auction | null };

export type RepublishProductByOrderIdMutation_republishProductByOrderId_Order = { __typename?: 'Order', id: any, state: OrderState, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, product: RepublishProductByOrderIdMutation_republishProductByOrderId_Order_product_Product };

export type RepublishProductByOrderIdMutation_Mutation = { __typename?: 'Mutation', republishProductByOrderId: RepublishProductByOrderIdMutation_republishProductByOrderId_Order };


export type RepublishProductByOrderIdMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type RepublishProductByOrderIdMutation = RepublishProductByOrderIdMutation_Mutation;

export type TranslateThreadMutation_translateThread_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null };

export type TranslateThreadMutation_translateThread_Thread = { __typename?: 'Thread', id: any, subscribers: Array<TranslateThreadMutation_translateThread_Thread_subscribers_Subscriber> };

export type TranslateThreadMutation_Mutation = { __typename?: 'Mutation', translateThread: TranslateThreadMutation_translateThread_Thread };


export type TranslateThreadMutationVariables = Exact<{
  input: TranslateThreadInput;
}>;


export type TranslateThreadMutation = TranslateThreadMutation_Mutation;

export type UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order_product_Product_auction_Auction = { __typename?: 'Auction', state: AuctionState };

export type UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order_product_Product = { __typename?: 'Product', id: any, state: ProductState, auction?: UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order_product_Product_auction_Auction | null };

export type UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order = { __typename?: 'Order', id: any, state: OrderState, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, product: UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order_product_Product };

export type UpdateOrderPickupConfirmationMutation_Mutation = { __typename?: 'Mutation', updateOrderPickupConfirmation: UpdateOrderPickupConfirmationMutation_updateOrderPickupConfirmation_Order };


export type UpdateOrderPickupConfirmationMutationVariables = Exact<{
  input: UpdateOrderPickupConfirmationInput;
}>;


export type UpdateOrderPickupConfirmationMutation = UpdateOrderPickupConfirmationMutation_Mutation;

export type UpdateOrderStateMutation_updateOrderState_Order = { __typename?: 'Order', id: any, state: OrderState };

export type UpdateOrderStateMutation_Mutation = { __typename?: 'Mutation', updateOrderState: UpdateOrderStateMutation_updateOrderState_Order };


export type UpdateOrderStateMutationVariables = Exact<{
  input: UpdateOrderStateInput;
}>;


export type UpdateOrderStateMutation = UpdateOrderStateMutation_Mutation;

export type ClearCartMutation_clearCart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, billing_address?: CartFragmentFragment_Cart_billing_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type ClearCartMutation_Mutation = { __typename?: 'Mutation', clearCart: ClearCartMutation_clearCart_Cart };


export type ClearCartMutationVariables = Exact<{
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type ClearCartMutation = ClearCartMutation_Mutation;

export type CloneProductMutation_cloneProduct_Product = { __typename?: 'Product', id: any };

export type CloneProductMutation_Mutation = { __typename?: 'Mutation', cloneProduct: CloneProductMutation_cloneProduct_Product };


export type CloneProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CloneProductMutation = CloneProductMutation_Mutation;

export type CreateDraftProductMutation_createDraftProduct_Product = { __typename?: 'Product', id: any, state: ProductState };

export type CreateDraftProductMutation_Mutation = { __typename?: 'Mutation', createDraftProduct: CreateDraftProductMutation_createDraftProduct_Product };


export type CreateDraftProductMutationVariables = Exact<{
  input: CreateDraftProductInput;
}>;


export type CreateDraftProductMutation = CreateDraftProductMutation_Mutation;

export type GenerateListingMutation_generateListing_ListingGeneration = { __typename?: 'ListingGeneration', status: ListingGenerationStatus, model?: string | null, durationMs?: number | null, failureReason?: string | null, generatedAt: any, runs: number, missing: Array<ListingFieldKey>, applicableKeys: Array<ListingFieldKey>, fields: Array<ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField>, knownItem?: ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint | null, dimensionGuide?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide | null };

export type GenerateListingMutation_Mutation = { __typename?: 'Mutation', generateListing: GenerateListingMutation_generateListing_ListingGeneration };


export type GenerateListingMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  numberOfItems?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateListingMutation = GenerateListingMutation_Mutation;

export type PublishCreateAdV2ProductMutation_publishProduct_Product = { __typename?: 'Product', id: any, state: ProductState, status: ProductStatus };

export type PublishCreateAdV2ProductMutation_Mutation = { __typename?: 'Mutation', publishProduct: PublishCreateAdV2ProductMutation_publishProduct_Product };


export type PublishCreateAdV2ProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PublishCreateAdV2ProductMutation = PublishCreateAdV2ProductMutation_Mutation;

export type RemoveCreateAdV2PhotoMutation_Mutation = { __typename?: 'Mutation', removeMedia: boolean };


export type RemoveCreateAdV2PhotoMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveCreateAdV2PhotoMutation = RemoveCreateAdV2PhotoMutation_Mutation;

export type SetListingFieldMutation_setListingField_ListingGeneration = { __typename?: 'ListingGeneration', status: ListingGenerationStatus, model?: string | null, durationMs?: number | null, failureReason?: string | null, generatedAt: any, runs: number, missing: Array<ListingFieldKey>, applicableKeys: Array<ListingFieldKey>, fields: Array<ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField>, knownItem?: ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint | null, dimensionGuide?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide | null };

export type SetListingFieldMutation_Mutation = { __typename?: 'Mutation', setListingField: SetListingFieldMutation_setListingField_ListingGeneration };


export type SetListingFieldMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  input: SetListingFieldInput;
}>;


export type SetListingFieldMutation = SetListingFieldMutation_Mutation;

export type StartListingManuallyMutation_startListingManually_ListingGeneration = { __typename?: 'ListingGeneration', status: ListingGenerationStatus, model?: string | null, durationMs?: number | null, failureReason?: string | null, generatedAt: any, runs: number, missing: Array<ListingFieldKey>, applicableKeys: Array<ListingFieldKey>, fields: Array<ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField>, knownItem?: ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint | null, dimensionGuide?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide | null };

export type StartListingManuallyMutation_Mutation = { __typename?: 'Mutation', startListingManually: StartListingManuallyMutation_startListingManually_ListingGeneration };


export type StartListingManuallyMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  numberOfItems?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartListingManuallyMutation = StartListingManuallyMutation_Mutation;

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia_ARObject = { __typename?: 'ARObject' };

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia_Audio = { __typename?: 'Audio' };

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia_Document = { __typename?: 'Document' };

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia_Image = { __typename?: 'Image', id: any, position: number };

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia_Video = { __typename?: 'Video' };

export type UpdateCreateAdV2PhotoPositionMutation_updateMedia = UpdateCreateAdV2PhotoPositionMutation_updateMedia_ARObject | UpdateCreateAdV2PhotoPositionMutation_updateMedia_Audio | UpdateCreateAdV2PhotoPositionMutation_updateMedia_Document | UpdateCreateAdV2PhotoPositionMutation_updateMedia_Image | UpdateCreateAdV2PhotoPositionMutation_updateMedia_Video;

export type UpdateCreateAdV2PhotoPositionMutation_Mutation = { __typename?: 'Mutation', updateMedia: UpdateCreateAdV2PhotoPositionMutation_updateMedia };


export type UpdateCreateAdV2PhotoPositionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
}>;


export type UpdateCreateAdV2PhotoPositionMutation = UpdateCreateAdV2PhotoPositionMutation_Mutation;

export type CreateAbuseReportMutation_Mutation = { __typename?: 'Mutation', createAbuseReport: boolean };


export type CreateAbuseReportMutationVariables = Exact<{
  input: AbuseReportInput;
}>;


export type CreateAbuseReportMutation = CreateAbuseReportMutation_Mutation;

export type CreateAddressMutation_createAddress_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type CreateAddressMutation_Mutation = { __typename?: 'Mutation', createAddress: CreateAddressMutation_createAddress_Address };


export type CreateAddressMutationVariables = Exact<{
  merchant_id: Scalars['UUID']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
}>;


export type CreateAddressMutation = CreateAddressMutation_Mutation;

export type CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert_product_Product = { __typename?: 'Product', id: any };

export type CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert = { __typename?: 'ComingSoonAlert', id: any, created: any, product: CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert_product_Product };

export type CreateComingSoonAlertMutation_Mutation = { __typename?: 'Mutation', createComingSoonAlert: CreateComingSoonAlertMutation_createComingSoonAlert_ComingSoonAlert };


export type CreateComingSoonAlertMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CreateComingSoonAlertMutation = CreateComingSoonAlertMutation_Mutation;

export type CreateFavoriteMutation_createFavorite_Favorite_item_Product_favorite_Favorite = { __typename?: 'Favorite', id: any };

export type CreateFavoriteMutation_createFavorite_Favorite_item_Merchant = { __typename?: 'Merchant' };

export type CreateFavoriteMutation_createFavorite_Favorite_item_Product = { __typename?: 'Product', id: any, favorite?: CreateFavoriteMutation_createFavorite_Favorite_item_Product_favorite_Favorite | null };

export type CreateFavoriteMutation_createFavorite_Favorite_item = CreateFavoriteMutation_createFavorite_Favorite_item_Merchant | CreateFavoriteMutation_createFavorite_Favorite_item_Product;

export type CreateFavoriteMutation_createFavorite_Favorite = { __typename?: 'Favorite', id: any, created: any, item: CreateFavoriteMutation_createFavorite_Favorite_item };

export type CreateFavoriteMutation_Mutation = { __typename?: 'Mutation', createFavorite: CreateFavoriteMutation_createFavorite_Favorite };


export type CreateFavoriteMutationVariables = Exact<{
  input: FavoriteInput;
}>;


export type CreateFavoriteMutation = CreateFavoriteMutation_Mutation;

export type CreateOrUpdateBankAccountMutation_createOrUpdateBankAccount_ExternalBankAccount = { __typename?: 'ExternalBankAccount', id: string, currency: Currency, country: string, account_holder_name?: string | null, bank_name: string, last4: string };

export type CreateOrUpdateBankAccountMutation_Mutation = { __typename?: 'Mutation', createOrUpdateBankAccount: CreateOrUpdateBankAccountMutation_createOrUpdateBankAccount_ExternalBankAccount };


export type CreateOrUpdateBankAccountMutationVariables = Exact<{
  input: ExternalBankAccountInput;
}>;


export type CreateOrUpdateBankAccountMutation = CreateOrUpdateBankAccountMutation_Mutation;

export type CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup_payment_OrderGroupPayment = { __typename?: 'OrderGroupPayment', paymentIntentId: string, paymentClientSecret: string };

export type CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup = { __typename?: 'OrderGroup', id: any, paymentMethod: PaymentMethod, payment?: CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup_payment_OrderGroupPayment | null };

export type CreateOrderGroupForCartMutation_Mutation = { __typename?: 'Mutation', createOrderGroupForCart: CreateOrderGroupForCartMutation_createOrderGroupForCart_OrderGroup };


export type CreateOrderGroupForCartMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  importChargesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  importChargesEstimates?: InputMaybe<Array<CartItemImportChargesEstimateInput> | CartItemImportChargesEstimateInput>;
}>;


export type CreateOrderGroupForCartMutation = CreateOrderGroupForCartMutation_Mutation;

export type CreatePaymentForBoostMutation_createPaymentForBoost_BoostPayment = { __typename?: 'BoostPayment', paymentClientSecret: string, paymentIntentId: string };

export type CreatePaymentForBoostMutation_Mutation = { __typename?: 'Mutation', createPaymentForBoost: CreatePaymentForBoostMutation_createPaymentForBoost_BoostPayment };


export type CreatePaymentForBoostMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type CreatePaymentForBoostMutation = CreatePaymentForBoostMutation_Mutation;

export type CreateProductMutation_createProduct_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, auto_discount?: boolean | null, favorite_count: number, showroomModel: boolean, quality?: ProductQuality | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, shape?: Shape | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type CreateProductMutation_Mutation = { __typename?: 'Mutation', createProduct: CreateProductMutation_createProduct_Product };


export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type CreateProductMutation = CreateProductMutation_Mutation;

export type CreateSavedSearchMutation_createSavedSearch_SavedSearch = { __typename?: 'SavedSearch', id: any };

export type CreateSavedSearchMutation_Mutation = { __typename?: 'Mutation', createSavedSearch: CreateSavedSearchMutation_createSavedSearch_SavedSearch };


export type CreateSavedSearchMutationVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<FilterInput>> | InputMaybe<FilterInput>>;
  query?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSavedSearchMutation = CreateSavedSearchMutation_Mutation;

export type CreateStripeAccountLinkMutation_createStripeAccountLink_StripeAccountLink = { __typename?: 'StripeAccountLink', url: string };

export type CreateStripeAccountLinkMutation_Mutation = { __typename?: 'Mutation', createStripeAccountLink: CreateStripeAccountLinkMutation_createStripeAccountLink_StripeAccountLink };


export type CreateStripeAccountLinkMutationVariables = Exact<{
  input: StripeAccountLinkInput;
}>;


export type CreateStripeAccountLinkMutation = CreateStripeAccountLinkMutation_Mutation;

export type ForgotPasswordMutation_forgotPassword_ForgotPasswordResponse = { __typename?: 'ForgotPasswordResponse', message: string, status: ForgotPasswordResult };

export type ForgotPasswordMutation_Mutation = { __typename?: 'Mutation', forgotPassword: ForgotPasswordMutation_forgotPassword_ForgotPasswordResponse };


export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = ForgotPasswordMutation_Mutation;

export type GenerateIterableJwtMutation_generateIterableJwt_GenerateIterableJwtResponse = { __typename?: 'GenerateIterableJwtResponse', token: string };

export type GenerateIterableJwtMutation_Mutation = { __typename?: 'Mutation', generateIterableJwt: GenerateIterableJwtMutation_generateIterableJwt_GenerateIterableJwtResponse };


export type GenerateIterableJwtMutationVariables = Exact<{
  input?: InputMaybe<GenerateIterableJwtInput>;
}>;


export type GenerateIterableJwtMutation = GenerateIterableJwtMutation_Mutation;

export type LoginMutation_login_LoginResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null };

export type LoginMutation_login_LoginResponse_user_Member = { __typename?: 'Member', id: any, locale: Locale, merchants: Array<LoginMutation_login_LoginResponse_user_Member_merchants_Merchant> };

export type LoginMutation_login_LoginResponse = { __typename?: 'LoginResponse', access_token: string, user: LoginMutation_login_LoginResponse_user_Member };

export type LoginMutation_Mutation = { __typename?: 'Mutation', login: LoginMutation_login_LoginResponse };


export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = LoginMutation_Mutation;

export type LoginWithAppleMutation_loginWithApple_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithAppleMutation_Mutation = { __typename?: 'Mutation', loginWithApple: LoginWithAppleMutation_loginWithApple_LoginResponse };


export type LoginWithAppleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithAppleMutation = LoginWithAppleMutation_Mutation;

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null };

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member = { __typename?: 'Member', id: any, locale: Locale, merchants: Array<LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member_merchants_Merchant> };

export type LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse = { __typename?: 'EmailTokenLoginResponse', token: string, redirectUrl: string, user: LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse_user_Member };

export type LoginWithEmailTokenMutation_Mutation = { __typename?: 'Mutation', loginWithEmailToken: LoginWithEmailTokenMutation_loginWithEmailToken_EmailTokenLoginResponse };


export type LoginWithEmailTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  cookie: Scalars['String']['input'];
}>;


export type LoginWithEmailTokenMutation = LoginWithEmailTokenMutation_Mutation;

export type LoginWithFacebookMutation_loginWithFacebook_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithFacebookMutation_Mutation = { __typename?: 'Mutation', loginWithFacebook: LoginWithFacebookMutation_loginWithFacebook_LoginResponse };


export type LoginWithFacebookMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithFacebookMutation = LoginWithFacebookMutation_Mutation;

export type LoginWithGoogleMutation_loginWithGoogle_LoginResponse = { __typename?: 'LoginResponse', access_token: string };

export type LoginWithGoogleMutation_Mutation = { __typename?: 'Mutation', loginWithGoogle: LoginWithGoogleMutation_loginWithGoogle_LoginResponse };


export type LoginWithGoogleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithGoogleMutation = LoginWithGoogleMutation_Mutation;

export type RequestVacationModeDisableMutation_requestVacationModeDisable_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type RequestVacationModeDisableMutation_Mutation = { __typename?: 'Mutation', requestVacationModeDisable: RequestVacationModeDisableMutation_requestVacationModeDisable_Merchant };


export type RequestVacationModeDisableMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestVacationModeDisableMutation = RequestVacationModeDisableMutation_Mutation;

export type RequestVacationModeEnableMutation_requestVacationModeEnable_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type RequestVacationModeEnableMutation_Mutation = { __typename?: 'Mutation', requestVacationModeEnable: RequestVacationModeEnableMutation_requestVacationModeEnable_Merchant };


export type RequestVacationModeEnableMutationVariables = Exact<{
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type RequestVacationModeEnableMutation = RequestVacationModeEnableMutation_Mutation;

export type SetMerchantTradeDiscountMutation_setMerchantTradeDiscount_Merchant_tradeDiscount_MerchantTradeDiscount = { __typename?: 'MerchantTradeDiscount', enabled: boolean, pct?: number | null, updatedAt?: any | null, activeListingCount: number };

export type SetMerchantTradeDiscountMutation_setMerchantTradeDiscount_Merchant = { __typename?: 'Merchant', id: any, tradeDiscount?: SetMerchantTradeDiscountMutation_setMerchantTradeDiscount_Merchant_tradeDiscount_MerchantTradeDiscount | null };

export type SetMerchantTradeDiscountMutation_Mutation = { __typename?: 'Mutation', setMerchantTradeDiscount: SetMerchantTradeDiscountMutation_setMerchantTradeDiscount_Merchant };


export type SetMerchantTradeDiscountMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  pct?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetMerchantTradeDiscountMutation = SetMerchantTradeDiscountMutation_Mutation;

export type UpdateVacationModeEndDateMutation_updateVacationModeEndDate_Merchant = { __typename?: 'Merchant', id: any, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null };

export type UpdateVacationModeEndDateMutation_Mutation = { __typename?: 'Mutation', updateVacationModeEndDate: UpdateVacationModeEndDateMutation_updateVacationModeEndDate_Merchant };


export type UpdateVacationModeEndDateMutationVariables = Exact<{
  vacationModeEndDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateVacationModeEndDateMutation = UpdateVacationModeEndDateMutation_Mutation;

export type AddBoostToPackageCartMutation_addBoostToPackageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type AddBoostToPackageCartMutation_Mutation = { __typename?: 'Mutation', addBoostToPackageCart: AddBoostToPackageCartMutation_addBoostToPackageCart_PackageCart };


export type AddBoostToPackageCartMutationVariables = Exact<{
  input: AddBoostToPackageCartInput;
  displayCurrency?: InputMaybe<Currency>;
}>;


export type AddBoostToPackageCartMutation = AddBoostToPackageCartMutation_Mutation;

export type AddListingFeeToPackageCartMutation_addListingFeeToPackageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type AddListingFeeToPackageCartMutation_Mutation = { __typename?: 'Mutation', addListingFeeToPackageCart: AddListingFeeToPackageCartMutation_addListingFeeToPackageCart_PackageCart };


export type AddListingFeeToPackageCartMutationVariables = Exact<{
  input: AddListingFeeToPackageCartInput;
  displayCurrency?: InputMaybe<Currency>;
}>;


export type AddListingFeeToPackageCartMutation = AddListingFeeToPackageCartMutation_Mutation;

export type AddPromotionToPackageCartMutation_addPromotionToPackageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type AddPromotionToPackageCartMutation_Mutation = { __typename?: 'Mutation', addPromotionToPackageCart: AddPromotionToPackageCartMutation_addPromotionToPackageCart_PackageCart };


export type AddPromotionToPackageCartMutationVariables = Exact<{
  input: AddPromotionToPackageCartInput;
  displayCurrency?: InputMaybe<Currency>;
}>;


export type AddPromotionToPackageCartMutation = AddPromotionToPackageCartMutation_Mutation;

export type BeginPackageCheckoutMutation_beginPackageCheckout_PackageCheckout = { __typename?: 'PackageCheckout', id: string, orderGroupId: string, status: PackageCheckoutStatus, paymentIntentClientSecret?: string | null, total: PackageCheckoutDetailsFragment_PackageCheckout_total_Price, convertedTotal?: PackageCheckoutDetailsFragment_PackageCheckout_convertedTotal_Price | null, campaigns: Array<PackageCheckoutDetailsFragment_PackageCheckout_campaigns_PromotionCampaign>, items: Array<PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem> };

export type BeginPackageCheckoutMutation_Mutation = { __typename?: 'Mutation', beginPackageCheckout: BeginPackageCheckoutMutation_beginPackageCheckout_PackageCheckout };


export type BeginPackageCheckoutMutationVariables = Exact<{
  input: BeginPackageCheckoutInput;
  displayCurrency?: InputMaybe<Currency>;
}>;


export type BeginPackageCheckoutMutation = BeginPackageCheckoutMutation_Mutation;

export type CancelPackageCheckoutMutation_cancelPackageCheckout_PackageCheckout = { __typename?: 'PackageCheckout', id: string, orderGroupId: string, status: PackageCheckoutStatus, paymentIntentClientSecret?: string | null, total: PackageCheckoutDetailsFragment_PackageCheckout_total_Price, convertedTotal?: PackageCheckoutDetailsFragment_PackageCheckout_convertedTotal_Price | null, campaigns: Array<PackageCheckoutDetailsFragment_PackageCheckout_campaigns_PromotionCampaign>, items: Array<PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem> };

export type CancelPackageCheckoutMutation_Mutation = { __typename?: 'Mutation', cancelPackageCheckout: CancelPackageCheckoutMutation_cancelPackageCheckout_PackageCheckout };


export type CancelPackageCheckoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  displayCurrency?: InputMaybe<Currency>;
}>;


export type CancelPackageCheckoutMutation = CancelPackageCheckoutMutation_Mutation;

export type ClearPackageCartMutation_clearPackageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type ClearPackageCartMutation_Mutation = { __typename?: 'Mutation', clearPackageCart: ClearPackageCartMutation_clearPackageCart_PackageCart };


export type ClearPackageCartMutationVariables = Exact<{
  displayCurrency?: InputMaybe<Currency>;
}>;


export type ClearPackageCartMutation = ClearPackageCartMutation_Mutation;

export type CreatePaymentForPackageCartMutation_createPaymentForPackageCart_PackagePayment = { __typename?: 'PackagePayment', paymentClientSecret: string, paymentIntentId: string };

export type CreatePaymentForPackageCartMutation_Mutation = { __typename?: 'Mutation', createPaymentForPackageCart: CreatePaymentForPackageCartMutation_createPaymentForPackageCart_PackagePayment };


export type CreatePaymentForPackageCartMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type CreatePaymentForPackageCartMutation = CreatePaymentForPackageCartMutation_Mutation;

export type RemoveFromPackageCartMutation_removeFromPackageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type RemoveFromPackageCartMutation_Mutation = { __typename?: 'Mutation', removeFromPackageCart: RemoveFromPackageCartMutation_removeFromPackageCart_PackageCart };


export type RemoveFromPackageCartMutationVariables = Exact<{
  kind: PackageKind;
  productId: Scalars['UUID']['input'];
  displayCurrency?: InputMaybe<Currency>;
}>;


export type RemoveFromPackageCartMutation = RemoveFromPackageCartMutation_Mutation;

export type CreatePaymentForDynamicListingFeeMutation_createPaymentForDynamicListingFee_ListingFeePayment = { __typename?: 'ListingFeePayment', paymentIntentId: string, paymentClientSecret: string };

export type CreatePaymentForDynamicListingFeeMutation_Mutation = { __typename?: 'Mutation', createPaymentForDynamicListingFee: CreatePaymentForDynamicListingFeeMutation_createPaymentForDynamicListingFee_ListingFeePayment };


export type CreatePaymentForDynamicListingFeeMutationVariables = Exact<{
  input: CreatePaymentForListingFeeInput;
}>;


export type CreatePaymentForDynamicListingFeeMutation = CreatePaymentForDynamicListingFeeMutation_Mutation;

export type CreatePaymentForListingFeeMutation_createPaymentForListingFee_ListingFeePayment = { __typename?: 'ListingFeePayment', paymentIntentId: string, paymentClientSecret: string };

export type CreatePaymentForListingFeeMutation_Mutation = { __typename?: 'Mutation', createPaymentForListingFee: CreatePaymentForListingFeeMutation_createPaymentForListingFee_ListingFeePayment };


export type CreatePaymentForListingFeeMutationVariables = Exact<{
  input: CreatePaymentForListingFeeInput;
}>;


export type CreatePaymentForListingFeeMutation = CreatePaymentForListingFeeMutation_Mutation;

export type CreatePostalShipmentMutation_createPostalShipment_PostalShipment = { __typename?: 'PostalShipment', id: any };

export type CreatePostalShipmentMutation_Mutation = { __typename?: 'Mutation', createPostalShipment?: CreatePostalShipmentMutation_createPostalShipment_PostalShipment | null };


export type CreatePostalShipmentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type CreatePostalShipmentMutation = CreatePostalShipmentMutation_Mutation;

export type AssignPurchaseToProBuyerProjectMutation_assignPurchaseToProBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type AssignPurchaseToProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', assignPurchaseToProBuyerProject: AssignPurchaseToProBuyerProjectMutation_assignPurchaseToProBuyerProject_ProBuyerProject };


export type AssignPurchaseToProBuyerProjectMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  orderId: Scalars['UUID']['input'];
}>;


export type AssignPurchaseToProBuyerProjectMutation = AssignPurchaseToProBuyerProjectMutation_Mutation;

export type CreateProBuyerProjectMutation_createProBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type CreateProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', createProBuyerProject: CreateProBuyerProjectMutation_createProBuyerProject_ProBuyerProject };


export type CreateProBuyerProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProBuyerProjectMutation = CreateProBuyerProjectMutation_Mutation;

export type DeleteProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', deleteProBuyerProject: boolean };


export type DeleteProBuyerProjectMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteProBuyerProjectMutation = DeleteProBuyerProjectMutation_Mutation;

export type RemovePurchaseFromProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', removePurchaseFromProBuyerProject: boolean };


export type RemovePurchaseFromProBuyerProjectMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type RemovePurchaseFromProBuyerProjectMutation = RemovePurchaseFromProBuyerProjectMutation_Mutation;

export type RenameProBuyerProjectMutation_renameProBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type RenameProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', renameProBuyerProject: RenameProBuyerProjectMutation_renameProBuyerProject_ProBuyerProject };


export type RenameProBuyerProjectMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameProBuyerProjectMutation = RenameProBuyerProjectMutation_Mutation;

export type RequestReservationForProjectMutation_requestReservation_BuyerReservation = { __typename?: 'BuyerReservation', id: any, status: ReservationStatus, requestExpiresAt: any, reservedUntil?: any | null, productId: any, productTitle: string, productSlug: string, productImage?: string | null, fixedPrice?: ProBuyerProjectReservationFragment_BuyerReservation_fixedPrice_Price | null };

export type RequestReservationForProjectMutation_Mutation = { __typename?: 'Mutation', requestReservation: RequestReservationForProjectMutation_requestReservation_BuyerReservation };


export type RequestReservationForProjectMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
}>;


export type RequestReservationForProjectMutation = RequestReservationForProjectMutation_Mutation;

export type AddProBuyerProjectItemsToCartMutation_addProBuyerProjectItemsToCart_ProBuyerProjectCartResult = { __typename?: 'ProBuyerProjectCartResult', added: number, alreadyInCart: number, skippedItemIds: Array<any>, cartCount: number };

export type AddProBuyerProjectItemsToCartMutation_Mutation = { __typename?: 'Mutation', addProBuyerProjectItemsToCart: AddProBuyerProjectItemsToCartMutation_addProBuyerProjectItemsToCart_ProBuyerProjectCartResult };


export type AddProBuyerProjectItemsToCartMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  itemIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AddProBuyerProjectItemsToCartMutation = AddProBuyerProjectItemsToCartMutation_Mutation;

export type AddProductsToProBuyerProjectMutation_addProductsToProBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type AddProductsToProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', addProductsToProBuyerProject: AddProductsToProBuyerProjectMutation_addProductsToProBuyerProject_ProBuyerProject };


export type AddProductsToProBuyerProjectMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  roomId?: InputMaybe<Scalars['UUID']['input']>;
  source: ProBuyerProjectItemSource;
}>;


export type AddProductsToProBuyerProjectMutation = AddProductsToProBuyerProjectMutation_Mutation;

export type CreateProBuyerProjectRoomMutation_createProBuyerProjectRoom_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type CreateProBuyerProjectRoomMutation_Mutation = { __typename?: 'Mutation', createProBuyerProjectRoom: CreateProBuyerProjectRoomMutation_createProBuyerProjectRoom_ProBuyerProjectRoom };


export type CreateProBuyerProjectRoomMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateProBuyerProjectRoomMutation = CreateProBuyerProjectRoomMutation_Mutation;

export type DeleteProBuyerProjectRoomMutation_Mutation = { __typename?: 'Mutation', deleteProBuyerProjectRoom: boolean };


export type DeleteProBuyerProjectRoomMutationVariables = Exact<{
  roomId: Scalars['UUID']['input'];
}>;


export type DeleteProBuyerProjectRoomMutation = DeleteProBuyerProjectRoomMutation_Mutation;

export type MarkProBuyerProjectSeenMutation_markProBuyerProjectSeen_ProBuyerProject_changes_ProBuyerProjectChanges = { __typename?: 'ProBuyerProjectChanges', priceDropped: number, unavailable: number, reactedItems: number, reactionsYes: number, reactionsNo: number };

export type MarkProBuyerProjectSeenMutation_markProBuyerProjectSeen_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, lastViewedAt?: any | null, changes: MarkProBuyerProjectSeenMutation_markProBuyerProjectSeen_ProBuyerProject_changes_ProBuyerProjectChanges };

export type MarkProBuyerProjectSeenMutation_Mutation = { __typename?: 'Mutation', markProBuyerProjectSeen: MarkProBuyerProjectSeenMutation_markProBuyerProjectSeen_ProBuyerProject };


export type MarkProBuyerProjectSeenMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type MarkProBuyerProjectSeenMutation = MarkProBuyerProjectSeenMutation_Mutation;

export type MoveProBuyerProjectItemMutation_moveProBuyerProjectItem_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type MoveProBuyerProjectItemMutation_Mutation = { __typename?: 'Mutation', moveProBuyerProjectItem: MoveProBuyerProjectItemMutation_moveProBuyerProjectItem_ProBuyerProject };


export type MoveProBuyerProjectItemMutationVariables = Exact<{
  itemId: Scalars['UUID']['input'];
  toProjectId: Scalars['UUID']['input'];
}>;


export type MoveProBuyerProjectItemMutation = MoveProBuyerProjectItemMutation_Mutation;

export type ReactToProBuyerSelectionItemMutation_Mutation = { __typename?: 'Mutation', reactToProBuyerSelectionItem: boolean };


export type ReactToProBuyerSelectionItemMutationVariables = Exact<{
  token: Scalars['String']['input'];
  itemId: Scalars['UUID']['input'];
  visitorId: Scalars['UUID']['input'];
  reaction?: InputMaybe<ProBuyerClientReactionValue>;
}>;


export type ReactToProBuyerSelectionItemMutation = ReactToProBuyerSelectionItemMutation_Mutation;

export type RemoveProductFromProBuyerProjectMutation_removeProductFromProBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type RemoveProductFromProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', removeProductFromProBuyerProject: RemoveProductFromProBuyerProjectMutation_removeProductFromProBuyerProject_ProBuyerProject };


export type RemoveProductFromProBuyerProjectMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
}>;


export type RemoveProductFromProBuyerProjectMutation = RemoveProductFromProBuyerProjectMutation_Mutation;

export type ReorderProBuyerProjectItemsMutation_Mutation = { __typename?: 'Mutation', reorderProBuyerProjectItems: boolean };


export type ReorderProBuyerProjectItemsMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  itemIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReorderProBuyerProjectItemsMutation = ReorderProBuyerProjectItemsMutation_Mutation;

export type ReorderProBuyerProjectRoomsMutation_reorderProBuyerProjectRooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ReorderProBuyerProjectRoomsMutation_Mutation = { __typename?: 'Mutation', reorderProBuyerProjectRooms: Array<ReorderProBuyerProjectRoomsMutation_reorderProBuyerProjectRooms_ProBuyerProjectRoom> };


export type ReorderProBuyerProjectRoomsMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  roomIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReorderProBuyerProjectRoomsMutation = ReorderProBuyerProjectRoomsMutation_Mutation;

export type SetCartItemProBuyerProjectMutation_setCartItemProBuyerProject_CartItem_proBuyerProject_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type SetCartItemProBuyerProjectMutation_setCartItemProBuyerProject_CartItem = { __typename?: 'CartItem', id: any, proBuyerProject?: SetCartItemProBuyerProjectMutation_setCartItemProBuyerProject_CartItem_proBuyerProject_ProBuyerProjectRef | null };

export type SetCartItemProBuyerProjectMutation_Mutation = { __typename?: 'Mutation', setCartItemProBuyerProject: SetCartItemProBuyerProjectMutation_setCartItemProBuyerProject_CartItem };


export type SetCartItemProBuyerProjectMutationVariables = Exact<{
  cartItemId: Scalars['UUID']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetCartItemProBuyerProjectMutation = SetCartItemProBuyerProjectMutation_Mutation;

export type SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_activeProject_ProBuyerProject_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_activeProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string>, rooms: Array<SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_activeProject_ProBuyerProject_rooms_ProBuyerProjectRoom> };

export type SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_projects_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace = { __typename?: 'ProBuyerWorkspace', activeRoomId?: any | null, activeProject?: SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_activeProject_ProBuyerProject | null, projects: Array<SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace_projects_ProBuyerProject> };

export type SetProBuyerActiveProjectMutation_Mutation = { __typename?: 'Mutation', setProBuyerActiveProject: SetProBuyerActiveProjectMutation_setProBuyerActiveProject_ProBuyerWorkspace };


export type SetProBuyerActiveProjectMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  roomId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetProBuyerActiveProjectMutation = SetProBuyerActiveProjectMutation_Mutation;

export type UpdateProBuyerBrandProfileMutation_updateProBuyerBrandProfile_ProBuyerBrandProfile = { __typename?: 'ProBuyerBrandProfile', brandName: string, logo?: string | null, accentColor: string, fontStyle: ProBuyerProposalFontStyle, legalName: string, addressLine: string, postalCode: string, city: string, country: string, email: string, phone: string, website: string, cocNumber: string, vatNumber: string, saved: boolean };

export type UpdateProBuyerBrandProfileMutation_Mutation = { __typename?: 'Mutation', updateProBuyerBrandProfile: UpdateProBuyerBrandProfileMutation_updateProBuyerBrandProfile_ProBuyerBrandProfile };


export type UpdateProBuyerBrandProfileMutationVariables = Exact<{
  input: ProBuyerBrandProfileInput;
}>;


export type UpdateProBuyerBrandProfileMutation = UpdateProBuyerBrandProfileMutation_Mutation;

export type UpdateProBuyerProjectItemMutation_updateProBuyerProjectItem_ProBuyerProjectItem_room_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string };

export type UpdateProBuyerProjectItemMutation_updateProBuyerProjectItem_ProBuyerProjectItem = { __typename?: 'ProBuyerProjectItem', id: any, note: string, onMoodboard: boolean, room?: UpdateProBuyerProjectItemMutation_updateProBuyerProjectItem_ProBuyerProjectItem_room_ProBuyerProjectRoom | null };

export type UpdateProBuyerProjectItemMutation_Mutation = { __typename?: 'Mutation', updateProBuyerProjectItem: UpdateProBuyerProjectItemMutation_updateProBuyerProjectItem_ProBuyerProjectItem };


export type UpdateProBuyerProjectItemMutationVariables = Exact<{
  itemId: Scalars['UUID']['input'];
  input: ProBuyerProjectItemInput;
}>;


export type UpdateProBuyerProjectItemMutation = UpdateProBuyerProjectItemMutation_Mutation;

export type UpdateProBuyerProjectProposalMutation_updateProBuyerProjectProposal_ProBuyerProjectProposal = { __typename?: 'ProBuyerProjectProposal', title: string, clientName: string, intro: string, validUntil?: any | null, roomIds: Array<any>, includeUnassigned: boolean, showNotes: boolean, showDimensions: boolean, showTotals: boolean, hideUnavailable: boolean, pdfUrl: string, updatedAt?: any | null };

export type UpdateProBuyerProjectProposalMutation_Mutation = { __typename?: 'Mutation', updateProBuyerProjectProposal: UpdateProBuyerProjectProposalMutation_updateProBuyerProjectProposal_ProBuyerProjectProposal };


export type UpdateProBuyerProjectProposalMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  input: ProBuyerProjectProposalInput;
}>;


export type UpdateProBuyerProjectProposalMutation = UpdateProBuyerProjectProposalMutation_Mutation;

export type UpdateProBuyerProjectRoomMutation_updateProBuyerProjectRoom_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type UpdateProBuyerProjectRoomMutation_Mutation = { __typename?: 'Mutation', updateProBuyerProjectRoom: UpdateProBuyerProjectRoomMutation_updateProBuyerProjectRoom_ProBuyerProjectRoom };


export type UpdateProBuyerProjectRoomMutationVariables = Exact<{
  roomId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProBuyerProjectRoomMutation = UpdateProBuyerProjectRoomMutation_Mutation;

export type UpdateProBuyerProjectShareMutation_updateProBuyerProjectShare_ProBuyerProjectShare = { __typename?: 'ProBuyerProjectShare', enabled: boolean, token?: string | null, message: string, showPrices: boolean, showNotes: boolean, allowReactions: boolean, updatedAt?: any | null };

export type UpdateProBuyerProjectShareMutation_Mutation = { __typename?: 'Mutation', updateProBuyerProjectShare: UpdateProBuyerProjectShareMutation_updateProBuyerProjectShare_ProBuyerProjectShare };


export type UpdateProBuyerProjectShareMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  input: ProBuyerProjectShareInput;
}>;


export type UpdateProBuyerProjectShareMutation = UpdateProBuyerProjectShareMutation_Mutation;

export type CheckoutPromotionMutation_checkoutPromotion_PromotionCheckout = { __typename?: 'PromotionCheckout', campaignId: string, orderGroupId: string, paymentIntentClientSecret: string };

export type CheckoutPromotionMutation_Mutation = { __typename?: 'Mutation', checkoutPromotion: CheckoutPromotionMutation_checkoutPromotion_PromotionCheckout };


export type CheckoutPromotionMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  immediateStartConsent: Scalars['Boolean']['input'];
  termsVersion: Scalars['String']['input'];
}>;


export type CheckoutPromotionMutation = CheckoutPromotionMutation_Mutation;

export type CreatePromotionQuoteMutation_createPromotionQuote_PromotionQuote = { __typename?: 'PromotionQuote', id: string, expiresAt: any, purchaseContext: PromotionPurchaseContext, termsVersion: string, label?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_label_PromotionLabel | null, pack?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_pack_PromotionQuotePack | null, tax: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_tax_PromotionTax, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_price_PromotionMoney, offer: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer };

export type CreatePromotionQuoteMutation_Mutation = { __typename?: 'Mutation', createPromotionQuote: CreatePromotionQuoteMutation_createPromotionQuote_PromotionQuote };


export type CreatePromotionQuoteMutationVariables = Exact<{
  displayCurrency?: InputMaybe<Currency>;
  productId: Scalars['ID']['input'];
  offerCode: Scalars['String']['input'];
  labelCode?: InputMaybe<Scalars['String']['input']>;
  labelAttested?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseContext?: InputMaybe<PromotionPurchaseContext>;
  pack?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePromotionQuoteMutation = CreatePromotionQuoteMutation_Mutation;

export type RequestPromotionWithdrawalMutation_requestPromotionWithdrawal_PromotionCampaign = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, effects: Array<PromotionEffect>, catalogueVersion: number, status: PromotionStatus, paymentStatus: PromotionPaymentStatus, startsAt?: any | null, endsAt?: any | null, paidAt?: any | null, statusReason?: string | null, canResumeCheckout: boolean, canWithdraw: boolean, pack?: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack | null, benefits: Array<PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit>, price?: PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney | null, metrics?: PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics | null };

export type RequestPromotionWithdrawalMutation_Mutation = { __typename?: 'Mutation', requestPromotionWithdrawal: RequestPromotionWithdrawalMutation_requestPromotionWithdrawal_PromotionCampaign };


export type RequestPromotionWithdrawalMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RequestPromotionWithdrawalMutation = RequestPromotionWithdrawalMutation_Mutation;

export type ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_campaign_PromotionCampaign = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, effects: Array<PromotionEffect>, catalogueVersion: number, status: PromotionStatus, paymentStatus: PromotionPaymentStatus, startsAt?: any | null, endsAt?: any | null, paidAt?: any | null, statusReason?: string | null, canResumeCheckout: boolean, canWithdraw: boolean, pack?: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack | null, benefits: Array<PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit>, price?: PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney | null, metrics?: PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics | null };

export type ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_packageCheckout_PackageCheckout = { __typename?: 'PackageCheckout', id: string };

export type ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_checkout_PromotionCheckout = { __typename?: 'PromotionCheckout', campaignId: string, orderGroupId: string, paymentIntentClientSecret: string };

export type ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout = { __typename?: 'PromotionResumeCheckout', campaign: ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_campaign_PromotionCampaign, packageCheckout?: ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_packageCheckout_PackageCheckout | null, checkout?: ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout_checkout_PromotionCheckout | null };

export type ResumePromotionCheckoutMutation_Mutation = { __typename?: 'Mutation', resumePromotionCheckout: ResumePromotionCheckoutMutation_resumePromotionCheckout_PromotionResumeCheckout };


export type ResumePromotionCheckoutMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ResumePromotionCheckoutMutation = ResumePromotionCheckoutMutation_Mutation;

export type ReactivateProductMutation_reactivateProduct_Product = { __typename?: 'Product', id: any, status: ProductStatus };

export type ReactivateProductMutation_Mutation = { __typename?: 'Mutation', reactivateProduct: ReactivateProductMutation_reactivateProduct_Product };


export type ReactivateProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReactivateProductMutation = ReactivateProductMutation_Mutation;

export type RemoveAddressMutation_Mutation = { __typename?: 'Mutation', removeAddress: boolean };


export type RemoveAddressMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveAddressMutation = RemoveAddressMutation_Mutation;

export type RemoveCartItemMutation_removeCartItem_CartItem_product_Product = { __typename?: 'Product', isInCart: boolean };

export type RemoveCartItemMutation_removeCartItem_CartItem = { __typename?: 'CartItem', id: any, product: RemoveCartItemMutation_removeCartItem_CartItem_product_Product };

export type RemoveCartItemMutation_Mutation = { __typename?: 'Mutation', removeCartItem: RemoveCartItemMutation_removeCartItem_CartItem };


export type RemoveCartItemMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveCartItemMutation = RemoveCartItemMutation_Mutation;

export type RemoveComingSoonAlertMutation_Mutation = { __typename?: 'Mutation', removeComingSoonAlert: boolean };


export type RemoveComingSoonAlertMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveComingSoonAlertMutation = RemoveComingSoonAlertMutation_Mutation;

export type RemoveFavoriteProductMutation_Mutation = { __typename?: 'Mutation', removeFavorite: boolean };


export type RemoveFavoriteProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveFavoriteProductMutation = RemoveFavoriteProductMutation_Mutation;

export type RequestAccountDeletionMutation_requestAccountDeletion_RequestAccountDeletionResponse = { __typename?: 'RequestAccountDeletionResponse', requestedDeletionAt: any, scheduledDeletionAt: any };

export type RequestAccountDeletionMutation_Mutation = { __typename?: 'Mutation', requestAccountDeletion: RequestAccountDeletionMutation_requestAccountDeletion_RequestAccountDeletionResponse };


export type RequestAccountDeletionMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestAccountDeletionMutation = RequestAccountDeletionMutation_Mutation;

export type RequestDeliveryQuoteMutation_requestDeliveryQuote_DeliveryQuote = { __typename?: 'DeliveryQuote', id: any, status: DeliveryQuoteStatus, postalCode: string, region: string, city: string, deliveryType: DeliveryQuoteDeliveryType, requestedAt: any, validUntil?: any | null, fee?: DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price | null };

export type RequestDeliveryQuoteMutation_Mutation = { __typename?: 'Mutation', requestDeliveryQuote: RequestDeliveryQuoteMutation_requestDeliveryQuote_DeliveryQuote };


export type RequestDeliveryQuoteMutationVariables = Exact<{
  input: RequestDeliveryQuoteInput;
  currency?: InputMaybe<Currency>;
}>;


export type RequestDeliveryQuoteMutation = RequestDeliveryQuoteMutation_Mutation;

export type RequestEmailTokenMutation_Mutation = { __typename?: 'Mutation', requestEmailToken: string };


export type RequestEmailTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type RequestEmailTokenMutation = RequestEmailTokenMutation_Mutation;

export type RequestPhoneUpdateOtpMutation_requestPhoneUpdateOTP_RequestPhoneUpdateOTPResponse = { __typename?: 'RequestPhoneUpdateOTPResponse', success: boolean, message: string, retryAfter: number };

export type RequestPhoneUpdateOtpMutation_Mutation = { __typename?: 'Mutation', requestPhoneUpdateOTP: RequestPhoneUpdateOtpMutation_requestPhoneUpdateOTP_RequestPhoneUpdateOTPResponse };


export type RequestPhoneUpdateOtpMutationVariables = Exact<{
  input: RequestPhoneUpdateOtpInput;
}>;


export type RequestPhoneUpdateOtpMutation = RequestPhoneUpdateOtpMutation_Mutation;

export type CreateFeedbackMutation_createFeedback_Order = { __typename?: 'Order', id: any, state: OrderState, disputeReason?: string | null };

export type CreateFeedbackMutation_Mutation = { __typename?: 'Mutation', createFeedback: CreateFeedbackMutation_createFeedback_Order };


export type CreateFeedbackMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  received: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  disputeReason?: InputMaybe<DisputeReason>;
}>;


export type CreateFeedbackMutation = CreateFeedbackMutation_Mutation;

export type SendContactMessageMutation_sendContactMessage_SendContactMessageResponse = { __typename?: 'SendContactMessageResponse', received: boolean, reference: string };

export type SendContactMessageMutation_Mutation = { __typename?: 'Mutation', sendContactMessage: SendContactMessageMutation_sendContactMessage_SendContactMessageResponse };


export type SendContactMessageMutationVariables = Exact<{
  input: SendContactMessageInput;
}>;


export type SendContactMessageMutation = SendContactMessageMutation_Mutation;

export type SendHelpFeedbackMutation_Mutation = { __typename?: 'Mutation', sendHelpFeedback: boolean };


export type SendHelpFeedbackMutationVariables = Exact<{
  articleId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  helpful: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendHelpFeedbackMutation = SendHelpFeedbackMutation_Mutation;

export type SendOtpMutation_sendOtp_SendOtpResponse = { __typename?: 'SendOtpResponse', message: string, success: boolean };

export type SendOtpMutation_Mutation = { __typename?: 'Mutation', sendOtp: SendOtpMutation_sendOtp_SendOtpResponse };


export type SendOtpMutationVariables = Exact<{ [key: string]: never; }>;


export type SendOtpMutation = SendOtpMutation_Mutation;

export type CreateBrowserTokenMutation_createBrowserToken_BrowserToken = { __typename?: 'BrowserToken', accessToken: string, expiresAt: any };

export type CreateBrowserTokenMutation_Mutation = { __typename?: 'Mutation', createBrowserToken: CreateBrowserTokenMutation_createBrowserToken_BrowserToken };


export type CreateBrowserTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBrowserTokenMutation = CreateBrowserTokenMutation_Mutation;

export type LogoutSessionMutation_Mutation = { __typename?: 'Mutation', logout: boolean };


export type LogoutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutSessionMutation = LogoutSessionMutation_Mutation;

export type RenewWebSessionMutation_renewWebSession_WebSession = { __typename?: 'WebSession', accessToken: string, expiresAt: any };

export type RenewWebSessionMutation_Mutation = { __typename?: 'Mutation', renewWebSession: RenewWebSessionMutation_renewWebSession_WebSession };


export type RenewWebSessionMutationVariables = Exact<{
  revokePrevious?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RenewWebSessionMutation = RenewWebSessionMutation_Mutation;

export type SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant_default_shipping_address_Address = { __typename?: 'Address', id: any };

export type SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant_invoice_address_Address = { __typename?: 'Address', id: any };

export type SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant = { __typename?: 'Merchant', id: any, default_shipping_address?: SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant_default_shipping_address_Address | null, invoice_address?: SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant_invoice_address_Address | null };

export type SetDefaultShippingAddressMutation_Mutation = { __typename?: 'Mutation', setDefaultShippingAddress: SetDefaultShippingAddressMutation_setDefaultShippingAddress_Merchant };


export type SetDefaultShippingAddressMutationVariables = Exact<{
  addressId: Scalars['UUID']['input'];
}>;


export type SetDefaultShippingAddressMutation = SetDefaultShippingAddressMutation_Mutation;

export type SetInvoiceAddressMutation_setInvoiceAddress_Merchant_default_shipping_address_Address = { __typename?: 'Address', id: any };

export type SetInvoiceAddressMutation_setInvoiceAddress_Merchant_invoice_address_Address = { __typename?: 'Address', id: any };

export type SetInvoiceAddressMutation_setInvoiceAddress_Merchant = { __typename?: 'Merchant', id: any, default_shipping_address?: SetInvoiceAddressMutation_setInvoiceAddress_Merchant_default_shipping_address_Address | null, invoice_address?: SetInvoiceAddressMutation_setInvoiceAddress_Merchant_invoice_address_Address | null };

export type SetInvoiceAddressMutation_Mutation = { __typename?: 'Mutation', setInvoiceAddress: SetInvoiceAddressMutation_setInvoiceAddress_Merchant };


export type SetInvoiceAddressMutationVariables = Exact<{
  addressId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetInvoiceAddressMutation = SetInvoiceAddressMutation_Mutation;

export type SetPreferredCurrencyMutation_setPreferredCurrency_Member = { __typename?: 'Member', id: any, preferred_currency?: Currency | null };

export type SetPreferredCurrencyMutation_Mutation = { __typename?: 'Mutation', setPreferredCurrency: SetPreferredCurrencyMutation_setPreferredCurrency_Member };


export type SetPreferredCurrencyMutationVariables = Exact<{
  currency: Currency;
}>;


export type SetPreferredCurrencyMutation = SetPreferredCurrencyMutation_Mutation;

export type SignupMutation_signup_SignupResponse = { __typename?: 'SignupResponse', access_token: string };

export type SignupMutation_Mutation = { __typename?: 'Mutation', signup: SignupMutation_signup_SignupResponse };


export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = SignupMutation_Mutation;

export type TranslateReviewsMutation_translateReviews_Review_reviewer_Merchant = { __typename?: 'Merchant', name: string };

export type TranslateReviewsMutation_translateReviews_Review = { __typename?: 'Review', id: any, review?: string | null, score?: number | null, created?: any | null, originalReview?: string | null, reviewer?: TranslateReviewsMutation_translateReviews_Review_reviewer_Merchant | null };

export type TranslateReviewsMutation_Mutation = { __typename?: 'Mutation', translateReviews?: Array<TranslateReviewsMutation_translateReviews_Review> | null };


export type TranslateReviewsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang: Language;
}>;


export type TranslateReviewsMutation = TranslateReviewsMutation_Mutation;

export type UnsubscribeFromEmailMutation_Mutation = { __typename?: 'Mutation', unsubscribeFromEmail: boolean };


export type UnsubscribeFromEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnsubscribeFromEmailMutation = UnsubscribeFromEmailMutation_Mutation;

export type UpdateCartMutation_updateCart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, billing_address?: CartFragmentFragment_Cart_billing_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type UpdateCartMutation_Mutation = { __typename?: 'Mutation', updateCart: UpdateCartMutation_updateCart_Cart };


export type UpdateCartMutationVariables = Exact<{
  payment_method?: InputMaybe<PaymentMethod>;
  delivery_method?: InputMaybe<DeliveryMethod>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  shipping_address_id?: InputMaybe<Scalars['UUID']['input']>;
  billing_address_id?: InputMaybe<Scalars['UUID']['input']>;
  buyer_protection?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type UpdateCartMutation = UpdateCartMutation_Mutation;

export type UpdateCartItemMutation_updateCartItem_CartItem = { __typename?: 'CartItem', id: any };

export type UpdateCartItemMutation_Mutation = { __typename?: 'Mutation', updateCartItem: UpdateCartItemMutation_updateCartItem_CartItem };


export type UpdateCartItemMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  shippingMethod?: InputMaybe<ShippingMethodEnum>;
  shippingProvider?: InputMaybe<ShippingProviderEnum>;
  shippingOptionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  services?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type UpdateCartItemMutation = UpdateCartItemMutation_Mutation;

export type UpdateForgottenPasswordMutation_updateForgottenPassword_UpdateForgottenPasswordResponse = { __typename?: 'UpdateForgottenPasswordResponse', message: string, status: UpdateForgottenPasswordResult };

export type UpdateForgottenPasswordMutation_Mutation = { __typename?: 'Mutation', updateForgottenPassword: UpdateForgottenPasswordMutation_updateForgottenPassword_UpdateForgottenPasswordResponse };


export type UpdateForgottenPasswordMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  token: Scalars['String']['input'];
  new_password: Scalars['String']['input'];
  new_password_confirmation: Scalars['String']['input'];
}>;


export type UpdateForgottenPasswordMutation = UpdateForgottenPasswordMutation_Mutation;

export type UpdateMeMutation_updateMe_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, name: string, email?: string | null, phone?: string | null };

export type UpdateMeMutation_updateMe_Member = { __typename?: 'Member', id: any, email: string, given_name: string, family_name: string, dob?: any | null, locale: Locale, placeOfBirth?: string | null, countryOfBirth?: string | null, merchants: Array<UpdateMeMutation_updateMe_Member_merchants_Merchant> };

export type UpdateMeMutation_Mutation = { __typename?: 'Mutation', updateMe: UpdateMeMutation_updateMe_Member };


export type UpdateMeMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Locale>;
  type?: InputMaybe<MerchantType>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['UUID']['input']>;
  place_of_birth?: InputMaybe<Scalars['String']['input']>;
  country_of_birth?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMeMutation = UpdateMeMutation_Mutation;

export type UpdateNotificationPreferencesMutation_updateNotificationPreferences_NotificationPreferences_preferences_NotificationPreference = { __typename?: 'NotificationPreference', key: string, section: NotificationPreferenceSection, alwaysOn: boolean, email: boolean, push: boolean, whatsapp?: boolean | null };

export type UpdateNotificationPreferencesMutation_updateNotificationPreferences_NotificationPreferences = { __typename?: 'NotificationPreferences', preferences: Array<UpdateNotificationPreferencesMutation_updateNotificationPreferences_NotificationPreferences_preferences_NotificationPreference> };

export type UpdateNotificationPreferencesMutation_Mutation = { __typename?: 'Mutation', updateNotificationPreferences: UpdateNotificationPreferencesMutation_updateNotificationPreferences_NotificationPreferences };


export type UpdateNotificationPreferencesMutationVariables = Exact<{
  input: Array<NotificationPreferenceInput> | NotificationPreferenceInput;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNotificationPreferencesMutation = UpdateNotificationPreferencesMutation_Mutation;

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, phone?: string | null, verified?: boolean | null };

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member = { __typename?: 'Member', id: any, merchants: Array<UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member_merchants_Merchant> };

export type UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse = { __typename?: 'UpdatePhoneWithOTPResponse', success: boolean, message: string, user: UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse_user_Member };

export type UpdatePhoneWithOtpMutation_Mutation = { __typename?: 'Mutation', updatePhoneWithOTP: UpdatePhoneWithOtpMutation_updatePhoneWithOTP_UpdatePhoneWithOTPResponse };


export type UpdatePhoneWithOtpMutationVariables = Exact<{
  input: UpdatePhoneWithOtpInput;
}>;


export type UpdatePhoneWithOtpMutation = UpdatePhoneWithOtpMutation_Mutation;

export type UpdateProductMutation_updateProduct_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, auto_discount?: boolean | null, favorite_count: number, showroomModel: boolean, quality?: ProductQuality | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, shape?: Shape | null, last_boost?: any | null, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postal_package_weight_kg?: number | null, buy_now_price?: ProductFragmentFragment_Product_buy_now_price_Price | null, newPrice?: ProductFragmentFragment_Product_newPrice_Price | null, brand?: ProductFragmentFragment_Product_brand_Brand | null, original_price?: ProductFragmentFragment_Product_original_price_Price | null, image?: ProductFragmentFragment_Product_image_Image | null, images: Array<ProductFragmentFragment_Product_images_Image>, address?: ProductFragmentFragment_Product_address_Address | null, auction?: ProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: ProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<ProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: ProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: ProductFragmentFragment_Product_merchant_Merchant, favorite?: ProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<ProductFragmentFragment_Product_categories_Category>, attributes: Array<ProductFragmentFragment_Product_attributes>, product_type?: ProductFragmentFragment_Product_product_type_ProductType | null };

export type UpdateProductMutation_Mutation = { __typename?: 'Mutation', updateProduct: UpdateProductMutation_updateProduct_Product };


export type UpdateProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = UpdateProductMutation_Mutation;

export type ValidateVoucherMutation_validateVoucher_ValidateVoucherInvalid = { __typename?: 'ValidateVoucherInvalid', invalid: boolean, invalid_reason: string };

export type ValidateVoucherMutation_validateVoucher_ValidateVoucherValid = { __typename?: 'ValidateVoucherValid', type: DiscountType, value: number };

export type ValidateVoucherMutation_validateVoucher = ValidateVoucherMutation_validateVoucher_ValidateVoucherInvalid | ValidateVoucherMutation_validateVoucher_ValidateVoucherValid;

export type ValidateVoucherMutation_Mutation = { __typename?: 'Mutation', validateVoucher: ValidateVoucherMutation_validateVoucher };


export type ValidateVoucherMutationVariables = Exact<{
  code: Scalars['String']['input'];
  orderAmount?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ValidateVoucherMutation = ValidateVoucherMutation_Mutation;

export type VerifyOtpMutation_verifyOtp_VerifyOtpResponse = { __typename?: 'VerifyOtpResponse', message: string, success: boolean };

export type VerifyOtpMutation_Mutation = { __typename?: 'Mutation', verifyOtp: VerifyOtpMutation_verifyOtp_VerifyOtpResponse };


export type VerifyOtpMutationVariables = Exact<{
  input: VerifyOtpInput;
}>;


export type VerifyOtpMutation = VerifyOtpMutation_Mutation;

export type AdsAboutToExpireQuery_products_ProductResult_items_Product_image_Image = { __typename?: 'Image', url: string, width?: number | null, height?: number | null };

export type AdsAboutToExpireQuery_products_ProductResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: AdsAboutToExpireQuery_products_ProductResult_items_Product_image_Image | null };

export type AdsAboutToExpireQuery_products_ProductResult_pagination_PaginationResult = { __typename?: 'PaginationResult', count: number };

export type AdsAboutToExpireQuery_products_ProductResult = { __typename?: 'ProductResult', items: Array<AdsAboutToExpireQuery_products_ProductResult_items_Product>, pagination: AdsAboutToExpireQuery_products_ProductResult_pagination_PaginationResult };

export type AdsAboutToExpireQuery_Query = { __typename?: 'Query', products: AdsAboutToExpireQuery_products_ProductResult };


export type AdsAboutToExpireQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
}>;


export type AdsAboutToExpireQuery = AdsAboutToExpireQuery_Query;

export type AgentAuthorizationRequestQuery_agentAuthorizationRequest_AgentAuthorizationRequest = { __typename?: 'AgentAuthorizationRequest', clientName: string, clientId: string, redirectHost: string, logoUri?: string | null, scopes: Array<string>, canApprove: boolean };

export type AgentAuthorizationRequestQuery_Query = { __typename?: 'Query', agentAuthorizationRequest: AgentAuthorizationRequestQuery_agentAuthorizationRequest_AgentAuthorizationRequest };


export type AgentAuthorizationRequestQueryVariables = Exact<{
  input: AgentAuthorizationInput;
}>;


export type AgentAuthorizationRequestQuery = AgentAuthorizationRequestQuery_Query;

export type AgentGrantsQuery_agentGrants_AgentGrant = { __typename?: 'AgentGrant', id: string, clientName: string, clientId: string, scopes: Array<string>, created: any, lastUsedAt?: any | null };

export type AgentGrantsQuery_Query = { __typename?: 'Query', agentGrants: Array<AgentGrantsQuery_agentGrants_AgentGrant> };


export type AgentGrantsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgentGrantsQuery = AgentGrantsQuery_Query;

export type AttributesQuery_attributesByKey_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, slug: string };

export type AttributesQuery_attributesByKey_Artist = { __typename?: 'Artist', id: any, title: string };

export type AttributesQuery_attributesByKey_Brand = { __typename?: 'Brand' };

export type AttributesQuery_attributesByKey_Color = { __typename?: 'Color', id: any, slug: string, hex?: string | null, title: string };

export type AttributesQuery_attributesByKey_Designer = { __typename?: 'Designer' };

export type AttributesQuery_attributesByKey_HardwareColor = { __typename?: 'HardwareColor', id: any, slug: string, hex?: string | null, title: string };

export type AttributesQuery_attributesByKey_Label = { __typename?: 'Label' };

export type AttributesQuery_attributesByKey_Material = { __typename?: 'Material', id: any, title: string };

export type AttributesQuery_attributesByKey_Style = { __typename?: 'Style' };

export type AttributesQuery_attributesByKey_Subject = { __typename?: 'Subject' };

export type AttributesQuery_attributesByKey_UsageSign = { __typename?: 'UsageSign', id: any, slug: string };

export type AttributesQuery_attributesByKey = AttributesQuery_attributesByKey_AdditionalInfo | AttributesQuery_attributesByKey_Artist | AttributesQuery_attributesByKey_Brand | AttributesQuery_attributesByKey_Color | AttributesQuery_attributesByKey_Designer | AttributesQuery_attributesByKey_HardwareColor | AttributesQuery_attributesByKey_Label | AttributesQuery_attributesByKey_Material | AttributesQuery_attributesByKey_Style | AttributesQuery_attributesByKey_Subject | AttributesQuery_attributesByKey_UsageSign;

export type AttributesQuery_Query = { __typename?: 'Query', attributesByKey: Array<AttributesQuery_attributesByKey> };


export type AttributesQueryVariables = Exact<{
  key?: InputMaybe<AttributeFilterKey>;
  value: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type AttributesQuery = AttributesQuery_Query;

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_AdditionalInfo = { __typename?: 'AdditionalInfo', id: any, slug: string, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Artist = { __typename?: 'Artist', id: any, slug: string, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Brand = { __typename?: 'Brand', id: any, slug: string, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Color = { __typename?: 'Color', id: any, slug: string, hex?: string | null, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Designer = { __typename?: 'Designer' };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_HardwareColor = { __typename?: 'HardwareColor', id: any, slug: string, hex?: string | null, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Label = { __typename?: 'Label' };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Material = { __typename?: 'Material', id: any, slug: string, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Style = { __typename?: 'Style' };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Subject = { __typename?: 'Subject' };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_UsageSign = { __typename?: 'UsageSign', id: any, slug: string, title: string };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_items = AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_AdditionalInfo | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Artist | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Brand | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Color | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Designer | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_HardwareColor | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Label | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Material | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Style | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_Subject | AttributesByCategoryQuery_attributesByCategory_AttributeResult_items_UsageSign;

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number };

export type AttributesByCategoryQuery_attributesByCategory_AttributeResult = { __typename?: 'AttributeResult', items: Array<AttributesByCategoryQuery_attributesByCategory_AttributeResult_items>, pagination: AttributesByCategoryQuery_attributesByCategory_AttributeResult_pagination_PaginationResult };

export type AttributesByCategoryQuery_Query = { __typename?: 'Query', attributesByCategory: AttributesByCategoryQuery_attributesByCategory_AttributeResult };


export type AttributesByCategoryQueryVariables = Exact<{
  category?: InputMaybe<Scalars['UUID']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type AttributesByCategoryQuery = AttributesByCategoryQuery_Query;

export type BoostPackagesQuery_boostPackages_BoostPackage_originalPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostPackagesQuery_boostPackages_BoostPackage_discountedPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type BoostPackagesQuery_boostPackages_BoostPackage = { __typename?: 'BoostPackage', days: number, isMostPopular: boolean, originalPrice: BoostPackagesQuery_boostPackages_BoostPackage_originalPrice_Price, discountedPrice: BoostPackagesQuery_boostPackages_BoostPackage_discountedPrice_Price };

export type BoostPackagesQuery_Query = { __typename?: 'Query', boostPackages: Array<BoostPackagesQuery_boostPackages_BoostPackage> };


export type BoostPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type BoostPackagesQuery = BoostPackagesQuery_Query;

export type BoostCartQuery_boostCart_BoostCart = { __typename?: 'BoostCart', products: Array<BoostCartFragmentFragment_BoostCart_products_Product>, items: Array<BoostCartFragmentFragment_BoostCart_items_BoostCartItem>, total: BoostCartFragmentFragment_BoostCart_total_Price };

export type BoostCartQuery_Query = { __typename?: 'Query', boostCart: BoostCartQuery_boostCart_BoostCart };


export type BoostCartQueryVariables = Exact<{ [key: string]: never; }>;


export type BoostCartQuery = BoostCartQuery_Query;

export type BrandsQuery_brands_Brand_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type BrandsQuery_brands_Brand = { __typename?: 'Brand', id: any, title: string, slug: string, image?: string | null, listingPage?: BrandsQuery_brands_Brand_listingPage_ListingPage | null };

export type BrandsQuery_Query = { __typename?: 'Query', brands: Array<BrandsQuery_brands_Brand> };


export type BrandsQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  filters?: InputMaybe<BrandsFilter>;
}>;


export type BrandsQuery = BrandsQuery_Query;

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_unavailableDates_UnavailableDate = { __typename?: 'UnavailableDate', date: any, state: UnavailableDateState };

export type GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions = { __typename?: 'BrengerAppointmentOptions', dateFrom?: any | null, dateTo?: any | null, finalised: boolean, awaitingResponseFrom?: GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_awaitingResponseFrom_Merchant | null, unavailableDates?: Array<GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions_unavailableDates_UnavailableDate> | null };

export type GetBrengerAppointmentOptionsQuery_Query = { __typename?: 'Query', getBrengerAppointmentOptions: GetBrengerAppointmentOptionsQuery_getBrengerAppointmentOptions_BrengerAppointmentOptions };


export type GetBrengerAppointmentOptionsQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type GetBrengerAppointmentOptionsQuery = GetBrengerAppointmentOptionsQuery_Query;

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate_merchant_Merchant = { __typename?: 'Merchant', name: string };

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate = { __typename?: 'BrengerProposedDate', id: any, date: any, state: BrengerProposedDateState, merchantId: any, merchant: GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate_merchant_Merchant };

export type GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates = { __typename?: 'BrengerProposedDates', proposedDates: Array<GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates_proposedDates_BrengerProposedDate> };

export type GetBrengerProposedDatesQuery_Query = { __typename?: 'Query', getBrengerProposedDates: GetBrengerProposedDatesQuery_getBrengerProposedDates_BrengerProposedDates };


export type GetBrengerProposedDatesQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
}>;


export type GetBrengerProposedDatesQuery = GetBrengerProposedDatesQuery_Query;

export type CartQueryQuery_cart_Cart = { __typename?: 'Cart', id: any, payment_method: PaymentMethod, coupon_code?: string | null, payment?: CartFragmentFragment_Cart_payment_CartPayment | null, shipping_address?: CartFragmentFragment_Cart_shipping_address_Address | null, billing_address?: CartFragmentFragment_Cart_billing_address_Address | null, items: Array<CartFragmentFragment_Cart_items_CartItem>, available_coupon_codes: Array<CartFragmentFragment_Cart_available_coupon_codes_CouponCode>, totals2?: CartFragmentFragment_Cart_totals2_CartTotals | null };

export type CartQueryQuery_Query = { __typename?: 'Query', cart: CartQueryQuery_cart_Cart };


export type CartQueryQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type CartQueryQuery = CartQueryQuery_Query;

export type CartCountQuery_Query = { __typename?: 'Query', cartCount: number };


export type CartCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CartCountQuery = CartCountQuery_Query;

export type CartPaymentMethodConfigurationQuery_cart_Cart = { __typename?: 'Cart', id: any, paymentMethodConfiguration?: string | null };

export type CartPaymentMethodConfigurationQuery_Query = { __typename?: 'Query', cart: CartPaymentMethodConfigurationQuery_cart_Cart };


export type CartPaymentMethodConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type CartPaymentMethodConfigurationQuery = CartPaymentMethodConfigurationQuery_Query;

export type GetProductShippingOptionsQuery_getProductShippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type GetProductShippingOptionsQuery_Query = { __typename?: 'Query', getProductShippingOptions: Array<GetProductShippingOptionsQuery_getProductShippingOptions_ShippingOption> };


export type GetProductShippingOptionsQueryVariables = Exact<{
  input?: InputMaybe<ProductShippingOptionsInput>;
}>;


export type GetProductShippingOptionsQuery = GetProductShippingOptionsQuery_Query;

export type ListingPageQuery_listingPage_ListingPage_filters_ListingPageFilterItem = { __typename?: 'ListingPageFilterItem', key: ListingPageFilterKey, value: string };

export type ListingPageQuery_listingPage_ListingPage_categoryPages_ListingCategoryPage = { __typename?: 'ListingCategoryPage', listingLevel: ListingLevel, activeProductCount: number, url: string, title: string };

export type ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage_category_Category = { __typename?: 'Category', icon?: string | null };

export type ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage = { __typename?: 'ListingPage', url: string, title: string, category?: ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage_category_Category | null };

export type ListingPageQuery_listingPage_ListingPage_breadcrumbs_ListingPage = { __typename?: 'ListingPage', url: string, title: string, title_en: string };

export type ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage = { __typename?: 'RelatedListingPage', type: ListingPageRelationType, listingPage: ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage };

export type ListingPageQuery_listingPage_ListingPage = { __typename?: 'ListingPage', title: string, url: string, description?: string | null, image?: string | null, sort?: SearchSort | null, order?: Ordering | null, recommended?: boolean | null, noIndex?: boolean | null, url_en: string, url_nl: string, url_de: string, url_fr: string, url_it: string, url_es: string, filters: Array<ListingPageQuery_listingPage_ListingPage_filters_ListingPageFilterItem>, categoryPages: Array<ListingPageQuery_listingPage_ListingPage_categoryPages_ListingCategoryPage>, subcategoryPages: Array<ListingPageQuery_listingPage_ListingPage_subcategoryPages_ListingPage>, breadcrumbs: Array<ListingPageQuery_listingPage_ListingPage_breadcrumbs_ListingPage>, relatedListingPages: Array<ListingPageQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage> };

export type ListingPageQuery_Query = { __typename?: 'Query', listingPage?: ListingPageQuery_listingPage_ListingPage | null };


export type ListingPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  lang: Language;
}>;


export type ListingPageQuery = ListingPageQuery_Query;

export type CategoriesQuery_categories_CategoryResult_items_Category_parent_Category = { __typename?: 'Category', id: any, slug: string, level?: number | null, slug_en: string };

export type CategoriesQuery_categories_CategoryResult_items_Category_children_Category = { __typename?: 'Category', id: any };

export type CategoriesQuery_categories_CategoryResult_items_Category = { __typename?: 'Category', id: any, slug: string, level?: number | null, title: string, slug_en: string, parent?: CategoriesQuery_categories_CategoryResult_items_Category_parent_Category | null, children?: Array<CategoriesQuery_categories_CategoryResult_items_Category_children_Category | null> | null };

export type CategoriesQuery_categories_CategoryResult = { __typename?: 'CategoryResult', items: Array<CategoriesQuery_categories_CategoryResult_items_Category> };

export type CategoriesQuery_Query = { __typename?: 'Query', categories: CategoriesQuery_categories_CategoryResult };


export type CategoriesQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type CategoriesQuery = CategoriesQuery_Query;

export type GetListThreadQuery_thread_Thread = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type GetListThreadQuery_Query = { __typename?: 'Query', thread?: GetListThreadQuery_thread_Thread | null };


export type GetListThreadQueryVariables = Exact<{
  threadId: Scalars['UUID']['input'];
}>;


export type GetListThreadQuery = GetListThreadQuery_Query;

export type GetMessagesQuery_getMessages_GetMessagesResult_items_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, status?: MessageStatus | null, originalBody?: string | null, rejectionReason?: MessageFragment_Message_rejectionReason_MessageRejectionReason | null, sender: MessageFragment_Message_sender_Member, merchant: MessageFragment_Message_merchant_Merchant, item?: MessageFragment_Message_item | null };

export type GetMessagesQuery_getMessages_GetMessagesResult_pagination_CursorPaginationResult = { __typename?: 'CursorPaginationResult', hasMore: boolean };

export type GetMessagesQuery_getMessages_GetMessagesResult = { __typename?: 'GetMessagesResult', items: Array<GetMessagesQuery_getMessages_GetMessagesResult_items_Message>, pagination: GetMessagesQuery_getMessages_GetMessagesResult_pagination_CursorPaginationResult };

export type GetMessagesQuery_Query = { __typename?: 'Query', getMessages: GetMessagesQuery_getMessages_GetMessagesResult };


export type GetMessagesQueryVariables = Exact<{
  input: GetMessagesInput;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type GetMessagesQuery = GetMessagesQuery_Query;

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_addresses_Address = { __typename?: 'Address', city: string, country: string };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_image_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant = { __typename?: 'Merchant', id: any, email?: string | null, type: MerchantType, expert_seller?: boolean | null, name: string, created: any, rating?: number | null, reviewsCount?: number | null, addresses: Array<GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_addresses_Address>, image?: GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant_image_Image | null };

export type GetThreadQuery_thread_Thread_subscribers_Subscriber = { __typename?: 'Subscriber', id: any, requestedTranslationLanguage?: string | null, merchant: GetThreadQuery_thread_Thread_subscribers_Subscriber_merchant_Merchant };

export type GetThreadQuery_thread_Thread_item_Product_categories_Category = { __typename?: 'Category', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Artist = { __typename?: 'Artist' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Brand = { __typename?: 'Brand' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Color = { __typename?: 'Color' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Designer = { __typename?: 'Designer' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Label = { __typename?: 'Label' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Material = { __typename?: 'Material', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Style = { __typename?: 'Style', slug: string };

export type GetThreadQuery_thread_Thread_item_Product_attributes_Subject = { __typename?: 'Subject' };

export type GetThreadQuery_thread_Thread_item_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type GetThreadQuery_thread_Thread_item_Product_attributes = GetThreadQuery_thread_Thread_item_Product_attributes_AdditionalInfo | GetThreadQuery_thread_Thread_item_Product_attributes_Artist | GetThreadQuery_thread_Thread_item_Product_attributes_Brand | GetThreadQuery_thread_Thread_item_Product_attributes_Color | GetThreadQuery_thread_Thread_item_Product_attributes_Designer | GetThreadQuery_thread_Thread_item_Product_attributes_HardwareColor | GetThreadQuery_thread_Thread_item_Product_attributes_Label | GetThreadQuery_thread_Thread_item_Product_attributes_Material | GetThreadQuery_thread_Thread_item_Product_attributes_Style | GetThreadQuery_thread_Thread_item_Product_attributes_Subject | GetThreadQuery_thread_Thread_item_Product_attributes_UsageSign;

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_listing_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_listing_minimum_bid_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_highest_bid_Bid = { __typename?: 'Bid', state: BidState, id: any };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_order_Order = { __typename?: 'Order', orderState: OrderState };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_message_Message = { __typename?: 'Message', id: any };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid = { __typename?: 'Bid', id: any, state: BidState, merchantId: any, buyerId: any, isCounter: boolean, order?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_order_Order | null, message?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid_message_Message | null };

export type GetThreadQuery_thread_Thread_item_Product_auction_Auction = { __typename?: 'Auction', id: any, updated?: any | null, allow_buy_now: boolean, allow_bid: boolean, end_date?: any | null, state: AuctionState, buy_now_price?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_buy_now_price_Price | null, minimum_bid?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_minimum_bid_Price | null, listing_buy_now_price?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_listing_buy_now_price_Price | null, listing_minimum_bid?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_listing_minimum_bid_Price | null, highest_bid?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_highest_bid_Bid | null, sold_at?: GetThreadQuery_thread_Thread_item_Product_auction_Auction_sold_at_Price | null, bids: Array<GetThreadQuery_thread_Thread_item_Product_auction_Auction_bids_Bid> };

export type GetThreadQuery_thread_Thread_item_Product_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, email?: string | null, vacationModeEnabledAt?: any | null };

export type GetThreadQuery_thread_Thread_item_Product_merchant_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type GetThreadQuery_thread_Thread_item_Product_buy_now_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_original_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type GetThreadQuery_thread_Thread_item_Product_image_Image = { __typename?: 'Image', id: any, width?: number | null, height?: number | null, url: string };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_shippingMethod_ShippingMethod = { __typename?: 'ShippingMethod', slug: string, enum: ShippingMethodEnum };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_review_Review = { __typename?: 'Review', id: any };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', id: any, shipmentId?: string | null, shipmentUrl?: string | null, apiVersion?: number | null, state?: string | null, status?: BrengerShipmentStatus | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', id: any, orderId: any, apiVersion?: number | null, finalisedDate?: any | null, hasProposedDates: boolean, type: BrengerAppointmentType, awaitingResponseFrom?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant | null, brengerShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType, expert_seller?: boolean | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', id: any, shipmentId?: string | null, shipmentUrl?: string | null, apiVersion?: number | null, state?: string | null, status?: BrengerShipmentStatus | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', id: any, orderId: any, apiVersion?: number | null, finalisedDate?: any | null, hasProposedDates: boolean, type: BrengerAppointmentType, awaitingResponseFrom?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_awaitingResponseFrom_Merchant | null, brengerShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order_postalShipment_PostalShipment = { __typename?: 'PostalShipment', id: any, provider: ShippingProviderEnum, rateCarrier: string, shouldRemind: boolean, failedToSend: boolean, sendByDate: any, status?: PostalShipmentStatus | null, labelUrl?: string | null, parcelPointsUrl?: string | null, trackAndTraceUrl?: string | null, labelGeneratedAt?: any | null, selectedServicePoint?: PostalShipmentFragmentFragment_PostalShipment_selectedServicePoint_ServicePoint | null };

export type GetThreadQuery_thread_Thread_item_Product_orders_Order = { __typename?: 'Order', id: any, created?: any | null, merchantId: any, buyerId: any, state: OrderState, outsourceShippingMethod?: string | null, returnShippingMethod?: string | null, returnCaseStatus?: string | null, disputeReason?: string | null, damageFormUrl?: string | null, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, deliveryMethod: DeliveryMethod, externalDelivery?: boolean | null, shippingMethod?: GetThreadQuery_thread_Thread_item_Product_orders_Order_shippingMethod_ShippingMethod | null, review?: GetThreadQuery_thread_Thread_item_Product_orders_Order_review_Review | null, brengerAppointment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_brengerAppointment_BrengerAppointment | null, returnBrengerAppointment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_returnBrengerAppointment_BrengerAppointment | null, postalShipment?: GetThreadQuery_thread_Thread_item_Product_orders_Order_postalShipment_PostalShipment | null };

export type GetThreadQuery_thread_Thread_item_Product_address_Address = { __typename?: 'Address', id: any, city: string, country: string };

export type GetThreadQuery_thread_Thread_item_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', name: string, description?: string | null, icon?: string | null, shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, metadata?: any | null, active: boolean, price?: CartFragmentFragment_Cart_items_CartItem_shippingOptions_ShippingOption_price_Price | null };

export type GetThreadQuery_thread_Thread_item_Merchant = { __typename?: 'Merchant' };

export type GetThreadQuery_thread_Thread_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, openHome: boolean, width?: number | null, weight?: number | null, quality?: ProductQuality | null, state: ProductState, delivery_method: DeliveryMethod, categories: Array<GetThreadQuery_thread_Thread_item_Product_categories_Category>, attributes: Array<GetThreadQuery_thread_Thread_item_Product_attributes>, auction?: GetThreadQuery_thread_Thread_item_Product_auction_Auction | null, merchant: GetThreadQuery_thread_Thread_item_Product_merchant_Merchant, merchant_fee?: GetThreadQuery_thread_Thread_item_Product_merchant_fee_Fee | null, buy_now_price?: GetThreadQuery_thread_Thread_item_Product_buy_now_price_Price | null, original_price?: GetThreadQuery_thread_Thread_item_Product_original_price_Price | null, image?: GetThreadQuery_thread_Thread_item_Product_image_Image | null, orders: Array<GetThreadQuery_thread_Thread_item_Product_orders_Order>, address?: GetThreadQuery_thread_Thread_item_Product_address_Address | null, shippingOptions: Array<GetThreadQuery_thread_Thread_item_Product_shippingOptions_ShippingOption> };

export type GetThreadQuery_thread_Thread_item = GetThreadQuery_thread_Thread_item_Merchant | GetThreadQuery_thread_Thread_item_Product;

export type GetThreadQuery_thread_Thread = { __typename?: 'Thread', id: any, unread_count: number, canSendImageMessage: boolean, pendingActions: Array<PendingAction>, subscribers: Array<GetThreadQuery_thread_Thread_subscribers_Subscriber>, item: GetThreadQuery_thread_Thread_item };

export type GetThreadQuery_Query = { __typename?: 'Query', thread?: GetThreadQuery_thread_Thread | null };


export type GetThreadQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type GetThreadQuery = GetThreadQuery_Query;

export type GetThreadsQuery_getThreads_GetThreadsResult_items_Thread = { __typename?: 'Thread', id: any, updated?: any | null, unread_count: number, subscribers: Array<ListThreadFragmentFragment_Thread_subscribers_Subscriber>, item: ListThreadFragmentFragment_Thread_item };

export type GetThreadsQuery_getThreads_GetThreadsResult_pagination_CursorPaginationResult = { __typename?: 'CursorPaginationResult', hasMore: boolean };

export type GetThreadsQuery_getThreads_GetThreadsResult = { __typename?: 'GetThreadsResult', items: Array<GetThreadsQuery_getThreads_GetThreadsResult_items_Thread>, pagination: GetThreadsQuery_getThreads_GetThreadsResult_pagination_CursorPaginationResult };

export type GetThreadsQuery_Query = { __typename?: 'Query', getThreads: GetThreadsQuery_getThreads_GetThreadsResult };


export type GetThreadsQueryVariables = Exact<{
  input?: InputMaybe<GetThreadsInput>;
}>;


export type GetThreadsQuery = GetThreadsQuery_Query;

export type GetUnreadMessageCountQuery_Query = { __typename?: 'Query', getUnreadMessageCount: number };


export type GetUnreadMessageCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadMessageCountQuery = GetUnreadMessageCountQuery_Query;

export type CheckVatQuery_checkVat_vatCheckResult = { __typename?: 'vatCheckResult', result?: VatCheck | null };

export type CheckVatQuery_Query = { __typename?: 'Query', checkVat?: CheckVatQuery_checkVat_vatCheckResult | null };


export type CheckVatQueryVariables = Exact<{
  vat: Scalars['String']['input'];
}>;


export type CheckVatQuery = CheckVatQuery_Query;

export type GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock_listingPage_ListingPage = { __typename?: 'ListingPage', url: string };

export type GetCollectionsQuery_pageByKey_Page_blocks_AttributeBlock = { __typename?: 'AttributeBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_AudioBlock = { __typename?: 'AudioBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CallToActionBlock = { __typename?: 'CallToActionBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CategoriesBlock = { __typename?: 'CategoriesBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CategoryBlock = { __typename?: 'CategoryBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_CollectionBlock = { __typename?: 'CollectionBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_EmbeddedMessageBlock = { __typename?: 'EmbeddedMessageBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_ImageBlock = { __typename?: 'ImageBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_MemberBlock = { __typename?: 'MemberBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_MerchantBlock = { __typename?: 'MerchantBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock = { __typename?: 'ProductBlock', id: any, title: string, description?: string | null, slug: string, image: string, listingPage?: GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock_listingPage_ListingPage | null };

export type GetCollectionsQuery_pageByKey_Page_blocks_QueryBlock = { __typename?: 'QueryBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_SearchProductsBlock = { __typename?: 'SearchProductsBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_TextBlock = { __typename?: 'TextBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks_VideoBlock = { __typename?: 'VideoBlock' };

export type GetCollectionsQuery_pageByKey_Page_blocks = GetCollectionsQuery_pageByKey_Page_blocks_AttributeBlock | GetCollectionsQuery_pageByKey_Page_blocks_AudioBlock | GetCollectionsQuery_pageByKey_Page_blocks_CallToActionBlock | GetCollectionsQuery_pageByKey_Page_blocks_CategoriesBlock | GetCollectionsQuery_pageByKey_Page_blocks_CategoryBlock | GetCollectionsQuery_pageByKey_Page_blocks_CollectionBlock | GetCollectionsQuery_pageByKey_Page_blocks_EmbeddedMessageBlock | GetCollectionsQuery_pageByKey_Page_blocks_ImageBlock | GetCollectionsQuery_pageByKey_Page_blocks_MemberBlock | GetCollectionsQuery_pageByKey_Page_blocks_MerchantBlock | GetCollectionsQuery_pageByKey_Page_blocks_ProductBlock | GetCollectionsQuery_pageByKey_Page_blocks_QueryBlock | GetCollectionsQuery_pageByKey_Page_blocks_SearchProductsBlock | GetCollectionsQuery_pageByKey_Page_blocks_TextBlock | GetCollectionsQuery_pageByKey_Page_blocks_VideoBlock;

export type GetCollectionsQuery_pageByKey_Page = { __typename?: 'Page', id: any, blocks: Array<GetCollectionsQuery_pageByKey_Page_blocks> };

export type GetCollectionsQuery_Query = { __typename?: 'Query', pageByKey?: GetCollectionsQuery_pageByKey_Page | null };


export type GetCollectionsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type GetCollectionsQuery = GetCollectionsQuery_Query;

export type ConfigQuery_config_Config_supportedCountries_SupportedCountry = { __typename?: 'SupportedCountry', code: Country, supportLevel: CountrySupportLevel };

export type ConfigQuery_config_Config = { __typename?: 'Config', postalOriginCountries: Array<string>, supportedCountries: Array<ConfigQuery_config_Config_supportedCountries_SupportedCountry> };

export type ConfigQuery_Query = { __typename?: 'Query', config: ConfigQuery_config_Config };


export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = ConfigQuery_Query;

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Artist = { __typename?: 'Artist', id: any, title: string };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Brand = { __typename?: 'Brand', id: any, title: string };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Color = { __typename?: 'Color' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Designer = { __typename?: 'Designer', id: any, title: string };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_HardwareColor = { __typename?: 'HardwareColor' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Label = { __typename?: 'Label' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Material = { __typename?: 'Material' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Style = { __typename?: 'Style' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Subject = { __typename?: 'Subject' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_UsageSign = { __typename?: 'UsageSign' };

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items = CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_AdditionalInfo | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Artist | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Brand | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Color | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Designer | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_HardwareColor | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Label | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Material | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Style | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_Subject | CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items_UsageSign;

export type CreateAdV2MakersQuery_attributesByCategory_AttributeResult = { __typename?: 'AttributeResult', items: Array<CreateAdV2MakersQuery_attributesByCategory_AttributeResult_items> };

export type CreateAdV2MakersQuery_Query = { __typename?: 'Query', attributesByCategory: CreateAdV2MakersQuery_attributesByCategory_AttributeResult };


export type CreateAdV2MakersQueryVariables = Exact<{
  category?: InputMaybe<Scalars['UUID']['input']>;
  types: Array<AttributeType> | AttributeType;
}>;


export type CreateAdV2MakersQuery = CreateAdV2MakersQuery_Query;

export type CreateAdV2ProductQuery_productById_Product_listingGeneration_ListingGeneration = { __typename?: 'ListingGeneration', status: ListingGenerationStatus, model?: string | null, durationMs?: number | null, failureReason?: string | null, generatedAt: any, runs: number, missing: Array<ListingFieldKey>, applicableKeys: Array<ListingFieldKey>, fields: Array<ListingGenerationFragmentFragment_ListingGeneration_fields_ListingGenerationField>, knownItem?: ListingGenerationFragmentFragment_ListingGeneration_knownItem_KnownItemHint | null, dimensionGuide?: ListingGenerationFragmentFragment_ListingGeneration_dimensionGuide_ListingDimensionGuide | null };

export type CreateAdV2ProductQuery_productById_Product_priceDropSettings_PriceDropSettings_floor_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type CreateAdV2ProductQuery_productById_Product_priceDropSettings_PriceDropSettings = { __typename?: 'PriceDropSettings', enabled: boolean, pace: PriceDropPace, stepPercent: number, floor?: CreateAdV2ProductQuery_productById_Product_priceDropSettings_PriceDropSettings_floor_Price | null };

export type CreateAdV2ProductQuery_productById_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, favorite_count: number, quality?: ProductQuality | null, auto_discount?: boolean | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, number_of_items?: number | null, shape?: Shape | null, created?: any | null, curated_at?: any | null, condition: ProductCondition, isBoostable?: boolean | null, isBoosted?: boolean | null, boostStatus?: BoostStatus | null, lastBoosted?: any | null, boostEndsAt?: any | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, link: string, delivery_method: DeliveryMethod, bag_model?: string | null, gender?: Gender | null, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, year_of_purchase?: number | null, usage_signs_description?: string | null, showroomModel: boolean, note_for_curator?: string | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postalPackageSize?: PostalPackageSize | null, postal_package_weight_kg?: number | null, listingGeneration?: CreateAdV2ProductQuery_productById_Product_listingGeneration_ListingGeneration | null, priceDropSettings?: CreateAdV2ProductQuery_productById_Product_priceDropSettings_PriceDropSettings | null, buy_now_price?: PrivateProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductFragmentFragment_Product_original_price_Price | null, newPrice?: PrivateProductFragmentFragment_Product_newPrice_Price | null, image?: PrivateProductFragmentFragment_Product_image_Image | null, images: Array<PrivateProductFragmentFragment_Product_images_Image>, activeBoost?: PrivateProductFragmentFragment_Product_activeBoost_ProductBoost | null, address?: PrivateProductFragmentFragment_Product_address_Address | null, auction?: PrivateProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: PrivateProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: PrivateProductFragmentFragment_Product_merchant_Merchant, merchant_fee?: PrivateProductFragmentFragment_Product_merchant_fee_Fee | null, favorite?: PrivateProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PrivateProductFragmentFragment_Product_categories_Category>, breadcrumbs: Array<PrivateProductFragmentFragment_Product_breadcrumbs_Category>, brand?: PrivateProductFragmentFragment_Product_brand_Brand | null, hardware_color?: PrivateProductFragmentFragment_Product_hardware_color_HardwareColor | null, attributes: Array<PrivateProductFragmentFragment_Product_attributes>, curation_feedback?: PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback | null, activeListingFee?: PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee | null };

export type CreateAdV2ProductQuery_Query = { __typename?: 'Query', productById: CreateAdV2ProductQuery_productById_Product };


export type CreateAdV2ProductQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type CreateAdV2ProductQuery = CreateAdV2ProductQuery_Query;

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Artist = { __typename?: 'Artist' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Brand = { __typename?: 'Brand' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Color = { __typename?: 'Color', id: any, slug: string, title: string };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Designer = { __typename?: 'Designer' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_HardwareColor = { __typename?: 'HardwareColor' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Label = { __typename?: 'Label' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Material = { __typename?: 'Material', id: any, slug: string, title: string };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Style = { __typename?: 'Style', id: any, slug: string, title: string };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Subject = { __typename?: 'Subject' };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_UsageSign = { __typename?: 'UsageSign', id: any, slug: string, title: string };

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items = CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_AdditionalInfo | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Artist | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Brand | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Color | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Designer | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_HardwareColor | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Label | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Material | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Style | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_Subject | CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items_UsageSign;

export type CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult = { __typename?: 'AttributeResult', items: Array<CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult_items> };

export type CreateAdV2TaxonomyQuery_Query = { __typename?: 'Query', attributesByCategory: CreateAdV2TaxonomyQuery_attributesByCategory_AttributeResult };


export type CreateAdV2TaxonomyQueryVariables = Exact<{
  category?: InputMaybe<Scalars['UUID']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type CreateAdV2TaxonomyQuery = CreateAdV2TaxonomyQuery_Query;

export type ProductListingGenerationStatusQuery_productById_Product_listingGeneration_ListingGeneration = { __typename?: 'ListingGeneration', status: ListingGenerationStatus };

export type ProductListingGenerationStatusQuery_productById_Product = { __typename?: 'Product', id: any, state: ProductState, listingGeneration?: ProductListingGenerationStatusQuery_productById_Product_listingGeneration_ListingGeneration | null };

export type ProductListingGenerationStatusQuery_Query = { __typename?: 'Query', productById: ProductListingGenerationStatusQuery_productById_Product };


export type ProductListingGenerationStatusQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProductListingGenerationStatusQuery = ProductListingGenerationStatusQuery_Query;

export type SellerShippingEstimatesQuery_sellerShippingEstimates_ProductShippingOptionV2_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type SellerShippingEstimatesQuery_sellerShippingEstimates_ProductShippingOptionV2 = { __typename?: 'ProductShippingOptionV2', shippingMethod: ShippingMethodEnum, isSupported: boolean, unsupportedReason?: ShippingOptionUnsupportedReasonEnum | null, price?: SellerShippingEstimatesQuery_sellerShippingEstimates_ProductShippingOptionV2_price_Price | null };

export type SellerShippingEstimatesQuery_Query = { __typename?: 'Query', sellerShippingEstimates: Array<SellerShippingEstimatesQuery_sellerShippingEstimates_ProductShippingOptionV2> };


export type SellerShippingEstimatesQueryVariables = Exact<{
  productId: Scalars['UUID']['input'];
  country?: InputMaybe<Country>;
}>;


export type SellerShippingEstimatesQuery = SellerShippingEstimatesQuery_Query;

export type DesignersQuery_designers_Designer_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string };

export type DesignersQuery_designers_Designer = { __typename?: 'Designer', id: any, title: string, slug: string, image?: string | null, listingPage?: DesignersQuery_designers_Designer_listingPage_ListingPage | null };

export type DesignersQuery_Query = { __typename?: 'Query', designers: Array<DesignersQuery_designers_Designer> };


export type DesignersQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  filters?: InputMaybe<DesignersFilter>;
}>;


export type DesignersQuery = DesignersQuery_Query;

export type FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', slug: string };

export type FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult_items_Product | null> | null };

export type FallbackProductFromDmSlugQuery_Query = { __typename?: 'Query', searchProducts?: FallbackProductFromDmSlugQuery_searchProducts_SearchProductsResult | null };


export type FallbackProductFromDmSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type FallbackProductFromDmSlugQuery = FallbackProductFromDmSlugQuery_Query;

export type FavoriteProductsQuery_favorites_FavoriteResult_pagination_PaginationResult = { __typename?: 'PaginationResult', limit: number, page: number, pages: number, count: number };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', active: boolean, shippingProvider?: ShippingProviderEnum | null };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Merchant = { __typename?: 'Merchant' };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, shippingOptions: Array<FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product_shippingOptions_ShippingOption>, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item = FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Merchant | FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item_Product;

export type FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite = { __typename?: 'Favorite', id: any, item: FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite_item };

export type FavoriteProductsQuery_favorites_FavoriteResult = { __typename?: 'FavoriteResult', pagination: FavoriteProductsQuery_favorites_FavoriteResult_pagination_PaginationResult, items: Array<FavoriteProductsQuery_favorites_FavoriteResult_items_Favorite> };

export type FavoriteProductsQuery_Query = { __typename?: 'Query', favorites: FavoriteProductsQuery_favorites_FavoriteResult };


export type FavoriteProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  sort?: InputMaybe<FavoriteSort>;
  order?: InputMaybe<Ordering>;
  currency?: InputMaybe<Currency>;
}>;


export type FavoriteProductsQuery = FavoriteProductsQuery_Query;

export type GetCollectionQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type GetCollectionQuery_searchProducts_SearchProductsResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type GetCollectionQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<GetCollectionQuery_searchProducts_SearchProductsResult_items_Product | null> | null, pagination?: GetCollectionQuery_searchProducts_SearchProductsResult_pagination_PaginationResult | null };

export type GetCollectionQuery_blockByKey_AttributeBlock = { __typename?: 'AttributeBlock' };

export type GetCollectionQuery_blockByKey_AudioBlock = { __typename?: 'AudioBlock' };

export type GetCollectionQuery_blockByKey_CallToActionBlock = { __typename?: 'CallToActionBlock' };

export type GetCollectionQuery_blockByKey_CategoriesBlock = { __typename?: 'CategoriesBlock' };

export type GetCollectionQuery_blockByKey_CategoryBlock = { __typename?: 'CategoryBlock' };

export type GetCollectionQuery_blockByKey_CollectionBlock = { __typename?: 'CollectionBlock' };

export type GetCollectionQuery_blockByKey_EmbeddedMessageBlock = { __typename?: 'EmbeddedMessageBlock' };

export type GetCollectionQuery_blockByKey_ImageBlock = { __typename?: 'ImageBlock' };

export type GetCollectionQuery_blockByKey_MemberBlock = { __typename?: 'MemberBlock' };

export type GetCollectionQuery_blockByKey_MerchantBlock = { __typename?: 'MerchantBlock' };

export type GetCollectionQuery_blockByKey_ProductBlock = { __typename?: 'ProductBlock', id: any, title: string, slug: string, image: string };

export type GetCollectionQuery_blockByKey_QueryBlock = { __typename?: 'QueryBlock' };

export type GetCollectionQuery_blockByKey_SearchProductsBlock = { __typename?: 'SearchProductsBlock' };

export type GetCollectionQuery_blockByKey_TextBlock = { __typename?: 'TextBlock' };

export type GetCollectionQuery_blockByKey_VideoBlock = { __typename?: 'VideoBlock' };

export type GetCollectionQuery_blockByKey = GetCollectionQuery_blockByKey_AttributeBlock | GetCollectionQuery_blockByKey_AudioBlock | GetCollectionQuery_blockByKey_CallToActionBlock | GetCollectionQuery_blockByKey_CategoriesBlock | GetCollectionQuery_blockByKey_CategoryBlock | GetCollectionQuery_blockByKey_CollectionBlock | GetCollectionQuery_blockByKey_EmbeddedMessageBlock | GetCollectionQuery_blockByKey_ImageBlock | GetCollectionQuery_blockByKey_MemberBlock | GetCollectionQuery_blockByKey_MerchantBlock | GetCollectionQuery_blockByKey_ProductBlock | GetCollectionQuery_blockByKey_QueryBlock | GetCollectionQuery_blockByKey_SearchProductsBlock | GetCollectionQuery_blockByKey_TextBlock | GetCollectionQuery_blockByKey_VideoBlock;

export type GetCollectionQuery_Query = { __typename?: 'Query', searchProducts?: GetCollectionQuery_searchProducts_SearchProductsResult | null, blockByKey?: GetCollectionQuery_blockByKey | null };


export type GetCollectionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  sort?: InputMaybe<SearchSort>;
  order?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type GetCollectionQuery = GetCollectionQuery_Query;

export type GetFallbackListingPageQuery_getFallbackListingPage_ListingPage = { __typename?: 'ListingPage', url: string };

export type GetFallbackListingPageQuery_Query = { __typename?: 'Query', getFallbackListingPage: GetFallbackListingPageQuery_getFallbackListingPage_ListingPage };


export type GetFallbackListingPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang: Language;
}>;


export type GetFallbackListingPageQuery = GetFallbackListingPageQuery_Query;

export type GuestCartQuery_guestCart_GuestCart_products_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, favorite_count: number, quality?: ProductQuality | null, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type GuestCartQuery_guestCart_GuestCart = { __typename?: 'GuestCart', products: Array<GuestCartQuery_guestCart_GuestCart_products_Product> };

export type GuestCartQuery_Query = { __typename?: 'Query', guestCart: GuestCartQuery_guestCart_GuestCart };


export type GuestCartQueryVariables = Exact<{
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type GuestCartQuery = GuestCartQuery_Query;

export type HelpArticleQuery_helpArticle_HelpArticle_hreflang_HelpHreflangAlternate = { __typename?: 'HelpHreflangAlternate', locale: string, slug: string, categorySlug: string };

export type HelpArticleQuery_helpArticle_HelpArticle_previous_HelpArticleNeighbour = { __typename?: 'HelpArticleNeighbour', slug: string, title: string, categorySlug: string };

export type HelpArticleQuery_helpArticle_HelpArticle_next_HelpArticleNeighbour = { __typename?: 'HelpArticleNeighbour', slug: string, title: string, categorySlug: string };

export type HelpArticleQuery_helpArticle_HelpArticle_related_HelpArticleListItem = { __typename?: 'HelpArticleListItem', id: string, title: string, slug: string, summary: string, excerpt: string, readingTimeMinutes: number, categorySlug?: string | null };

export type HelpArticleQuery_helpArticle_HelpArticle = { __typename?: 'HelpArticle', id: string, title: string, slug: string, summary: string, excerpt: string, readingTimeMinutes: number, isFeatured: boolean, bodyHtml: string, categorySlug?: string | null, categoryTitle?: string | null, updatedAt?: any | null, hreflang: Array<HelpArticleQuery_helpArticle_HelpArticle_hreflang_HelpHreflangAlternate>, previous?: HelpArticleQuery_helpArticle_HelpArticle_previous_HelpArticleNeighbour | null, next?: HelpArticleQuery_helpArticle_HelpArticle_next_HelpArticleNeighbour | null, related: Array<HelpArticleQuery_helpArticle_HelpArticle_related_HelpArticleListItem> };

export type HelpArticleQuery_Query = { __typename?: 'Query', helpArticle?: HelpArticleQuery_helpArticle_HelpArticle | null };


export type HelpArticleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type HelpArticleQuery = HelpArticleQuery_Query;

export type HelpArticleMarkdownQuery_Query = { __typename?: 'Query', helpArticleMarkdown?: string | null };


export type HelpArticleMarkdownQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  canonicalBase: Scalars['String']['input'];
}>;


export type HelpArticleMarkdownQuery = HelpArticleMarkdownQuery_Query;

export type HelpArticlesQuery_helpArticles_HelpArticlePage_items_HelpArticleListItem = { __typename?: 'HelpArticleListItem', id: string, title: string, slug: string, summary: string, excerpt: string, readingTimeMinutes: number, categorySlug?: string | null };

export type HelpArticlesQuery_helpArticles_HelpArticlePage = { __typename?: 'HelpArticlePage', page: number, pageSize: number, total: number, items: Array<HelpArticlesQuery_helpArticles_HelpArticlePage_items_HelpArticleListItem> };

export type HelpArticlesQuery_Query = { __typename?: 'Query', helpArticles: HelpArticlesQuery_helpArticles_HelpArticlePage };


export type HelpArticlesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HelpArticlesQuery = HelpArticlesQuery_Query;

export type HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory_children_HelpCategory_children_HelpCategory = { __typename?: 'HelpCategory', id: string, title: string, slug: string, order: number, articleCount: number, description?: string | null };

export type HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory_children_HelpCategory = { __typename?: 'HelpCategory', id: string, title: string, slug: string, order: number, articleCount: number, description?: string | null, children: Array<HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory_children_HelpCategory_children_HelpCategory> };

export type HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory = { __typename?: 'HelpCategory', id: string, title: string, slug: string, order: number, articleCount: number, description?: string | null, children: Array<HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory_children_HelpCategory> };

export type HelpCategoriesQuery_helpCategories_HelpCategory = { __typename?: 'HelpCategory', id: string, title: string, slug: string, order: number, articleCount: number, description?: string | null, children: Array<HelpCategoriesQuery_helpCategories_HelpCategory_children_HelpCategory> };

export type HelpCategoriesQuery_Query = { __typename?: 'Query', helpCategories: Array<HelpCategoriesQuery_helpCategories_HelpCategory> };


export type HelpCategoriesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type HelpCategoriesQuery = HelpCategoriesQuery_Query;

export type HelpCenterMarkdownQuery_Query = { __typename?: 'Query', helpCenterMarkdown: string };


export type HelpCenterMarkdownQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  canonicalBase: Scalars['String']['input'];
}>;


export type HelpCenterMarkdownQuery = HelpCenterMarkdownQuery_Query;

export type HelpFeaturedArticlesQuery_helpFeaturedArticles_HelpArticleListItem = { __typename?: 'HelpArticleListItem', id: string, title: string, slug: string, summary: string, excerpt: string, readingTimeMinutes: number, categorySlug?: string | null };

export type HelpFeaturedArticlesQuery_Query = { __typename?: 'Query', helpFeaturedArticles: Array<HelpFeaturedArticlesQuery_helpFeaturedArticles_HelpArticleListItem> };


export type HelpFeaturedArticlesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HelpFeaturedArticlesQuery = HelpFeaturedArticlesQuery_Query;

export type HelpSearchQuery_helpSearch_HelpSearchResult = { __typename?: 'HelpSearchResult', id: string, title: string, slug: string, summary: string, categorySlug: string, excerpt: string };

export type HelpSearchQuery_Query = { __typename?: 'Query', helpSearch: Array<HelpSearchQuery_helpSearch_HelpSearchResult> };


export type HelpSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type HelpSearchQuery = HelpSearchQuery_Query;

export type HomepageQuery_homepage_Homepage_blocks_CategoriesBlock_categories_Category_listingPage_ListingPage = { __typename?: 'ListingPage', url: string };

export type HomepageQuery_homepage_Homepage_blocks_CategoriesBlock_categories_Category = { __typename?: 'Category', id: any, svgIcon?: string | null, title: string, listingPage: HomepageQuery_homepage_Homepage_blocks_CategoriesBlock_categories_Category_listingPage_ListingPage };

export type HomepageQuery_homepage_Homepage_blocks_AttributeBlock = { __typename?: 'AttributeBlock' };

export type HomepageQuery_homepage_Homepage_blocks_AudioBlock = { __typename?: 'AudioBlock' };

export type HomepageQuery_homepage_Homepage_blocks_CallToActionBlock = { __typename?: 'CallToActionBlock' };

export type HomepageQuery_homepage_Homepage_blocks_CategoriesBlock = { __typename?: 'CategoriesBlock', id: any, categories: Array<HomepageQuery_homepage_Homepage_blocks_CategoriesBlock_categories_Category> };

export type HomepageQuery_homepage_Homepage_blocks_CategoryBlock = { __typename?: 'CategoryBlock' };

export type HomepageQuery_homepage_Homepage_blocks_CollectionBlock = { __typename?: 'CollectionBlock' };

export type HomepageQuery_homepage_Homepage_blocks_EmbeddedMessageBlock = { __typename?: 'EmbeddedMessageBlock' };

export type HomepageQuery_homepage_Homepage_blocks_ImageBlock = { __typename?: 'ImageBlock' };

export type HomepageQuery_homepage_Homepage_blocks_MemberBlock = { __typename?: 'MemberBlock' };

export type HomepageQuery_homepage_Homepage_blocks_MerchantBlock = { __typename?: 'MerchantBlock' };

export type HomepageQuery_homepage_Homepage_blocks_ProductBlock = { __typename?: 'ProductBlock' };

export type HomepageQuery_homepage_Homepage_blocks_QueryBlock = { __typename?: 'QueryBlock' };

export type HomepageQuery_homepage_Homepage_blocks_SearchProductsBlock = { __typename?: 'SearchProductsBlock' };

export type HomepageQuery_homepage_Homepage_blocks_TextBlock = { __typename?: 'TextBlock' };

export type HomepageQuery_homepage_Homepage_blocks_VideoBlock = { __typename?: 'VideoBlock' };

export type HomepageQuery_homepage_Homepage_blocks = HomepageQuery_homepage_Homepage_blocks_AttributeBlock | HomepageQuery_homepage_Homepage_blocks_AudioBlock | HomepageQuery_homepage_Homepage_blocks_CallToActionBlock | HomepageQuery_homepage_Homepage_blocks_CategoriesBlock | HomepageQuery_homepage_Homepage_blocks_CategoryBlock | HomepageQuery_homepage_Homepage_blocks_CollectionBlock | HomepageQuery_homepage_Homepage_blocks_EmbeddedMessageBlock | HomepageQuery_homepage_Homepage_blocks_ImageBlock | HomepageQuery_homepage_Homepage_blocks_MemberBlock | HomepageQuery_homepage_Homepage_blocks_MerchantBlock | HomepageQuery_homepage_Homepage_blocks_ProductBlock | HomepageQuery_homepage_Homepage_blocks_QueryBlock | HomepageQuery_homepage_Homepage_blocks_SearchProductsBlock | HomepageQuery_homepage_Homepage_blocks_TextBlock | HomepageQuery_homepage_Homepage_blocks_VideoBlock;

export type HomepageQuery_homepage_Homepage = { __typename?: 'Homepage', blocks: Array<HomepageQuery_homepage_Homepage_blocks> };

export type HomepageQuery_Query = { __typename?: 'Query', homepage?: HomepageQuery_homepage_Homepage | null };


export type HomepageQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type HomepageQuery = HomepageQuery_Query;

export type CategoryBasicDetailsFragment = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string };

export type HomepageCategoriesQuery_categories_Category_children_Category = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string };

export type HomepageCategoriesQuery_categories_Category_avatarImage_Image = { __typename?: 'Image', id: any, url: string, width?: number | null, height?: number | null };

export type HomepageCategoriesQuery_categories_Category = { __typename?: 'Category', id: any, slug: string, route?: string | null, title: string, slug_en: string, children?: Array<HomepageCategoriesQuery_categories_Category_children_Category | null> | null, avatarImage?: HomepageCategoriesQuery_categories_Category_avatarImage_Image | null };

export type HomepageCategoriesQuery_Query = { __typename?: 'Query', categories: Array<HomepageCategoriesQuery_categories_Category> };


export type HomepageCategoriesQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type HomepageCategoriesQuery = HomepageCategoriesQuery_Query;

export type MeQuery_me_Member_merchants_Merchant_fee_Fee = { __typename?: 'Fee', type: CalculationMethod, amount: number };

export type MeQuery_me_Member_merchants_Merchant_image_Image = { __typename?: 'Image', url: string };

export type MeQuery_me_Member_merchants_Merchant_addresses_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type MeQuery_me_Member_merchants_Merchant_default_shipping_address_Address = { __typename?: 'Address', id: any };

export type MeQuery_me_Member_merchants_Merchant_invoice_address_Address = { __typename?: 'Address', id: any };

export type MeQuery_me_Member_merchants_Merchant_bank_account_BankAccount = { __typename?: 'BankAccount', account_number: string, account_holder_name: string };

export type MeQuery_me_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, name: string, email?: string | null, biography?: string | null, phone?: string | null, verified?: boolean | null, referral_code?: string | null, expert_seller?: boolean | null, rating?: number | null, number_of_buys?: number | null, number_of_bids?: number | null, number_of_sells?: number | null, number_of_ads?: number | null, number_of_favorites?: number | null, business_name?: string | null, url?: string | null, tax_id?: string | null, vat_id?: string | null, vacationModeEnableRequestedAt?: any | null, vacationModeDisableRequestedAt?: any | null, vacationModeEndDate?: any | null, vacationModeEnabledAt?: any | null, pendingActions: Array<PendingAction>, showroomModel: boolean, fee?: MeQuery_me_Member_merchants_Merchant_fee_Fee | null, image?: MeQuery_me_Member_merchants_Merchant_image_Image | null, addresses: Array<MeQuery_me_Member_merchants_Merchant_addresses_Address>, default_shipping_address?: MeQuery_me_Member_merchants_Merchant_default_shipping_address_Address | null, invoice_address?: MeQuery_me_Member_merchants_Merchant_invoice_address_Address | null, bank_account?: MeQuery_me_Member_merchants_Merchant_bank_account_BankAccount | null };

export type MeQuery_me_Member = { __typename?: 'Member', id: any, given_name: string, family_name: string, email: string, locale: Locale, preferred_currency?: Currency | null, last_login?: any | null, date_joined: any, dob?: any | null, lastUsedPaymentMethod?: PaymentMethod | null, placeOfBirth?: string | null, countryOfBirth?: string | null, merchants: Array<MeQuery_me_Member_merchants_Merchant> };

export type MeQuery_Query = { __typename?: 'Query', me?: MeQuery_me_Member | null };


export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = MeQuery_Query;

export type MeTradeDiscountQuery_me_Member_merchants_Merchant_tradeDiscount_MerchantTradeDiscount = { __typename?: 'MerchantTradeDiscount', enabled: boolean, pct?: number | null, updatedAt?: any | null, activeListingCount: number };

export type MeTradeDiscountQuery_me_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, tradeDiscount?: MeTradeDiscountQuery_me_Member_merchants_Merchant_tradeDiscount_MerchantTradeDiscount | null };

export type MeTradeDiscountQuery_me_Member = { __typename?: 'Member', merchants: Array<MeTradeDiscountQuery_me_Member_merchants_Merchant> };

export type MeTradeDiscountQuery_Query = { __typename?: 'Query', me?: MeTradeDiscountQuery_me_Member | null };


export type MeTradeDiscountQueryVariables = Exact<{ [key: string]: never; }>;


export type MeTradeDiscountQuery = MeTradeDiscountQuery_Query;

export type MerchantProductsQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type MerchantProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type MerchantProductsQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<MerchantProductsQuery_searchProducts_SearchProductsResult_items_Product | null> | null, pagination?: MerchantProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult | null };

export type MerchantProductsQuery_Query = { __typename?: 'Query', searchProducts?: MerchantProductsQuery_searchProducts_SearchProductsResult | null };


export type MerchantProductsQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type MerchantProductsQuery = MerchantProductsQuery_Query;

export type ReviewsQuery_reviews_ReviewResult_items_Review_reviewer_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType };

export type ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_product_Product = { __typename?: 'Product', id: any, title: string };

export type ReviewsQuery_reviews_ReviewResult_items_Review_order_Order = { __typename?: 'Order', merchant: ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_merchant_Merchant, product: ReviewsQuery_reviews_ReviewResult_items_Review_order_Order_product_Product };

export type ReviewsQuery_reviews_ReviewResult_items_Review = { __typename?: 'Review', id: any, score?: number | null, review?: string | null, anonymous?: boolean | null, created?: any | null, originalReview?: string | null, reviewer?: ReviewsQuery_reviews_ReviewResult_items_Review_reviewer_Merchant | null, order: ReviewsQuery_reviews_ReviewResult_items_Review_order_Order };

export type ReviewsQuery_reviews_ReviewResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type ReviewsQuery_reviews_ReviewResult = { __typename?: 'ReviewResult', items: Array<ReviewsQuery_reviews_ReviewResult_items_Review>, pagination: ReviewsQuery_reviews_ReviewResult_pagination_PaginationResult };

export type ReviewsQuery_Query = { __typename?: 'Query', reviews: ReviewsQuery_reviews_ReviewResult };


export type ReviewsQueryVariables = Exact<{
  merchant: Scalars['String']['input'];
  order?: InputMaybe<Ordering>;
  sort?: InputMaybe<ReviewSort>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type ReviewsQuery = ReviewsQuery_Query;

export type MyProductsQuery_products_ProductResult_items_Product_promotion_ProductPromotion_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type MyProductsQuery_products_ProductResult_items_Product_promotion_ProductPromotion = { __typename?: 'ProductPromotion', highlight: boolean, label?: MyProductsQuery_products_ProductResult_items_Product_promotion_ProductPromotion_label_PromotionLabel | null };

export type MyProductsQuery_products_ProductResult_items_Product_curation_feedback_CurationFeedback = { __typename?: 'CurationFeedback', message: string, severity: CurationFeedbackSeverity };

export type MyProductsQuery_products_ProductResult_items_Product_curated_reason_CurationReason = { __typename?: 'CurationReason', reason?: string | null, message?: string | null };

export type MyProductsQuery_products_ProductResult_items_Product_image_Image = { __typename?: 'Image', url: string, width?: number | null, height?: number | null };

export type MyProductsQuery_products_ProductResult_items_Product_merchant_Merchant = { __typename?: 'Merchant', id: any };

export type MyProductsQuery_products_ProductResult_items_Product_merchant_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type MyProductsQuery_products_ProductResult_items_Product_tradeDiscountPreviewPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_sold_at_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_auction_Auction = { __typename?: 'Auction', id: any, state: AuctionState, expiry_date?: any | null, allow_bid: boolean, allow_buy_now: boolean, minimum_bid?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_minimum_bid_Price | null, sold_at?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_sold_at_Price | null, buy_now_price?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction_buy_now_price_Price | null };

export type MyProductsQuery_products_ProductResult_items_Product_priceRecommendation_PriceRecommendation_expected_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type MyProductsQuery_products_ProductResult_items_Product_priceRecommendation_PriceRecommendation = { __typename?: 'PriceRecommendation', status: PriceRecommendationStatus, confidence?: PriceRecommendationConfidence | null, comparableSales?: number | null, expected?: MyProductsQuery_products_ProductResult_items_Product_priceRecommendation_PriceRecommendation_expected_Price | null };

export type MyProductsQuery_products_ProductResult_items_Product = { __typename?: 'Product', id: any, title: string, description?: string | null, slug: string, state: ProductState, status: ProductStatus, view_count: number, favorite_count: number, quality?: ProductQuality | null, push_to_top_count?: number | null, last_boost?: any | null, created?: any | null, isBoostable?: boolean | null, isBoosted?: boolean | null, delivery_method: DeliveryMethod, curated_custom?: string | null, promotion?: MyProductsQuery_products_ProductResult_items_Product_promotion_ProductPromotion | null, curation_feedback?: MyProductsQuery_products_ProductResult_items_Product_curation_feedback_CurationFeedback | null, curated_reason?: MyProductsQuery_products_ProductResult_items_Product_curated_reason_CurationReason | null, image?: MyProductsQuery_products_ProductResult_items_Product_image_Image | null, merchant: MyProductsQuery_products_ProductResult_items_Product_merchant_Merchant, merchant_fee?: MyProductsQuery_products_ProductResult_items_Product_merchant_fee_Fee | null, tradeDiscountPreviewPrice?: MyProductsQuery_products_ProductResult_items_Product_tradeDiscountPreviewPrice_Price | null, auction?: MyProductsQuery_products_ProductResult_items_Product_auction_Auction | null, priceRecommendation?: MyProductsQuery_products_ProductResult_items_Product_priceRecommendation_PriceRecommendation | null };

export type MyProductsQuery_products_ProductResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type MyProductsQuery_products_ProductResult = { __typename?: 'ProductResult', items: Array<MyProductsQuery_products_ProductResult_items_Product>, pagination: MyProductsQuery_products_ProductResult_pagination_PaginationResult };

export type MyProductsQuery_Query = { __typename?: 'Query', products: MyProductsQuery_products_ProductResult };


export type MyProductsQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  productStatus?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductSort>;
  sortOrder?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  withPriceCheck?: Scalars['Boolean']['input'];
}>;


export type MyProductsQuery = MyProductsQuery_Query;

export type NotificationPreferencesQuery_notificationPreferences_NotificationPreferences_preferences_NotificationPreference = { __typename?: 'NotificationPreference', key: string, section: NotificationPreferenceSection, alwaysOn: boolean, email: boolean, push: boolean, whatsapp?: boolean | null };

export type NotificationPreferencesQuery_notificationPreferences_NotificationPreferences = { __typename?: 'NotificationPreferences', preferences: Array<NotificationPreferencesQuery_notificationPreferences_NotificationPreferences_preferences_NotificationPreference> };

export type NotificationPreferencesQuery_Query = { __typename?: 'Query', notificationPreferences: NotificationPreferencesQuery_notificationPreferences_NotificationPreferences };


export type NotificationPreferencesQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationPreferencesQuery = NotificationPreferencesQuery_Query;

export type OrderQuery_order_Order_buyer_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrderQuery_order_Order_feeVatAmount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderQuery_order_Order_payoutDetails_PayoutDetails = { __typename?: 'PayoutDetails', status: PayoutStatus, statusLabel: string, statusDescription?: string | null, statusDescriptionImportant?: boolean | null, eta?: any | null, hold_reason: PayoutHoldReason, paid_confirmed: boolean };

export type OrderQuery_order_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType };

export type OrderQuery_order_Order_product_Product_image_Image = { __typename?: 'Image', url: string, id: any, thumbnail_url: string };

export type OrderQuery_order_Order_product_Product_images_Image = { __typename?: 'Image', id: any, x_small_url: string };

export type OrderQuery_order_Order_product_Product = { __typename?: 'Product', id: any, slug: string, title: string, image?: OrderQuery_order_Order_product_Product_image_Image | null, images: Array<OrderQuery_order_Order_product_Product_images_Image> };

export type OrderQuery_order_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type OrderQuery_order_Order = { __typename?: 'Order', id: any, identifier: string, total_incl_vat: number, subtotal_incl_vat: number, currency: Currency, payment_status?: PaymentStatus | null, payout_status?: PayoutStatus | null, payout_trace_id?: string | null, created?: any | null, state: OrderState, buyer_receipt?: string | null, seller_receipt?: string | null, payout: number, fee_excl_vat: number, fee_incl_vat: number, commissionPercent?: number | null, buyer: OrderQuery_order_Order_buyer_Merchant, feeVatAmount?: OrderQuery_order_Order_feeVatAmount_Price | null, payoutDetails?: OrderQuery_order_Order_payoutDetails_PayoutDetails | null, merchant: OrderQuery_order_Order_merchant_Merchant, product: OrderQuery_order_Order_product_Product, thread?: OrderQuery_order_Order_thread_Thread | null };

export type OrderQuery_Query = { __typename?: 'Query', order?: OrderQuery_order_Order | null };


export type OrderQueryVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type OrderQuery = OrderQuery_Query;

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban = { __typename?: 'StripePaymentIntentFinancialAddressIban', accountHolderName: string, bic: string, iban: string, country: string };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions = { __typename?: 'StripePaymentIntentDisplayBankTransferInstructions', amountRemaining?: number | null, reference?: string | null, financialAddresses?: Array<OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban> | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction = { __typename?: 'StripePaymentIntentNextAction', type: StripePaymentIntentNextActionType, displayBankTransferInstructions?: OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent = { __typename?: 'StripePaymentIntent', id: string, nextAction?: OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_shippingMethod_ShippingMethod = { __typename?: 'ShippingMethod', slug: string, enum: ShippingMethodEnum, title: string };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_postalShipment_PostalShipment = { __typename?: 'PostalShipment', id: any, status?: PostalShipmentStatus | null, rateCarrier: string, trackAndTraceUrl?: string | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment_events_BrengerShipmentEvent = { __typename?: 'BrengerShipmentEvent', status: BrengerShipmentStatus, timestamp: any };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', id: any, state?: string | null, status?: BrengerShipmentStatus | null, statusUpdatedAt?: any | null, shipmentUrl?: string | null, deliveryUrl?: string | null, events?: Array<OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment_events_BrengerShipmentEvent> | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', id: any, brengerShipment?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_product_Product_image_Image = { __typename?: 'Image', url: string };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_product_Product_image_Image | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_boostPackage_BoostPackage = { __typename?: 'BoostPackage', days: number };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_service_target_Product = { __typename?: 'Product', id: any };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, expiry_date: any, buyer_receipt?: string | null, returnCaseStatus?: string | null, disputeReason?: string | null, damageFormUrl?: string | null, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, subtotal_incl_vat: number, shipping_incl_vat: number, buyer_protection_incl_vat: number, discount_incl_vat: number, credit_card_cost_incl_vat: number, paypal_cost_incl_vat: number, service_cost_incl_vat: number, total_incl_vat: number, currency: Currency, deliveryMethod: DeliveryMethod, externalDelivery?: boolean | null, shippingMethod?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_shippingMethod_ShippingMethod | null, postalShipment?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_postalShipment_PostalShipment | null, brengerAppointment?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment | null, merchant: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_merchant_Merchant, thread?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_thread_Thread | null, product: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_product_Product, boostPackage?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_boostPackage_BoostPackage | null, service_target?: OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order_service_target_Product | null };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_totals_OrderGroupTotals_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup_totals_OrderGroupTotals = { __typename?: 'OrderGroupTotals', total: OrderGroupByIdQuery_orderGroupById_OrderGroup_totals_OrderGroupTotals_total_Price };

export type OrderGroupByIdQuery_orderGroupById_OrderGroup = { __typename?: 'OrderGroup', id: any, created?: any | null, paymentMethod: PaymentMethod, paymentIntent?: OrderGroupByIdQuery_orderGroupById_OrderGroup_paymentIntent_StripePaymentIntent | null, orders: Array<OrderGroupByIdQuery_orderGroupById_OrderGroup_orders_Order>, totals: OrderGroupByIdQuery_orderGroupById_OrderGroup_totals_OrderGroupTotals };

export type OrderGroupByIdQuery_Query = { __typename?: 'Query', orderGroupById?: OrderGroupByIdQuery_orderGroupById_OrderGroup | null };


export type OrderGroupByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type OrderGroupByIdQuery = OrderGroupByIdQuery_Query;

export type OrdersByProductQuery_orders_OrderResult_items_Order_payoutDetails_PayoutDetails = { __typename?: 'PayoutDetails', status: PayoutStatus, statusLabel: string, eta?: any | null };

export type OrdersByProductQuery_orders_OrderResult_items_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, payout: number, currency: Currency, payoutDetails?: OrdersByProductQuery_orders_OrderResult_items_Order_payoutDetails_PayoutDetails | null };

export type OrdersByProductQuery_orders_OrderResult = { __typename?: 'OrderResult', items: Array<OrdersByProductQuery_orders_OrderResult_items_Order> };

export type OrdersByProductQuery_Query = { __typename?: 'Query', orders: OrdersByProductQuery_orders_OrderResult };


export type OrdersByProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type OrdersByProductQuery = OrdersByProductQuery_Query;

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban = { __typename?: 'StripePaymentIntentFinancialAddressIban', accountHolderName: string, bic: string, iban: string, country: string };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions = { __typename?: 'StripePaymentIntentDisplayBankTransferInstructions', amountRemaining?: number | null, reference?: string | null, financialAddresses?: Array<PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban> | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction = { __typename?: 'StripePaymentIntentNextAction', type: StripePaymentIntentNextActionType, displayBankTransferInstructions?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent = { __typename?: 'StripePaymentIntent', id: string, nextAction?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_shippingMethod_ShippingMethod = { __typename?: 'ShippingMethod', slug: string, enum: ShippingMethodEnum };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_postalShipment_PostalShipment = { __typename?: 'PostalShipment', id: any, status?: PostalShipmentStatus | null, trackAndTraceUrl?: string | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment_events_BrengerShipmentEvent = { __typename?: 'BrengerShipmentEvent', status: BrengerShipmentStatus, timestamp: any };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', id: any, state?: string | null, status?: BrengerShipmentStatus | null, statusUpdatedAt?: any | null, shipmentUrl?: string | null, deliveryUrl?: string | null, events?: Array<PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment_events_BrengerShipmentEvent> | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', id: any, brengerShipment?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string, type: MerchantType };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_product_Product_image_Image = { __typename?: 'Image', url: string };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_product_Product_image_Image | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_boostPackage_BoostPackage = { __typename?: 'BoostPackage', days: number };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_service_target_Product = { __typename?: 'Product', id: any };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order = { __typename?: 'Order', id: any, identifier: string, created?: any | null, expiry_date: any, state: OrderState, buyer_receipt?: string | null, returnCaseStatus?: string | null, disputeReason?: string | null, damageFormUrl?: string | null, canUpdatePickupConfirmation?: boolean | null, buyerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, sellerPickupConfirmationStatus?: OrderPickupConfirmationStatus | null, subtotal_incl_vat: number, shipping_incl_vat: number, buyer_protection_incl_vat: number, discount_incl_vat: number, credit_card_cost_incl_vat: number, paypal_cost_incl_vat: number, service_cost_incl_vat: number, total_incl_vat: number, currency: Currency, deliveryMethod: DeliveryMethod, externalDelivery?: boolean | null, shippingMethod?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_shippingMethod_ShippingMethod | null, postalShipment?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_postalShipment_PostalShipment | null, brengerAppointment?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment | null, merchant: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_merchant_Merchant, thread?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_thread_Thread | null, product: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_product_Product, boostPackage?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_boostPackage_BoostPackage | null, service_target?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order_service_target_Product | null };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_totals_OrderGroupTotals_total_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_totals_OrderGroupTotals = { __typename?: 'OrderGroupTotals', total: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_totals_OrderGroupTotals_total_Price };

export type PurchasesQuery_purchases_PurchasesResult_items_OrderGroup = { __typename?: 'OrderGroup', id: any, paymentMethod: PaymentMethod, created?: any | null, paymentIntent?: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_paymentIntent_StripePaymentIntent | null, orders: Array<PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_orders_Order>, totals: PurchasesQuery_purchases_PurchasesResult_items_OrderGroup_totals_OrderGroupTotals };

export type PurchasesQuery_purchases_PurchasesResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type PurchasesQuery_purchases_PurchasesResult = { __typename?: 'PurchasesResult', items: Array<PurchasesQuery_purchases_PurchasesResult_items_OrderGroup>, pagination: PurchasesQuery_purchases_PurchasesResult_pagination_PaginationResult };

export type PurchasesQuery_Query = { __typename?: 'Query', purchases: PurchasesQuery_purchases_PurchasesResult };


export type PurchasesQueryVariables = Exact<{
  productTitleQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PurchasesSort>;
  order?: InputMaybe<Ordering>;
  lang?: InputMaybe<Language>;
}>;


export type PurchasesQuery = PurchasesQuery_Query;

export type SalesQuery_sales_SalesResult_items_Order_payoutDetails_PayoutDetails = { __typename?: 'PayoutDetails', status: PayoutStatus, statusLabel: string, statusDescription?: string | null, statusDescriptionImportant?: boolean | null, eta?: any | null, hold_reason: PayoutHoldReason, paid_confirmed: boolean };

export type SalesQuery_sales_SalesResult_items_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type SalesQuery_sales_SalesResult_items_Order_product_Product_image_Image = { __typename?: 'Image', url: string };

export type SalesQuery_sales_SalesResult_items_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, image?: SalesQuery_sales_SalesResult_items_Order_product_Product_image_Image | null };

export type SalesQuery_sales_SalesResult_items_Order = { __typename?: 'Order', id: any, identifier: string, created?: any | null, state: OrderState, seller_receipt?: string | null, payout_status?: PayoutStatus | null, subtotal_incl_vat: number, fee_excl_vat: number, fee_incl_vat: number, payout: number, currency: Currency, payoutDetails?: SalesQuery_sales_SalesResult_items_Order_payoutDetails_PayoutDetails | null, thread?: SalesQuery_sales_SalesResult_items_Order_thread_Thread | null, product: SalesQuery_sales_SalesResult_items_Order_product_Product };

export type SalesQuery_sales_SalesResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type SalesQuery_sales_SalesResult = { __typename?: 'SalesResult', items: Array<SalesQuery_sales_SalesResult_items_Order>, pagination: SalesQuery_sales_SalesResult_pagination_PaginationResult };

export type SalesQuery_Query = { __typename?: 'Query', sales: SalesQuery_sales_SalesResult };


export type SalesQueryVariables = Exact<{
  productTitleQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SalesSort>;
  order?: InputMaybe<Ordering>;
  lang?: InputMaybe<Language>;
}>;


export type SalesQuery = SalesQuery_Query;

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban = { __typename?: 'StripePaymentIntentFinancialAddressIban', accountHolderName: string, bic: string, iban: string, country: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions = { __typename?: 'StripePaymentIntentDisplayBankTransferInstructions', reference?: string | null, amountRemaining?: number | null, financialAddresses?: Array<OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions_financialAddresses_StripePaymentIntentFinancialAddressIban> | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction = { __typename?: 'StripePaymentIntentNextAction', type: StripePaymentIntentNextActionType, displayBankTransferInstructions?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent = { __typename?: 'StripePaymentIntent', id: string, nextAction?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_discount_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_total_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_convertedTotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_subtotal_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_tax_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_serviceCost_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_shipping_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_addon_Service = { __typename?: 'Service', id: any, name: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals = { __typename?: 'OrderGroupAddonTotals', addon: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_addon_Service, price: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals_price_Price };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals = { __typename?: 'OrderGroupTotals', discount: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_discount_Price, total: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_total_Price, convertedTotal?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_convertedTotal_Price | null, subtotal: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_subtotal_Price, tax: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_tax_Price, serviceCost: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_serviceCost_Price, shipping: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_shipping_Price, addons: Array<OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals_addons_OrderGroupAddonTotals> };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_billingAddress_OrderAddress = { __typename?: 'OrderAddress', line1: string, line2?: string | null, postal_code: string, country: string, city: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_shipping_method_ShippingMethod = { __typename?: 'ShippingMethod', id: any, slug: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment = { __typename?: 'BrengerShipment', id: any, shipmentId?: string | null, apiVersion?: number | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment = { __typename?: 'BrengerAppointment', id: any, apiVersion?: number | null, brengerShipment?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment_brengerShipment_BrengerShipment | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_image_Image = { __typename?: 'Image', url: string };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_auction_Auction_buy_now_price_Price | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product = { __typename?: 'Product', id: any, title: string, image?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_image_Image | null, auction?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product_auction_Auction | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_product_Product = { __typename?: 'Product', id: any, identifier: string, title: string, slug: string, state: ProductState, status: ProductStatus, isInCart: boolean, view_count: number, favorite_count: number, quality?: ProductQuality | null, condition: ProductCondition, delivery_method: DeliveryMethod, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, buy_now_price?: CartProductFragmentFragment_Product_buy_now_price_Price | null, address?: CartProductFragmentFragment_Product_address_Address | null, image?: CartProductFragmentFragment_Product_image_Image | null, images: Array<CartProductFragmentFragment_Product_images_Image>, shipping_method?: CartProductFragmentFragment_Product_shipping_method_ShippingMethod | null, favorite?: CartProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<CartProductFragmentFragment_Product_categories_Category>, auction?: CartProductFragmentFragment_Product_auction_Auction | null, attributes: Array<CartProductFragmentFragment_Product_attributes>, merchant: CartProductFragmentFragment_Product_merchant_Merchant };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_thread_Thread = { __typename?: 'Thread', id: any };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order = { __typename?: 'Order', expiry_date: any, id: any, currency: Currency, purchase_type: PurchaseType, subtotal_incl_vat: number, buyer_protection_incl_vat: number, delivery_method: DeliveryMethod, state: OrderState, external_delivery?: boolean | null, shipping_method?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_shipping_method_ShippingMethod | null, brengerAppointment?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_brengerAppointment_BrengerAppointment | null, service_target?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_service_target_Product | null, product: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_product_Product, thread?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order_thread_Thread | null };

export type OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup = { __typename?: 'OrderGroup', id: any, readableId?: string | null, couponCode?: string | null, created?: any | null, type: OrderGroupType, hasExternalDelivery?: boolean | null, paymentMethod: PaymentMethod, paymentIntent?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_paymentIntent_StripePaymentIntent | null, totals: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_totals_OrderGroupTotals, billingAddress?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_billingAddress_OrderAddress | null, orders: Array<OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup_orders_Order> };

export type OrderGroupByPaymentIntentQuery_Query = { __typename?: 'Query', orderGroupByPaymentIntent?: OrderGroupByPaymentIntentQuery_orderGroupByPaymentIntent_OrderGroup | null };


export type OrderGroupByPaymentIntentQueryVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type OrderGroupByPaymentIntentQuery = OrderGroupByPaymentIntentQuery_Query;

export type OrdersQuery_orders_OrderResult_items_Order_buyer_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrdersQuery_orders_OrderResult_items_Order_merchant_Merchant = { __typename?: 'Merchant', id: any, name: string };

export type OrdersQuery_orders_OrderResult_items_Order_payoutDetails_PayoutDetails = { __typename?: 'PayoutDetails', status: PayoutStatus, statusLabel: string, statusDescription?: string | null, statusDescriptionImportant?: boolean | null, eta?: any | null };

export type OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions = { __typename?: 'StripePaymentIntentDisplayBankTransferInstructions', hostedInstructionsUrl?: string | null };

export type OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_redirectToUrl_StripePaymentIntentRedirectToUrl = { __typename?: 'StripePaymentIntentRedirectToUrl', url?: string | null };

export type OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction = { __typename?: 'StripePaymentIntentNextAction', displayBankTransferInstructions?: OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_displayBankTransferInstructions_StripePaymentIntentDisplayBankTransferInstructions | null, redirectToUrl?: OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction_redirectToUrl_StripePaymentIntentRedirectToUrl | null };

export type OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent = { __typename?: 'StripePaymentIntent', id: string, clientSecret?: string | null, nextAction?: OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent_nextAction_StripePaymentIntentNextAction | null };

export type OrdersQuery_orders_OrderResult_items_Order_product_Product_image_Image = { __typename?: 'Image', url: string, id: any, thumbnail_url: string };

export type OrdersQuery_orders_OrderResult_items_Order_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, state: ProductState, image?: OrdersQuery_orders_OrderResult_items_Order_product_Product_image_Image | null };

export type OrdersQuery_orders_OrderResult_items_Order_service_target_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type OrdersQuery_orders_OrderResult_items_Order_service_target_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: OrdersQuery_orders_OrderResult_items_Order_service_target_Product_auction_Auction_buy_now_price_Price | null };

export type OrdersQuery_orders_OrderResult_items_Order_service_target_Product = { __typename?: 'Product', id: any, title: string, slug: string, auction?: OrdersQuery_orders_OrderResult_items_Order_service_target_Product_auction_Auction | null };

export type OrdersQuery_orders_OrderResult_items_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, buyer_receipt?: string | null, buyer_track_and_trace?: string | null, seller_receipt?: string | null, seller_track_and_trace?: string | null, payment_status?: PaymentStatus | null, payout_status?: PayoutStatus | null, payout_eta?: any | null, payout_trace_id?: string | null, payout: number, total_incl_vat: number, currency: Currency, buyer: OrdersQuery_orders_OrderResult_items_Order_buyer_Merchant, merchant: OrdersQuery_orders_OrderResult_items_Order_merchant_Merchant, payoutDetails?: OrdersQuery_orders_OrderResult_items_Order_payoutDetails_PayoutDetails | null, paymentIntent?: OrdersQuery_orders_OrderResult_items_Order_paymentIntent_StripePaymentIntent | null, product: OrdersQuery_orders_OrderResult_items_Order_product_Product, service_target?: OrdersQuery_orders_OrderResult_items_Order_service_target_Product | null };

export type OrdersQuery_orders_OrderResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type OrdersQuery_orders_OrderResult = { __typename?: 'OrderResult', items: Array<OrdersQuery_orders_OrderResult_items_Order>, pagination: OrdersQuery_orders_OrderResult_pagination_PaginationResult };

export type OrdersQuery_Query = { __typename?: 'Query', orders: OrdersQuery_orders_OrderResult };


export type OrdersQueryVariables = Exact<{
  filterKey: OrderFilterKey;
  userId: Scalars['String']['input'];
  productTitle?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrderSort>;
  order?: InputMaybe<Ordering>;
  orderState?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type OrdersQuery = OrdersQuery_Query;

export type PackageCartQuery_packageCart_PackageCart = { __typename?: 'PackageCart', fingerprint: string, convertedTotal?: PackageCartFragmentFragment_PackageCart_convertedTotal_Price | null, checkout?: PackageCartFragmentFragment_PackageCart_checkout_PackageCheckout | null, total: PackageCartFragmentFragment_PackageCart_total_Price, items: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem> };

export type PackageCartQuery_Query = { __typename?: 'Query', packageCart: PackageCartQuery_packageCart_PackageCart };


export type PackageCartQueryVariables = Exact<{
  displayCurrency?: InputMaybe<Currency>;
}>;


export type PackageCartQuery = PackageCartQuery_Query;

export type PackageCheckoutQuery_packageCheckout_PackageCheckout = { __typename?: 'PackageCheckout', id: string, orderGroupId: string, status: PackageCheckoutStatus, paymentIntentClientSecret?: string | null, total: PackageCheckoutDetailsFragment_PackageCheckout_total_Price, convertedTotal?: PackageCheckoutDetailsFragment_PackageCheckout_convertedTotal_Price | null, campaigns: Array<PackageCheckoutDetailsFragment_PackageCheckout_campaigns_PromotionCampaign>, items: Array<PackageCheckoutDetailsFragment_PackageCheckout_items_PackageCheckoutItem> };

export type PackageCheckoutQuery_Query = { __typename?: 'Query', packageCheckout?: PackageCheckoutQuery_packageCheckout_PackageCheckout | null };


export type PackageCheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  displayCurrency?: InputMaybe<Currency>;
}>;


export type PackageCheckoutQuery = PackageCheckoutQuery_Query;

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_defaultCommission_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_packageCommission_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_payout_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_savings_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_askingPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_feeVat_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_package_DynamicListingFeePackage_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_package_DynamicListingFeePackage = { __typename?: 'DynamicListingFeePackage', id: any, identifier: string, isPopular: boolean, reducedFeeAmount: number, title: string, price: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_package_DynamicListingFeePackage_price_Price };

export type DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption = { __typename?: 'DynamicListingFeePackageOption', chargesVatOnFee: boolean, defaultCommission: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_defaultCommission_Price, packageCommission: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_packageCommission_Price, payout: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_payout_Price, savings: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_savings_Price, askingPrice: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_askingPrice_Price, feeVat: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_feeVat_Price, package: DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption_package_DynamicListingFeePackage };

export type DynamicListingFeePackagesQuery_Query = { __typename?: 'Query', dynamicListingFeePackages: Array<DynamicListingFeePackagesQuery_dynamicListingFeePackages_DynamicListingFeePackageOption> };


export type DynamicListingFeePackagesQueryVariables = Exact<{
  productId: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type DynamicListingFeePackagesQuery = DynamicListingFeePackagesQuery_Query;

export type PayoutQuoteQuery_payoutQuote_PayoutQuote_askingPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PayoutQuoteQuery_payoutQuote_PayoutQuote_fee_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PayoutQuoteQuery_payoutQuote_PayoutQuote_feeExclVat_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PayoutQuoteQuery_payoutQuote_PayoutQuote_feeVat_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PayoutQuoteQuery_payoutQuote_PayoutQuote_payout_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PayoutQuoteQuery_payoutQuote_PayoutQuote = { __typename?: 'PayoutQuote', commissionPercent?: number | null, chargesVatOnFee: boolean, askingPrice: PayoutQuoteQuery_payoutQuote_PayoutQuote_askingPrice_Price, fee: PayoutQuoteQuery_payoutQuote_PayoutQuote_fee_Price, feeExclVat: PayoutQuoteQuery_payoutQuote_PayoutQuote_feeExclVat_Price, feeVat: PayoutQuoteQuery_payoutQuote_PayoutQuote_feeVat_Price, payout: PayoutQuoteQuery_payoutQuote_PayoutQuote_payout_Price };

export type PayoutQuoteQuery_Query = { __typename?: 'Query', payoutQuote: PayoutQuoteQuery_payoutQuote_PayoutQuote };


export type PayoutQuoteQueryVariables = Exact<{
  askingPrice: Scalars['Float']['input'];
  productId?: InputMaybe<Scalars['UUID']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type PayoutQuoteQuery = PayoutQuoteQuery_Query;

export type PostalPackageSizesQuery_postalPackageSizes_PostalPackageSizeOption = { __typename?: 'PostalPackageSizeOption', size: PostalPackageSize, width: number, height: number, length: number, maxWeightKg: number };

export type PostalPackageSizesQuery_Query = { __typename?: 'Query', postalPackageSizes: Array<PostalPackageSizesQuery_postalPackageSizes_PostalPackageSizeOption> };


export type PostalPackageSizesQueryVariables = Exact<{ [key: string]: never; }>;


export type PostalPackageSizesQuery = PostalPackageSizesQuery_Query;

export type PriceDropPreviewQuery_priceDropPreview_PriceDropSchedule = { __typename?: 'PriceDropSchedule', pace: PriceDropPace, stepPercent: number, pausedReason?: PriceDropPause | null, basePrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_basePrice_Price, floor: PriceDropScheduleFieldsFragment_PriceDropSchedule_floor_Price, lowestPrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_lowestPrice_Price, upcoming: Array<PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep> };

export type PriceDropPreviewQuery_Query = { __typename?: 'Query', priceDropPreview: PriceDropPreviewQuery_priceDropPreview_PriceDropSchedule };


export type PriceDropPreviewQueryVariables = Exact<{
  input: PriceDropPreviewInput;
}>;


export type PriceDropPreviewQuery = PriceDropPreviewQuery_Query;

export type PriceRecommendationQuery_priceRecommendation_PriceRecommendation_low_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceRecommendationQuery_priceRecommendation_PriceRecommendation_expected_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceRecommendationQuery_priceRecommendation_PriceRecommendation_high_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PriceRecommendationQuery_priceRecommendation_PriceRecommendation = { __typename?: 'PriceRecommendation', status: PriceRecommendationStatus, confidence?: PriceRecommendationConfidence | null, comparableSales?: number | null, basis?: string | null, low?: PriceRecommendationQuery_priceRecommendation_PriceRecommendation_low_Price | null, expected?: PriceRecommendationQuery_priceRecommendation_PriceRecommendation_expected_Price | null, high?: PriceRecommendationQuery_priceRecommendation_PriceRecommendation_high_Price | null };

export type PriceRecommendationQuery_Query = { __typename?: 'Query', priceRecommendation: PriceRecommendationQuery_priceRecommendation_PriceRecommendation };


export type PriceRecommendationQueryVariables = Exact<{
  productId: Scalars['UUID']['input'];
  surface?: InputMaybe<PriceRecommendationSurface>;
}>;


export type PriceRecommendationQuery = PriceRecommendationQuery_Query;

export type MeProBuyerProjectsQuery_me_Member = { __typename?: 'Member', id: any, proBuyerProjectsAccess?: ProBuyerProjectsAccess | null };

export type MeProBuyerProjectsQuery_Query = { __typename?: 'Query', me?: MeProBuyerProjectsQuery_me_Member | null };


export type MeProBuyerProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProBuyerProjectsQuery = MeProBuyerProjectsQuery_Query;

export type MyReservationProjectsQuery_myReservations_BuyerReservation_project_ReservationProject = { __typename?: 'ReservationProject', id: any, name: string };

export type MyReservationProjectsQuery_myReservations_BuyerReservation = { __typename?: 'BuyerReservation', id: any, project?: MyReservationProjectsQuery_myReservations_BuyerReservation_project_ReservationProject | null };

export type MyReservationProjectsQuery_Query = { __typename?: 'Query', myReservations: Array<MyReservationProjectsQuery_myReservations_BuyerReservation> };


export type MyReservationProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReservationProjectsQuery = MyReservationProjectsQuery_Query;

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_reservations_BuyerReservation = { __typename?: 'BuyerReservation', id: any, status: ReservationStatus, requestExpiresAt: any, reservedUntil?: any | null, productId: any, productTitle: string, productSlug: string, productImage?: string | null, fixedPrice?: ProBuyerProjectReservationFragment_BuyerReservation_fixedPrice_Price | null };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_invoiceZipParts_ProBuyerProjectInvoiceZipPart = { __typename?: 'ProBuyerProjectInvoiceZipPart', url: string, from: number, to: number, count: number };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_paid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_saved_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, currency: Currency, subtotal_incl_vat: number, product: ProBuyerProjectOrderFragment_Order_product_Product };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase = { __typename?: 'ProBuyerProjectPurchase', countsTowardTotals: boolean, fullyRefunded: boolean, orderGroupId?: any | null, priceKind: ProBuyerProjectPriceKind, proBuyerPct?: number | null, paid: ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_paid_Price, saved?: ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_saved_Price | null, order: ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order };

export type ProBuyerProjectQuery_proBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', invoiceCount: number, reservationCount?: number | null, reservationAwaitingSellerCount?: number | null, id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, reservations: Array<ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_reservations_BuyerReservation>, invoiceZipParts: Array<ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_invoiceZipParts_ProBuyerProjectInvoiceZipPart>, purchases: Array<ProBuyerProjectQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase>, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type ProBuyerProjectQuery_Query = { __typename?: 'Query', proBuyerProject?: ProBuyerProjectQuery_proBuyerProject_ProBuyerProject | null };


export type ProBuyerProjectQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProBuyerProjectQuery = ProBuyerProjectQuery_Query;

export type ProBuyerProjectAssignmentsQuery_proBuyerProjectAssignments_ProBuyerProjectAssignment = { __typename?: 'ProBuyerProjectAssignment', orderId: any, projectId?: any | null, projectName?: string | null, eligible: boolean };

export type ProBuyerProjectAssignmentsQuery_Query = { __typename?: 'Query', proBuyerProjectAssignments: Array<ProBuyerProjectAssignmentsQuery_proBuyerProjectAssignments_ProBuyerProjectAssignment> };


export type ProBuyerProjectAssignmentsQueryVariables = Exact<{
  orderIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ProBuyerProjectAssignmentsQuery = ProBuyerProjectAssignmentsQuery_Query;

export type ProBuyerProjectPurchaseOptionsQuery_proBuyerProjectPurchaseOptions_ProBuyerProjectPurchaseOption_order_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, currency: Currency, subtotal_incl_vat: number, product: ProBuyerProjectOrderFragment_Order_product_Product };

export type ProBuyerProjectPurchaseOptionsQuery_proBuyerProjectPurchaseOptions_ProBuyerProjectPurchaseOption = { __typename?: 'ProBuyerProjectPurchaseOption', projectId?: any | null, projectName?: string | null, order: ProBuyerProjectPurchaseOptionsQuery_proBuyerProjectPurchaseOptions_ProBuyerProjectPurchaseOption_order_Order };

export type ProBuyerProjectPurchaseOptionsQuery_Query = { __typename?: 'Query', proBuyerProjectPurchaseOptions: Array<ProBuyerProjectPurchaseOptionsQuery_proBuyerProjectPurchaseOptions_ProBuyerProjectPurchaseOption> };


export type ProBuyerProjectPurchaseOptionsQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type ProBuyerProjectPurchaseOptionsQuery = ProBuyerProjectPurchaseOptionsQuery_Query;

export type ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order_product_Product_image_Image = { __typename?: 'Image', id: any, thumbnail_url: string };

export type ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order_product_Product = { __typename?: 'Product', id: any, image?: ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order_product_Product_image_Image | null };

export type ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order = { __typename?: 'Order', id: any, product: ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order_product_Product };

export type ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject = { __typename?: 'ProBuyerProject', reservationCount?: number | null, reservationAwaitingSellerCount?: number | null, id: any, name: string, createdAt: any, updatedAt: any, purchaseCount: number, previewOrders: Array<ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_previewOrders_Order>, totals: Array<ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal> };

export type ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage = { __typename?: 'ProBuyerProjectPage', hasMore: boolean, items: Array<ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject> };

export type ProBuyerProjectsQuery_Query = { __typename?: 'Query', proBuyerProjects: ProBuyerProjectsQuery_proBuyerProjects_ProBuyerProjectPage };


export type ProBuyerProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProBuyerProjectsQuery = ProBuyerProjectsQuery_Query;

export type ProBuyerProjectsOverviewQuery_proBuyerProjectsOverview_ProBuyerProjectsOverview_totals_ProBuyerProjectTotal = { __typename?: 'ProBuyerProjectTotal', purchaseCount: number, spent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price, proBuyerSpent: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_proBuyerSpent_Price, saved: ProBuyerProjectSummaryFragment_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price };

export type ProBuyerProjectsOverviewQuery_proBuyerProjectsOverview_ProBuyerProjectsOverview = { __typename?: 'ProBuyerProjectsOverview', purchaseCount: number, unassignedPurchaseCount: number, reservedCount?: number | null, reservedAwaitingSellerCount?: number | null, totals: Array<ProBuyerProjectsOverviewQuery_proBuyerProjectsOverview_ProBuyerProjectsOverview_totals_ProBuyerProjectTotal> };

export type ProBuyerProjectsOverviewQuery_Query = { __typename?: 'Query', proBuyerProjectsOverview: ProBuyerProjectsOverviewQuery_proBuyerProjectsOverview_ProBuyerProjectsOverview };


export type ProBuyerProjectsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ProBuyerProjectsOverviewQuery = ProBuyerProjectsOverviewQuery_Query;

export type ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_product_Product = { __typename?: 'Product', id: any };

export type ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_proBuyerProject_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_proBuyerProjectsWithProduct_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerCartProjectsQuery_cart_Cart_items_CartItem = { __typename?: 'CartItem', id: any, product: ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_product_Product, proBuyerProject?: ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_proBuyerProject_ProBuyerProjectRef | null, proBuyerProjectsWithProduct?: Array<ProBuyerCartProjectsQuery_cart_Cart_items_CartItem_proBuyerProjectsWithProduct_ProBuyerProjectRef> | null };

export type ProBuyerCartProjectsQuery_cart_Cart = { __typename?: 'Cart', id: any, items: Array<ProBuyerCartProjectsQuery_cart_Cart_items_CartItem> };

export type ProBuyerCartProjectsQuery_Query = { __typename?: 'Query', cart: ProBuyerCartProjectsQuery_cart_Cart };


export type ProBuyerCartProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProBuyerCartProjectsQuery = ProBuyerCartProjectsQuery_Query;

export type ProBuyerFavoriteProjectsQuery_proBuyerFavoriteProjects_ProBuyerFavoriteProjects_projects_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerFavoriteProjectsQuery_proBuyerFavoriteProjects_ProBuyerFavoriteProjects = { __typename?: 'ProBuyerFavoriteProjects', productId: any, projects: Array<ProBuyerFavoriteProjectsQuery_proBuyerFavoriteProjects_ProBuyerFavoriteProjects_projects_ProBuyerProjectRef> };

export type ProBuyerFavoriteProjectsQuery_Query = { __typename?: 'Query', proBuyerFavoriteProjects: Array<ProBuyerFavoriteProjectsQuery_proBuyerFavoriteProjects_ProBuyerFavoriteProjects> };


export type ProBuyerFavoriteProjectsQueryVariables = Exact<{
  productIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ProBuyerFavoriteProjectsQuery = ProBuyerFavoriteProjectsQuery_Query;

export type ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary_projects_ProBuyerFavoritesProjectCount_project_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary_projects_ProBuyerFavoritesProjectCount = { __typename?: 'ProBuyerFavoritesProjectCount', count: number, project: ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary_projects_ProBuyerFavoritesProjectCount_project_ProBuyerProjectRef };

export type ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary = { __typename?: 'ProBuyerFavoritesSummary', total: number, notInProject: number, projects: Array<ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary_projects_ProBuyerFavoritesProjectCount> };

export type ProBuyerFavoritesSummaryQuery_Query = { __typename?: 'Query', proBuyerFavoritesSummary: ProBuyerFavoritesSummaryQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary };


export type ProBuyerFavoritesSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProBuyerFavoritesSummaryQuery = ProBuyerFavoritesSummaryQuery_Query;

export type ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_items_ProBuyerProjectItem = { __typename?: 'ProBuyerProjectItem', id: any, note: string, status: ProBuyerProjectItemStatus, createdAt: any, position: number, onMoodboard: boolean, reservationExpiresAt?: any | null, reservationRequested: boolean, priceAtSave?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_priceAtSave_Price | null, regularPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_regularPrice_Price | null, proBuyerPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice | null, purchase?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_purchase_ProBuyerProjectItemPurchase | null, clientReactions: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_clientReactions_ProBuyerClientReactions, room?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_room_ProBuyerProjectRoom | null, otherProjects: Array<ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_otherProjects_ProBuyerProjectRef>, product: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_product_Product };

export type ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_share_ProBuyerProjectShare = { __typename?: 'ProBuyerProjectShare', enabled: boolean, token?: string | null, message: string, showPrices: boolean, showNotes: boolean, allowReactions: boolean, updatedAt?: any | null };

export type ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_changes_ProBuyerProjectChanges = { __typename?: 'ProBuyerProjectChanges', priceDropped: number, unavailable: number, reactedItems: number, reactionsYes: number, reactionsNo: number };

export type ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, unassignedItemCount: number, lastViewedAt?: any | null, rooms: Array<ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom>, items: Array<ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_items_ProBuyerProjectItem>, share: ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_share_ProBuyerProjectShare, changes: ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject_changes_ProBuyerProjectChanges };

export type ProBuyerProjectBoardQuery_Query = { __typename?: 'Query', proBuyerProject?: ProBuyerProjectBoardQuery_proBuyerProject_ProBuyerProject | null };


export type ProBuyerProjectBoardQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProBuyerProjectBoardQuery = ProBuyerProjectBoardQuery_Query;

export type ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject_share_ProBuyerProjectShare = { __typename?: 'ProBuyerProjectShare', enabled: boolean, token?: string | null, message: string, showPrices: boolean, showNotes: boolean, allowReactions: boolean, updatedAt?: any | null };

export type ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, createdAt: any, itemCount: number, purchaseCount: number, invoiceCount: number, rooms: Array<ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom>, share: ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject_share_ProBuyerProjectShare };

export type ProBuyerProjectHeaderQuery_Query = { __typename?: 'Query', proBuyerProject?: ProBuyerProjectHeaderQuery_proBuyerProject_ProBuyerProject | null };


export type ProBuyerProjectHeaderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProBuyerProjectHeaderQuery = ProBuyerProjectHeaderQuery_Query;

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_invoiceZipParts_ProBuyerProjectInvoiceZipPart = { __typename?: 'ProBuyerProjectInvoiceZipPart', url: string, from: number, to: number, count: number };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal = { __typename?: 'ProBuyerProjectTotal', purchaseCount: number, spent: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal_spent_Price, saved: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal_saved_Price };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_paid_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_saved_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_listPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_product_Product_image_Image = { __typename?: 'Image', id: any, thumbnail_url: string };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_product_Product = { __typename?: 'Product', id: any, title: string, image?: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_product_Product_image_Image | null };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order = { __typename?: 'Order', id: any, identifier: string, state: OrderState, created?: any | null, buyer_receipt?: string | null, listPrice?: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_listPrice_Price | null, product: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order_product_Product };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase = { __typename?: 'ProBuyerProjectPurchase', countsTowardTotals: boolean, fullyRefunded: boolean, orderGroupId?: any | null, priceKind: ProBuyerProjectPriceKind, proBuyerPct?: number | null, paid: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_paid_Price, saved?: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_saved_Price | null, order: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase_order_Order };

export type ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, invoiceCount: number, invoiceZipParts: Array<ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_invoiceZipParts_ProBuyerProjectInvoiceZipPart>, totals: Array<ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_totals_ProBuyerProjectTotal>, purchases: Array<ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject_purchases_ProBuyerProjectPurchase> };

export type ProBuyerProjectInvoicesQuery_Query = { __typename?: 'Query', proBuyerProject?: ProBuyerProjectInvoicesQuery_proBuyerProject_ProBuyerProject | null };


export type ProBuyerProjectInvoicesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProBuyerProjectInvoicesQuery = ProBuyerProjectInvoicesQuery_Query;

export type ProBuyerProjectProposalQuery_proBuyerBrandProfile_ProBuyerBrandProfile = { __typename?: 'ProBuyerBrandProfile', brandName: string, logo?: string | null, accentColor: string, fontStyle: ProBuyerProposalFontStyle, legalName: string, addressLine: string, postalCode: string, city: string, country: string, email: string, phone: string, website: string, cocNumber: string, vatNumber: string, saved: boolean };

export type ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_items_ProBuyerProjectItem = { __typename?: 'ProBuyerProjectItem', id: any, note: string, status: ProBuyerProjectItemStatus, createdAt: any, position: number, onMoodboard: boolean, reservationExpiresAt?: any | null, reservationRequested: boolean, priceAtSave?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_priceAtSave_Price | null, regularPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_regularPrice_Price | null, proBuyerPrice?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_proBuyerPrice_ProBuyerPrice | null, purchase?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_purchase_ProBuyerProjectItemPurchase | null, clientReactions: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_clientReactions_ProBuyerClientReactions, room?: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_room_ProBuyerProjectRoom | null, otherProjects: Array<ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_otherProjects_ProBuyerProjectRef>, product: ProBuyerProjectItemFieldsFragment_ProBuyerProjectItem_product_Product };

export type ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_proposal_ProBuyerProjectProposal = { __typename?: 'ProBuyerProjectProposal', title: string, clientName: string, intro: string, validUntil?: any | null, roomIds: Array<any>, includeUnassigned: boolean, showNotes: boolean, showDimensions: boolean, showTotals: boolean, hideUnavailable: boolean, pdfUrl: string, updatedAt?: any | null };

export type ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, rooms: Array<ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_rooms_ProBuyerProjectRoom>, items: Array<ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_items_ProBuyerProjectItem>, proposal: ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject_proposal_ProBuyerProjectProposal };

export type ProBuyerProjectProposalQuery_Query = { __typename?: 'Query', proBuyerBrandProfile: ProBuyerProjectProposalQuery_proBuyerBrandProfile_ProBuyerBrandProfile, proBuyerProject?: ProBuyerProjectProposalQuery_proBuyerProject_ProBuyerProject | null };


export type ProBuyerProjectProposalQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProBuyerProjectProposalQuery = ProBuyerProjectProposalQuery_Query;

export type ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_changes_ProBuyerProjectChanges = { __typename?: 'ProBuyerProjectChanges', priceDropped: number, unavailable: number, reactedItems: number, reactionsYes: number, reactionsNo: number };

export type ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string>, changes: ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject_changes_ProBuyerProjectChanges };

export type ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage = { __typename?: 'ProBuyerProjectPage', items: Array<ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage_items_ProBuyerProject> };

export type ProBuyerProjectsDashboardQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary = { __typename?: 'ProBuyerFavoritesSummary', total: number, notInProject: number };

export type ProBuyerProjectsDashboardQuery_Query = { __typename?: 'Query', proBuyerProjects: ProBuyerProjectsDashboardQuery_proBuyerProjects_ProBuyerProjectPage, proBuyerFavoritesSummary: ProBuyerProjectsDashboardQuery_proBuyerFavoritesSummary_ProBuyerFavoritesSummary };


export type ProBuyerProjectsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ProBuyerProjectsDashboardQuery = ProBuyerProjectsDashboardQuery_Query;

export type ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget_project_ProBuyerProjectRef = { __typename?: 'ProBuyerProjectRef', id: any, name: string };

export type ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget = { __typename?: 'ProBuyerSaveTarget', itemCount: number, contains: boolean, itemId?: any | null, roomId?: any | null, project: ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget_project_ProBuyerProjectRef, rooms: Array<ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget_rooms_ProBuyerProjectRoom> };

export type ProBuyerSaveTargetsQuery_Query = { __typename?: 'Query', proBuyerSaveTargets: Array<ProBuyerSaveTargetsQuery_proBuyerSaveTargets_ProBuyerSaveTarget> };


export type ProBuyerSaveTargetsQueryVariables = Exact<{
  productId: Scalars['UUID']['input'];
}>;


export type ProBuyerSaveTargetsQuery = ProBuyerSaveTargetsQuery_Query;

export type ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom_items_ProBuyerSelectionItem_regularPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom_items_ProBuyerSelectionItem = { __typename?: 'ProBuyerSelectionItem', id: any, title: string, images: Array<string>, width?: number | null, height?: number | null, depth?: number | null, quality?: ProductQuality | null, note?: string | null, availability: ProBuyerSelectionAvailability, myReaction?: ProBuyerClientReactionValue | null, regularPrice?: ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom_items_ProBuyerSelectionItem_regularPrice_Price | null };

export type ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom = { __typename?: 'ProBuyerSelectionRoom', name: string, description: string, items: Array<ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom_items_ProBuyerSelectionItem> };

export type ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection = { __typename?: 'ProBuyerSelection', projectName: string, curatorName: string, curatorLogo?: string | null, message: string, updatedAt: any, itemCount: number, showPrices: boolean, allowReactions: boolean, rooms: Array<ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection_rooms_ProBuyerSelectionRoom> };

export type ProBuyerSelectionQuery_Query = { __typename?: 'Query', proBuyerSelection?: ProBuyerSelectionQuery_proBuyerSelection_ProBuyerSelection | null };


export type ProBuyerSelectionQueryVariables = Exact<{
  token: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProBuyerSelectionQuery = ProBuyerSelectionQuery_Query;

export type ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_activeProject_ProBuyerProject_rooms_ProBuyerProjectRoom = { __typename?: 'ProBuyerProjectRoom', id: any, name: string, description: string, position: number, itemCount: number };

export type ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_activeProject_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string>, rooms: Array<ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_activeProject_ProBuyerProject_rooms_ProBuyerProjectRoom> };

export type ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_projects_ProBuyerProject = { __typename?: 'ProBuyerProject', id: any, name: string, itemCount: number, purchaseCount: number, updatedAt: any, coverImages: Array<string> };

export type ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace = { __typename?: 'ProBuyerWorkspace', activeRoomId?: any | null, activeProject?: ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_activeProject_ProBuyerProject | null, projects: Array<ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace_projects_ProBuyerProject> };

export type ProBuyerWorkspaceQuery_Query = { __typename?: 'Query', proBuyerWorkspace: ProBuyerWorkspaceQuery_proBuyerWorkspace_ProBuyerWorkspace };


export type ProBuyerWorkspaceQueryVariables = Exact<{ [key: string]: never; }>;


export type ProBuyerWorkspaceQuery = ProBuyerWorkspaceQuery_Query;

export type GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2_price_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2_deliveryEstimate_ProductShippingEstimate = { __typename?: 'ProductShippingEstimate', minDays?: number | null, maxDays?: number | null };

export type GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2 = { __typename?: 'ProductShippingOptionV2', shippingMethod: ShippingMethodEnum, shippingProvider?: ShippingProviderEnum | null, requiredForPrice?: RequiredForPriceEnum | null, deliveryType?: PostalDeliveryTypeEnum | null, isSupported: boolean, price?: GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2_price_Price | null, deliveryEstimate?: GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2_deliveryEstimate_ProductShippingEstimate | null };

export type GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2 = { __typename?: 'ProductShippingDetailsV2', shippingOptions: Array<GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2> };

export type GetProductShippingDetailsQuery_Query = { __typename?: 'Query', getProductShippingDetailsV2: GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2 };


export type GetProductShippingDetailsQueryVariables = Exact<{
  input: GetProductShippingDetailsInput;
}>;


export type GetProductShippingDetailsQuery = GetProductShippingDetailsQuery_Query;

export type MyDeliveryQuoteQuery_product_Product_myDeliveryQuote_DeliveryQuote = { __typename?: 'DeliveryQuote', id: any, status: DeliveryQuoteStatus, postalCode: string, region: string, city: string, deliveryType: DeliveryQuoteDeliveryType, requestedAt: any, validUntil?: any | null, fee?: DeliveryQuoteFragmentFragment_DeliveryQuote_fee_Price | null };

export type MyDeliveryQuoteQuery_product_Product = { __typename?: 'Product', id: any, myDeliveryQuote?: MyDeliveryQuoteQuery_product_Product_myDeliveryQuote_DeliveryQuote | null };

export type MyDeliveryQuoteQuery_Query = { __typename?: 'Query', product?: MyDeliveryQuoteQuery_product_Product | null };


export type MyDeliveryQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
}>;


export type MyDeliveryQuoteQuery = MyDeliveryQuoteQuery_Query;

export type ReservationProductTitleQuery_product_Product = { __typename?: 'Product', id: any, title: string };

export type ReservationProductTitleQuery_Query = { __typename?: 'Query', product?: ReservationProductTitleQuery_product_Product | null };


export type ReservationProductTitleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ReservationProductTitleQuery = ReservationProductTitleQuery_Query;

export type ProductByIdQuery_productById_Product_promotion_ProductPromotion_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type ProductByIdQuery_productById_Product_promotion_ProductPromotion = { __typename?: 'ProductPromotion', highlight: boolean, label?: ProductByIdQuery_productById_Product_promotion_ProductPromotion_label_PromotionLabel | null };

export type ProductByIdQuery_productById_Product_tradeDiscountPreviewPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductByIdQuery_productById_Product_priceDropSchedule_PriceDropSchedule = { __typename?: 'PriceDropSchedule', pace: PriceDropPace, stepPercent: number, pausedReason?: PriceDropPause | null, basePrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_basePrice_Price, floor: PriceDropScheduleFieldsFragment_PriceDropSchedule_floor_Price, lowestPrice: PriceDropScheduleFieldsFragment_PriceDropSchedule_lowestPrice_Price, upcoming: Array<PriceDropScheduleFieldsFragment_PriceDropSchedule_upcoming_PriceDropStep> };

export type ProductByIdQuery_productById_Product_priceDropSettings_PriceDropSettings_floor_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductByIdQuery_productById_Product_priceDropSettings_PriceDropSettings = { __typename?: 'PriceDropSettings', enabled: boolean, pace: PriceDropPace, stepPercent: number, floor?: ProductByIdQuery_productById_Product_priceDropSettings_PriceDropSettings_floor_Price | null };

export type ProductByIdQuery_productById_Product = { __typename?: 'Product', id: any, slug: string, identifier: string, title: string, description?: string | null, state: ProductState, status: ProductStatus, view_count: number, favorite_count: number, quality?: ProductQuality | null, auto_discount?: boolean | null, brand_suggestion?: string | null, brandUnknown?: boolean | null, artist_suggestion?: string | null, artistUnknown?: boolean | null, number_of_items?: number | null, shape?: Shape | null, created?: any | null, curated_at?: any | null, condition: ProductCondition, isBoostable?: boolean | null, isBoosted?: boolean | null, boostStatus?: BoostStatus | null, lastBoosted?: any | null, boostEndsAt?: any | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, link: string, delivery_method: DeliveryMethod, bag_model?: string | null, gender?: Gender | null, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, year_of_purchase?: number | null, usage_signs_description?: string | null, showroomModel: boolean, note_for_curator?: string | null, user_confirmed_postal_fit?: boolean | null, postal_package_size?: PostalPackageSize | null, postalPackageSize?: PostalPackageSize | null, postal_package_weight_kg?: number | null, promotion?: ProductByIdQuery_productById_Product_promotion_ProductPromotion | null, tradeDiscountPreviewPrice?: ProductByIdQuery_productById_Product_tradeDiscountPreviewPrice_Price | null, priceDropSchedule?: ProductByIdQuery_productById_Product_priceDropSchedule_PriceDropSchedule | null, priceDropSettings?: ProductByIdQuery_productById_Product_priceDropSettings_PriceDropSettings | null, buy_now_price?: PrivateProductFragmentFragment_Product_buy_now_price_Price | null, original_price?: PrivateProductFragmentFragment_Product_original_price_Price | null, newPrice?: PrivateProductFragmentFragment_Product_newPrice_Price | null, image?: PrivateProductFragmentFragment_Product_image_Image | null, images: Array<PrivateProductFragmentFragment_Product_images_Image>, activeBoost?: PrivateProductFragmentFragment_Product_activeBoost_ProductBoost | null, address?: PrivateProductFragmentFragment_Product_address_Address | null, auction?: PrivateProductFragmentFragment_Product_auction_Auction | null, custom_shipping_cost?: PrivateProductFragmentFragment_Product_custom_shipping_cost_Price | null, customShippingPrices?: Array<PrivateProductFragmentFragment_Product_customShippingPrices_CustomShippingPrice> | null, shipping_method?: PrivateProductFragmentFragment_Product_shipping_method_ShippingMethod | null, merchant: PrivateProductFragmentFragment_Product_merchant_Merchant, merchant_fee?: PrivateProductFragmentFragment_Product_merchant_fee_Fee | null, favorite?: PrivateProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PrivateProductFragmentFragment_Product_categories_Category>, breadcrumbs: Array<PrivateProductFragmentFragment_Product_breadcrumbs_Category>, brand?: PrivateProductFragmentFragment_Product_brand_Brand | null, hardware_color?: PrivateProductFragmentFragment_Product_hardware_color_HardwareColor | null, attributes: Array<PrivateProductFragmentFragment_Product_attributes>, curation_feedback?: PrivateProductFragmentFragment_Product_curation_feedback_CurationFeedback | null, activeListingFee?: PrivateProductFragmentFragment_Product_activeListingFee_ProductListingFee | null };

export type ProductByIdQuery_Query = { __typename?: 'Query', productById: ProductByIdQuery_productById_Product };


export type ProductByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProductByIdQuery = ProductByIdQuery_Query;

export type ProductBySlugQuery_productBySlug_Product_tradeDiscountPreviewPrice_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type ProductBySlugQuery_productBySlug_Product_auction_Auction = { __typename?: 'Auction', end_date?: any | null, start_date?: any | null, id: any, state: AuctionState, created?: any | null, updated?: any | null, allow_bid: boolean, allow_buy_now: boolean, bid_count: number, coming_soon_time?: any | null, minimum_bid?: PublicProductFragmentFragment_Product_auction_Auction_minimum_bid_Price | null, sold_at?: PublicProductFragmentFragment_Product_auction_Auction_sold_at_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_auction_Auction_buy_now_price_Price | null };

export type ProductBySlugQuery_productBySlug_Product_relatedListingPages_ListingPage = { __typename?: 'ListingPage', title: string, url: string };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_ARObject = { __typename?: 'ARObject' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Audio = { __typename?: 'Audio' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Document = { __typename?: 'Document' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Image = { __typename?: 'Image', id: any, url: string, large_url: string, medium_url: string, small_url: string, x_small_url: string };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Video = { __typename?: 'Video' };

export type ProductBySlugQuery_productBySlug_Product_brand_Brand_media = ProductBySlugQuery_productBySlug_Product_brand_Brand_media_ARObject | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Audio | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Document | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Image | ProductBySlugQuery_productBySlug_Product_brand_Brand_media_Video;

export type ProductBySlugQuery_productBySlug_Product_brand_Brand = { __typename?: 'Brand', id: any, slug: string, media: Array<ProductBySlugQuery_productBySlug_Product_brand_Brand_media> };

export type ProductBySlugQuery_productBySlug_Product_shippingOptions_ShippingOption = { __typename?: 'ShippingOption', active: boolean, shippingProvider?: ShippingProviderEnum | null };

export type ProductBySlugQuery_productBySlug_Product = { __typename?: 'Product', created?: any | null, gone: boolean, state: ProductState, usShippable?: boolean, deliveryByQuote?: boolean, id: any, identifier: string, title: string, slug: string, description?: string | null, usage_signs_description?: string | null, art_orientation?: ArtOrientation | null, art_size?: ArtSize | null, status: ProductStatus, isInCart: boolean, view_count: number, cleaningServiceAvailable: boolean, favorite_count: number, isOwner?: boolean | null, isDesignerItem?: boolean | null, showroomModel: boolean, quality?: ProductQuality | null, two_man_delivery?: boolean | null, ground_floor_only_delivery?: boolean | null, updated?: any | null, brand_suggestion?: string | null, last_boost?: any | null, isBoosted?: boolean | null, isBoostable?: boolean | null, isCurated: boolean, number_of_items?: number | null, condition: ProductCondition, delivery_method: DeliveryMethod, width?: number | null, height?: number | null, depth?: number | null, seat_height?: number | null, weight?: number | null, gender?: Gender | null, bag_model?: string | null, year_of_purchase?: number | null, slug_en: string, slug_nl: string, slug_de: string, slug_fr: string, slug_es: string, slug_it: string, original_title: string, original_description?: string | null, original_usage_signs_description?: string | null, tradeDiscountPreviewPrice?: ProductBySlugQuery_productBySlug_Product_tradeDiscountPreviewPrice_Price | null, auction?: ProductBySlugQuery_productBySlug_Product_auction_Auction | null, relatedListingPages: Array<ProductBySlugQuery_productBySlug_Product_relatedListingPages_ListingPage>, brand?: ProductBySlugQuery_productBySlug_Product_brand_Brand | null, shippingOptions: Array<ProductBySlugQuery_productBySlug_Product_shippingOptions_ShippingOption>, newPrice?: PublicProductFragmentFragment_Product_newPrice_Price | null, buy_now_price?: PublicProductFragmentFragment_Product_buy_now_price_Price | null, activeBoost?: PublicProductFragmentFragment_Product_activeBoost_ProductBoost | null, original_price?: PublicProductFragmentFragment_Product_original_price_Price | null, android_arobject?: PublicProductFragmentFragment_Product_android_arobject_ARObject | null, ios_arobject?: PublicProductFragmentFragment_Product_ios_arobject_ARObject | null, product_type?: PublicProductFragmentFragment_Product_product_type_ProductType | null, images: Array<PublicProductFragmentFragment_Product_images_Image>, address?: PublicProductFragmentFragment_Product_address_Address | null, coming_soon_alert?: PublicProductFragmentFragment_Product_coming_soon_alert_ComingSoonAlert | null, custom_shipping_cost?: PublicProductFragmentFragment_Product_custom_shipping_cost_Price | null, shipping_method?: PublicProductFragmentFragment_Product_shipping_method_ShippingMethod | null, externalShippingMethods: Array<PublicProductFragmentFragment_Product_externalShippingMethods_ExternalShippingMethod>, merchant: PublicProductFragmentFragment_Product_merchant_Merchant, favorite?: PublicProductFragmentFragment_Product_favorite_Favorite | null, categories: Array<PublicProductFragmentFragment_Product_categories_Category>, shipping_method_prices: Array<PublicProductFragmentFragment_Product_shipping_method_prices_ShippingMethodCountryPrice>, hardware_color?: PublicProductFragmentFragment_Product_hardware_color_HardwareColor | null, attributes: Array<PublicProductFragmentFragment_Product_attributes> };

export type ProductBySlugQuery_Query = { __typename?: 'Query', productBySlug?: ProductBySlugQuery_productBySlug_Product | null };


export type ProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
  usMarket?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductBySlugQuery = ProductBySlugQuery_Query;

export type GetProductCountByStatusQuery_productCountByStatus_ProductCountByStatus = { __typename?: 'ProductCountByStatus', status: ProductStatus, count: number };

export type GetProductCountByStatusQuery_Query = { __typename?: 'Query', productCountByStatus: Array<GetProductCountByStatusQuery_productCountByStatus_ProductCountByStatus> };


export type GetProductCountByStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCountByStatusQuery = GetProductCountByStatusQuery_Query;

export type ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult_fee_Fee = { __typename?: 'Fee', amount: number, type: CalculationMethod };

export type ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult = { __typename?: 'ProductPlatformFeeResult', campaign_code?: string | null, fee: ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult_fee_Fee };

export type ProductPlatformFeeQuery_Query = { __typename?: 'Query', getProductPlatformFee: ProductPlatformFeeQuery_getProductPlatformFee_ProductPlatformFeeResult };


export type ProductPlatformFeeQueryVariables = Exact<{
  input?: InputMaybe<ProductPlatformFeeInput>;
}>;


export type ProductPlatformFeeQuery = ProductPlatformFeeQuery_Query;

export type PromotionsQuery_promotions_Promotion_discount_CouponCodeDiscount = { __typename?: 'CouponCodeDiscount', type: DiscountType, value: number };

export type PromotionsQuery_promotions_Promotion = { __typename?: 'Promotion', code: string, valid_upto?: any | null, discount: PromotionsQuery_promotions_Promotion_discount_CouponCodeDiscount };

export type PromotionsQuery_Query = { __typename?: 'Query', promotions: Array<PromotionsQuery_promotions_Promotion> };


export type PromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromotionsQuery = PromotionsQuery_Query;

export type HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_product_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion_disclosure_PromotionDisclosure = { __typename?: 'PromotionDisclosure', label: string, advertiserName: string, reason: string };

export type HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion = { __typename?: 'ProductPromotion', campaignId: string, highlight: boolean, token?: string | null, label?: HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion_label_PromotionLabel | null, disclosure: HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion_disclosure_PromotionDisclosure };

export type HomepagePromotionsQuery_homepagePromotions_HomepagePromotion = { __typename?: 'HomepagePromotion', product: HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_product_Product, promotion: HomepagePromotionsQuery_homepagePromotions_HomepagePromotion_promotion_ProductPromotion };

export type HomepagePromotionsQuery_Query = { __typename?: 'Query', homepagePromotions: Array<HomepagePromotionsQuery_homepagePromotions_HomepagePromotion> };


export type HomepagePromotionsQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type HomepagePromotionsQuery = HomepagePromotionsQuery_Query;

export type ProductPromotionPresentationQuery_productBySlug_Product_promotion_ProductPromotion_label_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type ProductPromotionPresentationQuery_productBySlug_Product_promotion_ProductPromotion = { __typename?: 'ProductPromotion', highlight: boolean, label?: ProductPromotionPresentationQuery_productBySlug_Product_promotion_ProductPromotion_label_PromotionLabel | null };

export type ProductPromotionPresentationQuery_productBySlug_Product = { __typename?: 'Product', id: any, promotion?: ProductPromotionPresentationQuery_productBySlug_Product_promotion_ProductPromotion | null };

export type ProductPromotionPresentationQuery_Query = { __typename?: 'Query', productBySlug?: ProductPromotionPresentationQuery_productBySlug_Product | null };


export type ProductPromotionPresentationQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ProductPromotionPresentationQuery = ProductPromotionPresentationQuery_Query;

export type PromotionCampaignQuery_promotionCampaign_PromotionCampaign = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, effects: Array<PromotionEffect>, catalogueVersion: number, status: PromotionStatus, paymentStatus: PromotionPaymentStatus, startsAt?: any | null, endsAt?: any | null, paidAt?: any | null, statusReason?: string | null, canResumeCheckout: boolean, canWithdraw: boolean, pack?: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack | null, benefits: Array<PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit>, price?: PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney | null, metrics?: PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics | null };

export type PromotionCampaignQuery_Query = { __typename?: 'Query', promotionCampaign?: PromotionCampaignQuery_promotionCampaign_PromotionCampaign | null };


export type PromotionCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromotionCampaignQuery = PromotionCampaignQuery_Query;

export type PromotionCampaignsQuery_promotionCampaigns_PromotionCampaign = { __typename?: 'PromotionCampaign', id: string, productId: string, offerTitle: string, effects: Array<PromotionEffect>, catalogueVersion: number, status: PromotionStatus, paymentStatus: PromotionPaymentStatus, startsAt?: any | null, endsAt?: any | null, paidAt?: any | null, statusReason?: string | null, canResumeCheckout: boolean, canWithdraw: boolean, pack?: PromotionCampaignDetailsFragment_PromotionCampaign_pack_PromotionQuotePack | null, benefits: Array<PromotionCampaignDetailsFragment_PromotionCampaign_benefits_PromotionCampaignBenefit>, price?: PromotionCampaignDetailsFragment_PromotionCampaign_price_PromotionMoney | null, metrics?: PromotionCampaignDetailsFragment_PromotionCampaign_metrics_PromotionMetrics | null };

export type PromotionCampaignsQuery_Query = { __typename?: 'Query', promotionCampaigns: Array<PromotionCampaignsQuery_promotionCampaigns_PromotionCampaign> };


export type PromotionCampaignsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type PromotionCampaignsQuery = PromotionCampaignsQuery_Query;

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_labelChoices_PromotionLabel = { __typename?: 'PromotionLabel', code: string, text: string };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_homepageAvailability_PromotionHomepageAvailability = { __typename?: 'PromotionHomepageAvailability', available: boolean, capacity: number, remaining: number, reason?: string | null };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_offers_PromotionOffer = { __typename?: 'PromotionOffer', code: string, title: string, durationDays: number, effects: Array<PromotionEffect>, catalogueVersion: number, eligible: boolean, reason?: string | null, benefits: Array<PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_benefits_PromotionBenefitTemplate>, price: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_price_PromotionMoney, separatePrice?: PackageCartFragmentFragment_PackageCart_items_PackageCartItem_promotionQuote_PromotionQuote_offer_PromotionOffer_separatePrice_PromotionMoney | null };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_price_PromotionMoney_converted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_price_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string, converted?: PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_price_PromotionMoney_converted_Price | null };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_listPrice_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption = { __typename?: 'PromotionBoostOption', days: number, popular: boolean, price: PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_price_PromotionMoney, listPrice: PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption_listPrice_PromotionMoney };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack_price_PromotionMoney_converted_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack_price_PromotionMoney = { __typename?: 'PromotionMoney', amount: number, currency: string, converted?: PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack_price_PromotionMoney_converted_Price | null };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack = { __typename?: 'PromotionStandOutPack', boostDays: number, price: PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack_price_PromotionMoney };

export type PromotionOffersQuery_promotionOffers_PromotionCatalogue = { __typename?: 'PromotionCatalogue', purchaseContext: PromotionPurchaseContext, purchaseContextReason?: string | null, eligible: boolean, reason?: string | null, purchaseSupported: boolean, termsVersion: string, catalogueVersion: number, availableEffects: Array<PromotionEffect>, boostAvailable: boolean, labelChoices: Array<PromotionOffersQuery_promotionOffers_PromotionCatalogue_labelChoices_PromotionLabel>, homepageAvailability: PromotionOffersQuery_promotionOffers_PromotionCatalogue_homepageAvailability_PromotionHomepageAvailability, offers: Array<PromotionOffersQuery_promotionOffers_PromotionCatalogue_offers_PromotionOffer>, boostOptions: Array<PromotionOffersQuery_promotionOffers_PromotionCatalogue_boostOptions_PromotionBoostOption>, standOutPack?: PromotionOffersQuery_promotionOffers_PromotionCatalogue_standOutPack_PromotionStandOutPack | null };

export type PromotionOffersQuery_Query = { __typename?: 'Query', promotionOffers: PromotionOffersQuery_promotionOffers_PromotionCatalogue };


export type PromotionOffersQueryVariables = Exact<{
  displayCurrency?: InputMaybe<Currency>;
  productId: Scalars['ID']['input'];
  lang?: InputMaybe<Language>;
  purchaseContext?: InputMaybe<PromotionPurchaseContext>;
}>;


export type PromotionOffersQuery = PromotionOffersQuery_Query;

export type ReferralTypesQuery_referralTypes_ReferralType = { __typename?: 'ReferralType', id: any, name: string };

export type ReferralTypesQuery_Query = { __typename?: 'Query', referralTypes: Array<ReferralTypesQuery_referralTypes_ReferralType> };


export type ReferralTypesQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
}>;


export type ReferralTypesQuery = ReferralTypesQuery_Query;

export type RelatedProductsQuery_relatedProducts_Product = { __typename?: 'Product', id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type RelatedProductsQuery_Query = { __typename?: 'Query', relatedProducts: Array<RelatedProductsQuery_relatedProducts_Product> };


export type RelatedProductsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type RelatedProductsQuery = RelatedProductsQuery_Query;

export type SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch_filters_FilterOutput = { __typename?: 'FilterOutput', key?: SearchFilterKey | null, value?: string | null };

export type SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch = { __typename?: 'SavedSearch', id: any, query?: string | null, filters?: Array<SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch_filters_FilterOutput | null> | null };

export type SavedSearchByIdentifierQuery_Query = { __typename?: 'Query', savedSearchByIdentifier?: SavedSearchByIdentifierQuery_savedSearchByIdentifier_SavedSearch | null };


export type SavedSearchByIdentifierQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type SavedSearchByIdentifierQuery = SavedSearchByIdentifierQuery_Query;

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Brand = { __typename?: 'Brand', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Category = { __typename?: 'Category', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Color = { __typename?: 'Color', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Designer = { __typename?: 'Designer' };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Empty = { __typename?: 'Empty' };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Material = { __typename?: 'Material', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Style = { __typename?: 'Style', title: string };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models = SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Brand | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Category | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Color | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Designer | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Empty | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Material | SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models_Style;

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput = { __typename?: 'FilterOutput', key?: SearchFilterKey | null, value?: string | null, models?: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput_models> | null };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch = { __typename?: 'SavedSearch', id: any, title?: string | null, query?: string | null, enabled?: boolean | null, filters?: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch_filters_FilterOutput | null> | null };

export type SavedSearchesQuery_savedSearches_SavedSearchResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, pages: number, count: number };

export type SavedSearchesQuery_savedSearches_SavedSearchResult = { __typename?: 'SavedSearchResult', items: Array<SavedSearchesQuery_savedSearches_SavedSearchResult_items_SavedSearch>, pagination: SavedSearchesQuery_savedSearches_SavedSearchResult_pagination_PaginationResult };

export type SavedSearchesQuery_Query = { __typename?: 'Query', savedSearches: SavedSearchesQuery_savedSearches_SavedSearchResult };


export type SavedSearchesQueryVariables = Exact<{
  sort?: InputMaybe<SavedSearchSort>;
  sortOrder?: InputMaybe<Ordering>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Language>;
}>;


export type SavedSearchesQuery = SavedSearchesQuery_Query;

export type SearchProductsQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', usShippable?: boolean, id: any, title: string, slug: string, isInCart: boolean, isDesignerItem?: boolean | null, isBoosted?: boolean | null, isCurated: boolean, showroomModel: boolean, quality?: ProductQuality | null, view_count: number, favorite_count: number, favorite?: PublicProductOverviewFragmentFragment_Product_favorite_Favorite | null, images: Array<PublicProductOverviewFragmentFragment_Product_images_Image>, auction?: PublicProductOverviewFragmentFragment_Product_auction_Auction | null, buy_now_price?: PublicProductOverviewFragmentFragment_Product_buy_now_price_Price | null, original_price?: PublicProductOverviewFragmentFragment_Product_original_price_Price | null, attributes: Array<PublicProductOverviewFragmentFragment_Product_attributes>, categories: Array<PublicProductOverviewFragmentFragment_Product_categories_Category> };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Artist = { __typename?: 'Artist', id: any, slug: string, title: string };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Brand = { __typename?: 'Brand' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Color = { __typename?: 'Color', id: any, hex?: string | null, title: string };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Designer = { __typename?: 'Designer' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_HardwareColor = { __typename?: 'HardwareColor', id: any, hex?: string | null, title: string };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Label = { __typename?: 'Label' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Material = { __typename?: 'Material' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Style = { __typename?: 'Style' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Subject = { __typename?: 'Subject' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_UsageSign = { __typename?: 'UsageSign' };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute = SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_AdditionalInfo | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Artist | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Brand | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Color | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Designer | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_HardwareColor | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Label | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Material | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Style | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_Subject | SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute_UsageSign;

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_category_Category = { __typename?: 'Category', route?: string | null, level?: number | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue = { __typename?: 'SearchFacetValue', value?: string | null, count?: number | null, attribute?: SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_attribute | null, category?: SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue_category_Category | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet = { __typename?: 'SearchFacet', key?: SearchFacetKey | null, values?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet_values_SearchFacetValue | null> | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_facetsStats_SearchFacetStats = { __typename?: 'SearchFacetStats', key: SearchFacetsStatKey, min?: number | null, max?: number | null };

export type SearchProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult = { __typename?: 'PaginationResult', page: number, limit: number, pages: number, count: number };

export type SearchProductsQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', queryID?: string | null, indexName?: string | null, items?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_items_Product | null> | null, facets?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facets_SearchFacet | null> | null, facetsStats?: Array<SearchProductsQuery_searchProducts_SearchProductsResult_facetsStats_SearchFacetStats | null> | null, pagination?: SearchProductsQuery_searchProducts_SearchProductsResult_pagination_PaginationResult | null };

export type SearchProductsQuery_Query = { __typename?: 'Query', searchProducts?: SearchProductsQuery_searchProducts_SearchProductsResult | null };


export type SearchProductsQueryVariables = Exact<{
  input?: InputMaybe<SearchProductsInput>;
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
  usMarket?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchProductsQuery = SearchProductsQuery_Query;

export type SellerPayoutsQuery_payouts_Payouts_items_Payout = { __typename?: 'Payout', amount: number, currency: string, created: any };

export type SellerPayoutsQuery_payouts_Payouts = { __typename?: 'Payouts', enabled: boolean, items: Array<SellerPayoutsQuery_payouts_Payouts_items_Payout> };

export type SellerPayoutsQuery_Query = { __typename?: 'Query', payouts: SellerPayoutsQuery_payouts_Payouts };


export type SellerPayoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type SellerPayoutsQuery = SellerPayoutsQuery_Query;

export type ShippingMethodsQuery_shippingMethods_ShippingMethod_price_Price = { __typename?: 'Price', currency: Currency, amount: number };

export type ShippingMethodsQuery_shippingMethods_ShippingMethod = { __typename?: 'ShippingMethod', id: any, title: string, slug: string, description?: string | null, price: ShippingMethodsQuery_shippingMethods_ShippingMethod_price_Price };

export type ShippingMethodsQuery_Query = { __typename?: 'Query', shippingMethods: Array<ShippingMethodsQuery_shippingMethods_ShippingMethod> };


export type ShippingMethodsQueryVariables = Exact<{
  originCountry?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShippingMethodsQuery = ShippingMethodsQuery_Query;

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_actions_SellerAction = { __typename?: 'SellerAction', kind: SellerActionKind, emphasis: SellerActionEmphasis, link_type?: StripeAccountLinkType | null, label: string, disabled_reason?: string | null };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_verification_issues_SellerVerificationIssue = { __typename?: 'SellerVerificationIssue', code: string, action: SellerVerificationAction, title: string, description: string, cta_label: string, why?: string | null, reason_codes: Array<string>, document_request_reason?: DocumentRequestReason | null };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance_available_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance_pending_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance = { __typename?: 'SellerBalance', available: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance_available_Price, pending: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance_pending_Price };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_amount_waiting_Price = { __typename?: 'Price', amount: number, currency: Currency };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_bank_account_ExternalBankAccount = { __typename?: 'ExternalBankAccount', id: string, currency: Currency, country: string, account_holder_name?: string | null, bank_name: string, last4: string, status?: string | null };

export type StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails = { __typename?: 'StripeAccountDetails', account_created: boolean, details_submitted: boolean, payouts_enabled: boolean, account_status: SellerAccountStatus, status_title: string, status_description: string, verification_status: SellerVerificationStatus, deadline?: any | null, disabled_reason?: string | null, pending_since?: any | null, blocker_family?: string | null, verification_as_of?: any | null, actions: Array<StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_actions_SellerAction>, verification_issues: Array<StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_verification_issues_SellerVerificationIssue>, balance?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_balance_SellerBalance | null, amount_waiting?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_amount_waiting_Price | null, bank_account?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails_bank_account_ExternalBankAccount | null };

export type StripeAccountDetailsQuery_Query = { __typename?: 'Query', stripeAccountDetails?: StripeAccountDetailsQuery_stripeAccountDetails_StripeAccountDetails | null };


export type StripeAccountDetailsQueryVariables = Exact<{
  lang?: InputMaybe<Language>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StripeAccountDetailsQuery = StripeAccountDetailsQuery_Query;

export type UpdateAddressMutation_updateAddress_Address = { __typename?: 'Address', id: any, line1: string, line2?: string | null, postal_code: string, city: string, state?: string | null, country: string };

export type UpdateAddressMutation_Mutation = { __typename?: 'Mutation', updateAddress: UpdateAddressMutation_updateAddress_Address };


export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  merchant_id: Scalars['UUID']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
}>;


export type UpdateAddressMutation = UpdateAddressMutation_Mutation;

export type MessageCreatedSubscription_messageCreated_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, status?: MessageStatus | null, originalBody?: string | null, rejectionReason?: MessageFragment_Message_rejectionReason_MessageRejectionReason | null, sender: MessageFragment_Message_sender_Member, merchant: MessageFragment_Message_merchant_Merchant, item?: MessageFragment_Message_item | null };

export type MessageCreatedSubscription_Subscription = { __typename?: 'Subscription', messageCreated: MessageCreatedSubscription_messageCreated_Message };


export type MessageCreatedSubscriptionVariables = Exact<{
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type MessageCreatedSubscription = MessageCreatedSubscription_Subscription;

export type MessageUpdatedSubscription_messageUpdated_Message = { __typename?: 'Message', id: any, body?: string | null, created: any, unread: boolean, metadata?: any | null, threadId: any, status?: MessageStatus | null, originalBody?: string | null, rejectionReason?: MessageFragment_Message_rejectionReason_MessageRejectionReason | null, sender: MessageFragment_Message_sender_Member, merchant: MessageFragment_Message_merchant_Merchant, item?: MessageFragment_Message_item | null };

export type MessageUpdatedSubscription_Subscription = { __typename?: 'Subscription', messageUpdated: MessageUpdatedSubscription_messageUpdated_Message };


export type MessageUpdatedSubscriptionVariables = Exact<{
  lang?: InputMaybe<Language>;
  currency?: InputMaybe<Currency>;
}>;


export type MessageUpdatedSubscription = MessageUpdatedSubscription_Subscription;

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_AdditionalInfo = { __typename?: 'AdditionalInfo' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Artist = { __typename?: 'Artist' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Brand = { __typename?: 'Brand', slug: string };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Color = { __typename?: 'Color' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Designer = { __typename?: 'Designer' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_HardwareColor = { __typename?: 'HardwareColor' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Label = { __typename?: 'Label' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Material = { __typename?: 'Material' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Style = { __typename?: 'Style' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Subject = { __typename?: 'Subject' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_UsageSign = { __typename?: 'UsageSign' };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes = OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_AdditionalInfo | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Artist | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Brand | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Color | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Designer | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_HardwareColor | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Label | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Material | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Style | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_Subject | OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes_UsageSign;

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction_minimum_bid_Price = { __typename?: 'Price', amount: number };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction = { __typename?: 'Auction', buy_now_price?: OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction_buy_now_price_Price | null, minimum_bid?: OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction_minimum_bid_Price | null };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_buy_now_price_Price = { __typename?: 'Price', amount: number };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product = { __typename?: 'Product', title: string, attributes: Array<OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_attributes>, auction?: OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_auction_Auction | null, buy_now_price?: OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product_buy_now_price_Price | null };

export type OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult = { __typename?: 'SearchProductsResult', items?: Array<OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult_items_Product | null> | null };

export type OpenHomeCatalogueMatchQuery_Query = { __typename?: 'Query', searchProducts?: OpenHomeCatalogueMatchQuery_searchProducts_SearchProductsResult | null };


export type OpenHomeCatalogueMatchQueryVariables = Exact<{
  input?: InputMaybe<SearchProductsInput>;
}>;


export type OpenHomeCatalogueMatchQuery = OpenHomeCatalogueMatchQuery_Query;

export type OpenHomeViewerQuery_me_Member_merchants_Merchant_addresses_Address = { __typename?: 'Address', city: string, country: string };

export type OpenHomeViewerQuery_me_Member_merchants_Merchant_fee_Fee = { __typename?: 'Fee', type: CalculationMethod, amount: number };

export type OpenHomeViewerQuery_me_Member_merchants_Merchant = { __typename?: 'Merchant', id: any, type: MerchantType, addresses: Array<OpenHomeViewerQuery_me_Member_merchants_Merchant_addresses_Address>, fee?: OpenHomeViewerQuery_me_Member_merchants_Merchant_fee_Fee | null };

export type OpenHomeViewerQuery_me_Member = { __typename?: 'Member', id: any, email: string, given_name: string, locale: Locale, merchants: Array<OpenHomeViewerQuery_me_Member_merchants_Merchant> };

export type OpenHomeViewerQuery_Query = { __typename?: 'Query', me?: OpenHomeViewerQuery_me_Member | null };


export type OpenHomeViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenHomeViewerQuery = OpenHomeViewerQuery_Query;

export type RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage_categoryPages_ListingCategoryPage = { __typename?: 'ListingCategoryPage', listingLevel: ListingLevel, activeProductCount: number };

export type RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage = { __typename?: 'ListingPage', url: string, title: string, categoryPages: Array<RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage_categoryPages_ListingCategoryPage> };

export type RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage = { __typename?: 'RelatedListingPage', type: ListingPageRelationType, listingPage: RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage_listingPage_ListingPage };

export type RelatedListingPagesQuery_listingPage_ListingPage = { __typename?: 'ListingPage', relatedListingPages: Array<RelatedListingPagesQuery_listingPage_ListingPage_relatedListingPages_RelatedListingPage> };

export type RelatedListingPagesQuery_Query = { __typename?: 'Query', listingPage?: RelatedListingPagesQuery_listingPage_ListingPage | null };


export type RelatedListingPagesQueryVariables = Exact<{
  url: Scalars['String']['input'];
  lang: Language;
}>;


export type RelatedListingPagesQuery = RelatedListingPagesQuery_Query;

export type ValueCheckCategoryQuery_category_Category = { __typename?: 'Category', id: any, title: string, route?: string | null };

export type ValueCheckCategoryQuery_Query = { __typename?: 'Query', category?: ValueCheckCategoryQuery_category_Category | null };


export type ValueCheckCategoryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  lang?: InputMaybe<Language>;
}>;


export type ValueCheckCategoryQuery = ValueCheckCategoryQuery_Query;
